/**********************************************************/
/**                                                      **/
/**                THIS FILE IS GENERATED                **/
/**                DO NOT MODIFY DIRECTLY                **/
/**                                                      **/
/**  Call yarn graphql:codegen, optionally with --watch  **/
/**                                                      **/
/**********************************************************/

/* eslint-disable */
import type {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a ISO-8601 date string. */
  Date: string;
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: string;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: object;
  /** The `Void` scalar type represents no value being returned. */
  Void: undefined;
};

export type AccountingTransaction = {
  readonly __typename: 'AccountingTransaction';
  readonly amount: Scalars['String'];
  readonly balance: Maybe<Scalars['String']>;
  readonly batchId: Scalars['String'];
  readonly carrierId: Scalars['String'];
  readonly companyId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly identifier: Scalars['ID'];
  readonly isMoneyTransferred: Scalars['String'];
  readonly isProfit: Scalars['String'];
  readonly isTopLevel: Scalars['String'];
  readonly moreLink: Maybe<Scalars['String']>;
  readonly note: Maybe<Scalars['String']>;
  readonly paymentId: Scalars['String'];
  readonly pickupRequestId: Scalars['String'];
  readonly reconciliationAdjustmentId: Scalars['String'];
  readonly reconciliationRunId: Scalars['String'];
  readonly referenceId: Scalars['String'];
  readonly shipmentId: Scalars['String'];
  readonly timestamp: Scalars['String'];
  readonly title: Maybe<Scalars['String']>;
  readonly transactionCount: Maybe<Scalars['String']>;
  readonly transactionType: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['String']>;
};

export type AdditionalMappingInput = {
  readonly additionalField: Scalars['String'];
  readonly customOptionSourceKeyToOverride?: InputMaybe<Scalars['String']>;
};

export type Address = AddressInterface &
  BasicAddressInterface & {
    readonly __typename: 'Address';
    readonly address1: Scalars['String'];
    readonly address2: Scalars['String'];
    /** This is the record type from SmartyStreets */
    readonly addressType: Scalars['String'];
    readonly city: Scalars['String'];
    readonly company: Scalars['String'];
    readonly countryCode: Scalars['String'];
    readonly fullName: Scalars['String'];
    readonly id: Scalars['ID'];
    readonly location: Location;
    readonly origin: Scalars['Boolean'];
    readonly originalId: Maybe<Scalars['ID']>;
    readonly phone: Scalars['String'];
    readonly poBox: Scalars['Boolean'];
    readonly postcode: Scalars['String'];
    readonly regionCode: Scalars['String'];
    readonly residential: Scalars['Boolean'];
    readonly timeZone: Scalars['String'];
    readonly valid: Scalars['Boolean'];
    readonly validationError: Scalars['String'];
    readonly warehouse: Maybe<Warehouse>;
    readonly zip4: Scalars['String'];
  };

export type AddressAutocompleteProvider = 'GOOGLE' | 'SMARTY';

export type AddressAutocompleteSettings = {
  readonly __typename: 'AddressAutocompleteSettings';
  readonly apiKey: Scalars['String'];
  readonly provider: AddressAutocompleteProvider;
};

export type AddressInput = {
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly zip4?: InputMaybe<Scalars['String']>;
};

export type AddressInterface = {
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  /** This is the record type from SmartyStreets */
  readonly addressType: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly location: Location;
  readonly origin: Scalars['Boolean'];
  readonly originalId: Maybe<Scalars['ID']>;
  readonly phone: Scalars['String'];
  readonly poBox: Scalars['Boolean'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly residential: Scalars['Boolean'];
  readonly timeZone: Scalars['String'];
  readonly valid: Scalars['Boolean'];
  readonly validationError: Scalars['String'];
  readonly warehouse: Maybe<Warehouse>;
  readonly zip4: Scalars['String'];
};

export type AdjustmentReason = {
  readonly __typename: 'AdjustmentReason';
  readonly description: Scalars['String'];
  readonly explanation: Maybe<Scalars['String']>;
  readonly reference: Maybe<AdjustmentReasonReference>;
  readonly type: Scalars['String'];
};

export type AdjustmentReasonReference = {
  readonly __typename: 'AdjustmentReasonReference';
  readonly type: UrlType;
  readonly value: Scalars['String'];
};

export type ApplicationConfiguration = {
  readonly __typename: 'ApplicationConfiguration';
  readonly datadogBrowserLoggingEnabled: Scalars['Boolean'];
  readonly datadogBrowserMonitoringEnabled: Scalars['Boolean'];
  readonly datadogClientToken: Scalars['String'];
  readonly datadogRumApplicationId: Scalars['String'];
  readonly inAppIdentityVerificationEnabled: Scalars['Boolean'];
  readonly intercomAppId: Scalars['String'];
  readonly intercomEnabled: Scalars['Boolean'];
  readonly loginWithGoogleEnabled: Scalars['Boolean'];
  readonly turnstileEnabled: Scalars['Boolean'];
  readonly turnstilePublicKey: Scalars['String'];
};

export type AssociatedCompany = {
  readonly __typename: 'AssociatedCompany';
  readonly address: Address;
  readonly title: Scalars['String'];
};

export type BasicAddress = BasicAddressInterface & {
  readonly __typename: 'BasicAddress';
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly residential: Scalars['Boolean'];
  readonly valid: Scalars['Boolean'];
  readonly zip4: Scalars['String'];
};

export type BasicAddressInterface = {
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly residential: Scalars['Boolean'];
  readonly valid: Scalars['Boolean'];
  readonly zip4: Scalars['String'];
};

export type Batch = {
  readonly __typename: 'Batch';
  readonly canCreateLabels: Scalars['Boolean'];
  readonly canCreateMobileCodes: Scalars['Boolean'];
  readonly canInstantRefundBatch: Scalars['Boolean'];
  readonly canRefund: Scalars['Boolean'];
  readonly carrierLogoClasses: ReadonlyArray<Scalars['String']>;
  readonly cleanupComplete: Scalars['Boolean'];
  readonly cleanupOriginal: Scalars['Boolean'];
  readonly containedMailClassGroupKeys: ReadonlyArray<Scalars['String']>;
  /** @deprecated Use containedMailClassGroupKeys instead */
  readonly containsGroundSaver: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTime'];
  readonly customsFormRequired: Scalars['Boolean'];
  readonly customsFormRequiredForAllShipments: Scalars['Boolean'];
  readonly customsFormSummary: BatchCustomsFormSummary;
  readonly dataSource: BatchSource;
  readonly defaultShipDate: Scalars['String'];
  /** Batch was requested to be deleted by the user */
  readonly deleted: Scalars['Boolean'];
  /** Get dock order IDs for a batch */
  readonly dockOrderIds: ReadonlyArray<Scalars['String']>;
  readonly eligibleForInsurance: Scalars['Boolean'];
  readonly emailNotificationPossible: Scalars['Boolean'];
  readonly emailNotificationSent: Scalars['Boolean'];
  readonly emailNotificationStatus: NotifyRecipientStatus;
  readonly emailNotificationTemplate: Maybe<MailTemplate>;
  /**
   * Starts the creation of an export file if no exportId is specified. If exportId is specified, the request will
   * be treated as a status request for the existing export.
   */
  readonly failedShipmentsExportStatus: DataGridExportStatus;
  readonly hasBeenDownloaded: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly labelFileFormat: FileFormat;
  readonly labelSize: LabelSize;
  readonly labelingArtifactType: LabelingArtifactType;
  readonly notifyRecipientsDate: Maybe<Scalars['String']>;
  readonly numShipments: Scalars['Int'];
  readonly originAddress: Address;
  readonly packageSummary: BatchPackageSummary;
  readonly percentageDelivered: Scalars['Float'];
  /** A summary of the purchased services in this batch with their costs(mail-classes + surcharges + extra services - refunds) */
  readonly priceSummary: ReadonlyArray<BatchPriceSummary>;
  /**
   * All possible Rates for the shipments in this batch, sorted by groups of similar shipments
   * like 'international bigger' and 'domestic smaller'
   */
  readonly rateGroups: ReadonlyArray<RateGroup>;
  readonly refundSuccessMessages: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly returnAddress: Address;
  readonly rubberStamps: ReadonlyArray<ShipmentMapping>;
  readonly runningProcess: Maybe<BatchProcess>;
  readonly shipDate: Scalars['String'];
  readonly shipDatePossibleNow: Scalars['Boolean'];
  /** A summary of the shipment statuses in this batch. Note: querying any subfields in this type will cause all queries in the class to trigger. */
  readonly shipmentStatusSummary: ShipmentStatusSummary;
  readonly shipments: ReadonlyArray<Shipment>;
  readonly spreadsheetMapping: ReadonlyArray<ShipmentMapping>;
  /**
   * This is named 'BatchStatusTag' in the legacy implementation, and is not in the database (i.e. it is computed at
   * runtime). Includes more info that is partially the status of the batch as it relates to the Pirate Ship buying
   * process, but also:
   * - Status of running or pending Batch Processes like Buy and Rate
   * - Refunds that are pending
   * - Tracking Status like In Transit or Delivered
   * As it acts like the actual status of the batch, we name it as such here (note: the column named 'status' we map
   * to "step", see above)
   */
  readonly status: BatchStatusTag;
  /**
   * User-friendly version of Batch Status
   * This is the 'Status Tag' that includes more info than just pp_batch status, it includes:
   * - Status of Batch Process like Buy and Rate
   * - Refunds that are pending
   * - Tracking Status like In Transit or Delivered
   */
  readonly statusText: Scalars['String'];
  /**
   * This is named 'status' in the database, however it represents more of a step in the Pirate Ship purchase
   * workflow. It is used more for logic than display. To avoid confusion with the BatchStatusTag (which is a
   * user-friendly combination status that involves tracking and our native statuses), we have named the property
   * "step".
   */
  readonly step: BatchStatus;
  readonly stepText: Scalars['String'];
  readonly title: Scalars['String'];
  readonly trackingDataGrid: DataGridResult;
  readonly upload: Maybe<ShipmentUpload>;
  readonly warehouse: Warehouse;
};

export type BatchFailedShipmentsExportStatusArgs = {
  exportId?: InputMaybe<Scalars['Int']>;
};

export type BatchShipmentsArgs = {
  downloadableOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shipmentId?: InputMaybe<Scalars['String']>;
};

export type BatchSpreadsheetMappingArgs = {
  shipmentFields?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

export type BatchCustomsFormSummary = {
  readonly __typename: 'BatchCustomsFormSummary';
  readonly contentType: Scalars['String'];
  readonly exporterTaxIdSummary: Scalars['String'];
  readonly itemSummary: ReadonlyArray<Scalars['String']>;
  readonly numCustomsForms: Scalars['Int'];
  readonly signer: Scalars['String'];
  readonly title: Scalars['String'];
};

export type BatchPackageSummary = {
  readonly __typename: 'BatchPackageSummary';
  readonly deliveryConfirmationSummary: Scalars['String'];
  readonly dimensionsSummary: Scalars['String'];
  readonly maxInsured: Scalars['Float'];
  readonly maxWeight: Scalars['Float'];
  readonly minInsured: Scalars['Float'];
  readonly minWeight: Scalars['Float'];
  /**
   * The default values the user has entered in our shipment form, they can be overridden by
   * data imported from Spreadsheet or from Integrations for each shipment in the batch
   */
  readonly packagePreset: Maybe<ShipmentPreset>;
  readonly packageTypeSummary: Scalars['String'];
};

export type BatchPriceSummary = {
  readonly __typename: 'BatchPriceSummary';
  readonly averagePrice: Scalars['Float'];
  readonly carrierKeys: ReadonlyArray<Scalars['String']>;
  readonly isRefunded: Scalars['Boolean'];
  readonly isReturnLabel: Scalars['Boolean'];
  readonly pirateShipService: Scalars['Boolean'];
  readonly returnsUsed: Scalars['Int'];
  readonly samePriceForAll: Scalars['Boolean'];
  readonly shipmentCount: Scalars['Int'];
  readonly surcharge: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly totalPrice: Scalars['Float'];
  readonly usedReturnPrice: Scalars['Float'];
};

export type BatchProcess = {
  readonly __typename: 'BatchProcess';
  /** Amount of run items in the process that are finished or currently running */
  readonly itemsInProgressCount: Scalars['Int'];
  /** Total amount of run items in the process (Normally, in a batch process each shipment has one run item) */
  readonly itemsTotalCount: Scalars['Int'];
  readonly key: BatchProcessKey;
  readonly processKey: Scalars['String'];
  readonly progressPercentage: Scalars['Int'];
  readonly progressTitle: Scalars['String'];
  /** Estimated seconds it will take for the process to finish */
  readonly secondsLeft: Scalars['Int'];
  readonly status: Scalars['String'];
};

/** All possible processes on batches of shipments labels */
export type BatchProcessKey = 'BUY_POSTAGE' | 'REFUND' | 'UNKNOWN' | 'VALIDATE_AND_RATE';

/** Enumeration of possible data sources for batches */
export type BatchSource =
  /** Data was manually entered in our single shipment form */
  | 'FORM'
  /** Data was fetched from integration (Orders) */
  | 'INTEGRATION'
  /** Data was uploaded from spreadsheet */
  | 'SPREADSHEET';

export type BatchStatus =
  | 'BILLED'
  | 'ERROR'
  | 'IMPORTED'
  | 'NEW'
  | 'PURCHASING'
  | 'RATED'
  | 'RATING'
  | 'REFUNDED'
  | 'REFUNDING'
  | 'VALIDATED';

export type BatchStatusTag =
  | 'COMPLETE'
  | 'DELIVERED'
  | 'ERROR'
  | 'IDLE'
  | 'IN_TRANSIT'
  | 'PARTIALLY_DELIVERED'
  | 'PARTLY_REFUNDED'
  | 'READY_TO_PRINT'
  | 'READY_TO_SHIP'
  | 'REFUNDED'
  | 'REFUND_FAILED'
  | 'REFUND_PENDING'
  | 'RUNNING';

export type BigcartelChannel = ChannelInterface & {
  readonly __typename: 'BigcartelChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly plan: Scalars['String'];
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type BigcommerceChannel = ChannelInterface & {
  readonly __typename: 'BigcommerceChannel';
  readonly active: Scalars['Boolean'];
  readonly apiUrl: Scalars['String'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type BlockedCountry = {
  readonly __typename: 'BlockedCountry';
  readonly blockReason: Scalars['String'];
  readonly twoCharIsoCode: Scalars['String'];
};

export type BlockedCountryInput = {
  readonly blockReason: Scalars['String'];
  readonly twoCharIsoCode: Scalars['String'];
};

export type Carrier = {
  readonly __typename: 'Carrier';
  readonly allowedPickupDateCutOff: Maybe<Scalars['DateTime']>;
  readonly allowedPickupDates: ReadonlyArray<Scalars['Date']>;
  readonly carrierKey: CarrierKey;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly mailClasses: ReadonlyArray<CarrierMailClass>;
  readonly packageTypes: ReadonlyArray<CarrierPackageType>;
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
};

export type CarrierAllowedPickupDatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type CarrierMailClassesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']>;
};

export type CarrierPackageTypesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};

export type CarrierKey = 'fedex' | 'ups' | 'usps';

export type CarrierMailClass = {
  readonly __typename: 'CarrierMailClass';
  readonly accuracy: Maybe<Scalars['Int']>;
  readonly averageDeliveryDays: Scalars['Float'];
  readonly carrierTitle: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly groupKey: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly international: Scalars['Boolean'];
  readonly mailClassKey: Scalars['String'];
  readonly serviceLevel: Scalars['Int'];
  readonly sortOrder: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
};

export type CarrierPackageType = {
  readonly __typename: 'CarrierPackageType';
  readonly carrierId: Scalars['ID'];
  readonly description: Scalars['String'];
  readonly dimensionsRequired: Scalars['Boolean'];
  readonly heightRequired: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly packageTypeKey: Scalars['String'];
  readonly title: Scalars['String'];
  readonly weightRequired: Scalars['Boolean'];
};

export type Challenge = {
  readonly __typename: 'Challenge';
  readonly action: ChallengeAction;
  readonly createdAt: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly key: ChallengeKey;
};

export type ChallengeAction = 'ACTION_ABORT' | 'ACTION_SUCCESS';

export type ChallengeKey =
  | 'CHALLENGE_ADD_PAYMENT_METHOD'
  | 'CHALLENGE_CONNECT_STORE'
  | 'CHALLENGE_EDIT_TRACKING'
  | 'CHALLENGE_PLAY_SOUNDS'
  | 'CHALLENGE_SHIP_PACKAGE'
  | 'CHALLENGE_VISIT_GENERAL_SETTINGS_PAGE'
  | 'CHALLENGE_VISIT_HELP_GENERAL'
  | 'CHALLENGE_VISIT_HELP_PRINT'
  | 'CHALLENGE_VISIT_RATES_PAGE'
  | 'CHALLENGE_WATCH_VIDEO_GENERAL'
  | 'CHALLENGE_WATCH_VIDEO_V2';

export type ChallengeState = {
  readonly __typename: 'ChallengeState';
  readonly isCompleted: Scalars['Boolean'];
  readonly key: Scalars['String'];
};

export type Channel = ChannelInterface & {
  readonly __typename: 'Channel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type ChannelInterface = {
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type ChannelRubberstampConfig = {
  readonly __typename: 'ChannelRubberstampConfig';
  readonly configuredField: Scalars['String'];
  readonly rubberstamp: Scalars['String'];
};

export type ChannelSync = {
  readonly __typename: 'ChannelSync';
  readonly date: Scalars['DateTime'];
  readonly info: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: LastSyncStatus;
};

export type ChannelUnion =
  | BigcartelChannel
  | BigcommerceChannel
  | CratejoyChannel
  | DiscogsChannel
  | EbayChannel
  | EcwidChannel
  | EtsyChannel
  | FakeshopChannel
  | PaypalChannel
  | ShopifyChannel
  | SquareChannel
  | SquarespaceChannel
  | SubblyChannel
  | WixChannel
  | WoocommerceChannel;

export type Chart = {
  readonly __typename: 'Chart';
  readonly charts: ReadonlyArray<Scalars['Float']>;
  readonly colors: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly labels: ReadonlyArray<Scalars['String']>;
};

export type ClaimInsuranceLinkResult = {
  readonly __typename: 'ClaimInsuranceLinkResult';
  readonly url: Scalars['String'];
};

export type Company = {
  readonly __typename: 'Company';
  readonly accountBalance: Scalars['Float'];
  readonly activeCarriers: ReadonlyArray<CarrierKey>;
  readonly activePaymentMethods: ReadonlyArray<PaymentMethodType>;
  /** Billing Address */
  readonly address: Address;
  readonly channels: ReadonlyArray<ChannelUnion>;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly debuggingEnabled: Scalars['Boolean'];
  readonly email: Scalars['String'];
  readonly emulating: Scalars['Boolean'];
  readonly features: ReadonlyArray<Feature>;
  readonly fraudScore: Scalars['Int'];
  readonly fraudStatus: Scalars['String'];
  readonly hasAnyPlaidPaymentSource: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isFirstLabel: Scalars['Boolean'];
  readonly isSuspended: Scalars['Boolean'];
  readonly mailTemplates: ReadonlyArray<MailTemplate>;
  readonly merchantAccounts: ReadonlyArray<MerchantAccount>;
  readonly paymentSources: ReadonlyArray<PaymentSource>;
  readonly phone: Scalars['String'];
  /**
   * Summarize the shipments created with the specified carrier for the specified ship date (postmark date)
   * of today (in the company's time zone) or greater.
   */
  readonly pickupSummary: ShipmentSummary;
  readonly pickups: ReadonlyArray<PickupRequest>;
  /** The address we want to use for merchant accounts for the specified carrier */
  readonly preferredMerchantAccountAddress: Address;
  readonly settings: CompanySettings;
  readonly shipmentPresets: ReadonlyArray<ShipmentPreset>;
  /**
   * Summarize the shipments created with the specified carrier in the specified time range for the current company
   * The dates can also include a time.
   * If they do not include a time, the range will be from the start of the $startDate to the end of the $endDate
   * by default
   */
  readonly shipmentSummary: ShipmentSummary;
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly warehouses: ReadonlyArray<Warehouse>;
};

export type CompanyChannelsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  onlyActiveAndValid?: InputMaybe<Scalars['Boolean']>;
  platformKey?: InputMaybe<Scalars['String']>;
};

export type CompanyMailTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CompanyPickupSummaryArgs = {
  carrierKey: CarrierKey;
};

export type CompanyPickupsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CompanyPreferredMerchantAccountAddressArgs = {
  carrierKey: CarrierKey;
};

export type CompanyShipmentPresetsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CompanyShipmentSummaryArgs = {
  carrierKey: CarrierKey;
  endDate: Scalars['DateTime'];
  includeFullEndDate?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

export type CompanyWarehousesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  withScanFormsAvailable?: InputMaybe<Scalars['Boolean']>;
};

export type CompanySettings = {
  readonly __typename: 'CompanySettings';
  readonly addressCorrection: Scalars['String'];
  readonly areMobileCodesEnabled: Scalars['Boolean'];
  readonly defaultChargeAmount: Scalars['Int'];
  readonly defaultDestinationCountryCode: Scalars['String'];
  readonly defaultEmailTemplateId: Scalars['ID'];
  readonly defaultPaymentSourceId: Scalars['ID'];
  readonly defaultShipmentPresetId: Scalars['ID'];
  readonly defaultTrackingEmailsDelay: Scalars['String'];
  readonly defaultTrackingEmailsEnabled: Scalars['Boolean'];
  readonly defaultWarehouseId: Scalars['ID'];
  readonly packingListTemplate: Scalars['String'];
  readonly shipmentLabelFileFormat: Scalars['String'];
  readonly shipmentLabelFormat: Scalars['String'];
  readonly shipmentLabelSize: Scalars['String'];
  readonly shipmentSpreadsheetFormat: Scalars['String'];
  readonly showLogoOnLabel: Scalars['Boolean'];
  readonly trackingEmailBrandingEnabled: Scalars['Boolean'];
};

export type CompanyUser = {
  readonly __typename: 'CompanyUser';
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly status: Status;
};

export type Country = {
  readonly __typename: 'Country';
  readonly id: Scalars['ID'];
  readonly isoAlpha2Code: Scalars['String'];
  readonly isoAlpha3Code: Scalars['String'];
  /** @deprecated Use getIsoAlpha2Code instead */
  readonly isoNumericCode: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly parentCountry: Maybe<Country>;
  readonly postcodeRequired: Scalars['Boolean'];
};

export type CountryDistributionChart = {
  readonly __typename: 'CountryDistributionChart';
  readonly countryDistributions: ReadonlyArray<DistributionChartItem>;
  readonly totalCount: Scalars['Int'];
};

export type CratejoyChannel = ChannelInterface & {
  readonly __typename: 'CratejoyChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientId: Scalars['String'];
  readonly clientSecret: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly skipFutureSubscriptions: Scalars['Boolean'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type CreateBigcommerceChannelInput = {
  readonly apiUrl: Scalars['String'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type CreateCratejoyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientId: Scalars['String'];
  readonly clientSecret: Scalars['String'];
  readonly skipFutureSubscriptions: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type CreateDiscogsChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type CreateFakeshopChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly orderGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title: Scalars['String'];
};

export type CreatePaymentSourceResponse = {
  readonly __typename: 'CreatePaymentSourceResponse';
  readonly isDefault: Scalars['Boolean'];
  readonly paymentSource: PaymentSource;
};

export type CreatePaymentSourceResult = {
  readonly __typename: 'CreatePaymentSourceResult';
  readonly default: Scalars['Boolean'];
  readonly paymentSource: PaymentSource;
};

export type CreateShipmentPresetResult = {
  readonly __typename: 'CreateShipmentPresetResult';
  readonly default: Scalars['Boolean'];
  readonly shipmentPreset: ShipmentPreset;
};

export type CreateSquarespaceChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type CreateSubblyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type CustomOption = {
  readonly __typename: 'CustomOption';
  readonly channelId: Scalars['Int'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly override: Scalars['String'];
  readonly sourceKey: Scalars['String'];
  readonly status: CustomOptionStatus;
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valueType: CustomOptionValue;
};

export type CustomOptionStatus = 'DEFAULT' | 'IGNORE' | 'OVERRIDE';

export type CustomOptionValue =
  | 'TYPE_DATE'
  | 'TYPE_DATETIME'
  | 'TYPE_NUMBER'
  | 'TYPE_OPTION'
  | 'TYPE_PARAGRAPH'
  | 'TYPE_TEXT';

export type CustomsItem = {
  readonly __typename: 'CustomsItem';
  readonly countryCodeOfOrigin: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly hsTariffNumber: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly itemValue: Scalars['Float'];
  readonly quantity: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly weight: Scalars['Float'];
};

export type CustomsItemInput = {
  readonly countryCodeOfOrigin: Scalars['String'];
  readonly hsTariffNumber: Scalars['String'];
  readonly itemValue: Scalars['Float'];
  readonly quantity: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type DataGridColumn = {
  readonly __typename: 'DataGridColumn';
  readonly alternativeSortingField: Maybe<Scalars['String']>;
  readonly exactMatch: Scalars['Boolean'];
  readonly field: Scalars['String'];
  readonly hidden: Scalars['Boolean'];
  readonly label: Scalars['String'];
  readonly multiCheck: Scalars['Boolean'];
  readonly sortable: Scalars['Boolean'];
  readonly type: Scalars['String'];
  readonly width: Maybe<Scalars['Int']>;
};

export type DataGridColumnOverride = {
  readonly __typename: 'DataGridColumnOverride';
  readonly field: Scalars['String'];
  readonly hidden: Scalars['Boolean'];
  readonly width: Scalars['Int'];
};

export type DataGridColumnOverrideInput = {
  readonly field: Scalars['String'];
  readonly hidden: Scalars['Boolean'];
  readonly width: Scalars['Int'];
};

export type DataGridExportStatus = {
  readonly __typename: 'DataGridExportStatus';
  readonly downloadable: Scalars['Boolean'];
  /** How much time is left until the token for the export expires in milliseconds */
  readonly expire: Scalars['Int'];
  readonly exportId: Scalars['Int'];
  readonly filename: Scalars['String'];
  readonly url: Maybe<Scalars['String']>;
};

export type DataGridFilter = {
  readonly __typename: 'DataGridFilter';
  readonly field: Scalars['String'];
  readonly operator: Scalars['String'];
  readonly values: ReadonlyArray<Scalars['String']>;
};

export type DataGridFilterInput = {
  readonly field: Scalars['String'];
  readonly operator: Scalars['String'];
  readonly values: ReadonlyArray<Scalars['String']>;
};

export type DataGridFilterOption = {
  readonly __typename: 'DataGridFilterOption';
  readonly count: Scalars['Int'];
  readonly disabled: Scalars['Boolean'];
  readonly label: Scalars['String'];
  readonly value: Scalars['String'];
};

export type DataGridMetaData = {
  readonly __typename: 'DataGridMetaData';
  readonly key: Scalars['String'];
  readonly value: Scalars['String'];
};

export type DataGridResult = {
  readonly __typename: 'DataGridResult';
  /** Grid column definition. */
  readonly columns: ReadonlyArray<DataGridColumn>;
  /** Whether to show an export button. */
  readonly exportAllowed: Scalars['Boolean'];
  /**
   * Starts the creation of an export file. If there is no exportId specified,
   * returns the status of the export file, the URL where it can be downloaded and the exportId
   * (if it is a large amount of data, the file might not be immediately downloadable).
   * Specify an exportId to check the status of a previously requested export file.
   */
  readonly exportUrl: DataGridExportStatus;
  /** Whether to show a refund button. */
  readonly gridActions: ReadonlyArray<DataGridRowAction>;
  /** Grid ID to use when saving state. */
  readonly id: Scalars['ID'];
  /** Whether to use filter settings stored locally in the browser instead of the server-defined static filters. */
  readonly localFiltersEnabled: Scalars['Boolean'];
  /** Maximum number of rows per page allowed. */
  readonly maxPageSize: Scalars['Int'];
  readonly metaData: ReadonlyArray<DataGridMetaData>;
  /**
   * Returns a distinct set of values for a given field using a defined set of filters and search term. Use to provide
   * multi-check capability resulting in a includes-filter.
   */
  readonly multiCheckOptions: ReadonlyArray<DataGridFilterOption>;
  /** Row actions define a set of per-row buttons that need their click event mapped in the client. */
  readonly rowActions: Maybe<ReadonlyArray<DataGridRowAction>>;
  /** Grid rows and related information. */
  readonly rows: DataGridResultRows;
  /** Default filters the grid must be initialized with. */
  readonly staticFilters: ReadonlyArray<DataGridFilter>;
  /** Persisted per-user grid settings. */
  readonly userSettings: Maybe<DataGridSettings>;
};

export type DataGridResultExportUrlArgs = {
  columns?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  exportId?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<ReadonlyArray<DataGridFilterInput>>;
  ids?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<ReadonlyArray<DataGridSortingInput>>;
};

export type DataGridResultMultiCheckOptionsArgs = {
  filters?: InputMaybe<ReadonlyArray<DataGridFilterInput>>;
  groupByField: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type DataGridResultRowsArgs = {
  filters?: InputMaybe<ReadonlyArray<DataGridFilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<ReadonlyArray<DataGridSortingInput>>;
};

export type DataGridResultUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type DataGridResultRows = {
  readonly __typename: 'DataGridResultRows';
  /** Checkable IDs of all pages */
  readonly checkableIds: ReadonlyArray<Scalars['ID']>;
  /** Untyped key-value data with keys in snake_case format matching the column definition. */
  readonly nodes: ReadonlyArray<Scalars['JSONObject']>;
  /** Total count of matching rows. */
  readonly totalCount: Scalars['Int'];
};

export type DataGridRowAction = {
  readonly __typename: 'DataGridRowAction';
  readonly fullWidth: Scalars['Boolean'];
  /** ID used for mapping. */
  readonly id: Maybe<Scalars['ID']>;
  /** Button label. */
  readonly label: Scalars['String'];
  /** Button variant. */
  readonly variant: Scalars['String'];
};

export type DataGridSettings = {
  readonly __typename: 'DataGridSettings';
  readonly columnOrder: ReadonlyArray<Scalars['String']>;
  readonly columns: ReadonlyArray<DataGridColumnOverride>;
  readonly pageSize: Scalars['Int'];
  readonly sorting: ReadonlyArray<DataGridSorting>;
};

export type DataGridSettingsInput = {
  readonly columnOrder: ReadonlyArray<Scalars['String']>;
  readonly columns: ReadonlyArray<DataGridColumnOverrideInput>;
  readonly pageSize: Scalars['Int'];
  readonly sorting: ReadonlyArray<DataGridSortingInput>;
};

export type DataGridSorting = {
  readonly __typename: 'DataGridSorting';
  readonly direction: Scalars['String'];
  readonly field: Scalars['String'];
};

export type DataGridSortingInput = {
  readonly direction: Scalars['String'];
  readonly field: Scalars['String'];
};

export type DateTimeRange = {
  readonly __typename: 'DateTimeRange';
  readonly endDatetime: Scalars['DateTime'];
  readonly startDatetime: Scalars['DateTime'];
};

export type DatetimeRangeInput = {
  readonly endDatetime: Scalars['String'];
  readonly startDatetime: Scalars['String'];
};

export type DeliveryConfirmation = 'adult_signature' | 'direct_signature' | 'none' | 'signature';

export type DeliveryEstimation = {
  readonly __typename: 'DeliveryEstimation';
  readonly arrivalLocalDateTime: Maybe<Scalars['DateTime']>;
  readonly pickupLocalDateTime: Maybe<Scalars['DateTime']>;
};

export type DiscogsChannel = ChannelInterface & {
  readonly __typename: 'DiscogsChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type DisputeStatus =
  | 'DISPUTE_APPROVED'
  | 'DISPUTE_DENIED'
  | 'DISPUTE_PENDING'
  | 'UNDISPUTED';

export type DistributionChartItem = {
  readonly __typename: 'DistributionChartItem';
  readonly count: Scalars['String'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
  readonly percent: Scalars['Float'];
  readonly price: Scalars['Float'];
};

export type DockOrder = AddressInterface &
  BasicAddressInterface & {
    readonly __typename: 'DockOrder';
    /** Address line 1 */
    readonly address1: Scalars['String'];
    /** Address line 2 */
    readonly address2: Scalars['String'];
    /** Address line 3 */
    readonly address3: Scalars['String'];
    /** This is the record type from SmartyStreets */
    readonly addressType: Scalars['String'];
    /** Channel ID this order belongs to */
    readonly channelId: Scalars['Int'];
    /** City */
    readonly city: Scalars['String'];
    /** Company name */
    readonly company: Scalars['String'];
    readonly countryCode: Scalars['String'];
    /** Country ID (e.g., "US", "CA") */
    readonly countryId: Scalars['String'];
    /** Coupon code */
    readonly coupon: Scalars['String'];
    /** Email address */
    readonly email: Scalars['String'];
    /** Foreign order ID from the platform */
    readonly foreignOrderId: Scalars['String'];
    /** Recipient's full name */
    readonly fullName: Scalars['String'];
    readonly id: Scalars['ID'];
    readonly location: Location;
    /** Order items as comma-separated text */
    readonly orderItemsText: Scalars['String'];
    /** Link to the order on the external platform */
    readonly orderLink: Maybe<Link>;
    /** Order value in dollars */
    readonly orderValue: Scalars['Float'];
    readonly origin: Scalars['Boolean'];
    readonly originalId: Maybe<Scalars['ID']>;
    /** Phone number */
    readonly phone: Scalars['String'];
    /** The platform this order was imported from */
    readonly platform: Maybe<Platform>;
    /** Platform key (e.g., "shopify", "woocommerce") */
    readonly platformKey: Scalars['String'];
    /** Links to view this order on the external platform (order, subscription, shipment) */
    readonly platformLinks: ReadonlyArray<PlatformLink>;
    readonly poBox: Scalars['Boolean'];
    /** Postal code / ZIP code */
    readonly postcode: Scalars['String'];
    readonly regionCode: Scalars['String'];
    /** Region/State ID */
    readonly regionId: Scalars['String'];
    readonly residential: Scalars['Boolean'];
    /** Rubber stamp 1 (US orders only) */
    readonly rubberStamp1: Scalars['String'];
    /** Rubber stamp 2 (US orders only) */
    readonly rubberStamp2: Scalars['String'];
    /** Rubber stamp 3 (US orders only) */
    readonly rubberStamp3: Scalars['String'];
    /** Link to the shipment on the external platform */
    readonly shipmentLink: Maybe<Link>;
    /** Link to the subscription on the external platform */
    readonly subscriptionLink: Maybe<Link>;
    readonly timeZone: Scalars['String'];
    readonly valid: Scalars['Boolean'];
    readonly validationError: Scalars['String'];
    readonly warehouse: Maybe<Warehouse>;
    /** Order weight in ounces */
    readonly weight: Scalars['Float'];
    readonly zip4: Scalars['String'];
  };

export type DownloadStatus = 'ERROR' | 'FINISHED' | 'IDLE' | 'RUNNING';

export type EbayChannel = ChannelInterface & {
  readonly __typename: 'EbayChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type EcwidChannel = ChannelInterface & {
  readonly __typename: 'EcwidChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customFulfillmentStatuses: ReadonlyArray<EcwidOrderStatus>;
  readonly customFulfillmentStatusesToImport: ReadonlyArray<Scalars['String']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly customPaymentStatuses: ReadonlyArray<EcwidOrderStatus>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly username: Scalars['String'];
  readonly valid: Scalars['Boolean'];
};

export type EcwidOrderStatus = {
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
};

export type EcwidOrderStatusImpl = EcwidOrderStatus & {
  readonly __typename: 'EcwidOrderStatusImpl';
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
};

export type EmailTemplate = {
  readonly __typename: 'EmailTemplate';
  readonly html: Scalars['String'];
  readonly plainText: Scalars['String'];
  readonly subject: Scalars['String'];
};

/** Enumeration of email verification statuses */
export type EmailVerificationStatus = 'CONFIRMED' | 'NOT_SENT' | 'NOT_SUPPORTED' | 'PENDING';

export type EtsyChannel = ChannelInterface & {
  readonly __typename: 'EtsyChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type FakeshopChannel = ChannelInterface & {
  readonly __typename: 'FakeshopChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly orderGroups: ReadonlyArray<Scalars['String']>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type Feature = {
  readonly __typename: 'Feature';
  readonly key: Scalars['String'];
  readonly value: Scalars['Boolean'];
};

export type FileFormat = 'PDF' | 'PNG' | 'ZPL';

export type FlashMessage = {
  readonly __typename: 'FlashMessage';
  readonly message: Scalars['String'];
  readonly variant: FlashMessageVariant;
};

export type FlashMessageVariant = 'DANGER' | 'INFO' | 'SUCCESS' | 'WARNING';

export type Funding =
  | 'CHARGE'
  | 'CREDIT'
  | 'DEBIT'
  | 'DEFERRED_DEBIT'
  | 'PREPAID'
  | 'PREPAID_RELOADABLE'
  | 'UNKNOWN';

export type GlobalSettings = {
  readonly __typename: 'GlobalSettings';
  readonly emailTemplate: EmailTemplate;
};

export type GridMode = 'DEFAULT' | 'IGNORED';

export type HistoricShipmentAddress = BasicAddressInterface & {
  readonly __typename: 'HistoricShipmentAddress';
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly email: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly ids: Scalars['ID'];
  readonly phone: Scalars['String'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly residential: Scalars['Boolean'];
  readonly valid: Scalars['Boolean'];
  readonly zip4: Scalars['String'];
};

export type HistoricShipmentAddressSearchField = 'COMPANY' | 'EMAIL' | 'FULL_NAME';

export type IgnoreOrderResult = {
  readonly __typename: 'IgnoreOrderResult';
  readonly count: Scalars['Int'];
  readonly ids: ReadonlyArray<Scalars['ID']>;
  readonly success: Scalars['Boolean'];
};

export type InstallTwoFactorAuthenticationResultType = {
  readonly __typename: 'InstallTwoFactorAuthenticationResultType';
  readonly secret: Maybe<SecretType>;
  readonly user: User;
};

export type InsuranceDetailsType = {
  readonly __typename: 'InsuranceDetailsType';
  /** Important Note: we generally have different types of possible insurance scenarios. */
  readonly hasOnlyCarrierLiabilityInsurance: Scalars['Boolean'];
  readonly insuranceSurcharge: Maybe<ShipmentPrice>;
  readonly insuredValue: Scalars['Float'];
  readonly insuredValueRequested: Scalars['Float'];
  readonly insuredValueType: InsuredValueType;
  readonly isShippingCostInsured: Scalars['Boolean'];
};

export type InsuredValueType =
  | 'INSURESHIELD'
  | 'NONE'
  | 'PIRATE_SHIP'
  | 'SHIPSURANCE'
  | 'UPS'
  | 'USPS';

export type InterceptOptionsType = {
  readonly __typename: 'InterceptOptionsType';
  readonly canRedirectToNewAddress: Scalars['Boolean'];
  readonly canReturnToSender: Scalars['Boolean'];
};

export type InterceptPriceType = {
  readonly __typename: 'InterceptPriceType';
  readonly chargeCurrency: Scalars['String'];
  readonly interceptCharge: Scalars['Int'];
  readonly totalCharge: Scalars['Int'];
};

export type LabelSize = 'SIZE_2x7' | 'SIZE_4x6';

export type LabelingArtifactType = 'LABEL' | 'MOBILE_CODE';

export type LabelsType = {
  readonly __typename: 'LabelsType';
  readonly fileFormat: Maybe<FileFormat>;
  readonly id: Scalars['ID'];
  readonly pageLayout: Maybe<PageLayout>;
  readonly status: DownloadStatus;
  readonly url: Maybe<Scalars['String']>;
};

export type LastSyncStatus = 'ERROR' | 'SUCCESS';

export type Link = {
  readonly __typename: 'Link';
  readonly text: Scalars['String'];
  readonly url: Scalars['String'];
};

export type Location = {
  readonly __typename: 'Location';
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

export type MailClassCount = {
  readonly __typename: 'MailClassCount';
  readonly mailClass: CarrierMailClass;
  readonly shipmentCount: Scalars['Int'];
};

export type MailClassRateInput = {
  readonly mailClassGroup: Scalars['String'];
  readonly price: Scalars['Float'];
};

export type MailTemplate = {
  readonly __typename: 'MailTemplate';
  readonly asDefault: Scalars['Boolean'];
  readonly bccEmail: Scalars['String'];
  readonly companyId: Scalars['ID'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly replyToEmail: Scalars['String'];
  readonly senderEmail: Scalars['String'];
  readonly senderName: Scalars['String'];
  readonly subject: Scalars['String'];
  readonly templateHtml: Scalars['String'];
  readonly templateText: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly userId: Scalars['ID'];
};

export type MappableShipmentField = {
  readonly __typename: 'MappableShipmentField';
  readonly key: ShipmentKey;
  /** If null, there is no limit */
  readonly maxMappings: Maybe<Scalars['Int']>;
  readonly required: Maybe<Scalars['Int']>;
  readonly title: Scalars['String'];
};

/** Enum constants listing all possible payment strategy names. */
export type Mel_Payment_Enum_StrategyName =
  /**
   * Authorization on payment creation and charge (aka capture) at payment completion (which might happen sometime
   * later than creation)
   */
  | 'AUTH_AND_CAPTURE'
  /**
   * Payments stay in pending state, until the amount and/or time threshold is reached, at which point a group
   * payment is created that is used to charge the sum of all pending payment's amounts in one go.
   */
  | 'CONSOLIDATION';

export type Mel_Pp_Model_Shipment_TrackingStatus =
  | 'AVAILABLE_FOR_PICKUP'
  | 'CUSTOMER_RECALL'
  | 'DEAD_LETTER'
  | 'DELIVERED'
  | 'DELIVERY_STATUS_NOT_UPDATED'
  | 'FORWARD'
  | 'NEW_ITEM'
  | 'NOTICE'
  | 'NOT_FOUND'
  | 'OTHER'
  | 'OUT_FOR_DELIVERY'
  | 'REFUNDED'
  | 'RETURNED_TO_SENDER'
  | 'SCANNED'
  | 'UNDELIVERABLE'
  | 'UNKNOWN';

export type MerchantAccount = {
  readonly __typename: 'MerchantAccount';
  readonly accountStatus: Maybe<MerchantAccountTransmissionStatus>;
  readonly carrierKey: CarrierKey;
  readonly errorCategory: Maybe<MerchantAccountErrorCategory>;
  readonly errorMessage: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly termsAndConditionsLastAcceptedAt: Maybe<Scalars['DateTime']>;
  readonly termsAndConditionsOutdated: Scalars['Boolean'];
};

export type MerchantAccountErrorCategory =
  | 'ADDRESS_IS_PO_BOX'
  | 'BILLING_ADDRESS'
  | 'DUPLICATE'
  | 'EMAIL'
  | 'INVALID_NAME'
  | 'INVALID_PHONE_NUMBER'
  | 'INVALID_STREET_OR_STATE_OR_POSTCODE'
  | 'MAINTENANCE'
  | 'MILITARY_ADDRESS'
  | 'NAME_OR_COMPANY_MISSING'
  | 'OTHER'
  | 'OUTAGE';

export type MerchantAccountTransmissionStatus = 'NOT_TRANSMITTED' | 'OK' | 'TRANSMISSION_ERROR';

export type Mutation = {
  readonly __typename: 'Mutation';
  readonly abortChallenge: ChallengeState;
  readonly acceptTerms: User;
  readonly addCreditToPaymentSource: Company;
  readonly buyBatch: Batch;
  readonly buyRedirectPackageToNewAddress: Scalars['Boolean'];
  readonly buyReturnPackageToSender: Scalars['Boolean'];
  /** Cancel email notifications for all recipients of the batch */
  readonly cancelEmailNotification: Batch;
  readonly cancelPickup: PickupRequest;
  readonly channelAutoSync: Scalars['Boolean'];
  readonly completeBatchFromUpload: Batch;
  readonly confirmTwoFactorAuthenticationProvider: User;
  readonly connectWoocommerceChannel: Scalars['String'];
  readonly consumeGtmEvents: ReadonlyArray<Scalars['JSONObject']>;
  readonly consumeMessages: ReadonlyArray<FlashMessage>;
  /** Create a batch from imported orders (from integrations like Shopify, WooCommerce, etc.) */
  readonly createBatchFromImport: Batch;
  readonly createBatchFromSingleShipment: Batch;
  /**
   * Create a new batch of shipments from a previously uploaded spreadsheet.
   * If a batch for this upload already exists, the existing batch will be returned with updated mapping.
   * This will only create a minimal batch with the info we already have from the upload. To be able to rate and buy
   * this batch, you need to also call completeBatchFromUpload and provide additional info: a warehouse for
   * origin/return address and a preset for package weight/dimensions, extra services etc. Only then can we determine
   * an initial ship date, create shipments and start a rating process.
   */
  readonly createBatchFromUpload: Batch;
  readonly createBigcommerceChannel: BigcommerceChannel;
  readonly createCcPaymentSource: CreatePaymentSourceResponse;
  readonly createCratejoyChannel: CratejoyChannel;
  readonly createDiscogsChannel: DiscogsChannel;
  readonly createFakeshopChannel: FakeshopChannel;
  readonly createMailTemplate: MailTemplate;
  readonly createMappings: ChannelUnion;
  readonly createOfflinePaymentSource: CreatePaymentSourceResponse;
  /** Update the UPS Merchant Account with the current billing address of the company */
  readonly createOrUpdateUpsMerchantAccount: MerchantAccount;
  readonly createPayPalPaymentSource: CreatePaymentSourceResponse;
  readonly createPlaidAccessToken: PlaidActivation;
  readonly createPlaidActivation: PlaidActivation;
  readonly createPlaidConsent: CreatePaymentSourceResponse;
  readonly createPlaidValidationActivation: PlaidActivation;
  readonly createScanForm: ScanFormResult;
  readonly createScanFormByBatch: PossibleScanFormResult;
  readonly createScopedShipmentPreset: ShipmentPreset;
  /** This mutation also triggers sending of a confirmation mail via Postmark. */
  readonly createSenderEmailMetadata: Maybe<SenderEmailMetadata>;
  readonly createShipmentPreset: CreateShipmentPresetResult;
  readonly createSquarespaceChannel: SquarespaceChannel;
  readonly createSubblyChannel: SubblyChannel;
  /** Add a batch to the database. By default, it will include two shipments and one of them will be international */
  readonly createTestBatch: Batch;
  /**
   * Add a purchased shipment to the database, all unspecified parameters will get default values, so you will
   * always receive a shipment with all related data, that can be used to go directly to Rate or Buy Page
   * The used rate data is fake, so please don't rely on the prices on the Buy Page
   */
  readonly createTestShipment: Shipment;
  /**
   * Add a shipment to the database with fixture data (can be exported from live on the shipment page)
   * The ship date will be moved to today.
   */
  readonly createTestShipmentFromFixture: Shipment;
  readonly createUser: CompanyUser;
  /** Update the USPS Merchant Account with the current billing address of the company */
  readonly createUspsMerchantAccount: MerchantAccount;
  readonly createVenmoPaymentSource: CreatePaymentSourceResponse;
  readonly createWarehouse: Warehouse;
  readonly deleteBatch: Batch;
  readonly deleteChannel: ChannelUnion;
  readonly deleteMailTemplate: MailTemplate;
  readonly deletePaymentSource: PaymentSource;
  readonly deleteShipmentPreset: ShipmentPreset;
  readonly deleteSuggestedAddress: Scalars['Boolean'];
  readonly deleteTestBatch: Scalars['Boolean'];
  readonly deleteTwoFactorAuthenticationProvider: User;
  readonly deleteUser: CompanyUser;
  readonly deleteWarehouse: Warehouse;
  readonly disableChannel: ChannelUnion;
  readonly disablePlaidPromotionForCurrentCompany: Maybe<Scalars['Void']>;
  readonly disputeAdjustments: ReadonlyArray<ReconciliationAdjustment>;
  readonly downloadMobileCodeForShipment: ShipmentMobileCode;
  readonly downloadMobileCodesForBatch: ReadonlyArray<ShipmentMobileCode>;
  readonly emulateViaShipment: Scalars['Boolean'];
  readonly enableChannel: ChannelUnion;
  readonly fetchSenderEmailMetadata: SenderEmailMetadata;
  readonly fetchShipmentStageDots: ReadonlyArray<StageDot>;
  readonly generateJumioWebClientUrl: Scalars['String'];
  readonly generateOrGetShareLink: Scalars['String'];
  readonly hideHistoricShipmentAddresses: Maybe<Scalars['Void']>;
  readonly ignoreOrders: IgnoreOrderResult;
  readonly installTwoFactorAuthenticationProvider: InstallTwoFactorAuthenticationResultType;
  readonly markJumioFlowAsDismissed: Maybe<Scalars['Void']>;
  readonly markJumioFlowAsFinished: Maybe<Scalars['Void']>;
  /** @deprecated In the future we use downloadMobileCodesForBatch instead so as to not have the uri be inside the Shipment Type. */
  readonly markMobileCodeBatchAsDownloaded: Batch;
  /** @deprecated Will be replaced with downloadMobileCodeForShipment, which will do more than just mark it. */
  readonly markMobileCodeShipmentAsDownloaded: Shipment;
  readonly modifyInsuranceOnRatedBatch: Batch;
  readonly provideCode: Scalars['Boolean'];
  readonly ratePickup: PickupRateResult;
  /**
   * Will start a background process that will refund all shipments in the batch
   * Poll the status on the Shipments to see the result
   */
  readonly refundBatch: Batch;
  readonly refundCreditFromPaymentSource: Company;
  readonly refundShipment: Batch;
  readonly requestPickup: PickupRequest;
  /** Trigger a new Rating of the Batch in the Background (will return before the process is finished) */
  readonly rerateBatch: Batch;
  readonly resendUserInvitation: CompanyUser;
  readonly resetNickname: Maybe<Scalars['Void']>;
  readonly sendConfirmationMail: SenderEmailMetadata;
  readonly sendEmail: Scalars['String'];
  readonly sendResetPasswordLink: Scalars['String'];
  readonly sendUserEmailVerificationLink: Scalars['Boolean'];
  readonly setBatchToNew: Batch;
  readonly setDefaultPaymentSource: PaymentSource;
  readonly setDefaultWarehouse: Warehouse;
  readonly setNickname: Maybe<Scalars['Void']>;
  readonly setShipmentUploadMapping: ShipmentUpload;
  readonly succeedAtChallenge: ChallengeState;
  readonly triggerChannelSync: Scalars['Boolean'];
  readonly triggerLabelCreationByBatches: Scalars['ID'];
  readonly triggerLabelCreationByShareToken: Scalars['ID'];
  readonly triggerLabelCreationByShipments: Scalars['ID'];
  readonly unignoreOrders: IgnoreOrderResult;
  readonly updateAccountEmail: User;
  readonly updateAccountProfile: User;
  readonly updateBatchTitle: Batch;
  readonly updateBigcartelChannel: BigcartelChannel;
  readonly updateBigcommerceChannel: BigcommerceChannel;
  readonly updateBillingAddress: Address;
  readonly updateBlockedCountries: ReadonlyArray<BlockedCountry>;
  readonly updateChargeAmount: Scalars['Int'];
  readonly updateCratejoyChannel: CratejoyChannel;
  readonly updateDataGridUserSettings: DataGridSettings;
  readonly updateDefaultTrackingEmailsDelay: Scalars['String'];
  readonly updateDefaultTrackingEmailsEnabled: Scalars['Boolean'];
  readonly updateDiscogsChannel: DiscogsChannel;
  readonly updateEbayChannel: EbayChannel;
  readonly updateEcwidChannel: EcwidChannel;
  /** Change email notification date time and template for all recipients of the batch */
  readonly updateEmailNotification: Batch;
  readonly updateEtsyChannel: EtsyChannel;
  readonly updateFakeshopChannel: FakeshopChannel;
  readonly updateGeneralSettings: Scalars['Boolean'];
  readonly updateMailTemplate: MailTemplate;
  readonly updateNotificationsSettings: NotificationsSettings;
  readonly updatePaypalChannel: PaypalChannel;
  /**
   * Update the address that should be used for the merchant account when it is submitted to the carrier
   * This does not submit the address to the carrier, it is just storing the address in the account for all later
   * submits! It is only meant for unsubmitted accounts, not to update already submitted accounts.
   */
  readonly updatePreferredUpsMerchantAccountAddress: Address;
  readonly updateRateGroupSortOrder: User;
  readonly updateSenderEmailMetadata: SenderEmailMetadata;
  readonly updateShipmentPreset: UpdateShipmentPresetResult;
  readonly updateShopifyChannel: ShopifyChannel;
  readonly updateSquareChannel: SquareChannel;
  readonly updateSquarespaceChannel: SquarespaceChannel;
  readonly updateSubblyChannel: SubblyChannel;
  readonly updateTrackingEmailBrandingEnabled: Scalars['Boolean'];
  readonly updateWarehouse: Warehouse;
  readonly updateWixChannel: WixChannel;
  readonly updateWoocommerceChannel: WoocommerceChannel;
};

export type MutationAbortChallengeArgs = {
  key: Scalars['String'];
};

export type MutationAcceptTermsArgs = {
  accepted: Scalars['Boolean'];
};

export type MutationAddCreditToPaymentSourceArgs = {
  addCreditAmount: Scalars['Float'];
  paymentSourceId: Scalars['ID'];
};

export type MutationBuyBatchArgs = {
  id: Scalars['ID'];
  mailTemplateId?: InputMaybe<Scalars['ID']>;
  notifyRecipientsDate?: InputMaybe<Scalars['String']>;
  paymentSourceId: Scalars['ID'];
  rateSelection: ReadonlyArray<RateSelectionInput>;
  shipDate: Scalars['DateTime'];
  totalCharge: Scalars['Float'];
};

export type MutationBuyRedirectPackageToNewAddressArgs = {
  trackingId: Scalars['String'];
};

export type MutationBuyReturnPackageToSenderArgs = {
  trackingId: Scalars['String'];
};

export type MutationCancelEmailNotificationArgs = {
  id: Scalars['ID'];
};

export type MutationCancelPickupArgs = {
  id: Scalars['ID'];
};

export type MutationCompleteBatchFromUploadArgs = {
  batchId: Scalars['ID'];
  batchTitle: Scalars['String'];
  shipmentPresetId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

export type MutationConfirmTwoFactorAuthenticationProviderArgs = {
  code: Scalars['String'];
  provider: Provider;
};

export type MutationConnectWoocommerceChannelArgs = {
  shopUrl: Scalars['String'];
};

export type MutationCreateBatchFromImportArgs = {
  orderIds: ReadonlyArray<Scalars['ID']>;
  overrideMultiple: Scalars['Boolean'];
  shipmentPresetId: Scalars['ID'];
  title: Scalars['String'];
  warehouseId: Scalars['ID'];
};

export type MutationCreateBatchFromSingleShipmentArgs = {
  rubberStamps: RubberStampsInput;
  shipToAddress: RecipientAddressInput;
  shipmentPresetId: Scalars['ID'];
  skipCorrection?: InputMaybe<Scalars['Boolean']>;
  validatedAddressId?: InputMaybe<Scalars['ID']>;
  warehouseId: Scalars['ID'];
};

export type MutationCreateBatchFromUploadArgs = {
  mapping: ReadonlyArray<ShipmentMappingInput>;
  uploadId: Scalars['ID'];
};

export type MutationCreateBigcommerceChannelArgs = {
  input: CreateBigcommerceChannelInput;
};

export type MutationCreateCcPaymentSourceArgs = {
  ccReference: Scalars['String'];
  cp: Scalars['Boolean'];
};

export type MutationCreateCratejoyChannelArgs = {
  input: CreateCratejoyChannelInput;
};

export type MutationCreateDiscogsChannelArgs = {
  input: CreateDiscogsChannelInput;
};

export type MutationCreateFakeshopChannelArgs = {
  input: CreateFakeshopChannelInput;
};

export type MutationCreateMailTemplateArgs = {
  asDefault: Scalars['Boolean'];
  bccEmail?: InputMaybe<Scalars['String']>;
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
  templateHtml: Scalars['String'];
  title: Scalars['String'];
};

export type MutationCreateMappingsArgs = {
  additionalMapping?: ReadonlyArray<AdditionalMappingInput>;
  channelId: Scalars['ID'];
  rubberStamp1?: InputMaybe<Scalars['String']>;
  rubberStamp2?: InputMaybe<Scalars['String']>;
  rubberStamp3?: InputMaybe<Scalars['String']>;
};

export type MutationCreatePayPalPaymentSourceArgs = {
  nonce: Scalars['String'];
};

export type MutationCreatePlaidAccessTokenArgs = {
  handle: Scalars['String'];
  publicToken: Scalars['String'];
};

export type MutationCreatePlaidActivationArgs = {
  origin: Scalars['String'];
};

export type MutationCreatePlaidConsentArgs = {
  paymentSourceId: Scalars['ID'];
};

export type MutationCreatePlaidValidationActivationArgs = {
  origin: Scalars['String'];
  paymentSourceId: Scalars['ID'];
};

export type MutationCreateScanFormArgs = {
  shipDate: Scalars['String'];
  warehouseId: Scalars['ID'];
};

export type MutationCreateScanFormByBatchArgs = {
  batchId: Scalars['ID'];
};

export type MutationCreateScopedShipmentPresetArgs = {
  originalPresetId?: InputMaybe<Scalars['ID']>;
  values: ShipmentPresetInput;
};

export type MutationCreateSenderEmailMetadataArgs = {
  emailAddress: Scalars['ID'];
  senderName: Scalars['String'];
};

export type MutationCreateShipmentPresetArgs = {
  default: Scalars['Boolean'];
  shipmentPreset: ShipmentPresetInput;
};

export type MutationCreateSquarespaceChannelArgs = {
  input: CreateSquarespaceChannelInput;
};

export type MutationCreateSubblyChannelArgs = {
  input: CreateSubblyChannelInput;
};

export type MutationCreateTestBatchArgs = {
  customsItems?: ReadonlyArray<CustomsItemInput>;
  destinationAddresses?: ReadonlyArray<AddressInput>;
  existingWarehouseTitle?: InputMaybe<Scalars['String']>;
  includeSingleCarrierRateGroup?: InputMaybe<Scalars['Int']>;
  mailClasses?: ReadonlyArray<Scalars['Int']>;
  numInternationalShipments?: InputMaybe<Scalars['Int']>;
  orderItems?: ReadonlyArray<OrderItemInput>;
  originAddress?: InputMaybe<AddressInput>;
  returnAddress?: InputMaybe<AddressInput>;
  shipDate?: InputMaybe<Scalars['DateTime']>;
  shipmentPreset?: InputMaybe<ShipmentPresetInput>;
  shipmentStatuses?: ReadonlyArray<ShipmentStatus>;
  surcharges?: ReadonlyArray<SurchargePriceInput>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  trackingStatus?: InputMaybe<Mel_Pp_Model_Shipment_TrackingStatus>;
  uploadMapping?: ReadonlyArray<ShipmentMappingInput>;
  userId: Scalars['ID'];
  warehouseId?: InputMaybe<Scalars['Int']>;
  zone?: InputMaybe<Scalars['String']>;
};

export type MutationCreateTestShipmentArgs = {
  customsItems?: ReadonlyArray<CustomsItemInput>;
  destinationAddress?: InputMaybe<AddressInput>;
  existingWarehouseTitle?: InputMaybe<Scalars['String']>;
  isReturnLabel?: InputMaybe<Scalars['Boolean']>;
  labelFileType?: InputMaybe<Scalars['String']>;
  labelSize?: InputMaybe<Scalars['String']>;
  mailClassKey?: InputMaybe<Scalars['String']>;
  orderItems?: ReadonlyArray<OrderItemInput>;
  originAddress?: InputMaybe<AddressInput>;
  rates?: ReadonlyArray<MailClassRateInput>;
  returnAddress?: InputMaybe<AddressInput>;
  rubberStamps?: ReadonlyArray<Scalars['String']>;
  shipDate?: InputMaybe<Scalars['DateTime']>;
  shipmentPreset?: InputMaybe<ShipmentPresetInput>;
  singleCarrier?: InputMaybe<Scalars['Int']>;
  status: ShipmentStatus;
  surcharges?: ReadonlyArray<SurchargePriceInput>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  trackingStatus?: InputMaybe<Mel_Pp_Model_Shipment_TrackingStatus>;
  uploadMapping?: ReadonlyArray<ShipmentMappingInput>;
  userId: Scalars['ID'];
  warehouseId?: InputMaybe<Scalars['Int']>;
  warehouseTitle?: InputMaybe<Scalars['String']>;
  zone?: InputMaybe<Scalars['String']>;
};

export type MutationCreateTestShipmentFromFixtureArgs = {
  fixturePath: Scalars['String'];
  userId: Scalars['Int'];
};

export type MutationCreateUserArgs = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  password: Scalars['String'];
};

export type MutationCreateVenmoPaymentSourceArgs = {
  nonce: Scalars['String'];
};

export type MutationCreateWarehouseArgs = {
  originAddress: AddressInput;
  returnAddress?: InputMaybe<AddressInput>;
  saveAddressForReuse?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  useOriginAsReturnAddress: Scalars['Boolean'];
};

export type MutationDeleteBatchArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteChannelArgs = {
  channelId: Scalars['ID'];
};

export type MutationDeleteMailTemplateArgs = {
  id: Scalars['String'];
};

export type MutationDeletePaymentSourceArgs = {
  paymentSourceId: Scalars['ID'];
};

export type MutationDeleteShipmentPresetArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteSuggestedAddressArgs = {
  addressId: Scalars['ID'];
};

export type MutationDeleteTestBatchArgs = {
  batchId: Scalars['ID'];
};

export type MutationDeleteTwoFactorAuthenticationProviderArgs = {
  password: Scalars['String'];
  provider: Provider;
};

export type MutationDeleteUserArgs = {
  userId: Scalars['ID'];
};

export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID'];
};

export type MutationDisableChannelArgs = {
  channelId: Scalars['ID'];
};

export type MutationDisputeAdjustmentsArgs = {
  disputeReason: Scalars['String'];
  shipmentId: Scalars['ID'];
};

export type MutationDownloadMobileCodeForShipmentArgs = {
  id: Scalars['ID'];
};

export type MutationDownloadMobileCodesForBatchArgs = {
  id: Scalars['ID'];
};

export type MutationEmulateViaShipmentArgs = {
  shipmentId: Scalars['String'];
};

export type MutationEnableChannelArgs = {
  channelId: Scalars['ID'];
};

export type MutationFetchSenderEmailMetadataArgs = {
  emailAddress: Scalars['ID'];
};

export type MutationFetchShipmentStageDotsArgs = {
  id: Scalars['ID'];
};

export type MutationGenerateJumioWebClientUrlArgs = {
  returnPath: Scalars['String'];
};

export type MutationGenerateOrGetShareLinkArgs = {
  downloadId: Scalars['ID'];
};

export type MutationHideHistoricShipmentAddressesArgs = {
  ids: Scalars['ID'];
};

export type MutationIgnoreOrdersArgs = {
  ids: ReadonlyArray<Scalars['String']>;
};

export type MutationInstallTwoFactorAuthenticationProviderArgs = {
  provider: Provider;
};

export type MutationMarkJumioFlowAsFinishedArgs = {
  workflowExecutionId: Scalars['String'];
};

export type MutationMarkMobileCodeBatchAsDownloadedArgs = {
  id: Scalars['ID'];
};

export type MutationMarkMobileCodeShipmentAsDownloadedArgs = {
  id: Scalars['ID'];
};

export type MutationModifyInsuranceOnRatedBatchArgs = {
  id: Scalars['ID'];
  insuredValue: Scalars['Float'];
};

export type MutationRatePickupArgs = {
  pickupRequest: PickupRequestInput;
};

export type MutationRefundBatchArgs = {
  id: Scalars['ID'];
};

export type MutationRefundCreditFromPaymentSourceArgs = {
  paymentSourceId: Scalars['ID'];
  refundCreditAmount: Scalars['Float'];
};

export type MutationRefundShipmentArgs = {
  shipmentId: Scalars['ID'];
};

export type MutationRequestPickupArgs = {
  paymentSourceId: Scalars['ID'];
  pickupRequest: PickupRequestInput;
  totalCharge: Scalars['Float'];
};

export type MutationRerateBatchArgs = {
  id: Scalars['ID'];
  shipDate?: InputMaybe<Scalars['DateTime']>;
};

export type MutationResendUserInvitationArgs = {
  password: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationResetNicknameArgs = {
  paymentSourceId: Scalars['ID'];
};

export type MutationSendConfirmationMailArgs = {
  emailAddress: Scalars['ID'];
};

export type MutationSendEmailArgs = {
  id: Scalars['String'];
};

export type MutationSendResetPasswordLinkArgs = {
  email: Scalars['String'];
};

export type MutationSetBatchToNewArgs = {
  id: Scalars['ID'];
};

export type MutationSetDefaultPaymentSourceArgs = {
  paymentSourceId: Scalars['ID'];
};

export type MutationSetDefaultWarehouseArgs = {
  warehouseId: Scalars['ID'];
};

export type MutationSetNicknameArgs = {
  nickname: Scalars['String'];
  paymentSourceId: Scalars['ID'];
};

export type MutationSetShipmentUploadMappingArgs = {
  batchId: Scalars['ID'];
  mapping: ReadonlyArray<ShipmentMappingInput>;
};

export type MutationSucceedAtChallengeArgs = {
  key: Scalars['String'];
};

export type MutationTriggerLabelCreationByBatchesArgs = {
  batchIds: ReadonlyArray<Scalars['ID']>;
  pageLayout?: InputMaybe<PageLayout>;
};

export type MutationTriggerLabelCreationByShareTokenArgs = {
  pageLayout?: InputMaybe<PageLayout>;
  shareToken: Scalars['String'];
};

export type MutationTriggerLabelCreationByShipmentsArgs = {
  isViaAdminBar?: InputMaybe<Scalars['Boolean']>;
  pageLayout?: InputMaybe<PageLayout>;
  shipmentIds: ReadonlyArray<Scalars['ID']>;
};

export type MutationUnignoreOrdersArgs = {
  ids: ReadonlyArray<Scalars['String']>;
};

export type MutationUpdateAccountEmailArgs = {
  currentPassword?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateAccountProfileArgs = {
  currentPassword: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  timezone: Scalars['String'];
};

export type MutationUpdateBatchTitleArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type MutationUpdateBigcartelChannelArgs = {
  input: UpdateBigcartelChannelInput;
};

export type MutationUpdateBigcommerceChannelArgs = {
  input: UpdateBigcommerceChannelInput;
};

export type MutationUpdateBillingAddressArgs = {
  billingAddress: AddressInput;
};

export type MutationUpdateBlockedCountriesArgs = {
  blockedCountries: ReadonlyArray<BlockedCountryInput>;
  carrierKey: CarrierKey;
};

export type MutationUpdateChargeAmountArgs = {
  amount: Scalars['Int'];
};

export type MutationUpdateCratejoyChannelArgs = {
  input: UpdateCratejoyChannelInput;
};

export type MutationUpdateDataGridUserSettingsArgs = {
  gridId: Scalars['String'];
  settings: DataGridSettingsInput;
};

export type MutationUpdateDefaultTrackingEmailsDelayArgs = {
  inAdvance: Scalars['String'];
};

export type MutationUpdateDefaultTrackingEmailsEnabledArgs = {
  enabled: Scalars['Boolean'];
};

export type MutationUpdateDiscogsChannelArgs = {
  input: UpdateDiscogsChannelInput;
};

export type MutationUpdateEbayChannelArgs = {
  input: UpdateEbayChannelInput;
};

export type MutationUpdateEcwidChannelArgs = {
  input: UpdateEcwidChannelInput;
};

export type MutationUpdateEmailNotificationArgs = {
  batchId: Scalars['ID'];
  mailTemplateId: Scalars['ID'];
  scheduledDateTime: Scalars['String'];
};

export type MutationUpdateEtsyChannelArgs = {
  input: UpdateEtsyChannelInput;
};

export type MutationUpdateFakeshopChannelArgs = {
  input: UpdateFakeshopChannelInput;
};

export type MutationUpdateGeneralSettingsArgs = {
  addressCorrection: Scalars['String'];
  areMobileCodesEnabled: Scalars['Boolean'];
  packingListTemplate: Scalars['String'];
  shipmentLabelFileFormat: Scalars['String'];
  shipmentLabelSize: Scalars['String'];
  shipmentSpreadsheetFormat: Scalars['String'];
  showLogoOnLabel: Scalars['Boolean'];
};

export type MutationUpdateMailTemplateArgs = {
  asDefault: Scalars['Boolean'];
  bccEmail?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sendTemplatePreview: Scalars['Boolean'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
  templateHtml: Scalars['String'];
  title: Scalars['String'];
};

export type MutationUpdateNotificationsSettingsArgs = {
  carrierAdjustmentDisputesEnabled: Scalars['Boolean'];
  carrierAdjustmentsNotificationEnabled: Scalars['Boolean'];
  newFeaturesAnnouncementsNotificationEnabled: Scalars['Boolean'];
  newLoginNotificationEnabled: Scalars['Boolean'];
  paymentFailuresNotificationEnabled: Scalars['Boolean'];
  paymentReceiptsNotificationEnabled: Scalars['Boolean'];
};

export type MutationUpdatePaypalChannelArgs = {
  input: UpdatePaypalChannelInput;
};

export type MutationUpdatePreferredUpsMerchantAccountAddressArgs = {
  address: AddressInput;
};

export type MutationUpdateRateGroupSortOrderArgs = {
  sortOrder: RateGroupSortOrder;
};

export type MutationUpdateSenderEmailMetadataArgs = {
  emailAddress: Scalars['ID'];
  senderName: Scalars['String'];
};

export type MutationUpdateShipmentPresetArgs = {
  default: Scalars['Boolean'];
  shipmentPreset: ShipmentPresetInput;
};

export type MutationUpdateShopifyChannelArgs = {
  input: UpdateShopifyChannelInput;
};

export type MutationUpdateSquareChannelArgs = {
  input: UpdateSquareChannelInput;
};

export type MutationUpdateSquarespaceChannelArgs = {
  input: UpdateSquarespaceChannelInput;
};

export type MutationUpdateSubblyChannelArgs = {
  input: UpdateSubblyChannelInput;
};

export type MutationUpdateTrackingEmailBrandingEnabledArgs = {
  enabled: Scalars['Boolean'];
};

export type MutationUpdateWarehouseArgs = {
  id: Scalars['ID'];
  originAddress: AddressInput;
  returnAddress?: InputMaybe<AddressInput>;
  title: Scalars['String'];
  useOriginAsReturnAddress: Scalars['Boolean'];
};

export type MutationUpdateWixChannelArgs = {
  input: UpdateWixChannelInput;
};

export type MutationUpdateWoocommerceChannelArgs = {
  input: UpdateWoocommerceChannelInput;
};

export type NavbarLink = {
  readonly __typename: 'NavbarLink';
  readonly children: Maybe<ReadonlyArray<NavbarLink>>;
  readonly text: Scalars['String'];
  readonly url: Scalars['String'];
};

export type NotOverrideableReason = {
  readonly __typename: 'NotOverrideableReason';
  readonly order: DockOrder;
  readonly orderId: Scalars['String'];
  readonly reasons: ReadonlyArray<Scalars['String']>;
};

export type NotificationsSettings = {
  readonly __typename: 'NotificationsSettings';
  readonly carrierAdjustmentDisputesEnabled: Scalars['Boolean'];
  readonly carrierAdjustmentsNotificationEnabled: Scalars['Boolean'];
  readonly newFeaturesAnnouncementsNotificationEnabled: Scalars['Boolean'];
  readonly newLoginNotificationEnabled: Scalars['Boolean'];
  readonly paymentFailuresNotificationEnabled: Scalars['Boolean'];
  readonly paymentReceiptsNotificationEnabled: Scalars['Boolean'];
};

export type NotifyRecipientStatus = 'ERROR' | 'NOT_SCHEDULED' | 'RUNNING' | 'SCHEDULED' | 'SENT';

export type Numbers = {
  readonly __typename: 'Numbers';
  readonly carrierAdjustmentsAmount: Scalars['Float'];
  readonly netLabelAverage: Scalars['Float'];
  readonly netLabelAverageDom: Scalars['Float'];
  readonly netLabelAverageInt: Scalars['Float'];
  readonly netLabelCount: Scalars['Float'];
  readonly netLabelTotal: Scalars['Float'];
  readonly payments: Scalars['Float'];
  readonly pendingNumbers: PendingNumbers;
};

export type Order = {
  readonly __typename: 'Order';
  /** ID that this order has on the platform we imported it from */
  readonly foreignOrderId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly orderItems: ReadonlyArray<OrderItem>;
  /** Link to the order on the platform we imported it from */
  readonly orderLink: Maybe<Link>;
  /** The platform we imported this order from (Shopify, WooCommerce, etc) */
  readonly platform: Platform;
  /** Name of the platform we imported this order from */
  readonly platformKey: Scalars['String'];
  /** Link to the subscription on the platform we imported it from */
  readonly shipmentLink: Maybe<Link>;
  /** Link to the subscription on the platform we imported it from */
  readonly subscriptionLink: Maybe<Link>;
};

export type OrderItem = {
  readonly __typename: 'OrderItem';
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['Float'];
  readonly sku: Scalars['String'];
  readonly title: Scalars['String'];
};

export type OrderItemInput = {
  readonly quantity: Scalars['Int'];
  readonly sku: Scalars['String'];
  readonly title: Scalars['String'];
};

export type OrderSummary = {
  readonly __typename: 'OrderSummary';
  readonly count: Scalars['Int'];
  readonly customsFormRequired: Scalars['Boolean'];
  readonly customsFormRequiredCount: Scalars['Int'];
  readonly domesticCount: Scalars['Int'];
  readonly exporterTaxId: Scalars['String'];
  readonly hSCodeRequired: Scalars['Boolean'];
  readonly internationalCount: Scalars['Int'];
  readonly maxValue: Scalars['Float'];
  readonly maxValueFormatted: Scalars['String'];
  readonly maxWeight: Scalars['Float'];
  readonly maxWeightFormatted: Scalars['String'];
  readonly minValue: Scalars['Float'];
  readonly minValueFormatted: Scalars['String'];
  readonly minWeight: Scalars['Float'];
  readonly minWeightFormatted: Scalars['String'];
  /** Get reasons why override is not possible for specific orders */
  readonly notOverrideableReasons: ReadonlyArray<NotOverrideableReason>;
  /** Get the single order (only available when count == 1) */
  readonly order: Maybe<DockOrder>;
  /** Get the array of order IDs in this summary */
  readonly orderIds: ReadonlyArray<Scalars['ID']>;
  readonly ordersSimilar: Scalars['Boolean'];
  readonly overrideable: Scalars['Boolean'];
  readonly suggestedBatchTitle: Scalars['String'];
  readonly suggestedShipmentPreset: Maybe<ShipmentPreset>;
  /** Get unique customs items across all orders */
  readonly uniqueCustomsItems: ReadonlyArray<OrderSummaryCustomsItem>;
  readonly uniqueOrderItemTexts: ReadonlyArray<Scalars['String']>;
  readonly uniquePlatformKeys: ReadonlyArray<Scalars['String']>;
  readonly uniqueValues: ReadonlyArray<Scalars['Float']>;
  readonly uniqueWeights: ReadonlyArray<Scalars['Float']>;
};

export type OrderSummaryCustomsItem = {
  readonly __typename: 'OrderSummaryCustomsItem';
  readonly description: Scalars['String'];
  readonly harmonization: Scalars['String'];
  readonly origin: Scalars['String'];
  readonly qty: Scalars['Int'];
  /** Item value in dollars */
  readonly value: Scalars['Float'];
  /** Item weight in ounces */
  readonly weight: Scalars['Float'];
};

export type PageInfo = {
  readonly __typename: 'PageInfo';
  readonly endCursor: Maybe<Scalars['String']>;
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor: Maybe<Scalars['String']>;
};

export type PageLayout =
  | 'LAYOUT_2x7'
  | 'LAYOUT_4x6'
  | 'LAYOUT_85x11_1UP_LEFT'
  | 'LAYOUT_85x11_1UP_RIGHT'
  | 'LAYOUT_85x11_2UP';

export type PaginatedBatches = {
  readonly __typename: 'PaginatedBatches';
  readonly batches: ReadonlyArray<Batch>;
};

export type Payment = {
  readonly __typename: 'Payment';
  readonly apiMethodId: Scalars['String'];
  readonly authorizedAmount: Scalars['Float'];
  readonly batchId: Scalars['Int'];
  readonly batchRatedAmount: Scalars['Float'];
  readonly chargeError: Scalars['String'];
  readonly chargebackFeeClient: Scalars['Float'];
  readonly chargebackFeePirate: Scalars['Float'];
  readonly chargedAmount: Scalars['Float'];
  readonly companyId: Scalars['Int'];
  readonly createdAt: Scalars['String'];
  readonly debtDue: Scalars['Float'];
  readonly fee: Scalars['Float'];
  readonly feeDate: Scalars['String'];
  readonly gatewayId: Scalars['String'];
  readonly groupPaymentId: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
  readonly moreLink: Maybe<Scalars['String']>;
  readonly note: Scalars['String'];
  readonly paymentSourceId: Scalars['String'];
  readonly receipt: Receipt;
  readonly reconciliationRunId: Scalars['Int'];
  readonly refundTotal: Scalars['Float'];
  readonly status: Scalars['String'];
  readonly strategy: Maybe<Mel_Payment_Enum_StrategyName>;
  readonly title: Scalars['String'];
  readonly total: Scalars['String'];
  readonly updatedAt: Scalars['String'];
  readonly userId: Scalars['Int'];
};

export type PaymentAction = {
  readonly __typename: 'PaymentAction';
  readonly actionType: Scalars['String'];
  readonly applicationErrorCode: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly errorMessage: Scalars['String'];
  readonly gatewayToken: Scalars['String'];
  readonly httpErrorCode: Scalars['String'];
  readonly identifier: Scalars['ID'];
  readonly newPaymentStatus: Scalars['String'];
  readonly paymentId: Scalars['Int'];
  readonly remoteReferenceId: Scalars['String'];
  readonly remoteTransactionId: Scalars['String'];
  readonly success: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type PaymentApiMethod = {
  readonly __typename: 'PaymentApiMethod';
  /** Public key (PayPal: tokenization key) for payment API */
  readonly apiKey: Maybe<Scalars['String']>;
  /** API to be used for new payment sources with this payment method */
  readonly apiTitle: PaymentApiMethodTitle;
  readonly code: PaymentMethodType;
  readonly id: Scalars['ID'];
};

/** Enumeration of all value types */
export type PaymentApiMethodTitle =
  | 'Offline'
  | 'PayPal'
  | 'Plaid'
  | 'Spreedly'
  | 'Stripe'
  | 'Venmo';

/** Enumeration of all value types */
export type PaymentMethodType = 'ach' | 'cc' | 'manual' | 'paypal' | 'plaidach' | 'venmo';

export type PaymentSource = {
  readonly __typename: 'PaymentSource';
  readonly bankAccountType: Scalars['String'];
  readonly billingZipcode: Scalars['String'];
  readonly billingZipcodeVerification: Scalars['String'];
  readonly brand: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly email: Maybe<Scalars['String']>;
  readonly expMonth: Maybe<Scalars['Int']>;
  readonly expYear: Maybe<Scalars['Int']>;
  readonly first6: Maybe<Scalars['String']>;
  readonly funding: Maybe<Funding>;
  readonly hasConsented: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly last4: Maybe<Scalars['String']>;
  readonly nickname: Maybe<Scalars['String']>;
  readonly paymentMethodType: PaymentMethodType;
  readonly refundableAmount: Scalars['Float'];
  readonly resultMessage: Maybe<Scalars['String']>;
  readonly shortTitle: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly validationStatus: Scalars['String'];
};

export type PaypalChannel = ChannelInterface & {
  readonly __typename: 'PaypalChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly genericLineItemEnabled: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type PendingNumbers = {
  readonly __typename: 'PendingNumbers';
  readonly paymentsTotalAmount: Scalars['Float'];
  readonly refunds: Summary;
  readonly returns: Summary;
};

export type PickupRateResult = {
  readonly __typename: 'PickupRateResult';
  readonly basePrice: Scalars['Float'];
  readonly crossedOutBasePrice: Maybe<Scalars['Float']>;
  readonly crossedOutTotalPrice: Maybe<Scalars['Float']>;
  readonly surcharges: ReadonlyArray<PickupSurcharge>;
  readonly totalPrice: Scalars['Float'];
};

export type PickupRequest = {
  readonly __typename: 'PickupRequest';
  readonly canCancel: Scalars['Boolean'];
  readonly carrier: Carrier;
  readonly confirmationNumber: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly errorMessage: Scalars['String'];
  readonly foreignId: Maybe<Scalars['String']>;
  readonly frequency: Maybe<PickupRequestFrequency>;
  readonly hasUpsOverweightPackages: Maybe<Scalars['Boolean']>;
  readonly highestServiceLevel: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  /**
   * The date on which the pickup will happen in the location where the pickup happens
   * (Since this is a whole day without a specific time, it has no time and no timezone)
   * Format: 2023-06-22
   */
  readonly oneTimePickupDate: Maybe<Scalars['String']>;
  readonly packageLocation: PickupRequestPackageLocation;
  readonly previouslyRatedPrice: Maybe<Scalars['Float']>;
  readonly rate: PickupRateResult;
  readonly recurringPickupDays: Maybe<ReadonlyArray<PickupRequestDay>>;
  readonly specialInstructions: Maybe<Scalars['String']>;
  readonly status: PickupRequestStatus;
  readonly totalPackageCount: Scalars['Int'];
  readonly totalPackageWeight: Scalars['Float'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly warehouse: Warehouse;
  readonly warehouseCloseTime: Scalars['String'];
  readonly warehouseReadyTime: Scalars['String'];
};

/** Enumeration of pickup days */
export type PickupRequestDay =
  /** Pickup on Friday */
  | 'FRIDAY'
  /** Pickup on Monday */
  | 'MONDAY'
  /** Pickup on Saturday */
  | 'SATURDAY'
  /** Pickup on Sunday */
  | 'SUNDAY'
  /** Pickup on Thursday */
  | 'THURSDAY'
  /** Pickup on Tuesday */
  | 'TUESDAY'
  /** Pickup on Wednesday */
  | 'WEDNESDAY';

/** Enumeration of pickup request frequencies */
export type PickupRequestFrequency =
  /** Request a one-time pickup */
  | 'ONE_TIME'
  /** Request a recurring pickup on set days */
  | 'RECURRING';

export type PickupRequestInput = {
  readonly carrierKey: CarrierKey;
  readonly frequency: PickupRequestFrequency;
  readonly hasUpsOverweightPackages?: InputMaybe<Scalars['Boolean']>;
  readonly highestServiceLevel?: InputMaybe<Scalars['String']>;
  readonly oneTimePickupDate?: InputMaybe<Scalars['Date']>;
  readonly packageLocation: PickupRequestPackageLocation;
  readonly previouslyRatedPrice?: InputMaybe<Scalars['Float']>;
  readonly recurringPickupDays?: InputMaybe<ReadonlyArray<PickupRequestDay>>;
  readonly specialInstructions?: InputMaybe<Scalars['String']>;
  readonly totalPackageCount: Scalars['Int'];
  readonly totalPackageWeight: Scalars['Float'];
  readonly warehouseCloseTime: Scalars['String'];
  readonly warehouseId: Scalars['ID'];
  readonly warehouseReadyTime: Scalars['String'];
};

/** Enumeration of pickup package locations */
export type PickupRequestPackageLocation =
  /** Pick up packages at the back door */
  | 'BACK_DOOR'
  /** Pick up packages at the front door */
  | 'FRONT_DOOR'
  /** Knock on door to pick up packages */
  | 'KNOCK_OR_RING'
  /** Pick up packages from or at the mailbox */
  | 'MAILBOX'
  /** Pick up packages at the mail room */
  | 'MAIL_ROOM'
  /** Pick up packages at the office */
  | 'OFFICE'
  /** Pick up packages from another location (see further instructions) */
  | 'OTHER'
  /** Pick up packages at the reception */
  | 'RECEPTION'
  /** Pick up packages at the side door */
  | 'SIDE_DOOR';

/** Enumeration of pickup request statuses */
export type PickupRequestStatus =
  /** Pickup was canceled */
  | 'CANCELLED'
  /** Pickup was requested to be canceled */
  | 'CANCEL_REQUESTED'
  /** Pickup was confirmed by carrier */
  | 'CONFIRMED'
  /** Pickup request is created */
  | 'CREATED'
  /** Pickup request was denied */
  | 'DENIED'
  /** Pickup was requested from carrier */
  | 'REQUESTED';

export type PickupSurcharge = {
  readonly __typename: 'PickupSurcharge';
  readonly crossedOutPrice: Maybe<Scalars['Float']>;
  readonly helpLink: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
};

export type PlaidActivation = {
  readonly __typename: 'PlaidActivation';
  readonly handle: Scalars['String'];
  readonly linkToken: Scalars['String'];
  readonly mask: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly paymentSource: Maybe<PaymentSource>;
  readonly publicToken: Maybe<Scalars['String']>;
};

export type Platform = {
  readonly __typename: 'Platform';
  readonly additionalTrackingEmailCopy: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly installUrl: Maybe<Scalars['String']>;
  readonly module: Scalars['String'];
  readonly platformKey: Scalars['String'];
  readonly reconnectSupported: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly trackingEmailSupported: Scalars['Boolean'];
};

export type PlatformLink = {
  readonly __typename: 'PlatformLink';
  /** The identifier for this resource on the platform (e.g., order number) */
  readonly identifier: Scalars['String'];
  /** The platform name (e.g., "Shopify", "WooCommerce") */
  readonly platform: Scalars['String'];
  /** The type of link (e.g., "Order", "Subscription", "Shipment") */
  readonly type: Scalars['String'];
  /** URL to view this resource on the platform (nullable) */
  readonly url: Maybe<Scalars['String']>;
};

export type PlatformMappableField = {
  readonly __typename: 'PlatformMappableField';
  readonly field: Scalars['String'];
  readonly label: Scalars['String'];
};

export type PlatformOverrideField = {
  readonly __typename: 'PlatformOverrideField';
  readonly field: Scalars['String'];
  readonly label: Scalars['String'];
};

export type PossibleScanFormResult = {
  readonly __typename: 'PossibleScanFormResult';
  readonly canCreateScanForm: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly scanFormUrl: Maybe<Scalars['String']>;
};

export type Provider = 'APP' | 'DEFAULT' | 'EMAIL';

export type Query = {
  readonly __typename: 'Query';
  readonly addressAutocompleteSettings: AddressAutocompleteSettings;
  readonly adminShipmentsReport: DataGridResult;
  readonly applicationConfiguration: ApplicationConfiguration;
  readonly applicationEnvironment: Scalars['String'];
  readonly applicationHostname: Scalars['String'];
  readonly autoRefundedShipmentsSummary: Summary;
  readonly averageCostChart: Chart;
  readonly batch: Batch;
  readonly batches: ReadonlyArray<Batch>;
  readonly blockedCountries: ReadonlyArray<BlockedCountry>;
  readonly boughtBatchShipmentsGrid: DataGridResult;
  readonly captainsNotes: ReadonlyArray<Scalars['String']>;
  readonly carrier: Carrier;
  readonly carrierAdjustmentReport: DataGridResult;
  readonly carrierAdjustments: Scalars['JSONObject'];
  readonly carriers: ReadonlyArray<Carrier>;
  readonly challenges: ReadonlyArray<ChallengeState>;
  readonly channel: Maybe<Channel>;
  readonly channelSyncStatus: SyncStatusResult;
  readonly chargeAmountOptions: ReadonlyArray<Scalars['Int']>;
  /**
   * Returns a grid listing all clients(companies) of Pirate Ship
   * This is only available for supporters
   * The available columns and features depend on the supporters access rights
   */
  readonly clientsGrid: DataGridResult;
  readonly company: Company;
  readonly companySavings: Scalars['Float'];
  readonly countries: ReadonlyArray<Country>;
  readonly countryDistributionChart: CountryDistributionChart;
  readonly globalSettings: GlobalSettings;
  readonly hasBatches: Scalars['Boolean'];
  readonly historicShipmentAddresses: ReadonlyArray<HistoricShipmentAddress>;
  readonly importedOrders: DataGridResult;
  readonly insuranceUnsupportedCountries: ReadonlyArray<Scalars['String']>;
  readonly interceptPrice: InterceptPriceType;
  readonly intercomArticle: Scalars['String'];
  readonly isEu: Scalars['Boolean'];
  readonly labels: LabelsType;
  readonly latestBatches: PaginatedBatches;
  readonly latestTerms: UserTerms;
  /** All shipment fields that can be mapped to a column in an order upload spreadsheet */
  readonly mappableShipmentFields: ReadonlyArray<MappableShipmentField>;
  readonly navbarLinks: ReadonlyArray<NavbarLink>;
  readonly navbarMetaLinks: ReadonlyArray<NavbarLink>;
  readonly notificationsSettings: NotificationsSettings;
  readonly numbers: Numbers;
  readonly orderSummary: OrderSummary;
  readonly parsedAddress: RecipientAddress;
  /**
   * Defines which payment service should be used for which payment method.
   * This is a global setting for all clients and users that can only be changed by admins.
   */
  readonly paymentApiMethods: ReadonlyArray<PaymentApiMethod>;
  readonly paymentChart: Chart;
  readonly paymentReceipts: Maybe<Scalars['JSONObject']>;
  readonly platforms: ReadonlyArray<Platform>;
  readonly rates: ReadonlyArray<RateResult>;
  readonly receipt: Receipt;
  readonly receiptsReport: DataGridResult;
  readonly recipientTaxIdRequiringCountries: ReadonlyArray<Scalars['String']>;
  readonly redirectOptions: InterceptOptionsType;
  readonly refundReport: DataGridResult;
  readonly refunds: Maybe<Scalars['JSONObject']>;
  readonly regions: ReadonlyArray<Region>;
  readonly returnLabelsReport: DataGridResult;
  readonly returnPath: Maybe<Scalars['String']>;
  readonly returns: Maybe<Scalars['JSONObject']>;
  readonly scanFormByBatch: PossibleScanFormResult;
  readonly scanFormByShareToken: PossibleScanFormResult;
  readonly senderEmailMetadata: Maybe<SenderEmailMetadata>;
  readonly shipment: Shipment;
  readonly shipmentBoundaries: ShipmentBoundaries;
  readonly shipmentChart: Chart;
  readonly shipmentForOrder: Maybe<Shipment>;
  readonly shipmentPieChart: Chart;
  readonly shipmentReport: DataGridResult;
  readonly shipmentTrackingNumbers: ShipmentTrackingNumbers;
  /**
   * Info about an Upload of orders from a spreadsheet with it's mapping to shipment fields.
   * (initial mapping is a suggested mapping)
   */
  readonly shipmentUpload: ShipmentUpload;
  readonly shipments: ReadonlyArray<Shipment>;
  readonly spreedlyIframeParameters: SpreedlyIframeParameters;
  readonly spyglassLink: Scalars['String'];
  readonly stateDistributionChart: StateDistributionChart;
  readonly supportSearch: ReadonlyArray<SupportSearchResult>;
  readonly timezones: ReadonlyArray<Timezone>;
  readonly transactionHistory: DataGridResult;
  readonly twoFactorAuthenticationConfiguration: TwoFactorAuthenticationConfiguration;
  readonly user: User;
  readonly users: ReadonlyArray<CompanyUser>;
  readonly verificationRequired: Scalars['Boolean'];
  readonly verificationStatus: Maybe<Scalars['String']>;
  readonly woocommerceEgressIps: ReadonlyArray<Scalars['String']>;
  readonly zoneChart: Chart;
  /** Returns zone for the provided origin-destination zip code pair. */
  readonly zoneForRoute: Scalars['Int'];
  /**
   * Returns zones from the provided origin zip to all destinations. Returned as a hash table keyed by 3-digit
   * destination zip codes for quick lookup. Zip codes are prefixed to avoid key access issues in JavaScript objects.
   * The returned JSON object looks like this:
   *
   * {
   *   ...
   *   "zip832": 4,
   *   "zip833": 5,
   *   ...
   * }
   */
  readonly zoneMapForOrigin: Scalars['JSONObject'];
  /**
   * Returns zones from all origins to all destinations, keyed by 3-digit zip codes in a nested hashtable for
   * quick lookup. Zip codes are prefixed to avoid key access issues in JavaScript objects.
   * The returned JSON object looks like this:
   *
   * {
   *   ...
   *   "zip902": { ..., "zip832": 4, "zip833": 5, ...},
   *   "zip903": { ..., "zip832": 4, "zip833": 5, ...},
   *   ...
   * }
   */
  readonly zoneTable: Scalars['JSONObject'];
};

export type QueryAverageCostChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryBatchArgs = {
  id: Scalars['ID'];
};

export type QueryBatchesArgs = {
  batchIds: ReadonlyArray<Scalars['ID']>;
};

export type QueryBlockedCountriesArgs = {
  carrierKey: CarrierKey;
};

export type QueryBoughtBatchShipmentsGridArgs = {
  batchId: Scalars['ID'];
};

export type QueryCarrierArgs = {
  carrierKey: CarrierKey;
};

export type QueryChannelArgs = {
  id: Scalars['ID'];
};

export type QueryCompanyArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};

export type QueryCompanySavingsArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryCountryDistributionChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryHistoricShipmentAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchField: HistoricShipmentAddressSearchField;
  value: Scalars['String'];
};

export type QueryImportedOrdersArgs = {
  gridMode?: InputMaybe<GridMode>;
};

export type QueryInterceptPriceArgs = {
  trackingId: Scalars['String'];
  type: Scalars['String'];
};

export type QueryIntercomArticleArgs = {
  url: Scalars['String'];
};

export type QueryLabelsArgs = {
  downloadId: Scalars['ID'];
  isViaAdminBar?: InputMaybe<Scalars['Boolean']>;
  shareToken?: InputMaybe<Scalars['String']>;
};

export type QueryLatestBatchesArgs = {
  pageIndex: Scalars['Int'];
};

export type QueryNumbersArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryOrderSummaryArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};

export type QueryParsedAddressArgs = {
  address: Scalars['String'];
};

export type QueryPaymentChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryPlatformsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRatesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  deliveryConfirmation?: InputMaybe<DeliveryConfirmation>;
  destinationCountryCode?: InputMaybe<Scalars['String']>;
  destinationRegionCode?: InputMaybe<Scalars['String']>;
  destinationZip?: InputMaybe<Scalars['String']>;
  dimensionX?: InputMaybe<Scalars['Float']>;
  dimensionY?: InputMaybe<Scalars['Float']>;
  dimensionZ?: InputMaybe<Scalars['Float']>;
  hazardousMaterials?: InputMaybe<Scalars['Boolean']>;
  insureShippingCosts?: InputMaybe<Scalars['Boolean']>;
  insuredValue?: InputMaybe<Scalars['Float']>;
  irregularPackage?: InputMaybe<Scalars['Boolean']>;
  isPoBox?: InputMaybe<Scalars['Boolean']>;
  isResidential?: InputMaybe<Scalars['Boolean']>;
  isReturnLabel?: InputMaybe<Scalars['Boolean']>;
  mailClassKeys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  originCity?: InputMaybe<Scalars['String']>;
  originRegionCode?: InputMaybe<Scalars['String']>;
  originZip: Scalars['String'];
  packageTypeKeys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  priceBaseTypeKeys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  pricingTypes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  returnCheapest?: InputMaybe<Scalars['Boolean']>;
  shipDate?: InputMaybe<Scalars['String']>;
  showUpsRatesWhen2x7Selected?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type QueryReceiptArgs = {
  paymentId: Scalars['ID'];
};

export type QueryRedirectOptionsArgs = {
  trackingId: Scalars['String'];
};

export type QueryRegionsArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};

export type QueryScanFormByBatchArgs = {
  batchId: Scalars['ID'];
};

export type QueryScanFormByShareTokenArgs = {
  shareToken: Scalars['String'];
};

export type QuerySenderEmailMetadataArgs = {
  emailAddress: Scalars['ID'];
};

export type QueryShipmentArgs = {
  id: Scalars['ID'];
};

export type QueryShipmentChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryShipmentForOrderArgs = {
  orderId: Scalars['ID'];
};

export type QueryShipmentPieChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryShipmentTrackingNumbersArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryShipmentUploadArgs = {
  id: Scalars['ID'];
};

export type QueryShipmentsArgs = {
  shipmentIds: ReadonlyArray<Scalars['ID']>;
};

export type QueryStateDistributionChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QuerySupportSearchArgs = {
  term: Scalars['String'];
};

export type QueryZoneChartArgs = {
  datetimeRange: DatetimeRangeInput;
};

export type QueryZoneForRouteArgs = {
  carrierId: Scalars['ID'];
  destinationZip: Scalars['String'];
  originZip: Scalars['String'];
};

export type QueryZoneMapForOriginArgs = {
  carrierId: Scalars['ID'];
  originZip: Scalars['String'];
};

export type QueryZoneTableArgs = {
  carrierId: Scalars['ID'];
};

export type RateGroup = {
  readonly __typename: 'RateGroup';
  readonly affectedByUpsRateLimit: Scalars['Boolean'];
  readonly defaultShipDate: Scalars['String'];
  readonly groupId: Scalars['String'];
  readonly groupKey: RateGroupKey;
  readonly label: Scalars['String'];
  readonly maximumShipments: Scalars['Int'];
  readonly rateSummaries: ReadonlyArray<RateSummary>;
};

export type RateGroupKey = {
  readonly __typename: 'RateGroupKey';
  readonly string: Scalars['String'];
  readonly traits: ReadonlyArray<RateGroupTrait>;
};

export type RateGroupKeyInput = {
  readonly traits: ReadonlyArray<RateGroupTraitInput>;
};

export type RateGroupLayerKey = 'Address' | 'Carrier' | 'Direction' | 'Measurements' | 'Recipient';

export type RateGroupSortOrder = 'BEST' | 'CHEAPEST' | 'UPS' | 'USPS';

export type RateGroupTrait = {
  readonly __typename: 'RateGroupTrait';
  readonly layer: RateGroupLayerKey;
  readonly value: RateGroupTraitKey;
};

export type RateGroupTraitInput = {
  readonly layer: RateGroupLayerKey;
  readonly value: RateGroupTraitKey;
};

export type RateGroupTraitKey =
  | 'ASSOCIATED'
  | 'BIG_OR_HEAVY'
  | 'BUSINESS'
  | 'DOMESTIC'
  | 'INTERNATIONAL'
  | 'LAYER_IRRELEVANT'
  | 'LIGHT_AND_SMALL'
  | 'MILITARY_PO_BOX'
  | 'RETURN'
  | 'UPS'
  | 'USPS';

export type RateResult = {
  readonly __typename: 'RateResult';
  readonly arrivalLocalTime: Maybe<Scalars['DateTime']>;
  readonly basePrice: Scalars['Float'];
  readonly best: Scalars['Boolean'];
  readonly carrier: Carrier;
  readonly cheapest: Scalars['Boolean'];
  readonly crossedTotalPrice: Scalars['Float'];
  readonly cubicTier: Maybe<Scalars['String']>;
  readonly deliveryDescription: Scalars['String'];
  readonly fastest: Scalars['Boolean'];
  readonly isGuaranteedDelivery: Scalars['Boolean'];
  readonly isSaturdayDelivery: Scalars['Boolean'];
  readonly learnMoreUrl: Scalars['String'];
  readonly mailClass: CarrierMailClass;
  readonly mailClassKey: Scalars['String'];
  readonly packageTypeKey: Scalars['String'];
  readonly pickupLocalTime: Maybe<Scalars['DateTime']>;
  readonly priceBaseTypeKey: Scalars['String'];
  readonly pricingDescription: Scalars['String'];
  readonly pricingSubType: Scalars['String'];
  readonly pricingType: Scalars['String'];
  readonly ratePeriodId: Scalars['Int'];
  readonly serviceDescription: Scalars['String'];
  readonly surcharges: ReadonlyArray<RateSurcharge>;
  readonly title: Scalars['String'];
  readonly totalPrice: Scalars['Float'];
  readonly trackingDescription: Scalars['String'];
  readonly zone: Scalars['String'];
};

export type RateSelection = {
  readonly __typename: 'RateSelection';
  readonly groupKey: RateGroupKey;
  readonly mailClassId: Scalars['String'];
  readonly packageTypeId: Scalars['String'];
  readonly saturdayDelivery: Scalars['Boolean'];
};

export type RateSelectionInput = {
  readonly groupKeyInput: RateGroupKeyInput;
  readonly isSaturdayDelivery: Scalars['Boolean'];
  readonly mailClassId: Scalars['String'];
  readonly packageTypeId: Scalars['String'];
};

export type RateSummary = {
  readonly __typename: 'RateSummary';
  readonly availableShipDates: ReadonlyArray<Scalars['String']>;
  readonly averageBasePrice: Scalars['Float'];
  readonly averageTotalPrice: Scalars['Float'];
  readonly basePrice: Scalars['Float'];
  readonly best: Scalars['Boolean'];
  readonly carrier: Carrier;
  readonly cheapest: Scalars['Boolean'];
  readonly crossedTotalPrice: Scalars['Float'];
  readonly deliveryDays: Scalars['Float'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly fastest: Scalars['Boolean'];
  readonly firstMailClass: CarrierMailClass;
  readonly firstZone: Scalars['String'];
  readonly flatPrice: Scalars['Boolean'];
  readonly mailClassTitle: Scalars['String'];
  readonly maxWeightOz: Scalars['Float'];
  readonly packageType: CarrierPackageType;
  readonly ratePeriodEndDate: Maybe<Scalars['String']>;
  readonly ratePeriodStartDate: Maybe<Scalars['String']>;
  readonly savings: Scalars['String'];
  readonly serviceTitle: Scalars['String'];
  readonly shipmentCount: Scalars['Int'];
  readonly surcharges: ReadonlyArray<RateSurchargeSummary>;
  readonly surchargesPrice: Scalars['Float'];
  readonly totalPrice: Scalars['Float'];
  readonly uniqueId: Scalars['String'];
  readonly upsellRateSummary: Maybe<RateSummary>;
  readonly valueLimit: Scalars['Float'];
};

export type RateSurcharge = {
  readonly __typename: 'RateSurcharge';
  readonly parentSurchargeId: Maybe<Scalars['Int']>;
  readonly price: Scalars['Float'];
  readonly surchargeKey: Scalars['String'];
  readonly title: Scalars['String'];
};

export type RateSurchargeSummary = {
  readonly __typename: 'RateSurchargeSummary';
  readonly averagePrice: Scalars['Float'];
  readonly crossedPrice: Maybe<Scalars['Float']>;
  readonly helpLink: Maybe<Scalars['String']>;
  readonly price: Scalars['Float'];
  readonly shipmentCount: Scalars['Int'];
  readonly surchargeId: Scalars['String'];
  readonly surchargeKey: Scalars['String'];
  readonly title: Scalars['String'];
};

export type Receipt = {
  readonly __typename: 'Receipt';
  readonly billingAddress: AddressInterface;
  readonly chargeSuccessful: Scalars['Boolean'];
  readonly company: Company;
  readonly endBalance: Scalars['Float'];
  readonly isCharged: Scalars['Boolean'];
  readonly payment: Payment;
  readonly paymentSuccessful: Scalars['Boolean'];
  readonly reversals: ReadonlyArray<ReversalType>;
  readonly startBalance: Scalars['Float'];
  readonly transactions: ReadonlyArray<AccountingTransaction>;
};

export type RecipientAddress = BasicAddressInterface & {
  readonly __typename: 'RecipientAddress';
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly address3: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly email: Maybe<Scalars['String']>;
  readonly fullName: Scalars['String'];
  readonly location: Location;
  readonly phone: Scalars['String'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly residential: Scalars['Boolean'];
  readonly valid: Scalars['Boolean'];
  readonly zip4: Scalars['String'];
};

export type RecipientAddressInput = {
  readonly address1: Scalars['String'];
  readonly address2: Scalars['String'];
  readonly city: Scalars['String'];
  readonly company: Scalars['String'];
  readonly countryCode: Scalars['String'];
  readonly email: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly postcode: Scalars['String'];
  readonly regionCode: Scalars['String'];
  readonly zip4?: InputMaybe<Scalars['String']>;
};

export type ReconciliationAdjustment = {
  readonly __typename: 'ReconciliationAdjustment';
  readonly adjustmentReasons: Maybe<ReadonlyArray<AdjustmentReason>>;
  readonly clientPriceChange: Scalars['Float'];
  readonly createdAt: Scalars['DateTime'];
  readonly dimensionX: Scalars['Float'];
  readonly dimensionXOriginal: Maybe<Scalars['Float']>;
  readonly dimensionY: Scalars['Float'];
  readonly dimensionYOriginal: Maybe<Scalars['Float']>;
  readonly dimensionZ: Scalars['Float'];
  readonly dimensionZOriginal: Maybe<Scalars['Float']>;
  readonly disputeProcessedAt: Maybe<Scalars['DateTime']>;
  readonly disputeReason: Scalars['String'];
  readonly disputeStatus: DisputeStatus;
  readonly disputedAt: Maybe<Scalars['DateTime']>;
  readonly eligibilityIssueMessage: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isDisputable: Scalars['Boolean'];
  readonly notes: ReadonlyArray<Scalars['String']>;
  readonly processedAt: Scalars['DateTime'];
  readonly weight: Scalars['Float'];
  readonly weightOriginal: Maybe<Scalars['Float']>;
};

export type Region = {
  readonly __typename: 'Region';
  readonly countryCode: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly regionCode: Scalars['String'];
};

/** Enumeration of all value types */
export type ReturnLabel = 'return' | 'standard' | 'standard_and_return';

export type ReversalType = {
  readonly __typename: 'ReversalType';
  readonly action: PaymentAction;
  readonly amount: Scalars['Float'];
  readonly coveringAccountingTransaction: Maybe<AccountingTransaction>;
};

export type Role =
  | 'ACTIVE_USER'
  | 'ADJUSTMENTS'
  | 'ADMIN'
  | 'ANY_WEBSITE_VISITOR'
  | 'DATA_ANALYST'
  | 'EDIT_CLIENT'
  | 'FRAUD_REVIEWER'
  | 'INSURANCE_CLAIM'
  | 'LAWYER'
  | 'LOOT_DEFENDER'
  | 'MANAGE_CARRIER_ADJUSTMENTS'
  | 'PAYMENTS'
  | 'SUPPORT'
  | 'SUSPEND_UPS_MERCHANT_ACCOUNT'
  | 'TECHNICAL_SUPPORT'
  | 'UPS_VIEW_ACCOUNT_DETAILS'
  | 'USER_DID_NOT_ACCEPT_TERMS';

export type RubberStamps = {
  readonly __typename: 'RubberStamps';
  readonly rubberStamp1: Scalars['String'];
  readonly rubberStamp2: Scalars['String'];
};

export type RubberStampsInput = {
  readonly rubberStamp1: Scalars['String'];
  readonly rubberStamp2: Scalars['String'];
};

export type ScanForm = {
  readonly __typename: 'ScanForm';
  readonly id: Scalars['ID'];
  readonly isNew: Scalars['Boolean'];
  readonly printableShipmentIds: ReadonlyArray<Scalars['String']>;
  readonly shipDate: Scalars['String'];
  readonly shipmentCount: Scalars['Int'];
  readonly updatedAt: Scalars['String'];
  readonly url: Scalars['String'];
};

export type ScanFormFile = {
  readonly __typename: 'ScanFormFile';
  readonly downloadUrl: Scalars['String'];
  readonly fileType: Scalars['String'];
  readonly id: Scalars['Int'];
};

export type ScanFormResult = {
  readonly __typename: 'ScanFormResult';
  readonly id: Scalars['ID'];
  readonly printableShipmentIds: ReadonlyArray<Scalars['String']>;
  readonly shipDate: Scalars['String'];
  readonly shipmentCount: Scalars['Int'];
  readonly updatedAt: Scalars['String'];
  readonly url: Scalars['String'];
};

export type SecretType = {
  readonly __typename: 'SecretType';
  readonly qrCode: Scalars['String'];
  readonly secret: Scalars['String'];
};

export type SelectOption = {
  readonly __typename: 'SelectOption';
  readonly label: Scalars['String'];
  readonly value: Scalars['String'];
};

export type SenderEmailMetadata = {
  readonly __typename: 'SenderEmailMetadata';
  readonly dkimHost: Scalars['String'];
  readonly dkimTextValue: Scalars['String'];
  readonly dkimVerified: Scalars['Boolean'];
  readonly domain: Scalars['String'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly returnPathDomain: Scalars['String'];
  readonly returnPathDomainCnameValue: Scalars['String'];
  readonly returnPathDomainVerified: Scalars['Boolean'];
  readonly senderName: Scalars['String'];
  readonly verificationStatus: Maybe<EmailVerificationStatus>;
};

export type Shipment = AddressInterface &
  BasicAddressInterface & {
    readonly __typename: 'Shipment';
    readonly additionalRefundNotice: Scalars['String'];
    readonly address1: Scalars['String'];
    readonly address2: Scalars['String'];
    /** This is the record type from SmartyStreets */
    readonly addressType: Scalars['String'];
    readonly adjustments: ReadonlyArray<ReconciliationAdjustment>;
    readonly baseClientPrice: Maybe<Scalars['Float']>;
    readonly baseClientPriceOriginal: Maybe<Scalars['Float']>;
    readonly batch: Batch;
    readonly canDisplayPrices: Scalars['Boolean'];
    readonly canInstantRefundShipment: Scalars['Boolean'];
    readonly canPrint: Scalars['Boolean'];
    readonly canShowMobileCode: Scalars['Boolean'];
    readonly carrierKey: Scalars['String'];
    readonly carrierTitle: Scalars['String'];
    readonly city: Scalars['String'];
    readonly company: Scalars['String'];
    readonly companyId: Scalars['String'];
    readonly countryCode: Scalars['String'];
    readonly countryId: Scalars['String'];
    readonly countryIdOriginal: Scalars['String'];
    readonly customsContentType: Scalars['String'];
    readonly customsFormEnabled: Scalars['Boolean'];
    /** todo: this should be named getCustomsItemsDescription, because it only returns a description of each customs item */
    readonly customsItems: ReadonlyArray<Maybe<Scalars['String']>>;
    readonly customsItemsObjects: ReadonlyArray<ShippingCustomsItem>;
    readonly customsSigner: Scalars['String'];
    readonly deliveryEstimation: Maybe<DeliveryEstimation>;
    readonly dimensionX: Scalars['Float'];
    readonly dimensionXOriginal: Scalars['Float'];
    readonly dimensionY: Scalars['Float'];
    readonly dimensionYOriginal: Scalars['Float'];
    readonly dimensionZ: Maybe<Scalars['Float']>;
    readonly dimensionZOriginal: Maybe<Scalars['Float']>;
    readonly errorMessage: Scalars['String'];
    readonly exporterTaxId: Maybe<Scalars['String']>;
    readonly foreignOrderId: Scalars['String'];
    readonly fullName: Scalars['String'];
    readonly hasBeenDownloaded: Scalars['Boolean'];
    readonly id: Scalars['ID'];
    readonly insuranceDetails: InsuranceDetailsType;
    /** @deprecated Use mailClass.groupKey === '93' instead */
    readonly isGroundSaver: Scalars['Boolean'];
    readonly isRedacted: Scalars['Boolean'];
    readonly isReturnLabel: Scalars['Boolean'];
    readonly isShipmentRefundable: Scalars['Boolean'];
    readonly location: Location;
    readonly mailClass: Maybe<CarrierMailClass>;
    /** @deprecated Use mailClass.mailClassKey instead */
    readonly mailClassKey: Maybe<Scalars['String']>;
    readonly mailClassOriginal: Maybe<CarrierMailClass>;
    readonly map: Scalars['String'];
    readonly notificationEmailSent: Scalars['Boolean'];
    readonly order: Maybe<Order>;
    readonly origin: Scalars['Boolean'];
    readonly originalId: Maybe<Scalars['ID']>;
    readonly packageType: CarrierPackageType;
    readonly packageTypeOriginal: CarrierPackageType;
    readonly passthroughFields: ReadonlyArray<ShipmentPassthroughFieldType>;
    readonly phone: Scalars['String'];
    readonly poBox: Scalars['Boolean'];
    readonly postcode: Scalars['String'];
    readonly recipientAddress: RecipientAddress;
    readonly recipientTaxId: Maybe<Scalars['String']>;
    readonly refundTimeNoticeShipmentDescription: Scalars['String'];
    readonly refundTimeNoticeShipmentTitle: Scalars['String'];
    readonly regionCode: Scalars['String'];
    readonly residential: Scalars['Boolean'];
    readonly rubberStamp1: Maybe<Scalars['String']>;
    readonly rubberStamp2: Maybe<Scalars['String']>;
    readonly rubberStamp3: Maybe<Scalars['String']>;
    readonly stageDotsStatus: ReadonlyArray<Scalars['String']>;
    readonly status: ShipmentStatus;
    readonly surcharges: Maybe<ReadonlyArray<ShipmentPrice>>;
    readonly timeZone: Scalars['String'];
    readonly totalClientPrice: Maybe<Scalars['Float']>;
    readonly totalClientPriceOriginal: Maybe<Scalars['Float']>;
    /**
     * Starts the creation of an export file if no exportId is specified. If exportId is specified, the request will
     * be treated as a status request for the existing export.
     */
    readonly trackingDataExportUrl: DataGridExportStatus;
    readonly trackingLink: Scalars['String'];
    readonly trackingNr: Maybe<Scalars['String']>;
    readonly valid: Scalars['Boolean'];
    readonly validationError: Scalars['String'];
    readonly warehouse: Maybe<Warehouse>;
    readonly weight: Scalars['Float'];
    readonly weightOriginal: Scalars['Float'];
    readonly zip4: Scalars['String'];
    readonly zone: Maybe<Scalars['String']>;
    readonly zoneOriginal: Maybe<Scalars['String']>;
  };

export type ShipmentMapArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ShipmentTrackingDataExportUrlArgs = {
  exportId?: InputMaybe<Scalars['Int']>;
};

export type ShipmentBoundaries = {
  readonly __typename: 'ShipmentBoundaries';
  readonly maxCombinedLength: Scalars['Float'];
  readonly maxLengthPlusGirth: Scalars['Float'];
  readonly maxLongSide: Scalars['Float'];
  readonly maxMiddleSide: Scalars['Float'];
  readonly maxShortSide: Scalars['Float'];
  readonly maxWeight: Scalars['Float'];
  readonly minLongSide: Scalars['Float'];
  readonly minMiddleSide: Scalars['Float'];
  readonly minShortSide: Scalars['Float'];
};

/** Enumeration of shipment keys */
export type ShipmentKey =
  | 'ADDRESS1'
  | 'ADDRESS2'
  | 'ADDRESS3'
  | 'CITY'
  | 'COMPANY'
  | 'COUNTRY_ID'
  | 'DIMENSION_X'
  | 'DIMENSION_Y'
  | 'DIMENSION_Z'
  | 'EMAIL'
  | 'EXPORTER_TAX_ID'
  | 'FIRST_NAME'
  | 'FOREIGN_ORDER_ID'
  | 'FULL_NAME'
  | 'LAST_NAME'
  | 'MIDDLE_NAME'
  | 'OMIT'
  | 'PASSTHROUGH'
  | 'PASSTHROUGH1'
  | 'PASSTHROUGH2'
  | 'PASSTHROUGH3'
  | 'PASSTHROUGH4'
  | 'PASSTHROUGH5'
  | 'PASSTHROUGH6'
  | 'PASSTHROUGH7'
  | 'PASSTHROUGH8'
  | 'PASSTHROUGH9'
  | 'PASSTHROUGH10'
  | 'PHONE'
  | 'POSTCODE'
  | 'RECIPIENT_TAX_ID'
  | 'REGION_ID'
  | 'RUBBER_STAMP1'
  | 'RUBBER_STAMP2'
  | 'RUBBER_STAMP3'
  | 'WEIGHT'
  | 'WEIGHT_POUNDS';

export type ShipmentMapping = {
  readonly __typename: 'ShipmentMapping';
  readonly firstValue: Scalars['String'];
  readonly id: Maybe<Scalars['ID']>;
  readonly ordering: Scalars['Int'];
  readonly shipmentKey: ShipmentKey;
  readonly userFriendlyShipmentKey: Scalars['String'];
  /**
   * For Spreadsheets, this will be the name of the column, for integrations the field in the imported order,
   * for values that come directly from a single shipment or from what the user entered in the form, it is the value
   */
  readonly valueOrMappingKey: Scalars['String'];
};

export type ShipmentMappingInput = {
  readonly ordering?: InputMaybe<Scalars['Int']>;
  readonly shipmentKey: ShipmentKey;
  readonly valueOrMappingKey: Scalars['String'];
};

export type ShipmentMobileCode = {
  readonly __typename: 'ShipmentMobileCode';
  readonly mobileCodeDataUri: Maybe<Scalars['String']>;
  readonly shipmentId: Maybe<Scalars['String']>;
};

export type ShipmentPassthroughFieldType = {
  readonly __typename: 'ShipmentPassthroughFieldType';
  readonly fieldName: Scalars['String'];
  readonly value: Scalars['String'];
};

export type ShipmentPreset = {
  readonly __typename: 'ShipmentPreset';
  readonly availableReturnLabelOptions: ReadonlyArray<SelectOption>;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customsContentType: Scalars['String'];
  readonly customsFormEnabled: Scalars['Boolean'];
  readonly customsItems: ReadonlyArray<CustomsItem>;
  readonly customsSigner: Scalars['String'];
  readonly deliveryConfirmation: DeliveryConfirmation;
  readonly deliveryConfirmationFlag: Scalars['Boolean'];
  readonly deliveryConfirmationTitle: Scalars['String'];
  readonly description: Scalars['String'];
  readonly dimensionX: Scalars['Float'];
  readonly dimensionY: Scalars['Float'];
  readonly dimensionZ: Scalars['Float'];
  readonly exporterTaxId: Scalars['String'];
  readonly hazardousMaterialsEnabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly insuredValue: Scalars['Float'];
  readonly insuredValueFlag: Scalars['Boolean'];
  readonly irregularPackage: Scalars['Boolean'];
  readonly originalId: Maybe<Scalars['ID']>;
  readonly packageTypeId: Scalars['String'];
  readonly packageTypeKey: Scalars['String'];
  readonly qualifiesAsMediaMail: Scalars['Boolean'];
  readonly recipientTaxId: Scalars['String'];
  readonly returnLabel: ReturnLabel;
  readonly returnLabelFlag: Scalars['Boolean'];
  /** If true, it is a single use preset created in the shipment form or has been deleted by the user */
  readonly shy: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly weight: Scalars['Float'];
};

export type ShipmentPresetInput = {
  readonly customsContentType: Scalars['String'];
  readonly customsFormEnabled: Scalars['Boolean'];
  readonly customsItems?: InputMaybe<ReadonlyArray<CustomsItemInput>>;
  readonly customsSigner: Scalars['String'];
  readonly deliveryConfirmation: DeliveryConfirmation;
  readonly deliveryConfirmationFlag: Scalars['Boolean'];
  readonly dimensionX: Scalars['Float'];
  readonly dimensionY: Scalars['Float'];
  readonly dimensionZ: Scalars['Float'];
  readonly exporterTaxId: Scalars['String'];
  readonly hazardousMaterialsEnabled: Scalars['Boolean'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly insuredValue: Scalars['Float'];
  readonly insuredValueFlag: Scalars['Boolean'];
  readonly irregularPackage: Scalars['Boolean'];
  readonly packageTypeKey: Scalars['String'];
  readonly qualifiesAsMediaMail: Scalars['Boolean'];
  readonly recipientTaxId: Scalars['String'];
  readonly returnLabel: ReturnLabel;
  readonly returnLabelFlag: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type ShipmentPrice = {
  readonly __typename: 'ShipmentPrice';
  readonly apiKey: Scalars['String'];
  readonly clientPrice: Scalars['Float'];
  readonly clientPriceOriginal: Scalars['Float'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly helpLink: Scalars['String'];
  readonly isIgnored: Scalars['Boolean'];
  readonly isOriginalSurcharge: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
};

export type ShipmentStatus =
  | 'CREATED'
  | 'IMPORTED'
  | 'INVALID'
  | 'PURCHASED'
  | 'PURCHASE_FAILED'
  | 'RATED'
  | 'RATE_FAILED'
  | 'REFUNDED'
  | 'REFUND_DECLINED'
  | 'REFUND_FAILED'
  | 'REFUND_REQUESTED'
  | 'REFUND_REVERSED'
  | 'RETURN_EXCEEDED'
  | 'RETURN_PURCHASED'
  | 'RETURN_UNUSED'
  | 'VALIDATED'
  | 'VALIDATION_FAILED';

export type ShipmentStatusSummary = {
  readonly __typename: 'ShipmentStatusSummary';
  readonly deliveredCount: Scalars['Int'];
  readonly errorCount: Scalars['Int'];
  readonly inTransitCount: Scalars['Int'];
  readonly mobileCodeShowableCount: Scalars['Int'];
  readonly printableCount: Scalars['Int'];
  readonly readyToPrintCount: Scalars['Int'];
  readonly readyToShipCount: Scalars['Int'];
  readonly refundPendingCount: Scalars['Int'];
  readonly refundableCount: Scalars['Int'];
  readonly refundedCount: Scalars['Int'];
};

export type ShipmentSummary = {
  readonly __typename: 'ShipmentSummary';
  /** The count of shipments per mail class */
  readonly mailClassCounts: ReadonlyArray<MailClassCount>;
  /** Whether a shipment of over 70 pounds is included */
  readonly overweightShipmentIncluded: Scalars['Boolean'];
  readonly totalCount: Scalars['Int'];
  readonly totalWeightLbs: Scalars['Float'];
  readonly totalWeightOz: Scalars['Float'];
};

export type ShipmentTrackingNumbers = {
  readonly __typename: 'ShipmentTrackingNumbers';
  readonly shipmentsDelivered: Scalars['Int'];
  readonly shipmentsDeliveryIssue: Scalars['Int'];
  readonly shipmentsNew: Scalars['Int'];
  readonly shipmentsTransit: Scalars['Int'];
};

export type ShipmentUpload = {
  readonly __typename: 'ShipmentUpload';
  readonly batch: Maybe<Batch>;
  readonly errorMessage: Scalars['String'];
  readonly fileFormat: Scalars['String'];
  readonly filename: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly mapping: ReadonlyArray<Maybe<ShipmentMapping>>;
  readonly suggestedMapping: ReadonlyArray<ShipmentMapping>;
  readonly uploadStatus: Scalars['String'];
};

export type ShippingCustomsItem = {
  readonly __typename: 'ShippingCustomsItem';
  readonly countryCodeOfOrigin: Scalars['String'];
  readonly hsTariffNumber: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly itemValue: Scalars['Float'];
  readonly quantity: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type ShopifyChannel = ChannelInterface & {
  readonly __typename: 'ShopifyChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly fulfillmentLocations: ReadonlyArray<ShopifyLocation>;
  readonly id: Scalars['ID'];
  readonly importLineItemsNotRequireShippingEnabled: Scalars['Boolean'];
  readonly importOrdersNewerThan: Maybe<Scalars['Int']>;
  readonly lastSync: Maybe<ChannelSync>;
  readonly locationsToImport: ReadonlyArray<Scalars['ID']>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type ShopifyLocation = {
  readonly __typename: 'ShopifyLocation';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type SpreedlyIframeParameters = {
  readonly __typename: 'SpreedlyIframeParameters';
  readonly certificateToken: Scalars['String'];
  readonly nonce: Scalars['String'];
  readonly signature: Scalars['String'];
  readonly timestamp: Scalars['String'];
};

export type SquareChannel = ChannelInterface & {
  readonly __typename: 'SquareChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly importCustomAttributes: Scalars['Boolean'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly locations: ReadonlyArray<SquareLocation>;
  readonly locationsToImport: ReadonlyArray<Scalars['ID']>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type SquareLocation = {
  readonly __typename: 'SquareLocation';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type SquarespaceChannel = ChannelInterface & {
  readonly __typename: 'SquarespaceChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type StageDot = {
  readonly __typename: 'StageDot';
  readonly message: Scalars['String'];
  readonly status: Scalars['String'];
  readonly title: Scalars['String'];
};

export type StateDistributionChart = {
  readonly __typename: 'StateDistributionChart';
  readonly stateDistributions: ReadonlyArray<DistributionChartItem>;
  readonly totalCount: Scalars['Int'];
};

export type Status = 'ACTIVE' | 'INACTIVE' | 'INVITED' | 'REVOKED';

export type SubblyChannel = ChannelInterface & {
  readonly __typename: 'SubblyChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly clientSecret: Scalars['String'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type Summary = {
  readonly __typename: 'Summary';
  readonly amount: Scalars['Float'];
  readonly count: Scalars['Float'];
};

export type SupportSearchResult = {
  readonly __typename: 'SupportSearchResult';
  readonly id: Scalars['String'];
  readonly label: Scalars['String'];
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
};

export type SurchargePriceInput = {
  readonly price: Scalars['Float'];
  readonly surchargeKey: Scalars['String'];
};

export type SyncStatusResult = {
  readonly __typename: 'SyncStatusResult';
  readonly autosyncRequired: Scalars['Boolean'];
  readonly hasError: Scalars['Boolean'];
  readonly info: Scalars['String'];
  readonly isRunning: Scalars['Boolean'];
  readonly messages: ReadonlyArray<Scalars['String']>;
  readonly progress: Scalars['Int'];
  readonly timestamp: Scalars['Int'];
};

export type Timezone = {
  readonly __typename: 'Timezone';
  readonly description: Scalars['String'];
  readonly ianaName: Scalars['String'];
};

export type TwoFactorAuthenticationConfiguration = {
  readonly __typename: 'TwoFactorAuthenticationConfiguration';
  readonly activeProvider: Maybe<Provider>;
  readonly hasMultipleConfirmedProviders: Scalars['Boolean'];
  readonly staySignedIn: Scalars['Boolean'];
};

export type TwoFactorProvider = {
  readonly __typename: 'TwoFactorProvider';
  readonly active: Scalars['Boolean'];
  readonly confirmed: Scalars['Boolean'];
  readonly provider: Provider;
};

export type UpdateBigcartelChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateBigcommerceChannelInput = {
  readonly apiUrl: Scalars['String'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly clientSecret?: InputMaybe<Scalars['String']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateCratejoyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly clientId: Scalars['String'];
  readonly clientSecret?: InputMaybe<Scalars['String']>;
  readonly skipFutureSubscriptions: Scalars['Boolean'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateDiscogsChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly clientSecret?: InputMaybe<Scalars['String']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateEbayChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
};

export type UpdateEcwidChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly customFulfillmentStatusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateEtsyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateFakeshopChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly orderGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly title: Scalars['String'];
};

export type UpdatePaypalChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly genericLineItemEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateShipmentPresetResult = {
  readonly __typename: 'UpdateShipmentPresetResult';
  readonly default: Scalars['Boolean'];
  readonly shipmentPreset: ShipmentPreset;
};

export type UpdateShopifyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly importLineItemsNotRequireShippingEnabled: Scalars['Boolean'];
  readonly importOrdersNewerThan?: InputMaybe<Scalars['Int']>;
  readonly locationsToImport: ReadonlyArray<Scalars['ID']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateSquareChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly importCustomAttributes: Scalars['Boolean'];
  readonly locationsToImport: ReadonlyArray<Scalars['ID']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateSquarespaceChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly clientSecret?: InputMaybe<Scalars['String']>;
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateSubblyChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly clientSecret?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateWixChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UpdateWoocommerceChannelInput = {
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly channelId: Scalars['ID'];
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
};

export type UrlType = 'External' | 'Intercom' | 'Internal';

export type User = {
  readonly __typename: 'User';
  readonly activePlatforms: ReadonlyArray<Platform>;
  readonly admin: Scalars['Boolean'];
  readonly company: Company;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly email: Scalars['String'];
  readonly emailVerified: Scalars['Boolean'];
  readonly firstName: Scalars['String'];
  readonly groupId: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly rateGroupSortOrder: RateGroupSortOrder;
  readonly roles: ReadonlyArray<Role>;
  readonly status: Status;
  readonly timezone: Scalars['String'];
  readonly twoFactorAuthenticationProviders: ReadonlyArray<TwoFactorProvider>;
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly userHash: Scalars['String'];
};

export type UserTerms = {
  readonly __typename: 'UserTerms';
  readonly id: Scalars['ID'];
  readonly terms: Scalars['String'];
};

export type Warehouse = {
  readonly __typename: 'Warehouse';
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly originAddress: Address;
  readonly originalId: Maybe<Scalars['ID']>;
  readonly returnAddress: Address;
  readonly scanForms: ReadonlyArray<ScanForm>;
  /** If true, it is a single use warehouse created in the shipment form or has been deleted by the user */
  readonly shy: Scalars['Boolean'];
  readonly title: Maybe<Scalars['String']>;
  readonly totalAvailableLabelsForScanForm: Maybe<Scalars['Int']>;
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly useOriginAsReturnAddress: Scalars['Boolean'];
};

export type WixChannel = ChannelInterface & {
  readonly __typename: 'WixChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type WoocommerceChannel = ChannelInterface & {
  readonly __typename: 'WoocommerceChannel';
  readonly active: Scalars['Boolean'];
  readonly autoSyncEnabled: Scalars['Boolean'];
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly customOptions: ReadonlyArray<CustomOption>;
  readonly id: Scalars['ID'];
  readonly lastSync: Maybe<ChannelSync>;
  readonly mappableFields: ReadonlyArray<PlatformMappableField>;
  readonly platform: Maybe<Platform>;
  readonly reconnectUrl: Maybe<Scalars['String']>;
  readonly rubberstampConfig: ReadonlyArray<ChannelRubberstampConfig>;
  readonly shopUrl: Scalars['String'];
  readonly statusesToImport: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly trackingEmailsEnabled: Scalars['Boolean'];
  readonly updatedAt: Maybe<Scalars['DateTime']>;
  readonly valid: Scalars['Boolean'];
};

export type ConfirmTwoFactorAuthenticationProviderMutationVariables = Exact<{
  provider: Provider;
  code: Scalars['String'];
}>;

export type ConfirmTwoFactorAuthenticationProviderMutation = {
  readonly confirmTwoFactorAuthenticationProvider: {
    readonly __typename: 'User';
    readonly id: string;
    readonly email: string;
    readonly emailVerified: boolean;
    readonly firstName: string;
    readonly lastName: string;
    readonly timezone: string;
    readonly roles: ReadonlyArray<Role>;
    readonly admin: boolean;
    readonly userHash: string;
    readonly createdAt: string | null;
    readonly status: Status;
    readonly twoFactorAuthenticationProviders: ReadonlyArray<{
      readonly __typename: 'TwoFactorProvider';
      readonly provider: Provider;
      readonly confirmed: boolean;
      readonly active: boolean;
    }>;
  };
};

export type DeleteTwoFactorAuthenticationProviderMutationVariables = Exact<{
  provider: Provider;
  password: Scalars['String'];
}>;

export type DeleteTwoFactorAuthenticationProviderMutation = {
  readonly deleteTwoFactorAuthenticationProvider: {
    readonly __typename: 'User';
    readonly id: string;
    readonly email: string;
    readonly emailVerified: boolean;
    readonly firstName: string;
    readonly lastName: string;
    readonly timezone: string;
    readonly roles: ReadonlyArray<Role>;
    readonly admin: boolean;
    readonly userHash: string;
    readonly createdAt: string | null;
    readonly status: Status;
    readonly twoFactorAuthenticationProviders: ReadonlyArray<{
      readonly __typename: 'TwoFactorProvider';
      readonly provider: Provider;
      readonly confirmed: boolean;
      readonly active: boolean;
    }>;
  };
};

export type InstallTwoFactorAuthenticationProviderMutationVariables = Exact<{
  provider: Provider;
}>;

export type InstallTwoFactorAuthenticationProviderMutation = {
  readonly installTwoFactorAuthenticationProvider: {
    readonly __typename: 'InstallTwoFactorAuthenticationResultType';
    readonly secret: {
      readonly __typename: 'SecretType';
      readonly qrCode: string;
      readonly secret: string;
    } | null;
    readonly user: {
      readonly __typename: 'User';
      readonly id: string;
      readonly email: string;
      readonly emailVerified: boolean;
      readonly firstName: string;
      readonly lastName: string;
      readonly timezone: string;
      readonly roles: ReadonlyArray<Role>;
      readonly admin: boolean;
      readonly userHash: string;
      readonly createdAt: string | null;
      readonly status: Status;
      readonly twoFactorAuthenticationProviders: ReadonlyArray<{
        readonly __typename: 'TwoFactorProvider';
        readonly provider: Provider;
        readonly confirmed: boolean;
        readonly active: boolean;
      }>;
    };
  };
};

export type ProvideOtpMutationVariables = Exact<{ [key: string]: never }>;

export type ProvideOtpMutation = { readonly provideCode: boolean };

export type TwoFactorAuthenticationConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type TwoFactorAuthenticationConfigurationQuery = {
  readonly twoFactorAuthenticationConfiguration: {
    readonly __typename: 'TwoFactorAuthenticationConfiguration';
    readonly activeProvider: Provider | null;
    readonly hasMultipleConfirmedProviders: boolean;
    readonly staySignedIn: boolean;
  };
};

export type SendResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type SendResetPasswordLinkMutation = { readonly sendResetPasswordLink: string };

export type UpdateAccountEmailMutationVariables = Exact<{
  email: Scalars['String'];
  currentPassword?: InputMaybe<Scalars['String']>;
  otp?: InputMaybe<Scalars['String']>;
}>;

export type UpdateAccountEmailMutation = {
  readonly updateAccountEmail: {
    readonly __typename: 'User';
    readonly id: string;
    readonly email: string;
    readonly emailVerified: boolean;
  };
};

export type UpdateAccountProfileMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  timezone: Scalars['String'];
  currentPassword: Scalars['String'];
}>;

export type UpdateAccountProfileMutation = {
  readonly updateAccountProfile: {
    readonly __typename: 'User';
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly timezone: string;
  };
};

export type UpdateNotificationsSettingsMutationVariables = Exact<{
  carrierAdjustmentsNotificationEnabled: Scalars['Boolean'];
  paymentReceiptsNotificationEnabled: Scalars['Boolean'];
  paymentFailuresNotificationEnabled: Scalars['Boolean'];
  newLoginNotificationEnabled: Scalars['Boolean'];
  carrierAdjustmentDisputesEnabled: Scalars['Boolean'];
  newFeaturesAnnouncementsNotificationEnabled: Scalars['Boolean'];
}>;

export type UpdateNotificationsSettingsMutation = {
  readonly updateNotificationsSettings: {
    readonly __typename: 'NotificationsSettings';
    readonly carrierAdjustmentsNotificationEnabled: boolean;
    readonly paymentReceiptsNotificationEnabled: boolean;
    readonly paymentFailuresNotificationEnabled: boolean;
    readonly newLoginNotificationEnabled: boolean;
    readonly carrierAdjustmentDisputesEnabled: boolean;
    readonly newFeaturesAnnouncementsNotificationEnabled: boolean;
  };
};

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type AccountSettingsQuery = {
  readonly timezones: ReadonlyArray<{
    readonly __typename: 'Timezone';
    readonly ianaName: string;
    readonly description: string;
  }>;
  readonly user: {
    readonly __typename: 'User';
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string;
    readonly emailVerified: boolean;
    readonly timezone: string;
    readonly twoFactorAuthenticationProviders: ReadonlyArray<{
      readonly __typename: 'TwoFactorProvider';
      readonly provider: Provider;
      readonly confirmed: boolean;
    }>;
  };
  readonly notificationsSettings: {
    readonly __typename: 'NotificationsSettings';
    readonly carrierAdjustmentsNotificationEnabled: boolean;
    readonly paymentReceiptsNotificationEnabled: boolean;
    readonly paymentFailuresNotificationEnabled: boolean;
    readonly newLoginNotificationEnabled: boolean;
    readonly carrierAdjustmentDisputesEnabled: boolean;
    readonly newFeaturesAnnouncementsNotificationEnabled: boolean;
  };
};

export type DisputeAdjustmentsMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  disputeReason: Scalars['String'];
}>;

export type DisputeAdjustmentsMutation = {
  readonly disputeAdjustments: ReadonlyArray<{
    readonly __typename: 'ReconciliationAdjustment';
    readonly id: string;
    readonly disputedAt: string | null;
    readonly disputeStatus: DisputeStatus;
  }>;
};

export type EmulateViaShipmentMutationVariables = Exact<{
  shipmentId: Scalars['String'];
}>;

export type EmulateViaShipmentMutation = { readonly emulateViaShipment: boolean };

export type UpdateBlockedCountriesMutationVariables = Exact<{
  carrierKey: CarrierKey;
  blockedCountries: ReadonlyArray<BlockedCountryInput> | BlockedCountryInput;
}>;

export type UpdateBlockedCountriesMutation = {
  readonly updateBlockedCountries: ReadonlyArray<{
    readonly __typename: 'BlockedCountry';
    readonly twoCharIsoCode: string;
    readonly blockReason: string;
  }>;
};

export type CaptainsNotesQueryVariables = Exact<{ [key: string]: never }>;

export type CaptainsNotesQuery = { readonly captainsNotes: ReadonlyArray<string> };

export type BlockedCountriesQueryVariables = Exact<{
  carrierKey: CarrierKey;
}>;

export type BlockedCountriesQuery = {
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
  readonly blockedCountries: ReadonlyArray<{
    readonly __typename: 'BlockedCountry';
    readonly twoCharIsoCode: string;
    readonly blockReason: string;
  }>;
};

export type NavbarLinksQueryVariables = Exact<{ [key: string]: never }>;

export type NavbarLinksQuery = {
  readonly spyglassLink: string;
  readonly navbarLinks: ReadonlyArray<{
    readonly __typename: 'NavbarLink';
    readonly url: string;
    readonly text: string;
    readonly children: ReadonlyArray<{
      readonly __typename: 'NavbarLink';
      readonly url: string;
      readonly text: string;
    }> | null;
  }>;
  readonly navbarMetaLinks: ReadonlyArray<{
    readonly __typename: 'NavbarLink';
    readonly url: string;
    readonly text: string;
    readonly children: ReadonlyArray<{
      readonly __typename: 'NavbarLink';
      readonly url: string;
      readonly text: string;
    }> | null;
  }>;
};

export type SupportSearchQueryVariables = Exact<{
  term: Scalars['String'];
}>;

export type SupportSearchQuery = {
  readonly supportSearch: ReadonlyArray<{
    readonly __typename: 'SupportSearchResult';
    readonly id: string;
    readonly type: string;
    readonly label: string;
    readonly value: string;
  }>;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  readonly user: {
    readonly __typename: 'User';
    readonly id: string;
    readonly email: string;
    readonly emailVerified: boolean;
    readonly firstName: string;
    readonly lastName: string;
    readonly timezone: string;
    readonly roles: ReadonlyArray<Role>;
    readonly admin: boolean;
    readonly userHash: string;
    readonly createdAt: string | null;
    readonly status: Status;
    readonly company: {
      readonly __typename: 'Company';
      readonly id: string;
      readonly title: string;
      readonly debuggingEnabled: boolean;
      readonly hasAnyPlaidPaymentSource: boolean;
      readonly emulating: boolean;
      readonly features: ReadonlyArray<{
        readonly __typename: 'Feature';
        readonly key: string;
        readonly value: boolean;
      }>;
    };
    readonly activePlatforms: ReadonlyArray<{
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    }>;
    readonly twoFactorAuthenticationProviders: ReadonlyArray<{
      readonly __typename: 'TwoFactorProvider';
      readonly provider: Provider;
      readonly confirmed: boolean;
      readonly active: boolean;
    }>;
  };
};

export type BatchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BatchQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
    readonly status: BatchStatusTag;
    readonly stepText: string;
    readonly shipDatePossibleNow: boolean;
    readonly dockOrderIds: ReadonlyArray<string>;
    readonly numShipments: number;
    readonly shipDate: string;
    readonly dataSource: BatchSource;
    readonly labelFileFormat: FileFormat;
    readonly labelSize: LabelSize;
    readonly labelingArtifactType: LabelingArtifactType;
    readonly eligibleForInsurance: boolean;
    readonly customsFormRequired: boolean;
    readonly emailNotificationPossible: boolean;
    readonly warehouse: {
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly poBox: boolean;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    };
    readonly spreadsheetMapping: ReadonlyArray<{
      readonly __typename: 'ShipmentMapping';
      readonly id: string | null;
      readonly shipmentKey: ShipmentKey;
      readonly valueOrMappingKey: string;
    }>;
    readonly packageSummary: {
      readonly __typename: 'BatchPackageSummary';
      readonly maxWeight: number;
      readonly minWeight: number;
      readonly maxInsured: number;
      readonly minInsured: number;
      readonly dimensionsSummary: string;
      readonly packageTypeSummary: string;
      readonly deliveryConfirmationSummary: string;
      readonly packagePreset: {
        readonly __typename: 'ShipmentPreset';
        readonly id: string;
        readonly shy: boolean;
        readonly packageTypeKey: string;
        readonly dimensionX: number;
        readonly dimensionY: number;
        readonly dimensionZ: number;
        readonly weight: number;
        readonly insuredValueFlag: boolean;
        readonly insuredValue: number;
        readonly deliveryConfirmationFlag: boolean;
        readonly deliveryConfirmation: DeliveryConfirmation;
        readonly returnLabelFlag: boolean;
        readonly returnLabel: ReturnLabel;
        readonly qualifiesAsMediaMail: boolean;
        readonly irregularPackage: boolean;
        readonly hazardousMaterialsEnabled: boolean;
        readonly customsFormEnabled: boolean;
        readonly customsSigner: string;
        readonly customsContentType: string;
        readonly exporterTaxId: string;
        readonly recipientTaxId: string;
        readonly title: string;
        readonly customsItems: ReadonlyArray<{
          readonly __typename: 'CustomsItem';
          readonly title: string;
          readonly quantity: number;
          readonly itemValue: number;
          readonly weight: number;
          readonly hsTariffNumber: string;
          readonly countryCodeOfOrigin: string;
        }>;
      } | null;
    };
    readonly customsFormSummary: {
      readonly __typename: 'BatchCustomsFormSummary';
      readonly numCustomsForms: number;
      readonly signer: string;
      readonly title: string;
      readonly contentType: string;
      readonly itemSummary: ReadonlyArray<string>;
      readonly exporterTaxIdSummary: string;
    };
    readonly shipmentStatusSummary: {
      readonly __typename: 'ShipmentStatusSummary';
      readonly errorCount: number;
    };
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly isReturnLabel: boolean;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number | null;
      readonly weight: number;
      readonly customsFormEnabled: boolean;
      readonly rubberStamp1: string | null;
      readonly rubberStamp2: string | null;
      readonly rubberStamp3: string | null;
      readonly exporterTaxId: string | null;
      readonly recipientTaxId: string | null;
      readonly insuranceDetails: {
        readonly __typename: 'InsuranceDetailsType';
        readonly isShippingCostInsured: boolean;
      };
      readonly order: {
        readonly __typename: 'Order';
        readonly id: string;
        readonly foreignOrderId: string;
        readonly platformKey: string;
        readonly orderLink: {
          readonly __typename: 'Link';
          readonly text: string;
          readonly url: string;
        } | null;
        readonly shipmentLink: {
          readonly __typename: 'Link';
          readonly url: string;
          readonly text: string;
        } | null;
        readonly subscriptionLink: {
          readonly __typename: 'Link';
          readonly url: string;
          readonly text: string;
        } | null;
        readonly platform: { readonly __typename: 'Platform'; readonly title: string };
        readonly orderItems: ReadonlyArray<{
          readonly __typename: 'OrderItem';
          readonly quantity: number;
          readonly title: string;
          readonly sku: string;
        }>;
      } | null;
      readonly recipientAddress: {
        readonly __typename: 'RecipientAddress';
        readonly address3: string;
        readonly email: string | null;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly customsItemsObjects: ReadonlyArray<{
        readonly __typename: 'ShippingCustomsItem';
        readonly title: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly hsTariffNumber: string;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
    readonly rateGroups: ReadonlyArray<{
      readonly __typename: 'RateGroup';
      readonly maximumShipments: number;
      readonly defaultShipDate: string;
      readonly affectedByUpsRateLimit: boolean;
      readonly groupKey: {
        readonly __typename: 'RateGroupKey';
        readonly string: string;
        readonly traits: ReadonlyArray<{
          readonly __typename: 'RateGroupTrait';
          readonly layer: RateGroupLayerKey;
          readonly value: RateGroupTraitKey;
        }>;
      };
      readonly rateSummaries: ReadonlyArray<{
        readonly __typename: 'RateSummary';
        readonly availableShipDates: ReadonlyArray<string>;
        readonly serviceTitle: string;
        readonly mailClassTitle: string;
        readonly averageBasePrice: number;
        readonly averageTotalPrice: number;
        readonly basePrice: number;
        readonly best: boolean;
        readonly cheapest: boolean;
        readonly crossedTotalPrice: number;
        readonly deliveryDays: number;
        readonly fastest: boolean;
        readonly flatPrice: boolean;
        readonly ratePeriodEndDate: string | null;
        readonly ratePeriodStartDate: string | null;
        readonly errorMessage: string | null;
        readonly savings: string;
        readonly shipmentCount: number;
        readonly totalPrice: number;
        readonly uniqueId: string;
        readonly firstZone: string;
        readonly maxWeightOz: number;
        readonly valueLimit: number;
        readonly upsellRateSummary: {
          readonly __typename: 'RateSummary';
          readonly mailClassTitle: string;
          readonly totalPrice: number;
          readonly uniqueId: string;
          readonly carrier: {
            readonly __typename: 'Carrier';
            readonly carrierKey: CarrierKey;
            readonly title: string;
          };
          readonly firstMailClass: {
            readonly __typename: 'CarrierMailClass';
            readonly mailClassKey: string;
          };
        } | null;
        readonly carrier: {
          readonly __typename: 'Carrier';
          readonly carrierKey: CarrierKey;
          readonly title: string;
        };
        readonly firstMailClass: {
          readonly __typename: 'CarrierMailClass';
          readonly mailClassKey: string;
        };
        readonly packageType: {
          readonly __typename: 'CarrierPackageType';
          readonly packageTypeKey: string;
        };
        readonly surcharges: ReadonlyArray<{
          readonly __typename: 'RateSurchargeSummary';
          readonly surchargeKey: string;
          readonly title: string;
          readonly price: number;
          readonly helpLink: string | null;
          readonly crossedPrice: number | null;
        }>;
      }>;
    }>;
  };
  readonly user: {
    readonly __typename: 'User';
    readonly id: string;
    readonly rateGroupSortOrder: RateGroupSortOrder;
    readonly email: string;
    readonly timezone: string;
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly accountBalance: number;
    readonly hasAnyPlaidPaymentSource: boolean;
    readonly isFirstLabel: boolean;
    readonly activePaymentMethods: ReadonlyArray<PaymentMethodType>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly shipmentLabelSize: string;
      readonly shipmentLabelFileFormat: string;
      readonly packingListTemplate: string;
      readonly shipmentSpreadsheetFormat: string;
      readonly addressCorrection: string;
      readonly defaultTrackingEmailsDelay: string;
      readonly defaultTrackingEmailsEnabled: boolean;
      readonly defaultEmailTemplateId: string;
      readonly defaultChargeAmount: number;
      readonly defaultPaymentSourceId: string;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
    readonly merchantAccounts: ReadonlyArray<{
      readonly __typename: 'MerchantAccount';
      readonly id: string;
      readonly carrierKey: CarrierKey;
      readonly accountStatus: MerchantAccountTransmissionStatus | null;
      readonly errorCategory: MerchantAccountErrorCategory | null;
      readonly errorMessage: string;
      readonly termsAndConditionsOutdated: boolean;
    }>;
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly subject: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
    }>;
  };
  readonly paymentApiMethods: ReadonlyArray<{
    readonly __typename: 'PaymentApiMethod';
    readonly id: string;
    readonly code: PaymentMethodType;
    readonly apiTitle: PaymentApiMethodTitle;
    readonly apiKey: string | null;
  }>;
};

export type BuyBatchMutationVariables = Exact<{
  id: Scalars['ID'];
  rateSelection: ReadonlyArray<RateSelectionInput> | RateSelectionInput;
  paymentSourceId: Scalars['ID'];
  shipDate: Scalars['DateTime'];
  totalCharge: Scalars['Float'];
  mailTemplateId?: InputMaybe<Scalars['ID']>;
  notifyRecipientsDate?: InputMaybe<Scalars['String']>;
}>;

export type BuyBatchMutation = {
  readonly buyBatch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly shipDate: string;
    readonly numShipments: number;
    readonly shipments: ReadonlyArray<{ readonly __typename: 'Shipment'; readonly id: string }>;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type ModifyInsuranceOnRatedBatchMutationVariables = Exact<{
  id: Scalars['ID'];
  insuredValue: Scalars['Float'];
}>;

export type ModifyInsuranceOnRatedBatchMutation = {
  readonly modifyInsuranceOnRatedBatch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
    readonly status: BatchStatusTag;
    readonly stepText: string;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
    readonly rateGroups: ReadonlyArray<{
      readonly __typename: 'RateGroup';
      readonly maximumShipments: number;
      readonly defaultShipDate: string;
      readonly affectedByUpsRateLimit: boolean;
      readonly groupKey: {
        readonly __typename: 'RateGroupKey';
        readonly string: string;
        readonly traits: ReadonlyArray<{
          readonly __typename: 'RateGroupTrait';
          readonly layer: RateGroupLayerKey;
          readonly value: RateGroupTraitKey;
        }>;
      };
      readonly rateSummaries: ReadonlyArray<{
        readonly __typename: 'RateSummary';
        readonly availableShipDates: ReadonlyArray<string>;
        readonly serviceTitle: string;
        readonly mailClassTitle: string;
        readonly averageBasePrice: number;
        readonly averageTotalPrice: number;
        readonly basePrice: number;
        readonly best: boolean;
        readonly cheapest: boolean;
        readonly crossedTotalPrice: number;
        readonly deliveryDays: number;
        readonly fastest: boolean;
        readonly flatPrice: boolean;
        readonly ratePeriodEndDate: string | null;
        readonly ratePeriodStartDate: string | null;
        readonly errorMessage: string | null;
        readonly savings: string;
        readonly shipmentCount: number;
        readonly totalPrice: number;
        readonly uniqueId: string;
        readonly firstZone: string;
        readonly maxWeightOz: number;
        readonly valueLimit: number;
        readonly upsellRateSummary: {
          readonly __typename: 'RateSummary';
          readonly mailClassTitle: string;
          readonly totalPrice: number;
          readonly uniqueId: string;
          readonly carrier: {
            readonly __typename: 'Carrier';
            readonly carrierKey: CarrierKey;
            readonly title: string;
          };
          readonly firstMailClass: {
            readonly __typename: 'CarrierMailClass';
            readonly mailClassKey: string;
          };
        } | null;
        readonly carrier: {
          readonly __typename: 'Carrier';
          readonly carrierKey: CarrierKey;
          readonly title: string;
        };
        readonly firstMailClass: {
          readonly __typename: 'CarrierMailClass';
          readonly mailClassKey: string;
        };
        readonly packageType: {
          readonly __typename: 'CarrierPackageType';
          readonly packageTypeKey: string;
        };
        readonly surcharges: ReadonlyArray<{
          readonly __typename: 'RateSurchargeSummary';
          readonly surchargeKey: string;
          readonly title: string;
          readonly price: number;
          readonly helpLink: string | null;
          readonly crossedPrice: number | null;
        }>;
      }>;
    }>;
  };
};

export type RateGroupsFragment = {
  readonly __typename: 'Batch';
  readonly rateGroups: ReadonlyArray<{
    readonly __typename: 'RateGroup';
    readonly maximumShipments: number;
    readonly defaultShipDate: string;
    readonly affectedByUpsRateLimit: boolean;
    readonly groupKey: {
      readonly __typename: 'RateGroupKey';
      readonly string: string;
      readonly traits: ReadonlyArray<{
        readonly __typename: 'RateGroupTrait';
        readonly layer: RateGroupLayerKey;
        readonly value: RateGroupTraitKey;
      }>;
    };
    readonly rateSummaries: ReadonlyArray<{
      readonly __typename: 'RateSummary';
      readonly availableShipDates: ReadonlyArray<string>;
      readonly serviceTitle: string;
      readonly mailClassTitle: string;
      readonly averageBasePrice: number;
      readonly averageTotalPrice: number;
      readonly basePrice: number;
      readonly best: boolean;
      readonly cheapest: boolean;
      readonly crossedTotalPrice: number;
      readonly deliveryDays: number;
      readonly fastest: boolean;
      readonly flatPrice: boolean;
      readonly ratePeriodEndDate: string | null;
      readonly ratePeriodStartDate: string | null;
      readonly errorMessage: string | null;
      readonly savings: string;
      readonly shipmentCount: number;
      readonly totalPrice: number;
      readonly uniqueId: string;
      readonly firstZone: string;
      readonly maxWeightOz: number;
      readonly valueLimit: number;
      readonly upsellRateSummary: {
        readonly __typename: 'RateSummary';
        readonly mailClassTitle: string;
        readonly totalPrice: number;
        readonly uniqueId: string;
        readonly carrier: {
          readonly __typename: 'Carrier';
          readonly carrierKey: CarrierKey;
          readonly title: string;
        };
        readonly firstMailClass: {
          readonly __typename: 'CarrierMailClass';
          readonly mailClassKey: string;
        };
      } | null;
      readonly carrier: {
        readonly __typename: 'Carrier';
        readonly carrierKey: CarrierKey;
        readonly title: string;
      };
      readonly firstMailClass: {
        readonly __typename: 'CarrierMailClass';
        readonly mailClassKey: string;
      };
      readonly packageType: {
        readonly __typename: 'CarrierPackageType';
        readonly packageTypeKey: string;
      };
      readonly surcharges: ReadonlyArray<{
        readonly __typename: 'RateSurchargeSummary';
        readonly surchargeKey: string;
        readonly title: string;
        readonly price: number;
        readonly helpLink: string | null;
        readonly crossedPrice: number | null;
      }>;
    }>;
  }>;
};

export type RerateBatchMutationVariables = Exact<{
  id: Scalars['ID'];
  shipDate?: InputMaybe<Scalars['DateTime']>;
}>;

export type RerateBatchMutation = {
  readonly rerateBatch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly shipDate: string;
    readonly shipDatePossibleNow: boolean;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type SetBatchToNewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SetBatchToNewMutation = {
  readonly setBatchToNew: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
  };
};

export type UpdateRateGroupSortOrderMutationVariables = Exact<{
  sortOrder: RateGroupSortOrder;
}>;

export type UpdateRateGroupSortOrderMutation = {
  readonly updateRateGroupSortOrder: {
    readonly __typename: 'User';
    readonly id: string;
    readonly rateGroupSortOrder: RateGroupSortOrder;
  };
};

export type DummyDataGridInputTypeUsageQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ReadonlyArray<DataGridFilterInput> | DataGridFilterInput>;
  sorting?: InputMaybe<ReadonlyArray<DataGridSortingInput> | DataGridSortingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type DummyDataGridInputTypeUsageQuery = {
  readonly shipmentReport: {
    readonly __typename: 'DataGridResult';
    readonly id: string;
    readonly rows: {
      readonly __typename: 'DataGridResultRows';
      readonly totalCount: number;
      readonly nodes: ReadonlyArray<object>;
    };
  };
  readonly receiptsReport: {
    readonly __typename: 'DataGridResult';
    readonly id: string;
    readonly rows: {
      readonly __typename: 'DataGridResultRows';
      readonly totalCount: number;
      readonly nodes: ReadonlyArray<object>;
    };
  };
};

type AddressFragment_Address_ = {
  readonly __typename: 'Address';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

type AddressFragment_BasicAddress_ = {
  readonly __typename: 'BasicAddress';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

type AddressFragment_DockOrder_ = {
  readonly __typename: 'DockOrder';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

type AddressFragment_HistoricShipmentAddress_ = {
  readonly __typename: 'HistoricShipmentAddress';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

type AddressFragment_RecipientAddress_ = {
  readonly __typename: 'RecipientAddress';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

type AddressFragment_Shipment_ = {
  readonly __typename: 'Shipment';
  readonly fullName: string;
  readonly company: string;
  readonly address1: string;
  readonly address2: string;
  readonly city: string;
  readonly regionCode: string;
  readonly postcode: string;
  readonly zip4: string;
  readonly countryCode: string;
};

export type AddressFragment =
  | AddressFragment_Address_
  | AddressFragment_BasicAddress_
  | AddressFragment_DockOrder_
  | AddressFragment_HistoricShipmentAddress_
  | AddressFragment_RecipientAddress_
  | AddressFragment_Shipment_;

export type BasicPlatformFragment = {
  readonly __typename: 'Platform';
  readonly id: string;
  readonly platformKey: string;
  readonly title: string;
};

export type BasicUserFragment = {
  readonly __typename: 'User';
  readonly id: string;
  readonly email: string;
  readonly emailVerified: boolean;
  readonly firstName: string;
  readonly lastName: string;
  readonly timezone: string;
  readonly roles: ReadonlyArray<Role>;
  readonly admin: boolean;
  readonly userHash: string;
  readonly createdAt: string | null;
  readonly status: Status;
  readonly twoFactorAuthenticationProviders: ReadonlyArray<{
    readonly __typename: 'TwoFactorProvider';
    readonly provider: Provider;
    readonly confirmed: boolean;
    readonly active: boolean;
  }>;
};

export type CountryFragment = {
  readonly __typename: 'Country';
  readonly id: string;
  readonly name: string;
  readonly postcodeRequired: boolean;
  readonly countryCode: string;
  readonly countryCode3: string;
  readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
};

export type CurrentUserFragment = {
  readonly __typename: 'User';
  readonly id: string;
  readonly email: string;
  readonly emailVerified: boolean;
  readonly firstName: string;
  readonly lastName: string;
  readonly timezone: string;
  readonly roles: ReadonlyArray<Role>;
  readonly admin: boolean;
  readonly userHash: string;
  readonly createdAt: string | null;
  readonly status: Status;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly title: string;
    readonly debuggingEnabled: boolean;
    readonly hasAnyPlaidPaymentSource: boolean;
    readonly emulating: boolean;
    readonly features: ReadonlyArray<{
      readonly __typename: 'Feature';
      readonly key: string;
      readonly value: boolean;
    }>;
  };
  readonly activePlatforms: ReadonlyArray<{
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  }>;
  readonly twoFactorAuthenticationProviders: ReadonlyArray<{
    readonly __typename: 'TwoFactorProvider';
    readonly provider: Provider;
    readonly confirmed: boolean;
    readonly active: boolean;
  }>;
};

export type DataGridResultUserSettingsFragment = {
  readonly __typename: 'DataGridResult';
  readonly userSettings: {
    readonly __typename: 'DataGridSettings';
    readonly columnOrder: ReadonlyArray<string>;
    readonly pageSize: number;
    readonly columns: ReadonlyArray<{
      readonly __typename: 'DataGridColumnOverride';
      readonly field: string;
      readonly width: number;
      readonly hidden: boolean;
    }>;
    readonly sorting: ReadonlyArray<{
      readonly __typename: 'DataGridSorting';
      readonly field: string;
      readonly direction: string;
    }>;
  } | null;
};

export type DataGridSettingsFragment = {
  readonly __typename: 'DataGridSettings';
  readonly columnOrder: ReadonlyArray<string>;
  readonly pageSize: number;
  readonly columns: ReadonlyArray<{
    readonly __typename: 'DataGridColumnOverride';
    readonly field: string;
    readonly width: number;
    readonly hidden: boolean;
  }>;
  readonly sorting: ReadonlyArray<{
    readonly __typename: 'DataGridSorting';
    readonly field: string;
    readonly direction: string;
  }>;
};

export type MerchantAccountFragment = {
  readonly __typename: 'MerchantAccount';
  readonly id: string;
  readonly carrierKey: CarrierKey;
  readonly accountStatus: MerchantAccountTransmissionStatus | null;
  readonly errorCategory: MerchantAccountErrorCategory | null;
  readonly errorMessage: string;
  readonly termsAndConditionsOutdated: boolean;
};

export type PackageFragment = {
  readonly __typename: 'ShipmentPreset';
  readonly title: string;
  readonly packageTypeKey: string;
  readonly dimensionX: number;
  readonly dimensionY: number;
  readonly dimensionZ: number;
  readonly weight: number;
  readonly deliveryConfirmation: DeliveryConfirmation;
  readonly insuredValue: number;
  readonly returnLabelFlag: boolean;
  readonly hazardousMaterialsEnabled: boolean;
  readonly irregularPackage: boolean;
};

export type RateSummaryFragment = {
  readonly __typename: 'RateSummary';
  readonly serviceTitle: string;
  readonly mailClassTitle: string;
  readonly averageBasePrice: number;
  readonly averageTotalPrice: number;
  readonly basePrice: number;
  readonly best: boolean;
  readonly cheapest: boolean;
  readonly crossedTotalPrice: number;
  readonly deliveryDays: number;
  readonly fastest: boolean;
  readonly flatPrice: boolean;
  readonly ratePeriodEndDate: string | null;
  readonly ratePeriodStartDate: string | null;
  readonly errorMessage: string | null;
  readonly savings: string;
  readonly shipmentCount: number;
  readonly totalPrice: number;
  readonly uniqueId: string;
  readonly firstZone: string;
  readonly maxWeightOz: number;
  readonly valueLimit: number;
  readonly carrier: {
    readonly __typename: 'Carrier';
    readonly carrierKey: CarrierKey;
    readonly title: string;
  };
  readonly firstMailClass: {
    readonly __typename: 'CarrierMailClass';
    readonly mailClassKey: string;
  };
  readonly packageType: {
    readonly __typename: 'CarrierPackageType';
    readonly packageTypeKey: string;
  };
  readonly surcharges: ReadonlyArray<{
    readonly __typename: 'RateSurchargeSummary';
    readonly surchargeKey: string;
    readonly title: string;
    readonly price: number;
    readonly helpLink: string | null;
    readonly crossedPrice: number | null;
  }>;
};

export type RegionFragment = {
  readonly __typename: 'Region';
  readonly id: string;
  readonly regionCode: string;
  readonly countryCode: string;
  readonly name: string;
};

export type RunningProcessFragment = {
  readonly __typename: 'Batch';
  readonly runningProcess: {
    readonly __typename: 'BatchProcess';
    readonly status: string;
    readonly itemsInProgressCount: number;
    readonly itemsTotalCount: number;
    readonly processKey: string;
    readonly progressPercentage: number;
    readonly progressTitle: string;
    readonly secondsLeft: number;
  } | null;
};

export type ShipmentPresetFragment = {
  readonly __typename: 'ShipmentPreset';
  readonly id: string;
  readonly originalId: string | null;
  readonly title: string;
  readonly packageTypeId: string;
  readonly packageTypeKey: string;
  readonly dimensionX: number;
  readonly dimensionY: number;
  readonly dimensionZ: number;
  readonly weight: number;
  readonly deliveryConfirmation: DeliveryConfirmation;
  readonly deliveryConfirmationFlag: boolean;
  readonly irregularPackage: boolean;
  readonly insuredValue: number;
  readonly insuredValueFlag: boolean;
  readonly returnLabel: ReturnLabel;
  readonly returnLabelFlag: boolean;
  readonly customsFormEnabled: boolean;
  readonly customsSigner: string;
  readonly customsContentType: string;
  readonly exporterTaxId: string;
  readonly recipientTaxId: string;
  readonly qualifiesAsMediaMail: boolean;
  readonly hazardousMaterialsEnabled: boolean;
  readonly customsItems: ReadonlyArray<{
    readonly __typename: 'CustomsItem';
    readonly id: string;
    readonly title: string;
    readonly hsTariffNumber: string;
    readonly quantity: number;
    readonly itemValue: number;
    readonly weight: number;
    readonly countryCodeOfOrigin: string;
  }>;
};

export type ShipmentStatusSummaryFragment = {
  readonly __typename: 'ShipmentStatusSummary';
  readonly errorCount: number;
  readonly refundedCount: number;
  readonly refundableCount: number;
  readonly refundPendingCount: number;
  readonly inTransitCount: number;
  readonly deliveredCount: number;
  readonly readyToShipCount: number;
  readonly readyToPrintCount: number;
  readonly printableCount: number;
  readonly mobileCodeShowableCount: number;
};

export type WarehouseFragment = {
  readonly __typename: 'Warehouse';
  readonly id: string;
  readonly title: string | null;
  readonly useOriginAsReturnAddress: boolean;
  readonly shy: boolean;
  readonly originAddress: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly phone: string;
    readonly fullName: string;
    readonly company: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly regionCode: string;
    readonly postcode: string;
    readonly zip4: string;
    readonly countryCode: string;
  };
  readonly returnAddress: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly fullName: string;
    readonly company: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly regionCode: string;
    readonly postcode: string;
    readonly zip4: string;
    readonly countryCode: string;
  };
};

export type ConsumeGtmEventsMutationVariables = Exact<{ [key: string]: never }>;

export type ConsumeGtmEventsMutation = { readonly consumeGtmEvents: ReadonlyArray<object> };

export type ConsumeMessagesMutationVariables = Exact<{ [key: string]: never }>;

export type ConsumeMessagesMutation = {
  readonly consumeMessages: ReadonlyArray<{
    readonly __typename: 'FlashMessage';
    readonly variant: FlashMessageVariant;
    readonly message: string;
  }>;
};

export type CreateMappingsMutationVariables = Exact<{
  channelId: Scalars['ID'];
  rubberStamp1?: InputMaybe<Scalars['String']>;
  rubberStamp2?: InputMaybe<Scalars['String']>;
  rubberStamp3?: InputMaybe<Scalars['String']>;
  additionalMapping?: InputMaybe<ReadonlyArray<AdditionalMappingInput> | AdditionalMappingInput>;
}>;

export type CreateMappingsMutation = {
  readonly createMappings:
    | { readonly __typename: 'BigcartelChannel'; readonly id: string }
    | { readonly __typename: 'BigcommerceChannel'; readonly id: string }
    | { readonly __typename: 'CratejoyChannel'; readonly id: string }
    | { readonly __typename: 'DiscogsChannel'; readonly id: string }
    | { readonly __typename: 'EbayChannel'; readonly id: string }
    | { readonly __typename: 'EcwidChannel'; readonly id: string }
    | { readonly __typename: 'EtsyChannel'; readonly id: string }
    | { readonly __typename: 'FakeshopChannel'; readonly id: string }
    | { readonly __typename: 'PaypalChannel'; readonly id: string }
    | { readonly __typename: 'ShopifyChannel'; readonly id: string }
    | { readonly __typename: 'SquareChannel'; readonly id: string }
    | { readonly __typename: 'SquarespaceChannel'; readonly id: string }
    | { readonly __typename: 'SubblyChannel'; readonly id: string }
    | { readonly __typename: 'WixChannel'; readonly id: string }
    | { readonly __typename: 'WoocommerceChannel'; readonly id: string };
};

export type CreateOrUpdateUpsMerchantAccountMutationVariables = Exact<{ [key: string]: never }>;

export type CreateOrUpdateUpsMerchantAccountMutation = {
  readonly createOrUpdateUpsMerchantAccount: {
    readonly __typename: 'MerchantAccount';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly accountStatus: MerchantAccountTransmissionStatus | null;
    readonly errorCategory: MerchantAccountErrorCategory | null;
    readonly errorMessage: string;
    readonly termsAndConditionsOutdated: boolean;
  };
};

export type AddUpsToMerchantAccountsAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type AddUpsToMerchantAccountsAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly merchantAccounts: ReadonlyArray<{
      readonly __typename: 'MerchantAccount';
      readonly id: string;
      readonly carrierKey: CarrierKey;
      readonly accountStatus: MerchantAccountTransmissionStatus | null;
      readonly errorCategory: MerchantAccountErrorCategory | null;
      readonly errorMessage: string;
      readonly termsAndConditionsOutdated: boolean;
    }>;
  };
};

export type CreateShipmentPresetMutationVariables = Exact<{
  default: Scalars['Boolean'];
  shipmentPreset: ShipmentPresetInput;
}>;

export type CreateShipmentPresetMutation = {
  readonly createShipmentPreset: {
    readonly __typename: 'CreateShipmentPresetResult';
    readonly default: boolean;
    readonly shipmentPreset: {
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    };
  };
};

export type UpdateShipmentPresetsAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateShipmentPresetsAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultShipmentPresetId: string;
    };
  };
};

export type CreateUspsMerchantAccountMutationVariables = Exact<{ [key: string]: never }>;

export type CreateUspsMerchantAccountMutation = {
  readonly createUspsMerchantAccount: {
    readonly __typename: 'MerchantAccount';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly accountStatus: MerchantAccountTransmissionStatus | null;
    readonly errorCategory: MerchantAccountErrorCategory | null;
    readonly errorMessage: string;
    readonly termsAndConditionsOutdated: boolean;
  };
};

export type AddUspsToMerchantAccountsAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type AddUspsToMerchantAccountsAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly merchantAccounts: ReadonlyArray<{
      readonly __typename: 'MerchantAccount';
      readonly id: string;
      readonly carrierKey: CarrierKey;
      readonly accountStatus: MerchantAccountTransmissionStatus | null;
      readonly errorCategory: MerchantAccountErrorCategory | null;
      readonly errorMessage: string;
      readonly termsAndConditionsOutdated: boolean;
    }>;
  };
};

export type CreateWarehouseMutationVariables = Exact<{
  title: Scalars['String'];
  saveAddressForReuse: Scalars['Boolean'];
  useOriginAsReturnAddress: Scalars['Boolean'];
  originAddress: AddressInput;
  returnAddress?: InputMaybe<AddressInput>;
}>;

export type CreateWarehouseMutation = {
  readonly createWarehouse: {
    readonly __typename: 'Warehouse';
    readonly id: string;
    readonly title: string | null;
    readonly useOriginAsReturnAddress: boolean;
    readonly shy: boolean;
    readonly originAddress: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly phone: string;
      readonly fullName: string;
      readonly company: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly regionCode: string;
      readonly postcode: string;
      readonly zip4: string;
      readonly countryCode: string;
    };
    readonly returnAddress: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly fullName: string;
      readonly company: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly regionCode: string;
      readonly postcode: string;
      readonly zip4: string;
      readonly countryCode: string;
    };
  };
};

export type UpdateWarehousesAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateWarehousesAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type DeleteBatchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteBatchMutation = {
  readonly deleteBatch: { readonly __typename: 'Batch'; readonly id: string };
};

export type SendConfirmationMailMutationVariables = Exact<{
  emailAddress: Scalars['ID'];
}>;

export type SendConfirmationMailMutation = {
  readonly sendConfirmationMail: {
    readonly __typename: 'SenderEmailMetadata';
    readonly verificationStatus: EmailVerificationStatus | null;
    readonly dkimHost: string;
    readonly dkimTextValue: string;
    readonly dkimVerified: boolean;
    readonly returnPathDomain: string;
    readonly returnPathDomainCnameValue: string;
    readonly returnPathDomainVerified: boolean;
  };
};

export type UpdateBatchTitleMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
}>;

export type UpdateBatchTitleMutation = {
  readonly updateBatchTitle: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
  };
};

export type UpdateBillingAddressMutationVariables = Exact<{
  billingAddress: AddressInput;
}>;

export type UpdateBillingAddressMutation = {
  readonly updateBillingAddress: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly company: string;
    readonly fullName: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly postcode: string;
    readonly countryCode: string;
    readonly regionCode: string;
    readonly valid: boolean;
    readonly phone: string;
  };
};

export type UpdateChargeAmountMutationVariables = Exact<{
  amount: Scalars['Int'];
}>;

export type UpdateChargeAmountMutation = { readonly updateChargeAmount: number };

export type UpdateChargeAmountAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateChargeAmountAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultChargeAmount: number;
    };
  };
};

export type UpdateDataGridUserSettingsMutationVariables = Exact<{
  gridId: Scalars['String'];
  settings: DataGridSettingsInput;
}>;

export type UpdateDataGridUserSettingsMutation = {
  readonly updateDataGridUserSettings: {
    readonly __typename: 'DataGridSettings';
    readonly columnOrder: ReadonlyArray<string>;
    readonly pageSize: number;
    readonly columns: ReadonlyArray<{
      readonly __typename: 'DataGridColumnOverride';
      readonly field: string;
      readonly width: number;
      readonly hidden: boolean;
    }>;
    readonly sorting: ReadonlyArray<{
      readonly __typename: 'DataGridSorting';
      readonly field: string;
      readonly direction: string;
    }>;
  };
};

export type UpdatePreferredUpsMerchantAccountAddressMutationVariables = Exact<{
  address: AddressInput;
}>;

export type UpdatePreferredUpsMerchantAccountAddressMutation = {
  readonly updatePreferredUpsMerchantAccountAddress: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly company: string;
    readonly fullName: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly postcode: string;
    readonly countryCode: string;
    readonly regionCode: string;
    readonly valid: boolean;
    readonly phone: string;
  };
};

export type UpdateShipmentPresetMutationVariables = Exact<{
  default: Scalars['Boolean'];
  shipmentPreset: ShipmentPresetInput;
}>;

export type UpdateShipmentPresetMutation = {
  readonly updateShipmentPreset: {
    readonly __typename: 'UpdateShipmentPresetResult';
    readonly default: boolean;
    readonly shipmentPreset: {
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    };
  };
};

export type UpdateShipmentPresetsAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateShipmentPresetsAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultShipmentPresetId: string;
    };
  };
};

export type ApplicationConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicationConfigurationQuery = {
  readonly applicationConfiguration: {
    readonly __typename: 'ApplicationConfiguration';
    readonly turnstilePublicKey: string;
    readonly turnstileEnabled: boolean;
    readonly loginWithGoogleEnabled: boolean;
    readonly inAppIdentityVerificationEnabled: boolean;
    readonly intercomAppId: string;
    readonly intercomEnabled: boolean;
    readonly datadogClientToken: string;
    readonly datadogRumApplicationId: string;
    readonly datadogBrowserLoggingEnabled: boolean;
    readonly datadogBrowserMonitoringEnabled: boolean;
  };
};

export type ApplicationInformationQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicationInformationQuery = {
  readonly applicationHostname: string;
  readonly applicationEnvironment: string;
};

export type AutoRefundedShipmentsSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type AutoRefundedShipmentsSummaryQuery = {
  readonly autoRefundedShipmentsSummary: {
    readonly __typename: 'Summary';
    readonly count: number;
    readonly amount: number;
  };
};

export type BatchIdFromShipmentQueryVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;

export type BatchIdFromShipmentQuery = {
  readonly shipment: {
    readonly __typename: 'Shipment';
    readonly id: string;
    readonly batch: {
      readonly __typename: 'Batch';
      readonly id: string;
      readonly createdAt: string;
    };
  };
};

export type BatchProcessStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BatchProcessStatusQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly status: BatchStatusTag;
    readonly step: BatchStatus;
    readonly canInstantRefundBatch: boolean;
    readonly numShipments: number;
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly carrierKey: string;
    }>;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type BatchShipmentIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BatchShipmentIdsQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly createdAt: string;
    readonly shipments: ReadonlyArray<{ readonly __typename: 'Shipment'; readonly id: string }>;
  };
};

export type BatchStepQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BatchStepQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly createdAt: string;
    readonly shipments: ReadonlyArray<{ readonly __typename: 'Shipment'; readonly id: string }>;
  };
};

export type BillingAddressQueryVariables = Exact<{ [key: string]: never }>;

export type BillingAddressQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly address: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly company: string;
      readonly fullName: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly postcode: string;
      readonly countryCode: string;
      readonly regionCode: string;
      readonly valid: boolean;
      readonly phone: string;
    };
  };
};

export type ChargeAmountOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type ChargeAmountOptionsQuery = {
  readonly chargeAmountOptions: ReadonlyArray<number>;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultChargeAmount: number;
    };
  };
};

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
};

export type FailedShipmentsExportQueryVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type FailedShipmentsExportQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly failedShipmentsExportStatus: {
      readonly __typename: 'DataGridExportStatus';
      readonly exportId: number;
      readonly url: string | null;
    };
  };
};

export type PackageTypesQueryVariables = Exact<{ [key: string]: never }>;

export type PackageTypesQuery = {
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly description: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
  };
};

export type PreferredMerchantAccountAddressQueryVariables = Exact<{
  carrierKey: CarrierKey;
}>;

export type PreferredMerchantAccountAddressQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly preferredMerchantAccountAddress: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly company: string;
      readonly fullName: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly postcode: string;
      readonly countryCode: string;
      readonly regionCode: string;
      readonly valid: boolean;
      readonly phone: string;
    };
  };
};

export type RegionsQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;

export type RegionsQuery = {
  readonly regions: ReadonlyArray<{
    readonly __typename: 'Region';
    readonly id: string;
    readonly regionCode: string;
    readonly countryCode: string;
    readonly name: string;
  }>;
};

export type ShipmentBoundariesQueryVariables = Exact<{ [key: string]: never }>;

export type ShipmentBoundariesQuery = {
  readonly shipmentBoundaries: {
    readonly __typename: 'ShipmentBoundaries';
    readonly maxWeight: number;
    readonly maxCombinedLength: number;
    readonly maxLengthPlusGirth: number;
    readonly minLongSide: number;
    readonly maxLongSide: number;
    readonly minMiddleSide: number;
    readonly maxMiddleSide: number;
    readonly minShortSide: number;
    readonly maxShortSide: number;
  };
};

export type ShipmentPresetsQueryVariables = Exact<{ [key: string]: never }>;

export type ShipmentPresetsQuery = {
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultShipmentPresetId: string;
    };
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
  };
};

export type WarehousesQueryVariables = Exact<{ [key: string]: never }>;

export type WarehousesQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultWarehouseId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type BatchDetailsPageQueryVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type BatchDetailsPageQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
    readonly step: BatchStatus;
    readonly status: BatchStatusTag;
    readonly statusText: string;
    readonly labelFileFormat: FileFormat;
    readonly labelSize: LabelSize;
    readonly labelingArtifactType: LabelingArtifactType;
    readonly canRefund: boolean;
    readonly canInstantRefundBatch: boolean;
    readonly numShipments: number;
    readonly shipDate: string;
    readonly dataSource: BatchSource;
    readonly createdAt: string;
    readonly cleanupComplete: boolean;
    readonly notifyRecipientsDate: string | null;
    readonly emailNotificationPossible: boolean;
    readonly emailNotificationSent: boolean;
    readonly containedMailClassGroupKeys: ReadonlyArray<string>;
    readonly warehouse: {
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    };
    readonly spreadsheetMapping: ReadonlyArray<{
      readonly __typename: 'ShipmentMapping';
      readonly id: string | null;
      readonly shipmentKey: ShipmentKey;
      readonly valueOrMappingKey: string;
    }>;
    readonly packageSummary: {
      readonly __typename: 'BatchPackageSummary';
      readonly maxWeight: number;
      readonly minWeight: number;
      readonly maxInsured: number;
      readonly minInsured: number;
      readonly dimensionsSummary: string;
      readonly packageTypeSummary: string;
      readonly deliveryConfirmationSummary: string;
      readonly packagePreset: {
        readonly __typename: 'ShipmentPreset';
        readonly title: string;
        readonly packageTypeKey: string;
        readonly dimensionX: number;
        readonly dimensionY: number;
        readonly dimensionZ: number;
        readonly weight: number;
        readonly deliveryConfirmation: DeliveryConfirmation;
        readonly insuredValue: number;
        readonly returnLabelFlag: boolean;
        readonly hazardousMaterialsEnabled: boolean;
        readonly irregularPackage: boolean;
      } | null;
    };
    readonly customsFormSummary: {
      readonly __typename: 'BatchCustomsFormSummary';
      readonly numCustomsForms: number;
      readonly signer: string;
      readonly title: string;
      readonly contentType: string;
      readonly itemSummary: ReadonlyArray<string>;
      readonly exporterTaxIdSummary: string;
    };
    readonly shipmentStatusSummary: {
      readonly __typename: 'ShipmentStatusSummary';
      readonly errorCount: number;
      readonly refundedCount: number;
      readonly refundableCount: number;
      readonly refundPendingCount: number;
      readonly inTransitCount: number;
      readonly deliveredCount: number;
      readonly readyToShipCount: number;
      readonly readyToPrintCount: number;
      readonly printableCount: number;
      readonly mobileCodeShowableCount: number;
    };
    readonly emailNotificationTemplate: {
      readonly __typename: 'MailTemplate';
      readonly id: string;
    } | null;
    readonly priceSummary: ReadonlyArray<{
      readonly __typename: 'BatchPriceSummary';
      readonly title: string;
      readonly shipmentCount: number;
      readonly averagePrice: number;
      readonly totalPrice: number;
      readonly carrierKeys: ReadonlyArray<string>;
      readonly surcharge: boolean;
      readonly pirateShipService: boolean;
      readonly samePriceForAll: boolean;
      readonly usedReturnPrice: number;
      readonly isReturnLabel: boolean;
      readonly returnsUsed: number;
      readonly isRefunded: boolean;
    }>;
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly rubberStamp1: string | null;
      readonly rubberStamp2: string | null;
      readonly rubberStamp3: string | null;
      readonly carrierKey: string;
      readonly status: ShipmentStatus;
      readonly hasBeenDownloaded: boolean;
      readonly canPrint: boolean;
      readonly canShowMobileCode: boolean;
      readonly canInstantRefundShipment: boolean;
      readonly additionalRefundNotice: string;
      readonly order: {
        readonly __typename: 'Order';
        readonly id: string;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly title: string;
          readonly additionalTrackingEmailCopy: string;
        };
      } | null;
    }>;
    readonly trackingDataGrid: {
      readonly __typename: 'DataGridResult';
      readonly id: string;
      readonly rowActions: ReadonlyArray<{
        readonly __typename: 'DataGridRowAction';
        readonly id: string | null;
      }> | null;
    };
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
    readonly isSuspended: boolean;
  };
};

export type DataGridExportStatusQueryVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;

export type DataGridExportStatusQuery = {
  readonly shipment: {
    readonly __typename: 'Shipment';
    readonly trackingDataExportUrl: {
      readonly __typename: 'DataGridExportStatus';
      readonly exportId: number;
      readonly url: string | null;
      readonly downloadable: boolean;
      readonly filename: string;
      readonly expire: number;
    };
  };
};

export type FetchShipmentStageDotsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchShipmentStageDotsMutation = {
  readonly fetchShipmentStageDots: ReadonlyArray<{
    readonly __typename: 'StageDot';
    readonly title: string;
    readonly status: string;
    readonly message: string;
  }>;
};

export type MapQueryVariables = Exact<{
  id: Scalars['ID'];
  width: Scalars['Int'];
  height: Scalars['Int'];
}>;

export type MapQuery = {
  readonly shipment: { readonly __typename: 'Shipment'; readonly id: string; readonly map: string };
};

export type ShipmentContextualDropdownMenuQueryVariables = Exact<{
  batchId: Scalars['ID'];
  shipmentId: Scalars['String'];
}>;

export type ShipmentContextualDropdownMenuQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly companyId: string;
      readonly status: ShipmentStatus;
      readonly hasBeenDownloaded: boolean;
      readonly trackingNr: string | null;
      readonly carrierKey: string;
      readonly isRedacted: boolean;
      readonly adjustments: ReadonlyArray<{
        readonly __typename: 'ReconciliationAdjustment';
        readonly id: string;
        readonly disputeStatus: DisputeStatus;
      }>;
    }>;
  };
};

export type ShipmentDetailsPageQueryVariables = Exact<{
  batchId: Scalars['ID'];
  shipmentId: Scalars['String'];
}>;

export type ShipmentDetailsPageQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
    readonly step: BatchStatus;
    readonly labelFileFormat: FileFormat;
    readonly labelSize: LabelSize;
    readonly labelingArtifactType: LabelingArtifactType;
    readonly customsFormRequired: boolean;
    readonly numShipments: number;
    readonly shipDate: string;
    readonly dataSource: BatchSource;
    readonly containedMailClassGroupKeys: ReadonlyArray<string>;
    readonly createdAt: string;
    readonly cleanupComplete: boolean;
    readonly notifyRecipientsDate: string | null;
    readonly emailNotificationPossible: boolean;
    readonly emailNotificationSent: boolean;
    readonly warehouse: {
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    };
    readonly spreadsheetMapping: ReadonlyArray<{
      readonly __typename: 'ShipmentMapping';
      readonly id: string | null;
      readonly shipmentKey: ShipmentKey;
      readonly valueOrMappingKey: string;
    }>;
    readonly packageSummary: {
      readonly __typename: 'BatchPackageSummary';
      readonly maxWeight: number;
      readonly minWeight: number;
      readonly maxInsured: number;
      readonly minInsured: number;
      readonly dimensionsSummary: string;
      readonly packageTypeSummary: string;
      readonly deliveryConfirmationSummary: string;
      readonly packagePreset: {
        readonly __typename: 'ShipmentPreset';
        readonly id: string;
        readonly shy: boolean;
        readonly packageTypeKey: string;
        readonly dimensionX: number;
        readonly dimensionY: number;
        readonly dimensionZ: number;
        readonly weight: number;
        readonly insuredValueFlag: boolean;
        readonly insuredValue: number;
        readonly deliveryConfirmationFlag: boolean;
        readonly deliveryConfirmation: DeliveryConfirmation;
        readonly returnLabelFlag: boolean;
        readonly returnLabel: ReturnLabel;
        readonly qualifiesAsMediaMail: boolean;
        readonly irregularPackage: boolean;
        readonly hazardousMaterialsEnabled: boolean;
        readonly customsFormEnabled: boolean;
        readonly customsSigner: string;
        readonly customsContentType: string;
        readonly exporterTaxId: string;
        readonly recipientTaxId: string;
        readonly title: string;
        readonly customsItems: ReadonlyArray<{
          readonly __typename: 'CustomsItem';
          readonly title: string;
          readonly quantity: number;
          readonly itemValue: number;
          readonly weight: number;
          readonly hsTariffNumber: string;
          readonly countryCodeOfOrigin: string;
        }>;
      } | null;
    };
    readonly customsFormSummary: {
      readonly __typename: 'BatchCustomsFormSummary';
      readonly numCustomsForms: number;
      readonly signer: string;
      readonly title: string;
      readonly contentType: string;
      readonly itemSummary: ReadonlyArray<string>;
      readonly exporterTaxIdSummary: string;
    };
    readonly emailNotificationTemplate: {
      readonly __typename: 'MailTemplate';
      readonly id: string;
    } | null;
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly trackingNr: string | null;
      readonly trackingLink: string;
      readonly isReturnLabel: boolean;
      readonly foreignOrderId: string;
      readonly carrierTitle: string;
      readonly carrierKey: string;
      readonly errorMessage: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number | null;
      readonly dimensionXOriginal: number;
      readonly dimensionYOriginal: number;
      readonly dimensionZOriginal: number | null;
      readonly rubberStamp1: string | null;
      readonly rubberStamp2: string | null;
      readonly rubberStamp3: string | null;
      readonly weight: number;
      readonly weightOriginal: number;
      readonly status: ShipmentStatus;
      readonly hasBeenDownloaded: boolean;
      readonly canPrint: boolean;
      readonly canShowMobileCode: boolean;
      readonly baseClientPrice: number | null;
      readonly baseClientPriceOriginal: number | null;
      readonly totalClientPrice: number | null;
      readonly totalClientPriceOriginal: number | null;
      readonly mailClassKey: string | null;
      readonly zone: string | null;
      readonly zoneOriginal: string | null;
      readonly additionalRefundNotice: string;
      readonly isShipmentRefundable: boolean;
      readonly canInstantRefundShipment: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string | null;
      readonly recipientTaxId: string | null;
      readonly customsItems: ReadonlyArray<string | null>;
      readonly order: {
        readonly __typename: 'Order';
        readonly id: string;
        readonly foreignOrderId: string;
        readonly platformKey: string;
        readonly orderLink: {
          readonly __typename: 'Link';
          readonly url: string;
          readonly text: string;
        } | null;
        readonly shipmentLink: {
          readonly __typename: 'Link';
          readonly url: string;
          readonly text: string;
        } | null;
        readonly subscriptionLink: {
          readonly __typename: 'Link';
          readonly url: string;
          readonly text: string;
        } | null;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly title: string;
          readonly additionalTrackingEmailCopy: string;
        };
        readonly orderItems: ReadonlyArray<{
          readonly __typename: 'OrderItem';
          readonly quantity: number;
          readonly title: string;
          readonly sku: string;
        }>;
      } | null;
      readonly passthroughFields: ReadonlyArray<{
        readonly __typename: 'ShipmentPassthroughFieldType';
        readonly fieldName: string;
        readonly value: string;
      }>;
      readonly adjustments: ReadonlyArray<{
        readonly __typename: 'ReconciliationAdjustment';
        readonly id: string;
        readonly createdAt: string;
        readonly dimensionXOriginal: number | null;
        readonly dimensionX: number;
        readonly dimensionYOriginal: number | null;
        readonly dimensionY: number;
        readonly dimensionZOriginal: number | null;
        readonly dimensionZ: number;
        readonly disputedAt: string | null;
        readonly disputeStatus: DisputeStatus;
        readonly disputeReason: string;
        readonly eligibilityIssueMessage: string;
        readonly isDisputable: boolean;
        readonly processedAt: string;
        readonly disputeProcessedAt: string | null;
        readonly notes: ReadonlyArray<string>;
        readonly weightOriginal: number | null;
        readonly weight: number;
        readonly clientPriceChange: number;
      }>;
      readonly recipientAddress: {
        readonly __typename: 'RecipientAddress';
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
        readonly address3: string;
        readonly email: string | null;
        readonly phone: string;
      };
      readonly deliveryEstimation: {
        readonly __typename: 'DeliveryEstimation';
        readonly arrivalLocalDateTime: string | null;
        readonly pickupLocalDateTime: string | null;
      } | null;
      readonly packageTypeOriginal: {
        readonly __typename: 'CarrierPackageType';
        readonly title: string;
        readonly heightRequired: boolean;
      };
      readonly packageType: {
        readonly __typename: 'CarrierPackageType';
        readonly title: string;
        readonly heightRequired: boolean;
      };
      readonly mailClassOriginal: {
        readonly __typename: 'CarrierMailClass';
        readonly title: string;
      } | null;
      readonly mailClass: {
        readonly __typename: 'CarrierMailClass';
        readonly title: string;
      } | null;
      readonly surcharges: ReadonlyArray<{
        readonly __typename: 'ShipmentPrice';
        readonly isIgnored: boolean;
        readonly title: string;
        readonly apiKey: string;
        readonly clientPrice: number;
        readonly clientPriceOriginal: number;
        readonly isOriginalSurcharge: boolean;
        readonly helpLink: string;
      }> | null;
      readonly insuranceDetails: {
        readonly __typename: 'InsuranceDetailsType';
        readonly insuredValueRequested: number;
        readonly insuredValueType: InsuredValueType;
        readonly insuredValue: number;
        readonly hasOnlyCarrierLiabilityInsurance: boolean;
        readonly insuranceSurcharge: {
          readonly __typename: 'ShipmentPrice';
          readonly isIgnored: boolean;
          readonly title: string;
          readonly apiKey: string;
          readonly clientPrice: number;
          readonly clientPriceOriginal: number;
          readonly isOriginalSurcharge: boolean;
          readonly helpLink: string;
        } | null;
      };
      readonly customsItemsObjects: ReadonlyArray<{
        readonly __typename: 'ShippingCustomsItem';
        readonly title: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly hsTariffNumber: string;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
  };
};

export type GeneralSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GeneralSettingsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly areMobileCodesEnabled: boolean;
      readonly shipmentLabelSize: string;
      readonly shipmentLabelFileFormat: string;
      readonly packingListTemplate: string;
      readonly showLogoOnLabel: boolean;
      readonly shipmentSpreadsheetFormat: string;
      readonly addressCorrection: string;
    };
  };
};

export type UpdateGeneralSettingsMutationVariables = Exact<{
  areMobileCodesEnabled: Scalars['Boolean'];
  shipmentLabelSize: Scalars['String'];
  shipmentLabelFileFormat: Scalars['String'];
  packingListTemplate: Scalars['String'];
  showLogoOnLabel: Scalars['Boolean'];
  shipmentSpreadsheetFormat: Scalars['String'];
  addressCorrection: Scalars['String'];
}>;

export type UpdateGeneralSettingsMutation = { readonly updateGeneralSettings: boolean };

export type UpdateCompanySettingsAfterGeneralSettingsUpdateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateCompanySettingsAfterGeneralSettingsUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly areMobileCodesEnabled: boolean;
      readonly shipmentLabelSize: string;
      readonly packingListTemplate: string;
      readonly showLogoOnLabel: boolean;
      readonly shipmentSpreadsheetFormat: string;
      readonly shipmentLabelFileFormat: string;
      readonly addressCorrection: string;
    };
  };
};

export type GenerateJumioWebClientUrlMutationVariables = Exact<{
  returnPath: Scalars['String'];
}>;

export type GenerateJumioWebClientUrlMutation = { readonly generateJumioWebClientUrl: string };

export type MarkJumioFlowAsDismissedMutationVariables = Exact<{ [key: string]: never }>;

export type MarkJumioFlowAsDismissedMutation = {
  readonly markJumioFlowAsDismissed: undefined | null;
};

export type MarkJumioFlowAsFinishedMutationVariables = Exact<{
  workflowExecutionId: Scalars['String'];
}>;

export type MarkJumioFlowAsFinishedMutation = {
  readonly markJumioFlowAsFinished: undefined | null;
};

export type ReturnPathQueryVariables = Exact<{ [key: string]: never }>;

export type ReturnPathQuery = { readonly returnPath: string | null };

export type VerificationRequiredQueryVariables = Exact<{ [key: string]: never }>;

export type VerificationRequiredQuery = { readonly verificationRequired: boolean };

export type VerificationStatusQueryVariables = Exact<{ [key: string]: never }>;

export type VerificationStatusQuery = { readonly verificationStatus: string | null };

export type ChannelAutoSyncMutationVariables = Exact<{ [key: string]: never }>;

export type ChannelAutoSyncMutation = { readonly channelAutoSync: boolean };

export type IgnoreOrdersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;

export type IgnoreOrdersMutation = {
  readonly ignoreOrders: {
    readonly __typename: 'IgnoreOrderResult';
    readonly success: boolean;
    readonly count: number;
    readonly ids: ReadonlyArray<string>;
  };
};

export type TriggerChannelSyncMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerChannelSyncMutation = { readonly triggerChannelSync: boolean };

export type UnignoreOrdersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;

export type UnignoreOrdersMutation = {
  readonly unignoreOrders: {
    readonly __typename: 'IgnoreOrderResult';
    readonly success: boolean;
    readonly count: number;
    readonly ids: ReadonlyArray<string>;
  };
};

export type ChannelSyncStatusQueryVariables = Exact<{ [key: string]: never }>;

export type ChannelSyncStatusQuery = {
  readonly channelSyncStatus: {
    readonly __typename: 'SyncStatusResult';
    readonly timestamp: number;
    readonly messages: ReadonlyArray<string>;
    readonly info: string;
    readonly autosyncRequired: boolean;
    readonly hasError: boolean;
    readonly progress: number;
    readonly isRunning: boolean;
  };
};

export type ImportedOrdersBaseQueryVariables = Exact<{
  gridMode: GridMode;
}>;

export type ImportedOrdersBaseQuery = {
  readonly importedOrders: {
    readonly __typename: 'DataGridResult';
    readonly id: string;
    readonly metaData: ReadonlyArray<{
      readonly __typename: 'DataGridMetaData';
      readonly key: string;
      readonly value: string;
    }>;
  };
};

export type ShipmentForOrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;

export type ShipmentForOrderQuery = {
  readonly shipmentForOrder: {
    readonly __typename: 'Shipment';
    readonly id: string;
    readonly batch: { readonly __typename: 'Batch'; readonly id: string };
  } | null;
};

type ChannelFragment_BigcartelChannel_ = {
  readonly __typename: 'BigcartelChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_BigcommerceChannel_ = {
  readonly __typename: 'BigcommerceChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_Channel_ = {
  readonly __typename: 'Channel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_CratejoyChannel_ = {
  readonly __typename: 'CratejoyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_DiscogsChannel_ = {
  readonly __typename: 'DiscogsChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_EbayChannel_ = {
  readonly __typename: 'EbayChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_EcwidChannel_ = {
  readonly __typename: 'EcwidChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_EtsyChannel_ = {
  readonly __typename: 'EtsyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_FakeshopChannel_ = {
  readonly __typename: 'FakeshopChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_PaypalChannel_ = {
  readonly __typename: 'PaypalChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_ShopifyChannel_ = {
  readonly __typename: 'ShopifyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_SquareChannel_ = {
  readonly __typename: 'SquareChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_SquarespaceChannel_ = {
  readonly __typename: 'SquarespaceChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_SubblyChannel_ = {
  readonly __typename: 'SubblyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_WixChannel_ = {
  readonly __typename: 'WixChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

type ChannelFragment_WoocommerceChannel_ = {
  readonly __typename: 'WoocommerceChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

export type ChannelFragment =
  | ChannelFragment_BigcartelChannel_
  | ChannelFragment_BigcommerceChannel_
  | ChannelFragment_Channel_
  | ChannelFragment_CratejoyChannel_
  | ChannelFragment_DiscogsChannel_
  | ChannelFragment_EbayChannel_
  | ChannelFragment_EcwidChannel_
  | ChannelFragment_EtsyChannel_
  | ChannelFragment_FakeshopChannel_
  | ChannelFragment_PaypalChannel_
  | ChannelFragment_ShopifyChannel_
  | ChannelFragment_SquareChannel_
  | ChannelFragment_SquarespaceChannel_
  | ChannelFragment_SubblyChannel_
  | ChannelFragment_WixChannel_
  | ChannelFragment_WoocommerceChannel_;

type MappingFragment_BigcartelChannel_ = {
  readonly __typename: 'BigcartelChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_BigcommerceChannel_ = {
  readonly __typename: 'BigcommerceChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_Channel_ = {
  readonly __typename: 'Channel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_CratejoyChannel_ = {
  readonly __typename: 'CratejoyChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_DiscogsChannel_ = {
  readonly __typename: 'DiscogsChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_EbayChannel_ = {
  readonly __typename: 'EbayChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_EcwidChannel_ = {
  readonly __typename: 'EcwidChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_EtsyChannel_ = {
  readonly __typename: 'EtsyChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_FakeshopChannel_ = {
  readonly __typename: 'FakeshopChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_PaypalChannel_ = {
  readonly __typename: 'PaypalChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_ShopifyChannel_ = {
  readonly __typename: 'ShopifyChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_SquareChannel_ = {
  readonly __typename: 'SquareChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_SquarespaceChannel_ = {
  readonly __typename: 'SquarespaceChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_SubblyChannel_ = {
  readonly __typename: 'SubblyChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_WixChannel_ = {
  readonly __typename: 'WixChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

type MappingFragment_WoocommerceChannel_ = {
  readonly __typename: 'WoocommerceChannel';
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type MappingFragment =
  | MappingFragment_BigcartelChannel_
  | MappingFragment_BigcommerceChannel_
  | MappingFragment_Channel_
  | MappingFragment_CratejoyChannel_
  | MappingFragment_DiscogsChannel_
  | MappingFragment_EbayChannel_
  | MappingFragment_EcwidChannel_
  | MappingFragment_EtsyChannel_
  | MappingFragment_FakeshopChannel_
  | MappingFragment_PaypalChannel_
  | MappingFragment_ShopifyChannel_
  | MappingFragment_SquareChannel_
  | MappingFragment_SquarespaceChannel_
  | MappingFragment_SubblyChannel_
  | MappingFragment_WixChannel_
  | MappingFragment_WoocommerceChannel_;

export type BigcartelFragment = {
  readonly __typename: 'BigcartelChannel';
  readonly plan: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly autoSyncEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type BigcommerceFragment = {
  readonly __typename: 'BigcommerceChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly clientSecret: string;
  readonly apiUrl: string;
  readonly trackingEmailsEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type CratejoyFragment = {
  readonly __typename: 'CratejoyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly clientId: string;
  readonly clientSecret: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly skipFutureSubscriptions: boolean;
  readonly trackingEmailsEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type DiscogsFragment = {
  readonly __typename: 'DiscogsChannel';
  readonly clientSecret: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type EbayFragment = {
  readonly __typename: 'EbayChannel';
  readonly statusesToImport: ReadonlyArray<string>;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type EcwidFragment = {
  readonly __typename: 'EcwidChannel';
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly username: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly customFulfillmentStatusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly customPaymentStatuses: ReadonlyArray<{
    readonly __typename: 'EcwidOrderStatusImpl';
    readonly id: string;
    readonly name: string;
  }>;
  readonly customFulfillmentStatuses: ReadonlyArray<{
    readonly __typename: 'EcwidOrderStatusImpl';
    readonly id: string;
    readonly name: string;
  }>;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type EtsyFragment = {
  readonly __typename: 'EtsyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly trackingEmailsEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type FakeshopFragment = {
  readonly __typename: 'FakeshopChannel';
  readonly orderGroups: ReadonlyArray<string>;
  readonly autoSyncEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
};

export type PaypalFragment = {
  readonly __typename: 'PaypalChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly genericLineItemEnabled: boolean | null;
  readonly trackingEmailsEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type ShopifyFragment = {
  readonly __typename: 'ShopifyChannel';
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly shopUrl: string;
  readonly importLineItemsNotRequireShippingEnabled: boolean;
  readonly trackingEmailsEnabled: boolean;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly importOrdersNewerThan: number | null;
  readonly locationsToImport: ReadonlyArray<string>;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
  readonly customOptions: ReadonlyArray<{
    readonly __typename: 'CustomOption';
    readonly sourceKey: string;
    readonly name: string;
    readonly override: string;
  }>;
  readonly fulfillmentLocations: ReadonlyArray<{
    readonly __typename: 'ShopifyLocation';
    readonly id: string;
    readonly name: string;
  }>;
};

export type SquareFragment = {
  readonly __typename: 'SquareChannel';
  readonly statusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly locationsToImport: ReadonlyArray<string>;
  readonly importCustomAttributes: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly locations: ReadonlyArray<{
    readonly __typename: 'SquareLocation';
    readonly id: string;
    readonly name: string;
  }>;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type SquarespaceFragment = {
  readonly __typename: 'SquarespaceChannel';
  readonly clientSecret: string;
  readonly trackingEmailsEnabled: boolean;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type SubblyFragment = {
  readonly __typename: 'SubblyChannel';
  readonly clientSecret: string;
  readonly trackingEmailsEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type WixFragment = {
  readonly __typename: 'WixChannel';
  readonly statusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type WoocommerceFragment = {
  readonly __typename: 'WoocommerceChannel';
  readonly shopUrl: string;
  readonly statusesToImport: ReadonlyArray<string>;
  readonly trackingEmailsEnabled: boolean;
  readonly id: string;
  readonly title: string;
  readonly active: boolean;
  readonly valid: boolean;
  readonly autoSyncEnabled: boolean;
  readonly platform: {
    readonly __typename: 'Platform';
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  } | null;
  readonly mappableFields: ReadonlyArray<{
    readonly __typename: 'PlatformMappableField';
    readonly field: string;
    readonly label: string;
  }>;
  readonly rubberstampConfig: ReadonlyArray<{
    readonly __typename: 'ChannelRubberstampConfig';
    readonly rubberstamp: string;
    readonly configuredField: string;
  }>;
};

export type DeleteChannelMutationVariables = Exact<{
  channelId: Scalars['ID'];
}>;

export type DeleteChannelMutation = {
  readonly deleteChannel:
    | { readonly __typename: 'BigcartelChannel'; readonly id: string }
    | { readonly __typename: 'BigcommerceChannel'; readonly id: string }
    | { readonly __typename: 'CratejoyChannel'; readonly id: string }
    | { readonly __typename: 'DiscogsChannel'; readonly id: string }
    | { readonly __typename: 'EbayChannel'; readonly id: string }
    | { readonly __typename: 'EcwidChannel'; readonly id: string }
    | { readonly __typename: 'EtsyChannel'; readonly id: string }
    | { readonly __typename: 'FakeshopChannel'; readonly id: string }
    | { readonly __typename: 'PaypalChannel'; readonly id: string }
    | { readonly __typename: 'ShopifyChannel'; readonly id: string }
    | { readonly __typename: 'SquareChannel'; readonly id: string }
    | { readonly __typename: 'SquarespaceChannel'; readonly id: string }
    | { readonly __typename: 'SubblyChannel'; readonly id: string }
    | { readonly __typename: 'WixChannel'; readonly id: string }
    | { readonly __typename: 'WoocommerceChannel'; readonly id: string };
};

export type UpdateChannelsAfterDeleteQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateChannelsAfterDeleteQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel'; readonly id: string }
      | { readonly __typename: 'BigcommerceChannel'; readonly id: string }
      | { readonly __typename: 'CratejoyChannel'; readonly id: string }
      | { readonly __typename: 'DiscogsChannel'; readonly id: string }
      | { readonly __typename: 'EbayChannel'; readonly id: string }
      | { readonly __typename: 'EcwidChannel'; readonly id: string }
      | { readonly __typename: 'EtsyChannel'; readonly id: string }
      | { readonly __typename: 'FakeshopChannel'; readonly id: string }
      | { readonly __typename: 'PaypalChannel'; readonly id: string }
      | { readonly __typename: 'ShopifyChannel'; readonly id: string }
      | { readonly __typename: 'SquareChannel'; readonly id: string }
      | { readonly __typename: 'SquarespaceChannel'; readonly id: string }
      | { readonly __typename: 'SubblyChannel'; readonly id: string }
      | { readonly __typename: 'WixChannel'; readonly id: string }
      | { readonly __typename: 'WoocommerceChannel'; readonly id: string }
    >;
  };
};

export type DisableChannelMutationVariables = Exact<{
  channelId: Scalars['ID'];
}>;

export type DisableChannelMutation = {
  readonly disableChannel:
    | {
        readonly __typename: 'BigcartelChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'BigcommerceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'CratejoyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'DiscogsChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EbayChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EcwidChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EtsyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'FakeshopChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'PaypalChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'ShopifyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SquareChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SquarespaceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SubblyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'WixChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'WoocommerceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      };
};

export type EnableChannelMutationVariables = Exact<{
  channelId: Scalars['ID'];
}>;

export type EnableChannelMutation = {
  readonly enableChannel:
    | {
        readonly __typename: 'BigcartelChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'BigcommerceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'CratejoyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'DiscogsChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EbayChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EcwidChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'EtsyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'FakeshopChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'PaypalChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'ShopifyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SquareChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SquarespaceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'SubblyChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'WixChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      }
    | {
        readonly __typename: 'WoocommerceChannel';
        readonly id: string;
        readonly title: string;
        readonly active: boolean;
        readonly valid: boolean;
        readonly autoSyncEnabled: boolean;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly id: string;
          readonly platformKey: string;
          readonly title: string;
        } | null;
      };
};

export type ConnectWoocommerceMutationVariables = Exact<{
  shopUrl: Scalars['String'];
}>;

export type ConnectWoocommerceMutation = { readonly connectWoocommerceChannel: string };

export type CreateBigcommerceMutationVariables = Exact<{
  title: Scalars['String'];
  clientSecret: Scalars['String'];
  apiUrl: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateBigcommerceMutation = {
  readonly createBigcommerceChannel: {
    readonly __typename: 'BigcommerceChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly clientSecret: string;
    readonly apiUrl: string;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type CreateBigcommerceAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateBigcommerceAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | {
          readonly __typename: 'BigcommerceChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly clientSecret: string;
          readonly apiUrl: string;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CreateCratejoyMutationVariables = Exact<{
  title: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  skipFutureSubscriptions: Scalars['Boolean'];
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateCratejoyMutation = {
  readonly createCratejoyChannel: {
    readonly __typename: 'CratejoyChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly clientId: string;
    readonly clientSecret: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly skipFutureSubscriptions: boolean;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type CreateCratejoyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateCratejoyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | {
          readonly __typename: 'CratejoyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly clientId: string;
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly skipFutureSubscriptions: boolean;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CreateDiscogsMutationVariables = Exact<{
  title: Scalars['String'];
  clientSecret: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateDiscogsMutation = {
  readonly createDiscogsChannel: {
    readonly __typename: 'DiscogsChannel';
    readonly clientSecret: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type CreateDiscogsAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateDiscogsAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | {
          readonly __typename: 'DiscogsChannel';
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CreateFakeshopMutationVariables = Exact<{
  title: Scalars['String'];
  orderGroups: ReadonlyArray<Scalars['String']> | Scalars['String'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateFakeshopMutation = {
  readonly createFakeshopChannel: {
    readonly __typename: 'FakeshopChannel';
    readonly orderGroups: ReadonlyArray<string>;
    readonly autoSyncEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
  };
};

export type CreateFakeshopAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateFakeshopAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | {
          readonly __typename: 'FakeshopChannel';
          readonly orderGroups: ReadonlyArray<string>;
          readonly autoSyncEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CreateSquarespaceMutationVariables = Exact<{
  title: Scalars['String'];
  clientSecret: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateSquarespaceMutation = {
  readonly createSquarespaceChannel: {
    readonly __typename: 'SquarespaceChannel';
    readonly clientSecret: string;
    readonly trackingEmailsEnabled: boolean;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type CreateSquarespaceAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateSquarespaceAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | {
          readonly __typename: 'SquarespaceChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CreateSubblyMutationVariables = Exact<{
  title: Scalars['String'];
  clientSecret: Scalars['String'];
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type CreateSubblyMutation = {
  readonly createSubblyChannel: {
    readonly __typename: 'SubblyChannel';
    readonly clientSecret: string;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type CreateSubblyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type CreateSubblyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | {
          readonly __typename: 'SubblyChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateBigcartelMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateBigcartelMutation = {
  readonly updateBigcartelChannel: {
    readonly __typename: 'BigcartelChannel';
    readonly plan: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly autoSyncEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateBigcartelAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateBigcartelAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | {
          readonly __typename: 'BigcartelChannel';
          readonly plan: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly autoSyncEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateBigcommerceMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  apiUrl: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateBigcommerceMutation = {
  readonly updateBigcommerceChannel: {
    readonly __typename: 'BigcommerceChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly clientSecret: string;
    readonly apiUrl: string;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateBigcommerceAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateBigcommerceAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | {
          readonly __typename: 'BigcommerceChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly clientSecret: string;
          readonly apiUrl: string;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateCratejoyMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  skipFutureSubscriptions: Scalars['Boolean'];
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateCratejoyMutation = {
  readonly updateCratejoyChannel: {
    readonly __typename: 'CratejoyChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly clientId: string;
    readonly clientSecret: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly skipFutureSubscriptions: boolean;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateCratejoyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateCratejoyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | {
          readonly __typename: 'CratejoyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly clientId: string;
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly skipFutureSubscriptions: boolean;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateDiscogsMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateDiscogsMutation = {
  readonly updateDiscogsChannel: {
    readonly __typename: 'DiscogsChannel';
    readonly clientSecret: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateDiscogsAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateDiscogsAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | {
          readonly __typename: 'DiscogsChannel';
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateEbayMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateEbayMutation = {
  readonly updateEbayChannel: {
    readonly __typename: 'EbayChannel';
    readonly statusesToImport: ReadonlyArray<string>;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateEbayAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateEbayAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | {
          readonly __typename: 'EbayChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateEcwidMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  customFulfillmentStatusesToImport?: InputMaybe<
    ReadonlyArray<Scalars['String']> | Scalars['String']
  >;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateEcwidMutation = {
  readonly updateEcwidChannel: {
    readonly __typename: 'EcwidChannel';
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly username: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly customFulfillmentStatusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly customPaymentStatuses: ReadonlyArray<{
      readonly __typename: 'EcwidOrderStatusImpl';
      readonly id: string;
      readonly name: string;
    }>;
    readonly customFulfillmentStatuses: ReadonlyArray<{
      readonly __typename: 'EcwidOrderStatusImpl';
      readonly id: string;
      readonly name: string;
    }>;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateEcwidAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateEcwidAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | {
          readonly __typename: 'EcwidChannel';
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly username: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly customFulfillmentStatusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly customPaymentStatuses: ReadonlyArray<{
            readonly __typename: 'EcwidOrderStatusImpl';
            readonly id: string;
            readonly name: string;
          }>;
          readonly customFulfillmentStatuses: ReadonlyArray<{
            readonly __typename: 'EcwidOrderStatusImpl';
            readonly id: string;
            readonly name: string;
          }>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateEtsyMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateEtsyMutation = {
  readonly updateEtsyChannel: {
    readonly __typename: 'EtsyChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateEtsyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateEtsyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | {
          readonly __typename: 'EtsyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateFakeshopMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  orderGroups: ReadonlyArray<Scalars['String']> | Scalars['String'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateFakeshopMutation = {
  readonly updateFakeshopChannel: {
    readonly __typename: 'FakeshopChannel';
    readonly orderGroups: ReadonlyArray<string>;
    readonly autoSyncEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
  };
};

export type UpdateFakeshopAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateFakeshopAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | {
          readonly __typename: 'FakeshopChannel';
          readonly orderGroups: ReadonlyArray<string>;
          readonly autoSyncEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdatePaypalMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  genericLineItemEnabled?: InputMaybe<Scalars['Boolean']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdatePaypalMutation = {
  readonly updatePaypalChannel: {
    readonly __typename: 'PaypalChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly genericLineItemEnabled: boolean | null;
    readonly trackingEmailsEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdatePayPalAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePayPalAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | {
          readonly __typename: 'PaypalChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly genericLineItemEnabled: boolean | null;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateShopifyMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  locationsToImport: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  importLineItemsNotRequireShippingEnabled: Scalars['Boolean'];
  importOrdersNewerThan?: InputMaybe<Scalars['Int']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateShopifyMutation = {
  readonly updateShopifyChannel: {
    readonly __typename: 'ShopifyChannel';
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly shopUrl: string;
    readonly importLineItemsNotRequireShippingEnabled: boolean;
    readonly trackingEmailsEnabled: boolean;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly importOrdersNewerThan: number | null;
    readonly locationsToImport: ReadonlyArray<string>;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
    readonly customOptions: ReadonlyArray<{
      readonly __typename: 'CustomOption';
      readonly sourceKey: string;
      readonly name: string;
      readonly override: string;
    }>;
    readonly fulfillmentLocations: ReadonlyArray<{
      readonly __typename: 'ShopifyLocation';
      readonly id: string;
      readonly name: string;
    }>;
  };
};

export type UpdateShopifyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateShopifyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | {
          readonly __typename: 'ShopifyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly importLineItemsNotRequireShippingEnabled: boolean;
          readonly trackingEmailsEnabled: boolean;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly importOrdersNewerThan: number | null;
          readonly locationsToImport: ReadonlyArray<string>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
          readonly customOptions: ReadonlyArray<{
            readonly __typename: 'CustomOption';
            readonly sourceKey: string;
            readonly name: string;
            readonly override: string;
          }>;
          readonly fulfillmentLocations: ReadonlyArray<{
            readonly __typename: 'ShopifyLocation';
            readonly id: string;
            readonly name: string;
          }>;
        }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateSquareMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  locationsToImport: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  importCustomAttributes: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
  trackingEmailsEnabled: Scalars['Boolean'];
}>;

export type UpdateSquareMutation = {
  readonly updateSquareChannel: {
    readonly __typename: 'SquareChannel';
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly locationsToImport: ReadonlyArray<string>;
    readonly importCustomAttributes: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly locations: ReadonlyArray<{
      readonly __typename: 'SquareLocation';
      readonly id: string;
      readonly name: string;
    }>;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateSquareAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSquareAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | {
          readonly __typename: 'SquareChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly locationsToImport: ReadonlyArray<string>;
          readonly importCustomAttributes: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly locations: ReadonlyArray<{
            readonly __typename: 'SquareLocation';
            readonly id: string;
            readonly name: string;
          }>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateSquarespaceMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateSquarespaceMutation = {
  readonly updateSquarespaceChannel: {
    readonly __typename: 'SquarespaceChannel';
    readonly clientSecret: string;
    readonly trackingEmailsEnabled: boolean;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateSquarespaceAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSquarespaceAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | {
          readonly __typename: 'SquarespaceChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateSubblyMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateSubblyMutation = {
  readonly updateSubblyChannel: {
    readonly __typename: 'SubblyChannel';
    readonly clientSecret: string;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateSubblyAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSubblyAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | {
          readonly __typename: 'SubblyChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateWixMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  autoSyncEnabled: Scalars['Boolean'];
  trackingEmailsEnabled: Scalars['Boolean'];
}>;

export type UpdateWixMutation = {
  readonly updateWixChannel: {
    readonly __typename: 'WixChannel';
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateWixAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateWixAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | {
          readonly __typename: 'WixChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type UpdateWoocommerceMutationVariables = Exact<{
  channelId: Scalars['ID'];
  title: Scalars['String'];
  shopUrl: Scalars['String'];
  statusesToImport?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  trackingEmailsEnabled: Scalars['Boolean'];
  autoSyncEnabled: Scalars['Boolean'];
}>;

export type UpdateWoocommerceMutation = {
  readonly updateWoocommerceChannel: {
    readonly __typename: 'WoocommerceChannel';
    readonly shopUrl: string;
    readonly statusesToImport: ReadonlyArray<string>;
    readonly trackingEmailsEnabled: boolean;
    readonly id: string;
    readonly title: string;
    readonly active: boolean;
    readonly valid: boolean;
    readonly autoSyncEnabled: boolean;
    readonly platform: {
      readonly __typename: 'Platform';
      readonly id: string;
      readonly platformKey: string;
      readonly title: string;
    } | null;
    readonly mappableFields: ReadonlyArray<{
      readonly __typename: 'PlatformMappableField';
      readonly field: string;
      readonly label: string;
    }>;
    readonly rubberstampConfig: ReadonlyArray<{
      readonly __typename: 'ChannelRubberstampConfig';
      readonly rubberstamp: string;
      readonly configuredField: string;
    }>;
  };
};

export type UpdateWoocommerceAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateWoocommerceAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | {
          readonly __typename: 'WoocommerceChannel';
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
    >;
  };
};

export type ChannelsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type ChannelsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly channels: ReadonlyArray<
      | {
          readonly __typename: 'BigcartelChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'BigcommerceChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'CratejoyChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'DiscogsChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'EbayChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'EcwidChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'EtsyChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'FakeshopChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'PaypalChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'ShopifyChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'SquareChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'SquarespaceChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'SubblyChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'WixChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | {
          readonly __typename: 'WoocommerceChannel';
          readonly reconnectUrl: string | null;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
    >;
  };
};

export type PlatformsQueryVariables = Exact<{ [key: string]: never }>;

export type PlatformsQuery = {
  readonly platforms: ReadonlyArray<{
    readonly __typename: 'Platform';
    readonly installUrl: string | null;
    readonly reconnectSupported: boolean;
    readonly trackingEmailSupported: boolean;
    readonly id: string;
    readonly platformKey: string;
    readonly title: string;
  }>;
};

export type BigcartelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BigcartelQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | {
          readonly __typename: 'BigcartelChannel';
          readonly plan: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly autoSyncEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type BigcommerceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BigcommerceQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | {
          readonly __typename: 'BigcommerceChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly clientSecret: string;
          readonly apiUrl: string;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type CratejoyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CratejoyQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | {
          readonly __typename: 'CratejoyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly clientId: string;
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly skipFutureSubscriptions: boolean;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type DiscogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DiscogsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | {
          readonly __typename: 'DiscogsChannel';
          readonly clientSecret: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type EbayQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type EbayQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | {
          readonly __typename: 'EbayChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type EcwidQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type EcwidQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | {
          readonly __typename: 'EcwidChannel';
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly username: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly customFulfillmentStatusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly customPaymentStatuses: ReadonlyArray<{
            readonly __typename: 'EcwidOrderStatusImpl';
            readonly id: string;
            readonly name: string;
          }>;
          readonly customFulfillmentStatuses: ReadonlyArray<{
            readonly __typename: 'EcwidOrderStatusImpl';
            readonly id: string;
            readonly name: string;
          }>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type EtsyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type EtsyQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | {
          readonly __typename: 'EtsyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type FakeshopQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FakeshopQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | {
          readonly __typename: 'FakeshopChannel';
          readonly orderGroups: ReadonlyArray<string>;
          readonly autoSyncEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
        }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type PaypalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type PaypalQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | {
          readonly __typename: 'PaypalChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly genericLineItemEnabled: boolean | null;
          readonly trackingEmailsEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type ShopifyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ShopifyQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | {
          readonly __typename: 'ShopifyChannel';
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly shopUrl: string;
          readonly importLineItemsNotRequireShippingEnabled: boolean;
          readonly trackingEmailsEnabled: boolean;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly importOrdersNewerThan: number | null;
          readonly locationsToImport: ReadonlyArray<string>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
          readonly customOptions: ReadonlyArray<{
            readonly __typename: 'CustomOption';
            readonly sourceKey: string;
            readonly name: string;
            readonly override: string;
          }>;
          readonly fulfillmentLocations: ReadonlyArray<{
            readonly __typename: 'ShopifyLocation';
            readonly id: string;
            readonly name: string;
          }>;
        }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type SquareQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SquareQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | {
          readonly __typename: 'SquareChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly locationsToImport: ReadonlyArray<string>;
          readonly importCustomAttributes: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly locations: ReadonlyArray<{
            readonly __typename: 'SquareLocation';
            readonly id: string;
            readonly name: string;
          }>;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type SquarespaceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SquarespaceQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | {
          readonly __typename: 'SquarespaceChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type SubblyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SubblyQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | {
          readonly __typename: 'SubblyChannel';
          readonly clientSecret: string;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'WixChannel' }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type WixQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type WixQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | {
          readonly __typename: 'WixChannel';
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
      | { readonly __typename: 'WoocommerceChannel' }
    >;
  };
};

export type WoocommerceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type WoocommerceQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly channels: ReadonlyArray<
      | { readonly __typename: 'BigcartelChannel' }
      | { readonly __typename: 'BigcommerceChannel' }
      | { readonly __typename: 'CratejoyChannel' }
      | { readonly __typename: 'DiscogsChannel' }
      | { readonly __typename: 'EbayChannel' }
      | { readonly __typename: 'EcwidChannel' }
      | { readonly __typename: 'EtsyChannel' }
      | { readonly __typename: 'FakeshopChannel' }
      | { readonly __typename: 'PaypalChannel' }
      | { readonly __typename: 'ShopifyChannel' }
      | { readonly __typename: 'SquareChannel' }
      | { readonly __typename: 'SquarespaceChannel' }
      | { readonly __typename: 'SubblyChannel' }
      | { readonly __typename: 'WixChannel' }
      | {
          readonly __typename: 'WoocommerceChannel';
          readonly shopUrl: string;
          readonly statusesToImport: ReadonlyArray<string>;
          readonly trackingEmailsEnabled: boolean;
          readonly id: string;
          readonly title: string;
          readonly active: boolean;
          readonly valid: boolean;
          readonly autoSyncEnabled: boolean;
          readonly platform: {
            readonly __typename: 'Platform';
            readonly id: string;
            readonly platformKey: string;
            readonly title: string;
          } | null;
          readonly mappableFields: ReadonlyArray<{
            readonly __typename: 'PlatformMappableField';
            readonly field: string;
            readonly label: string;
          }>;
          readonly rubberstampConfig: ReadonlyArray<{
            readonly __typename: 'ChannelRubberstampConfig';
            readonly rubberstamp: string;
            readonly configuredField: string;
          }>;
        }
    >;
  };
};

export type WoocommerceEgressIpsQueryVariables = Exact<{ [key: string]: never }>;

export type WoocommerceEgressIpsQuery = { readonly woocommerceEgressIps: ReadonlyArray<string> };

export type IntercomArticleQueryVariables = Exact<{
  url: Scalars['String'];
}>;

export type IntercomArticleQuery = { readonly intercomArticle: string };

export type AcceptTermsMutationVariables = Exact<{
  accepted: Scalars['Boolean'];
}>;

export type AcceptTermsMutation = {
  readonly acceptTerms: {
    readonly __typename: 'User';
    readonly id: string;
    readonly roles: ReadonlyArray<Role>;
  };
};

export type LatestTermsQueryVariables = Exact<{ [key: string]: never }>;

export type LatestTermsQuery = {
  readonly latestTerms: {
    readonly __typename: 'UserTerms';
    readonly id: string;
    readonly terms: string;
  };
};

export type AreMobileCodesEnabledQueryVariables = Exact<{ [key: string]: never }>;

export type AreMobileCodesEnabledQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly areMobileCodesEnabled: boolean;
    };
  };
};

export type BatchMobileCodeModalQueryVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type BatchMobileCodeModalQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly containedMailClassGroupKeys: ReadonlyArray<string>;
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly carrierKey: string;
      readonly rubberStamp1: string | null;
      readonly rubberStamp2: string | null;
      readonly rubberStamp3: string | null;
      readonly weight: number;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number | null;
      readonly recipientAddress: {
        readonly __typename: 'RecipientAddress';
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly address3: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly packageType: { readonly __typename: 'CarrierPackageType'; readonly title: string };
    }>;
  };
};

export type DownloadMobileCodeForShipmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DownloadMobileCodeForShipmentMutation = {
  readonly downloadMobileCodeForShipment: {
    readonly __typename: 'ShipmentMobileCode';
    readonly mobileCodeDataUri: string | null;
  };
};

export type DownloadMobileCodesForBatchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DownloadMobileCodesForBatchMutation = {
  readonly downloadMobileCodesForBatch: ReadonlyArray<{
    readonly __typename: 'ShipmentMobileCode';
    readonly mobileCodeDataUri: string | null;
    readonly shipmentId: string | null;
  }>;
};

export type ShipmentAfterMobileCodeDownloadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ShipmentAfterMobileCodeDownloadQuery = {
  readonly shipment: {
    readonly __typename: 'Shipment';
    readonly id: string;
    readonly hasBeenDownloaded: boolean;
    readonly canInstantRefundShipment: boolean;
  };
};

export type PaymentApiMethodFragment = {
  readonly __typename: 'PaymentApiMethod';
  readonly id: string;
  readonly code: PaymentMethodType;
  readonly apiTitle: PaymentApiMethodTitle;
  readonly apiKey: string | null;
};

export type PaymentSourceFragment = {
  readonly __typename: 'PaymentSource';
  readonly id: string;
  readonly paymentMethodType: PaymentMethodType;
  readonly validationStatus: string;
  readonly brand: string;
  readonly last4: string | null;
  readonly expMonth: number | null;
  readonly expYear: number | null;
  readonly resultMessage: string | null;
  readonly email: string | null;
  readonly title: string;
  readonly nickname: string | null;
  readonly refundableAmount: number;
  readonly hasConsented: boolean;
};

export type AddCreditToPaymentSourceMutationVariables = Exact<{
  addCreditAmount: Scalars['Float'];
  paymentSourceId: Scalars['ID'];
}>;

export type AddCreditToPaymentSourceMutation = {
  readonly addCreditToPaymentSource: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
  };
};

export type CreateCcPaymentSourceMutationVariables = Exact<{
  ccReference: Scalars['String'];
  cp: Scalars['Boolean'];
}>;

export type CreateCcPaymentSourceMutation = {
  readonly createCcPaymentSource: {
    readonly __typename: 'CreatePaymentSourceResponse';
    readonly isDefault: boolean;
    readonly paymentSource: {
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    };
  };
};

export type UpdateCcPaymentSourceAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateCcPaymentSourceAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultPaymentSourceId: string;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
};

export type CreatePayPalPaymentSourceMutationVariables = Exact<{
  nonce: Scalars['String'];
}>;

export type CreatePayPalPaymentSourceMutation = {
  readonly createPayPalPaymentSource: {
    readonly __typename: 'CreatePaymentSourceResponse';
    readonly isDefault: boolean;
    readonly paymentSource: {
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    };
  };
};

export type UpdatePayPalPaymentSourceAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePayPalPaymentSourceAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultPaymentSourceId: string;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
};

export type CreatePlaidAccessTokenMutationVariables = Exact<{
  publicToken: Scalars['String'];
  handle: Scalars['String'];
}>;

export type CreatePlaidAccessTokenMutation = {
  readonly createPlaidAccessToken: {
    readonly __typename: 'PlaidActivation';
    readonly handle: string;
    readonly mask: string | null;
    readonly name: string;
    readonly paymentSource: {
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    } | null;
  };
};

export type CreatePlaidActivationMutationVariables = Exact<{
  origin: Scalars['String'];
}>;

export type CreatePlaidActivationMutation = {
  readonly createPlaidActivation: {
    readonly __typename: 'PlaidActivation';
    readonly handle: string;
    readonly linkToken: string;
  };
};

export type CreatePlaidConsentMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
}>;

export type CreatePlaidConsentMutation = {
  readonly createPlaidConsent: {
    readonly __typename: 'CreatePaymentSourceResponse';
    readonly isDefault: boolean;
    readonly paymentSource: {
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    };
  };
};

export type UpdatePlaidPaymentSourceAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePlaidPaymentSourceAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultPaymentSourceId: string;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
};

export type CreatePlaidValidationActivationMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
  origin: Scalars['String'];
}>;

export type CreatePlaidValidationActivationMutation = {
  readonly createPlaidValidationActivation: {
    readonly __typename: 'PlaidActivation';
    readonly handle: string;
    readonly linkToken: string;
  };
};

export type CreateVenmoPaymentSourceMutationVariables = Exact<{
  nonce: Scalars['String'];
}>;

export type CreateVenmoPaymentSourceMutation = {
  readonly createVenmoPaymentSource: {
    readonly __typename: 'CreatePaymentSourceResponse';
    readonly isDefault: boolean;
    readonly paymentSource: {
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    };
  };
};

export type UpdateVenmoSourceAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateVenmoSourceAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultPaymentSourceId: string;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
};

export type DeletePaymentSourceMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
}>;

export type DeletePaymentSourceMutation = {
  readonly deletePaymentSource: { readonly __typename: 'PaymentSource'; readonly id: string };
};

export type UpdatePaymentSourcesAfterDeleteQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePaymentSourcesAfterDeleteQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
};

export type RefundCreditFromPaymentSourceMutationVariables = Exact<{
  refundCreditAmount: Scalars['Float'];
  paymentSourceId: Scalars['ID'];
}>;

export type RefundCreditFromPaymentSourceMutation = {
  readonly refundCreditFromPaymentSource: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
  };
};

export type ResetNicknameMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
}>;

export type ResetNicknameMutation = { readonly resetNickname: undefined | null };

export type SetDefaultPaymentSourceMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
}>;

export type SetDefaultPaymentSourceMutation = {
  readonly setDefaultPaymentSource: { readonly __typename: 'PaymentSource'; readonly id: string };
};

export type UpdateSettingsAfterDefaultPaymentSourceQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSettingsAfterDefaultPaymentSourceQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultPaymentSourceId: string;
    };
  };
};

export type SetPaymentSourceNicknameMutationVariables = Exact<{
  paymentSourceId: Scalars['ID'];
  nickname: Scalars['String'];
}>;

export type SetPaymentSourceNicknameMutation = { readonly setNickname: undefined | null };

export type BillingPageQueryVariables = Exact<{ [key: string]: never }>;

export type BillingPageQuery = {
  readonly chargeAmountOptions: ReadonlyArray<number>;
  readonly user: { readonly __typename: 'User'; readonly id: string; readonly email: string };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
    readonly activePaymentMethods: ReadonlyArray<PaymentMethodType>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultDestinationCountryCode: string;
      readonly defaultPaymentSourceId: string;
      readonly defaultChargeAmount: number;
    };
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
  };
  readonly paymentApiMethods: ReadonlyArray<{
    readonly __typename: 'PaymentApiMethod';
    readonly id: string;
    readonly code: PaymentMethodType;
    readonly apiTitle: PaymentApiMethodTitle;
    readonly apiKey: string | null;
  }>;
};

export type PaymentModalQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentModalQuery = {
  readonly chargeAmountOptions: ReadonlyArray<number>;
  readonly user: { readonly __typename: 'User'; readonly id: string; readonly email: string };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
    readonly activePaymentMethods: ReadonlyArray<PaymentMethodType>;
    readonly features: ReadonlyArray<{
      readonly __typename: 'Feature';
      readonly key: string;
      readonly value: boolean;
    }>;
  };
  readonly paymentApiMethods: ReadonlyArray<{
    readonly __typename: 'PaymentApiMethod';
    readonly id: string;
    readonly code: PaymentMethodType;
    readonly apiTitle: PaymentApiMethodTitle;
    readonly apiKey: string | null;
  }>;
};

export type PaymentReceiptsQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentReceiptsQuery = { readonly paymentReceipts: object | null };

export type SpreedlyIframeParametersQueryVariables = Exact<{ [key: string]: never }>;

export type SpreedlyIframeParametersQuery = {
  readonly spreedlyIframeParameters: {
    readonly __typename: 'SpreedlyIframeParameters';
    readonly nonce: string;
    readonly timestamp: string;
    readonly signature: string;
    readonly certificateToken: string;
  };
};

export type CancelPickupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CancelPickupMutation = {
  readonly cancelPickup: {
    readonly __typename: 'PickupRequest';
    readonly id: string;
    readonly canCancel: boolean;
  };
};

export type UpdatePickupsAfterCancelQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePickupsAfterCancelQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly pickups: ReadonlyArray<{
      readonly __typename: 'PickupRequest';
      readonly id: string;
      readonly oneTimePickupDate: string | null;
      readonly warehouseReadyTime: string;
      readonly warehouseCloseTime: string;
      readonly totalPackageWeight: number;
      readonly confirmationNumber: string | null;
      readonly totalPackageCount: number;
      readonly status: PickupRequestStatus;
      readonly canCancel: boolean;
      readonly packageLocation: PickupRequestPackageLocation;
      readonly specialInstructions: string | null;
      readonly rate: { readonly __typename: 'PickupRateResult'; readonly totalPrice: number };
      readonly warehouse: {
        readonly __typename: 'Warehouse';
        readonly title: string | null;
        readonly originAddress: {
          readonly __typename: 'Address';
          readonly city: string;
          readonly postcode: string;
          readonly countryCode: string;
        };
      };
      readonly carrier: {
        readonly __typename: 'Carrier';
        readonly carrierKey: CarrierKey;
        readonly title: string;
      };
    }>;
  };
};

export type PickupFragment = {
  readonly __typename: 'PickupRequest';
  readonly id: string;
  readonly oneTimePickupDate: string | null;
  readonly warehouseReadyTime: string;
  readonly warehouseCloseTime: string;
  readonly totalPackageWeight: number;
  readonly confirmationNumber: string | null;
  readonly totalPackageCount: number;
  readonly status: PickupRequestStatus;
  readonly canCancel: boolean;
  readonly packageLocation: PickupRequestPackageLocation;
  readonly specialInstructions: string | null;
  readonly rate: { readonly __typename: 'PickupRateResult'; readonly totalPrice: number };
  readonly warehouse: {
    readonly __typename: 'Warehouse';
    readonly title: string | null;
    readonly originAddress: {
      readonly __typename: 'Address';
      readonly city: string;
      readonly postcode: string;
      readonly countryCode: string;
    };
  };
  readonly carrier: {
    readonly __typename: 'Carrier';
    readonly carrierKey: CarrierKey;
    readonly title: string;
  };
};

export type PickupCreationQueryVariables = Exact<{ [key: string]: never }>;

export type PickupCreationQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly accountBalance: number;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly activePaymentMethods: ReadonlyArray<PaymentMethodType>;
    readonly merchantAccounts: ReadonlyArray<{
      readonly __typename: 'MerchantAccount';
      readonly carrierKey: CarrierKey;
      readonly accountStatus: MerchantAccountTransmissionStatus | null;
      readonly termsAndConditionsOutdated: boolean;
    }>;
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
      readonly validationStatus: string;
      readonly brand: string;
      readonly last4: string | null;
      readonly expMonth: number | null;
      readonly expYear: number | null;
      readonly resultMessage: string | null;
      readonly email: string | null;
      readonly title: string;
      readonly nickname: string | null;
      readonly refundableAmount: number;
      readonly hasConsented: boolean;
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultChargeAmount: number;
      readonly defaultPaymentSourceId: string;
      readonly defaultWarehouseId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
    readonly features: ReadonlyArray<{
      readonly __typename: 'Feature';
      readonly key: string;
      readonly value: boolean;
    }>;
  };
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly allowedPickupDates: ReadonlyArray<string>;
    readonly mailClasses: ReadonlyArray<{
      readonly __typename: 'CarrierMailClass';
      readonly id: string;
      readonly title: string;
      readonly mailClassKey: string;
      readonly sortOrder: number;
      readonly serviceLevel: number;
    }>;
  }>;
  readonly paymentApiMethods: ReadonlyArray<{
    readonly __typename: 'PaymentApiMethod';
    readonly id: string;
    readonly code: PaymentMethodType;
    readonly apiTitle: PaymentApiMethodTitle;
    readonly apiKey: string | null;
  }>;
  readonly user: { readonly __typename: 'User'; readonly id: string; readonly email: string };
};

export type PickupsQueryVariables = Exact<{ [key: string]: never }>;

export type PickupsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly pickups: ReadonlyArray<{
      readonly __typename: 'PickupRequest';
      readonly id: string;
      readonly oneTimePickupDate: string | null;
      readonly warehouseReadyTime: string;
      readonly warehouseCloseTime: string;
      readonly totalPackageWeight: number;
      readonly confirmationNumber: string | null;
      readonly totalPackageCount: number;
      readonly status: PickupRequestStatus;
      readonly canCancel: boolean;
      readonly packageLocation: PickupRequestPackageLocation;
      readonly specialInstructions: string | null;
      readonly rate: { readonly __typename: 'PickupRateResult'; readonly totalPrice: number };
      readonly warehouse: {
        readonly __typename: 'Warehouse';
        readonly title: string | null;
        readonly originAddress: {
          readonly __typename: 'Address';
          readonly city: string;
          readonly postcode: string;
          readonly countryCode: string;
        };
      };
      readonly carrier: {
        readonly __typename: 'Carrier';
        readonly carrierKey: CarrierKey;
        readonly title: string;
      };
    }>;
  };
};

export type RatePickupMutationVariables = Exact<{
  pickupRequest: PickupRequestInput;
}>;

export type RatePickupMutation = {
  readonly ratePickup: {
    readonly __typename: 'PickupRateResult';
    readonly basePrice: number;
    readonly totalPrice: number;
    readonly crossedOutBasePrice: number | null;
    readonly crossedOutTotalPrice: number | null;
    readonly surcharges: ReadonlyArray<{
      readonly __typename: 'PickupSurcharge';
      readonly name: string;
      readonly price: number;
      readonly crossedOutPrice: number | null;
    }>;
  };
};

export type RequestPickupMutationVariables = Exact<{
  pickupRequest: PickupRequestInput;
  paymentSourceId: Scalars['ID'];
  totalCharge: Scalars['Float'];
}>;

export type RequestPickupMutation = {
  readonly requestPickup: {
    readonly __typename: 'PickupRequest';
    readonly id: string;
    readonly oneTimePickupDate: string | null;
    readonly warehouseReadyTime: string;
    readonly warehouseCloseTime: string;
    readonly totalPackageWeight: number;
    readonly confirmationNumber: string | null;
    readonly totalPackageCount: number;
    readonly status: PickupRequestStatus;
    readonly canCancel: boolean;
    readonly packageLocation: PickupRequestPackageLocation;
    readonly specialInstructions: string | null;
    readonly rate: { readonly __typename: 'PickupRateResult'; readonly totalPrice: number };
    readonly warehouse: {
      readonly __typename: 'Warehouse';
      readonly title: string | null;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly city: string;
        readonly postcode: string;
        readonly countryCode: string;
      };
    };
    readonly carrier: {
      readonly __typename: 'Carrier';
      readonly carrierKey: CarrierKey;
      readonly title: string;
    };
  };
};

export type UpdatePickupsAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePickupsAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly pickups: ReadonlyArray<{
      readonly __typename: 'PickupRequest';
      readonly id: string;
      readonly oneTimePickupDate: string | null;
      readonly warehouseReadyTime: string;
      readonly warehouseCloseTime: string;
      readonly totalPackageWeight: number;
      readonly confirmationNumber: string | null;
      readonly totalPackageCount: number;
      readonly status: PickupRequestStatus;
      readonly canCancel: boolean;
      readonly packageLocation: PickupRequestPackageLocation;
      readonly specialInstructions: string | null;
      readonly rate: { readonly __typename: 'PickupRateResult'; readonly totalPrice: number };
      readonly warehouse: {
        readonly __typename: 'Warehouse';
        readonly title: string | null;
        readonly originAddress: {
          readonly __typename: 'Address';
          readonly city: string;
          readonly postcode: string;
          readonly countryCode: string;
        };
      };
      readonly carrier: {
        readonly __typename: 'Carrier';
        readonly carrierKey: CarrierKey;
        readonly title: string;
      };
    }>;
  };
};

export type UpsPickupPrefillQueryVariables = Exact<{ [key: string]: never }>;

export type UpsPickupPrefillQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly pickupSummary: {
      readonly __typename: 'ShipmentSummary';
      readonly overweightShipmentIncluded: boolean;
      readonly totalCount: number;
      readonly mailClassCounts: ReadonlyArray<{
        readonly __typename: 'MailClassCount';
        readonly shipmentCount: number;
        readonly mailClass: {
          readonly __typename: 'CarrierMailClass';
          readonly mailClassKey: string;
        };
      }>;
    };
  };
};

export type UspsPickupPrefillQueryVariables = Exact<{ [key: string]: never }>;

export type UspsPickupPrefillQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly pickupSummary: {
      readonly __typename: 'ShipmentSummary';
      readonly overweightShipmentIncluded: boolean;
      readonly totalWeightOz: number;
      readonly totalWeightLbs: number;
      readonly totalCount: number;
    };
  };
};

export type BatchesAfterLabelDownloadQueryVariables = Exact<{
  batchIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;

export type BatchesAfterLabelDownloadQuery = {
  readonly batches: ReadonlyArray<{
    readonly __typename: 'Batch';
    readonly id: string;
    readonly canInstantRefundBatch: boolean;
    readonly hasBeenDownloaded: boolean;
    readonly canRefund: boolean;
    readonly statusText: string;
    readonly shipmentStatusSummary: {
      readonly __typename: 'ShipmentStatusSummary';
      readonly errorCount: number;
      readonly refundedCount: number;
      readonly refundableCount: number;
      readonly refundPendingCount: number;
      readonly inTransitCount: number;
      readonly deliveredCount: number;
      readonly readyToShipCount: number;
      readonly readyToPrintCount: number;
      readonly printableCount: number;
      readonly mobileCodeShowableCount: number;
    };
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly hasBeenDownloaded: boolean;
      readonly canPrint: boolean;
      readonly isShipmentRefundable: boolean;
      readonly canInstantRefundShipment: boolean;
    }>;
  }>;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly isSuspended: boolean;
  };
};

export type GenerateOrGetShareLinkMutationVariables = Exact<{
  downloadId: Scalars['ID'];
}>;

export type GenerateOrGetShareLinkMutation = { readonly generateOrGetShareLink: string };

export type LabelsQueryVariables = Exact<{
  downloadId: Scalars['ID'];
  shareToken?: InputMaybe<Scalars['String']>;
  isViaAdminBar?: InputMaybe<Scalars['Boolean']>;
}>;

export type LabelsQuery = {
  readonly labels: {
    readonly __typename: 'LabelsType';
    readonly id: string;
    readonly status: DownloadStatus;
    readonly fileFormat: FileFormat | null;
    readonly pageLayout: PageLayout | null;
    readonly url: string | null;
  };
};

export type PrintSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type PrintSettingsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly shipmentLabelSize: string;
      readonly shipmentLabelFileFormat: string;
      readonly packingListTemplate: string;
    };
  };
};

export type ScanFormByBatchQueryVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type ScanFormByBatchQuery = {
  readonly scanFormByBatch: {
    readonly __typename: 'PossibleScanFormResult';
    readonly id: string;
    readonly canCreateScanForm: boolean;
    readonly scanFormUrl: string | null;
  };
};

export type ScanFormByShareTokenAfterLabelDownloadQueryVariables = Exact<{
  shareToken: Scalars['String'];
}>;

export type ScanFormByShareTokenAfterLabelDownloadQuery = {
  readonly scanFormByShareToken: {
    readonly __typename: 'PossibleScanFormResult';
    readonly id: string;
    readonly canCreateScanForm: boolean;
    readonly scanFormUrl: string | null;
  };
};

export type ShipmentsAfterLabelDownloadQueryVariables = Exact<{
  shipmentIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;

export type ShipmentsAfterLabelDownloadQuery = {
  readonly shipments: ReadonlyArray<{
    readonly __typename: 'Shipment';
    readonly id: string;
    readonly canInstantRefundShipment: boolean;
    readonly hasBeenDownloaded: boolean;
    readonly canPrint: boolean;
    readonly isShipmentRefundable: boolean;
  }>;
};

export type TriggerDownloadLabelsByBatchesMutationVariables = Exact<{
  batchIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  pageLayout?: InputMaybe<PageLayout>;
}>;

export type TriggerDownloadLabelsByBatchesMutation = {
  readonly triggerLabelCreationByBatches: string;
};

export type TriggerDownloadLabelsByShareTokenMutationVariables = Exact<{
  shareToken: Scalars['String'];
  pageLayout?: InputMaybe<PageLayout>;
}>;

export type TriggerDownloadLabelsByShareTokenMutation = {
  readonly triggerLabelCreationByShareToken: string;
};

export type TriggerDownloadLabelsByShipmentsMutationVariables = Exact<{
  shipmentIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  pageLayout?: InputMaybe<PageLayout>;
  isViaAdminBar?: InputMaybe<Scalars['Boolean']>;
}>;

export type TriggerDownloadLabelsByShipmentsMutation = {
  readonly triggerLabelCreationByShipments: string;
};

export type RatesConfigQueryVariables = Exact<{ [key: string]: never }>;

export type RatesConfigQuery = {
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly mailClasses: ReadonlyArray<{
      readonly __typename: 'CarrierMailClass';
      readonly mailClassKey: string;
    }>;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly description: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultDestinationCountryCode: string;
      readonly defaultWarehouseId: string;
    };
  };
  readonly shipmentBoundaries: {
    readonly __typename: 'ShipmentBoundaries';
    readonly maxWeight: number;
    readonly maxCombinedLength: number;
    readonly maxLengthPlusGirth: number;
    readonly minLongSide: number;
    readonly maxLongSide: number;
    readonly minMiddleSide: number;
    readonly maxMiddleSide: number;
    readonly minShortSide: number;
    readonly maxShortSide: number;
  };
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
};

export type RatesQueryVariables = Exact<{
  originZip: Scalars['String'];
  originCity?: InputMaybe<Scalars['String']>;
  originRegionCode?: InputMaybe<Scalars['String']>;
  destinationZip?: InputMaybe<Scalars['String']>;
  isResidential?: InputMaybe<Scalars['Boolean']>;
  destinationCountryCode?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  dimensionX?: InputMaybe<Scalars['Float']>;
  dimensionY?: InputMaybe<Scalars['Float']>;
  dimensionZ?: InputMaybe<Scalars['Float']>;
  mailClassKeys: ReadonlyArray<Scalars['String']> | Scalars['String'];
  packageTypeKeys: ReadonlyArray<Scalars['String']> | Scalars['String'];
  pricingTypes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  showUpsRatesWhen2x7Selected?: InputMaybe<Scalars['Boolean']>;
}>;

export type RatesQuery = {
  readonly rates: ReadonlyArray<{
    readonly __typename: 'RateResult';
    readonly title: string;
    readonly deliveryDescription: string;
    readonly trackingDescription: string;
    readonly serviceDescription: string;
    readonly pricingDescription: string;
    readonly cubicTier: string | null;
    readonly mailClassKey: string;
    readonly packageTypeKey: string;
    readonly zone: string;
    readonly totalPrice: number;
    readonly priceBaseTypeKey: string;
    readonly basePrice: number;
    readonly crossedTotalPrice: number;
    readonly pricingType: string;
    readonly pricingSubType: string;
    readonly ratePeriodId: number;
    readonly learnMoreUrl: string;
    readonly cheapest: boolean;
    readonly fastest: boolean;
    readonly best: boolean;
    readonly mailClass: {
      readonly __typename: 'CarrierMailClass';
      readonly accuracy: number | null;
      readonly international: boolean;
    };
    readonly surcharges: ReadonlyArray<{
      readonly __typename: 'RateSurcharge';
      readonly title: string;
      readonly price: number;
    }>;
    readonly carrier: {
      readonly __typename: 'Carrier';
      readonly carrierKey: CarrierKey;
      readonly title: string;
    };
  }>;
};

export type RefundBatchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RefundBatchMutation = {
  readonly refundBatch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type RefundShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;

export type RefundShipmentMutation = {
  readonly refundShipment: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly canRefund: boolean;
    readonly canInstantRefundBatch: boolean;
    readonly shipmentStatusSummary: {
      readonly __typename: 'ShipmentStatusSummary';
      readonly refundableCount: number;
      readonly printableCount: number;
    };
    readonly shipments: ReadonlyArray<{
      readonly __typename: 'Shipment';
      readonly id: string;
      readonly status: ShipmentStatus;
      readonly hasBeenDownloaded: boolean;
      readonly canPrint: boolean;
      readonly carrierKey: string;
      readonly canShowMobileCode: boolean;
      readonly isShipmentRefundable: boolean;
      readonly canInstantRefundShipment: boolean;
      readonly additionalRefundNotice: string;
    }>;
  };
};

export type AverageCostChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type AverageCostChartQuery = {
  readonly averageCostChart: {
    readonly __typename: 'Chart';
    readonly charts: ReadonlyArray<number>;
    readonly labels: ReadonlyArray<string>;
  };
};

export type CompanySavingsQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type CompanySavingsQuery = { readonly companySavings: number };

export type CountryDistributionChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type CountryDistributionChartQuery = {
  readonly countryDistributionChart: {
    readonly __typename: 'CountryDistributionChart';
    readonly totalCount: number;
    readonly countryDistributions: ReadonlyArray<{
      readonly __typename: 'DistributionChartItem';
      readonly key: string;
      readonly count: string;
      readonly name: string;
      readonly percent: number;
      readonly price: number;
    }>;
  };
};

export type NumbersQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type NumbersQuery = {
  readonly numbers: {
    readonly __typename: 'Numbers';
    readonly carrierAdjustmentsAmount: number;
    readonly payments: number;
    readonly netLabelCount: number;
    readonly netLabelTotal: number;
    readonly netLabelAverage: number;
    readonly netLabelAverageDom: number;
    readonly netLabelAverageInt: number;
    readonly pendingNumbers: {
      readonly __typename: 'PendingNumbers';
      readonly paymentsTotalAmount: number;
      readonly returns: {
        readonly __typename: 'Summary';
        readonly amount: number;
        readonly count: number;
      };
      readonly refunds: {
        readonly __typename: 'Summary';
        readonly amount: number;
        readonly count: number;
      };
    };
  };
};

export type PaymentChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type PaymentChartQuery = {
  readonly paymentChart: {
    readonly __typename: 'Chart';
    readonly labels: ReadonlyArray<string>;
    readonly charts: ReadonlyArray<number>;
  };
};

export type ReceiptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ReceiptQuery = {
  readonly receipt: {
    readonly __typename: 'Receipt';
    readonly startBalance: number;
    readonly endBalance: number;
    readonly paymentSuccessful: boolean;
    readonly isCharged: boolean;
    readonly billingAddress:
      | {
          readonly __typename: 'Address';
          readonly fullName: string;
          readonly company: string;
          readonly address1: string;
          readonly address2: string;
          readonly city: string;
          readonly postcode: string;
          readonly regionCode: string;
          readonly timeZone: string;
          readonly zip4: string;
        }
      | {
          readonly __typename: 'DockOrder';
          readonly fullName: string;
          readonly company: string;
          readonly address1: string;
          readonly address2: string;
          readonly city: string;
          readonly postcode: string;
          readonly regionCode: string;
          readonly timeZone: string;
          readonly zip4: string;
        }
      | {
          readonly __typename: 'Shipment';
          readonly fullName: string;
          readonly company: string;
          readonly address1: string;
          readonly address2: string;
          readonly city: string;
          readonly postcode: string;
          readonly regionCode: string;
          readonly timeZone: string;
          readonly zip4: string;
        };
    readonly payment: {
      readonly __typename: 'Payment';
      readonly title: string;
      readonly total: string;
      readonly createdAt: string;
      readonly status: string;
      readonly chargeError: string;
      readonly refundTotal: number;
    };
    readonly transactions: ReadonlyArray<{
      readonly __typename: 'AccountingTransaction';
      readonly paymentId: string;
      readonly batchId: string;
      readonly shipmentId: string;
      readonly reconciliationRunId: string;
      readonly createdAt: string | null;
      readonly transactionType: string;
      readonly title: string | null;
      readonly amount: string;
      readonly balance: string | null;
    }>;
    readonly reversals: ReadonlyArray<{
      readonly __typename: 'ReversalType';
      readonly amount: number;
      readonly action: {
        readonly __typename: 'PaymentAction';
        readonly actionType: string;
        readonly newPaymentStatus: string;
        readonly createdAt: string;
      };
      readonly coveringAccountingTransaction: {
        readonly __typename: 'AccountingTransaction';
        readonly paymentId: string;
      } | null;
    }>;
  };
};

export type ReportsPageQueryVariables = Exact<{ [key: string]: never }>;

export type ReportsPageQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly createdAt: string | null;
    readonly accountBalance: number;
    readonly paymentSources: ReadonlyArray<{
      readonly __typename: 'PaymentSource';
      readonly id: string;
      readonly paymentMethodType: PaymentMethodType;
    }>;
  };
};

export type ShipmentChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type ShipmentChartQuery = {
  readonly shipmentChart: {
    readonly __typename: 'Chart';
    readonly charts: ReadonlyArray<number>;
    readonly labels: ReadonlyArray<string>;
  };
};

export type ShipmentPieChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type ShipmentPieChartQuery = {
  readonly shipmentPieChart: {
    readonly __typename: 'Chart';
    readonly charts: ReadonlyArray<number>;
    readonly colors: ReadonlyArray<string> | null;
    readonly labels: ReadonlyArray<string>;
  };
};

export type ShipmentTrackingNumbersQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type ShipmentTrackingNumbersQuery = {
  readonly shipmentTrackingNumbers: {
    readonly __typename: 'ShipmentTrackingNumbers';
    readonly shipmentsTransit: number;
    readonly shipmentsDelivered: number;
    readonly shipmentsNew: number;
    readonly shipmentsDeliveryIssue: number;
  };
};

export type StateDistributionChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type StateDistributionChartQuery = {
  readonly stateDistributionChart: {
    readonly __typename: 'StateDistributionChart';
    readonly totalCount: number;
    readonly stateDistributions: ReadonlyArray<{
      readonly __typename: 'DistributionChartItem';
      readonly key: string;
      readonly count: string;
      readonly name: string;
      readonly percent: number;
      readonly price: number;
    }>;
  };
};

export type ZoneChartQueryVariables = Exact<{
  datetimeRange: DatetimeRangeInput;
}>;

export type ZoneChartQuery = {
  readonly zoneChart: {
    readonly __typename: 'Chart';
    readonly labels: ReadonlyArray<string>;
    readonly charts: ReadonlyArray<number>;
    readonly colors: ReadonlyArray<string> | null;
  };
};

export type CreateScanFormMutationVariables = Exact<{
  warehouseId: Scalars['ID'];
  shipDate: Scalars['String'];
}>;

export type CreateScanFormMutation = {
  readonly createScanForm: {
    readonly __typename: 'ScanFormResult';
    readonly id: string;
    readonly updatedAt: string;
    readonly shipmentCount: number;
    readonly shipDate: string;
    readonly url: string;
    readonly printableShipmentIds: ReadonlyArray<string>;
  };
};

export type CreateScanFormByBatchMutationVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type CreateScanFormByBatchMutation = {
  readonly createScanFormByBatch: {
    readonly __typename: 'PossibleScanFormResult';
    readonly id: string;
    readonly canCreateScanForm: boolean;
    readonly scanFormUrl: string | null;
  };
};

export type ScanFormsQueryVariables = Exact<{ [key: string]: never }>;

export type ScanFormsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultWarehouseId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly totalAvailableLabelsForScanForm: number | null;
      readonly scanForms: ReadonlyArray<{
        readonly __typename: 'ScanForm';
        readonly id: string;
        readonly isNew: boolean;
        readonly shipmentCount: number;
        readonly shipDate: string;
        readonly updatedAt: string;
        readonly printableShipmentIds: ReadonlyArray<string>;
        readonly url: string;
      }>;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type AbortChallengeMutationVariables = Exact<{
  key: Scalars['String'];
}>;

export type AbortChallengeMutation = {
  readonly abortChallenge: {
    readonly __typename: 'ChallengeState';
    readonly key: string;
    readonly isCompleted: boolean;
  };
};

export type ChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengesQuery = {
  readonly challenges: ReadonlyArray<{
    readonly __typename: 'ChallengeState';
    readonly key: string;
    readonly isCompleted: boolean;
  }>;
};

export type HasBatchesQueryVariables = Exact<{ [key: string]: never }>;

export type HasBatchesQuery = { readonly hasBatches: boolean };

export type LatestBatchesQueryVariables = Exact<{
  pageIndex: Scalars['Int'];
}>;

export type LatestBatchesQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly isSuspended: boolean;
  };
  readonly latestBatches: {
    readonly __typename: 'PaginatedBatches';
    readonly batches: ReadonlyArray<{
      readonly __typename: 'Batch';
      readonly id: string;
      readonly createdAt: string;
      readonly title: string;
      readonly numShipments: number;
      readonly status: BatchStatusTag;
      readonly statusText: string;
      readonly step: BatchStatus;
      readonly labelingArtifactType: LabelingArtifactType;
      readonly canCreateLabels: boolean;
      readonly canCreateMobileCodes: boolean;
      readonly cleanupComplete: boolean;
      readonly hasBeenDownloaded: boolean;
      readonly carrierLogoClasses: ReadonlyArray<string>;
      readonly containedMailClassGroupKeys: ReadonlyArray<string>;
      readonly runningProcess: {
        readonly __typename: 'BatchProcess';
        readonly progressPercentage: number;
      } | null;
      readonly shipmentStatusSummary: {
        readonly __typename: 'ShipmentStatusSummary';
        readonly errorCount: number;
        readonly refundedCount: number;
        readonly refundableCount: number;
        readonly refundPendingCount: number;
        readonly inTransitCount: number;
        readonly deliveredCount: number;
        readonly readyToShipCount: number;
        readonly readyToPrintCount: number;
        readonly printableCount: number;
        readonly mobileCodeShowableCount: number;
      };
      readonly shipments: ReadonlyArray<{
        readonly __typename: 'Shipment';
        readonly id: string;
        readonly trackingNr: string | null;
      }>;
    }>;
  };
};

export type SucceedAtChallengeMutationVariables = Exact<{
  key: Scalars['String'];
}>;

export type SucceedAtChallengeMutation = {
  readonly succeedAtChallenge: {
    readonly __typename: 'ChallengeState';
    readonly key: string;
    readonly isCompleted: boolean;
  };
};

export type BatchUploadFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BatchUploadFormQuery = {
  readonly batch: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly title: string;
    readonly step: BatchStatus;
    readonly labelSize: LabelSize;
    readonly customsFormRequired: boolean;
    readonly customsFormRequiredForAllShipments: boolean;
    readonly labelingArtifactType: LabelingArtifactType;
    readonly numShipments: number;
    readonly upload: { readonly __typename: 'ShipmentUpload'; readonly id: string } | null;
    readonly packageSummary: {
      readonly __typename: 'BatchPackageSummary';
      readonly packagePreset: {
        readonly __typename: 'ShipmentPreset';
        readonly id: string;
        readonly packageTypeKey: string;
        readonly dimensionX: number;
        readonly dimensionY: number;
        readonly dimensionZ: number;
        readonly weight: number;
        readonly insuredValueFlag: boolean;
        readonly insuredValue: number;
        readonly deliveryConfirmationFlag: boolean;
        readonly deliveryConfirmation: DeliveryConfirmation;
        readonly returnLabelFlag: boolean;
        readonly returnLabel: ReturnLabel;
        readonly qualifiesAsMediaMail: boolean;
        readonly irregularPackage: boolean;
        readonly hazardousMaterialsEnabled: boolean;
        readonly customsFormEnabled: boolean;
        readonly customsSigner: string;
        readonly customsContentType: string;
        readonly exporterTaxId: string;
        readonly recipientTaxId: string;
        readonly title: string;
        readonly customsItems: ReadonlyArray<{
          readonly __typename: 'CustomsItem';
          readonly id: string;
          readonly title: string;
          readonly quantity: number;
          readonly itemValue: number;
          readonly weight: number;
          readonly hsTariffNumber: string;
          readonly countryCodeOfOrigin: string;
        }>;
      } | null;
    };
    readonly warehouse: {
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    };
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultWarehouseId: string;
      readonly defaultShipmentPresetId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
  };
  readonly shipmentBoundaries: {
    readonly __typename: 'ShipmentBoundaries';
    readonly maxWeight: number;
    readonly maxCombinedLength: number;
    readonly maxLengthPlusGirth: number;
    readonly minLongSide: number;
    readonly maxLongSide: number;
    readonly minMiddleSide: number;
    readonly maxMiddleSide: number;
    readonly minShortSide: number;
    readonly maxShortSide: number;
  };
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly description: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
};

export type CompleteBatchFromUploadMutationVariables = Exact<{
  batchId: Scalars['ID'];
  batchTitle: Scalars['String'];
  warehouseId: Scalars['ID'];
  shipmentPresetId: Scalars['ID'];
}>;

export type CompleteBatchFromUploadMutation = {
  readonly completeBatchFromUpload: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly status: BatchStatusTag;
    readonly title: string;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type CreateBatchFromImportMutationVariables = Exact<{
  orderIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  warehouseId: Scalars['ID'];
  shipmentPresetId: Scalars['ID'];
  title: Scalars['String'];
  overrideMultiple: Scalars['Boolean'];
}>;

export type CreateBatchFromImportMutation = {
  readonly createBatchFromImport: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly status: BatchStatusTag;
    readonly title: string;
    readonly runningProcess: {
      readonly __typename: 'BatchProcess';
      readonly status: string;
      readonly itemsInProgressCount: number;
      readonly itemsTotalCount: number;
      readonly processKey: string;
      readonly progressPercentage: number;
      readonly progressTitle: string;
      readonly secondsLeft: number;
    } | null;
  };
};

export type CreateBatchFromSingleShipmentMutationVariables = Exact<{
  warehouseId: Scalars['ID'];
  shipmentPresetId: Scalars['ID'];
  shipToAddress: RecipientAddressInput;
  rubberStamps: RubberStampsInput;
  validatedAddressId?: InputMaybe<Scalars['ID']>;
  skipCorrection: Scalars['Boolean'];
}>;

export type CreateBatchFromSingleShipmentMutation = {
  readonly createBatchFromSingleShipment: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly step: BatchStatus;
    readonly status: BatchStatusTag;
  };
};

export type CreateBatchFromUploadMutationVariables = Exact<{
  mapping: ReadonlyArray<ShipmentMappingInput> | ShipmentMappingInput;
  uploadId: Scalars['ID'];
}>;

export type CreateBatchFromUploadMutation = {
  readonly createBatchFromUpload: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly upload: {
      readonly __typename: 'ShipmentUpload';
      readonly id: string;
      readonly mapping: ReadonlyArray<{
        readonly __typename: 'ShipmentMapping';
        readonly valueOrMappingKey: string;
        readonly shipmentKey: ShipmentKey;
        readonly userFriendlyShipmentKey: string;
      } | null>;
    } | null;
  };
};

export type CreateScopedShipmentPresetMutationVariables = Exact<{
  originalPresetId: Scalars['ID'];
  shipmentPreset: ShipmentPresetInput;
}>;

export type CreateScopedShipmentPresetMutation = {
  readonly createScopedShipmentPreset: {
    readonly __typename: 'ShipmentPreset';
    readonly id: string;
  };
};

export type DeleteShipmentPresetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteShipmentPresetMutation = {
  readonly deleteShipmentPreset: { readonly __typename: 'ShipmentPreset'; readonly id: string };
};

export type UpdateShipmentPresetsAfterDeleteQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateShipmentPresetsAfterDeleteQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultShipmentPresetId: string;
    };
  };
};

export type DeleteSuggestedAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
}>;

export type DeleteSuggestedAddressMutation = { readonly deleteSuggestedAddress: boolean };

export type DeleteWarehouseMutationVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;

export type DeleteWarehouseMutation = {
  readonly deleteWarehouse: { readonly __typename: 'Warehouse'; readonly id: string };
};

export type UpdateWarehousesAfterDeleteQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateWarehousesAfterDeleteQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type HideHistoricShipmentAddressesMutationVariables = Exact<{
  ids: Scalars['ID'];
}>;

export type HideHistoricShipmentAddressesMutation = {
  readonly hideHistoricShipmentAddresses: undefined | null;
};

export type HistoricShipmentAddressesQueryVariables = Exact<{
  searchField: HistoricShipmentAddressSearchField;
  input: Scalars['String'];
}>;

export type HistoricShipmentAddressesQuery = {
  readonly historicShipmentAddresses: ReadonlyArray<{
    readonly __typename: 'HistoricShipmentAddress';
    readonly ids: string;
    readonly email: string;
    readonly phone: string;
    readonly fullName: string;
    readonly company: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly postcode: string;
    readonly zip4: string;
    readonly countryCode: string;
    readonly regionCode: string;
  }>;
};

export type ImportFormQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;

export type ImportFormQuery = {
  readonly insuranceUnsupportedCountries: ReadonlyArray<string>;
  readonly orderSummary: {
    readonly __typename: 'OrderSummary';
    readonly count: number;
    readonly domesticCount: number;
    readonly internationalCount: number;
    readonly maxWeight: number;
    readonly maxValue: number;
    readonly customsFormRequired: boolean;
    readonly customsFormRequiredCount: number;
    readonly overrideable: boolean;
    readonly exporterTaxId: string;
    readonly suggestedBatchTitle: string;
    readonly uniquePlatformKeys: ReadonlyArray<string>;
    readonly uniqueWeights: ReadonlyArray<number>;
    readonly uniqueValues: ReadonlyArray<number>;
    readonly minWeightFormatted: string;
    readonly maxWeightFormatted: string;
    readonly minValue: number;
    readonly minValueFormatted: string;
    readonly maxValueFormatted: string;
    readonly uniqueOrderItemTexts: ReadonlyArray<string>;
    readonly suggestedShipmentPreset: {
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    } | null;
    readonly uniqueCustomsItems: ReadonlyArray<{
      readonly __typename: 'OrderSummaryCustomsItem';
      readonly qty: number;
      readonly description: string;
      readonly origin: string;
      readonly harmonization: string;
      readonly value: number;
      readonly weight: number;
    }>;
    readonly notOverrideableReasons: ReadonlyArray<{
      readonly __typename: 'NotOverrideableReason';
      readonly orderId: string;
      readonly reasons: ReadonlyArray<string>;
      readonly order: {
        readonly __typename: 'DockOrder';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly platformKey: string;
        readonly foreignOrderId: string;
        readonly platform: {
          readonly __typename: 'Platform';
          readonly title: string;
          readonly platformKey: string;
        } | null;
        readonly platformLinks: ReadonlyArray<{
          readonly __typename: 'PlatformLink';
          readonly platform: string;
          readonly type: string;
          readonly identifier: string;
          readonly url: string | null;
        }>;
      };
    }>;
    readonly order: {
      readonly __typename: 'DockOrder';
      readonly id: string;
      readonly fullName: string;
      readonly company: string;
      readonly address1: string;
      readonly address2: string;
      readonly address3: string;
      readonly city: string;
      readonly postcode: string;
      readonly regionId: string;
      readonly countryId: string;
      readonly email: string;
      readonly phone: string;
      readonly weight: number;
      readonly orderValue: number;
      readonly coupon: string;
      readonly orderItemsText: string;
      readonly rubberStamp1: string;
      readonly rubberStamp2: string;
      readonly rubberStamp3: string;
      readonly platformKey: string;
      readonly foreignOrderId: string;
      readonly platform: {
        readonly __typename: 'Platform';
        readonly id: string;
        readonly title: string;
        readonly platformKey: string;
      } | null;
      readonly platformLinks: ReadonlyArray<{
        readonly __typename: 'PlatformLink';
        readonly platform: string;
        readonly type: string;
        readonly identifier: string;
        readonly url: string | null;
      }>;
      readonly orderLink: {
        readonly __typename: 'Link';
        readonly url: string;
        readonly text: string;
      } | null;
      readonly subscriptionLink: {
        readonly __typename: 'Link';
        readonly url: string;
        readonly text: string;
      } | null;
      readonly shipmentLink: {
        readonly __typename: 'Link';
        readonly url: string;
        readonly text: string;
      } | null;
    } | null;
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly shipmentLabelSize: string;
      readonly defaultWarehouseId: string;
      readonly defaultShipmentPresetId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
  };
  readonly shipmentBoundaries: {
    readonly __typename: 'ShipmentBoundaries';
    readonly maxWeight: number;
    readonly maxCombinedLength: number;
    readonly maxLengthPlusGirth: number;
    readonly minLongSide: number;
    readonly maxLongSide: number;
    readonly minMiddleSide: number;
    readonly maxMiddleSide: number;
    readonly minShortSide: number;
    readonly maxShortSide: number;
  };
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly description: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
};

export type MappableShipmentFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type MappableShipmentFieldsQuery = {
  readonly mappableShipmentFields: ReadonlyArray<{
    readonly __typename: 'MappableShipmentField';
    readonly key: ShipmentKey;
    readonly maxMappings: number | null;
    readonly required: number | null;
    readonly title: string;
  }>;
};

export type ParsedAddressQueryVariables = Exact<{
  address: Scalars['String'];
}>;

export type ParsedAddressQuery = {
  readonly parsedAddress: {
    readonly __typename: 'RecipientAddress';
    readonly email: string | null;
    readonly fullName: string;
    readonly company: string;
    readonly address1: string;
    readonly address2: string;
    readonly city: string;
    readonly regionCode: string;
    readonly postcode: string;
    readonly zip4: string;
    readonly countryCode: string;
  };
};

export type SetDefaultWarehouseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SetDefaultWarehouseMutation = {
  readonly setDefaultWarehouse: { readonly __typename: 'Warehouse'; readonly id: string };
};

export type UpdateSettingsAfterDefaultWarehouseQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSettingsAfterDefaultWarehouseQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultWarehouseId: string;
    };
  };
};

export type ShipmentPresetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ShipmentPresetQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultShipmentPresetId: string;
    };
  };
};

export type SingleShipmentFormQueryVariables = Exact<{ [key: string]: never }>;

export type SingleShipmentFormQuery = {
  readonly recipientTaxIdRequiringCountries: ReadonlyArray<string>;
  readonly insuranceUnsupportedCountries: ReadonlyArray<string>;
  readonly addressAutocompleteSettings: {
    readonly __typename: 'AddressAutocompleteSettings';
    readonly provider: AddressAutocompleteProvider;
    readonly apiKey: string;
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly activeCarriers: ReadonlyArray<CarrierKey>;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly shipmentLabelSize: string;
      readonly defaultWarehouseId: string;
      readonly defaultShipmentPresetId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
    readonly shipmentPresets: ReadonlyArray<{
      readonly __typename: 'ShipmentPreset';
      readonly id: string;
      readonly originalId: string | null;
      readonly title: string;
      readonly packageTypeId: string;
      readonly packageTypeKey: string;
      readonly dimensionX: number;
      readonly dimensionY: number;
      readonly dimensionZ: number;
      readonly weight: number;
      readonly deliveryConfirmation: DeliveryConfirmation;
      readonly deliveryConfirmationFlag: boolean;
      readonly irregularPackage: boolean;
      readonly insuredValue: number;
      readonly insuredValueFlag: boolean;
      readonly returnLabel: ReturnLabel;
      readonly returnLabelFlag: boolean;
      readonly customsFormEnabled: boolean;
      readonly customsSigner: string;
      readonly customsContentType: string;
      readonly exporterTaxId: string;
      readonly recipientTaxId: string;
      readonly qualifiesAsMediaMail: boolean;
      readonly hazardousMaterialsEnabled: boolean;
      readonly customsItems: ReadonlyArray<{
        readonly __typename: 'CustomsItem';
        readonly id: string;
        readonly title: string;
        readonly hsTariffNumber: string;
        readonly quantity: number;
        readonly itemValue: number;
        readonly weight: number;
        readonly countryCodeOfOrigin: string;
      }>;
    }>;
  };
  readonly shipmentBoundaries: {
    readonly __typename: 'ShipmentBoundaries';
    readonly maxWeight: number;
    readonly maxCombinedLength: number;
    readonly maxLengthPlusGirth: number;
    readonly minLongSide: number;
    readonly maxLongSide: number;
    readonly minMiddleSide: number;
    readonly maxMiddleSide: number;
    readonly minShortSide: number;
    readonly maxShortSide: number;
  };
  readonly carriers: ReadonlyArray<{
    readonly __typename: 'Carrier';
    readonly id: string;
    readonly carrierKey: CarrierKey;
    readonly packageTypes: ReadonlyArray<{
      readonly __typename: 'CarrierPackageType';
      readonly id: string;
      readonly packageTypeKey: string;
      readonly title: string;
      readonly description: string;
      readonly heightRequired: boolean;
      readonly weightRequired: boolean;
      readonly dimensionsRequired: boolean;
    }>;
  }>;
  readonly usRegions: ReadonlyArray<{
    readonly __typename: 'Region';
    readonly id: string;
    readonly regionCode: string;
    readonly countryCode: string;
    readonly name: string;
  }>;
  readonly countries: ReadonlyArray<{
    readonly __typename: 'Country';
    readonly id: string;
    readonly name: string;
    readonly postcodeRequired: boolean;
    readonly countryCode: string;
    readonly countryCode3: string;
    readonly parentCountry: { readonly __typename: 'Country'; readonly id: string } | null;
  }>;
};

export type SuggestedMappingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SuggestedMappingQuery = {
  readonly shipmentUpload: {
    readonly __typename: 'ShipmentUpload';
    readonly suggestedMapping: ReadonlyArray<{
      readonly __typename: 'ShipmentMapping';
      readonly shipmentKey: ShipmentKey;
      readonly firstValue: string;
      readonly userFriendlyShipmentKey: string;
      readonly valueOrMappingKey: string;
    }>;
  };
};

export type UpdateWarehouseMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  useOriginAsReturnAddress: Scalars['Boolean'];
  originAddress: AddressInput;
  returnAddress?: InputMaybe<AddressInput>;
}>;

export type UpdateWarehouseMutation = {
  readonly updateWarehouse: {
    readonly __typename: 'Warehouse';
    readonly originalId: string | null;
    readonly id: string;
    readonly title: string | null;
    readonly useOriginAsReturnAddress: boolean;
    readonly shy: boolean;
    readonly originAddress: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly phone: string;
      readonly fullName: string;
      readonly company: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly regionCode: string;
      readonly postcode: string;
      readonly zip4: string;
      readonly countryCode: string;
    };
    readonly returnAddress: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly fullName: string;
      readonly company: string;
      readonly address1: string;
      readonly address2: string;
      readonly city: string;
      readonly regionCode: string;
      readonly postcode: string;
      readonly zip4: string;
      readonly countryCode: string;
    };
  };
};

export type UpdateWarehousesAfterUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateWarehousesAfterUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type WarehouseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type WarehouseQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultWarehouseId: string;
    };
    readonly warehouses: ReadonlyArray<{
      readonly __typename: 'Warehouse';
      readonly id: string;
      readonly title: string | null;
      readonly useOriginAsReturnAddress: boolean;
      readonly shy: boolean;
      readonly originAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly phone: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
      readonly returnAddress: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly fullName: string;
        readonly company: string;
        readonly address1: string;
        readonly address2: string;
        readonly city: string;
        readonly regionCode: string;
        readonly postcode: string;
        readonly zip4: string;
        readonly countryCode: string;
      };
    }>;
  };
};

export type IsEuQueryVariables = Exact<{ [key: string]: never }>;

export type IsEuQuery = { readonly isEu: boolean };

export type CancelEmailNotificationMutationVariables = Exact<{
  batchId: Scalars['ID'];
}>;

export type CancelEmailNotificationMutation = {
  readonly cancelEmailNotification: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly notifyRecipientsDate: string | null;
    readonly emailNotificationTemplate: {
      readonly __typename: 'MailTemplate';
      readonly id: string;
    } | null;
  };
};

export type CreateMailTemplateMutationVariables = Exact<{
  title: Scalars['String'];
  asDefault: Scalars['Boolean'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
  templateHtml: Scalars['String'];
  bccEmail?: InputMaybe<Scalars['String']>;
}>;

export type CreateMailTemplateMutation = {
  readonly createMailTemplate: {
    readonly __typename: 'MailTemplate';
    readonly id: string;
    readonly name: string;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly asDefault: boolean;
    readonly bccEmail: string;
    readonly subject: string;
    readonly templateHtml: string;
  };
};

export type UpdateMailTemplatesAfterCreateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateMailTemplatesAfterCreateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultEmailTemplateId: string;
    };
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
      readonly bccEmail: string;
      readonly subject: string;
      readonly templateHtml: string;
    }>;
  };
};

export type CreateSenderEmailMetadataMutationVariables = Exact<{
  emailAddress: Scalars['ID'];
  senderName: Scalars['String'];
}>;

export type CreateSenderEmailMetadataMutation = {
  readonly createSenderEmailMetadata: {
    readonly __typename: 'SenderEmailMetadata';
    readonly verificationStatus: EmailVerificationStatus | null;
    readonly errorMessage: string | null;
    readonly dkimHost: string;
    readonly dkimTextValue: string;
    readonly dkimVerified: boolean;
    readonly returnPathDomain: string;
    readonly returnPathDomainCnameValue: string;
    readonly returnPathDomainVerified: boolean;
  } | null;
};

export type DefaultTrackingEmailDelayQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultTrackingEmailDelayQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultTrackingEmailsDelay: string;
    };
  };
};

export type DeleteMailTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteMailTemplateMutation = {
  readonly deleteMailTemplate: { readonly __typename: 'MailTemplate'; readonly id: string };
};

export type UpdateMailTemplatesAfterDeleteQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateMailTemplatesAfterDeleteQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
      readonly bccEmail: string;
      readonly subject: string;
      readonly templateHtml: string;
    }>;
  };
};

export type FetchSenderEmailMetadataMutationVariables = Exact<{
  emailAddress: Scalars['ID'];
}>;

export type FetchSenderEmailMetadataMutation = {
  readonly fetchSenderEmailMetadata: {
    readonly __typename: 'SenderEmailMetadata';
    readonly verificationStatus: EmailVerificationStatus | null;
    readonly errorMessage: string | null;
    readonly dkimHost: string;
    readonly dkimTextValue: string;
    readonly dkimVerified: boolean;
    readonly returnPathDomain: string;
    readonly returnPathDomainCnameValue: string;
    readonly returnPathDomainVerified: boolean;
  };
};

export type MailTemplateFragment = {
  readonly __typename: 'MailTemplate';
  readonly id: string;
  readonly name: string;
  readonly senderEmail: string;
  readonly senderName: string;
  readonly asDefault: boolean;
  readonly bccEmail: string;
  readonly subject: string;
  readonly templateHtml: string;
};

export type MailTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MailTemplateQuery = {
  readonly globalSettings: {
    readonly __typename: 'GlobalSettings';
    readonly emailTemplate: {
      readonly __typename: 'EmailTemplate';
      readonly subject: string;
      readonly plainText: string;
      readonly html: string;
    };
  };
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly title: string;
    readonly email: string;
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
      readonly bccEmail: string;
      readonly subject: string;
      readonly templateHtml: string;
    }>;
  };
};

export type MailTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type MailTemplatesQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultTrackingEmailsDelay: string;
      readonly defaultEmailTemplateId: string;
    };
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
      readonly bccEmail: string;
      readonly subject: string;
      readonly templateHtml: string;
    }>;
  };
};

export type SendPreviewEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type SendPreviewEmailMutation = { readonly sendEmail: string };

export type SenderEmailMetadataFragment = {
  readonly __typename: 'SenderEmailMetadata';
  readonly verificationStatus: EmailVerificationStatus | null;
  readonly errorMessage: string | null;
  readonly dkimHost: string;
  readonly dkimTextValue: string;
  readonly dkimVerified: boolean;
  readonly returnPathDomain: string;
  readonly returnPathDomainCnameValue: string;
  readonly returnPathDomainVerified: boolean;
};

export type SenderEmailMetadataQueryVariables = Exact<{
  emailAddress: Scalars['ID'];
}>;

export type SenderEmailMetadataQuery = {
  readonly senderEmailMetadata: {
    readonly __typename: 'SenderEmailMetadata';
    readonly verificationStatus: EmailVerificationStatus | null;
    readonly errorMessage: string | null;
    readonly domain: string;
    readonly dkimHost: string;
    readonly dkimTextValue: string;
    readonly dkimVerified: boolean;
    readonly returnPathDomain: string;
    readonly returnPathDomainCnameValue: string;
    readonly returnPathDomainVerified: boolean;
  } | null;
};

export type TrackingEmailsPageSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type TrackingEmailsPageSettingsQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly trackingEmailBrandingEnabled: boolean;
      readonly defaultTrackingEmailsEnabled: boolean;
    };
  };
};

export type UpdateDefaultTrackingEmailsDelayMutationVariables = Exact<{
  inAdvance: Scalars['String'];
}>;

export type UpdateDefaultTrackingEmailsDelayMutation = {
  readonly updateDefaultTrackingEmailsDelay: string;
};

export type UpdateDefaultTrackingEmailsEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;

export type UpdateDefaultTrackingEmailsEnabledMutation = {
  readonly updateDefaultTrackingEmailsEnabled: boolean;
};

export type UpdateDefaultTrackingEmailsEnabledUpdateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateDefaultTrackingEmailsEnabledUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultTrackingEmailsEnabled: boolean;
    };
  };
};

export type UpdateEmailNotificationMutationVariables = Exact<{
  batchId: Scalars['ID'];
  mailTemplateId: Scalars['ID'];
  scheduledDateTime: Scalars['String'];
}>;

export type UpdateEmailNotificationMutation = {
  readonly updateEmailNotification: {
    readonly __typename: 'Batch';
    readonly id: string;
    readonly notifyRecipientsDate: string | null;
    readonly emailNotificationTemplate: {
      readonly __typename: 'MailTemplate';
      readonly id: string;
    } | null;
  };
};

export type UpdateMailTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  asDefault: Scalars['Boolean'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
  templateHtml: Scalars['String'];
  bccEmail?: InputMaybe<Scalars['String']>;
  sendTemplatePreview: Scalars['Boolean'];
}>;

export type UpdateMailTemplateMutation = {
  readonly updateMailTemplate: {
    readonly __typename: 'MailTemplate';
    readonly id: string;
    readonly name: string;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly asDefault: boolean;
    readonly bccEmail: string;
    readonly subject: string;
    readonly templateHtml: string;
  };
};

export type UpdateSettingsAfterUpdateMailTemplateQueryVariables = Exact<{ [key: string]: never }>;

export type UpdateSettingsAfterUpdateMailTemplateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly defaultEmailTemplateId: string;
    };
    readonly mailTemplates: ReadonlyArray<{
      readonly __typename: 'MailTemplate';
      readonly id: string;
      readonly name: string;
      readonly senderEmail: string;
      readonly senderName: string;
      readonly asDefault: boolean;
      readonly bccEmail: string;
      readonly subject: string;
      readonly templateHtml: string;
    }>;
  };
};

export type UpdateSenderEmailMetadataMutationVariables = Exact<{
  emailAddress: Scalars['ID'];
  senderName: Scalars['String'];
}>;

export type UpdateSenderEmailMetadataMutation = {
  readonly updateSenderEmailMetadata: {
    readonly __typename: 'SenderEmailMetadata';
    readonly verificationStatus: EmailVerificationStatus | null;
    readonly errorMessage: string | null;
    readonly dkimHost: string;
    readonly dkimTextValue: string;
    readonly dkimVerified: boolean;
    readonly returnPathDomain: string;
    readonly returnPathDomainCnameValue: string;
    readonly returnPathDomainVerified: boolean;
  };
};

export type UpdateTrackingEmailBrandingEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;

export type UpdateTrackingEmailBrandingEnabledMutation = {
  readonly updateTrackingEmailBrandingEnabled: boolean;
};

export type UpdateTrackingEmailBrandingEnabledUpdateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateTrackingEmailBrandingEnabledUpdateQuery = {
  readonly company: {
    readonly __typename: 'Company';
    readonly id: string;
    readonly settings: {
      readonly __typename: 'CompanySettings';
      readonly trackingEmailBrandingEnabled: boolean;
    };
  };
};

export type BuyRedirectPackageToNewAddressMutationVariables = Exact<{
  trackingId: Scalars['String'];
}>;

export type BuyRedirectPackageToNewAddressMutation = {
  readonly buyRedirectPackageToNewAddress: boolean;
};

export type BuyReturnPackageToSenderMutationVariables = Exact<{
  trackingId: Scalars['String'];
}>;

export type BuyReturnPackageToSenderMutation = { readonly buyReturnPackageToSender: boolean };

export type InterceptPriceQueryVariables = Exact<{
  trackingId: Scalars['String'];
  type: Scalars['String'];
}>;

export type InterceptPriceQuery = {
  readonly interceptPrice: {
    readonly __typename: 'InterceptPriceType';
    readonly totalCharge: number;
    readonly chargeCurrency: string;
    readonly interceptCharge: number;
  };
};

export type RedirectOptionsQueryVariables = Exact<{
  trackingId: Scalars['String'];
}>;

export type RedirectOptionsQuery = {
  readonly redirectOptions: {
    readonly __typename: 'InterceptOptionsType';
    readonly canReturnToSender: boolean;
    readonly canRedirectToNewAddress: boolean;
  };
};

export type SendUserEmailVerificationLinkMutationVariables = Exact<{ [key: string]: never }>;

export type SendUserEmailVerificationLinkMutation = {
  readonly sendUserEmailVerificationLink: boolean;
};

export type CompanyUserFragment = {
  readonly __typename: 'CompanyUser';
  readonly id: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly status: Status;
};

export type CreateUserMutationVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;

export type CreateUserMutation = {
  readonly createUser: {
    readonly __typename: 'CompanyUser';
    readonly id: string;
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly status: Status;
  };
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type DeleteUserMutation = {
  readonly deleteUser: { readonly __typename: 'CompanyUser'; readonly id: string };
};

export type ResendUserInvitationMutationVariables = Exact<{
  password: Scalars['String'];
  userId: Scalars['String'];
}>;

export type ResendUserInvitationMutation = {
  readonly resendUserInvitation: {
    readonly __typename: 'CompanyUser';
    readonly id: string;
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly status: Status;
  };
};

export type UsersQueryVariables = Exact<{ [key: string]: never }>;

export type UsersQuery = {
  readonly users: ReadonlyArray<{
    readonly __typename: 'CompanyUser';
    readonly id: string;
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly status: Status;
  }>;
};

export const RateSummaryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firstMailClass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packageType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageBasePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'best' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cheapest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crossedTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fastest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodStartDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'savings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surcharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'surchargeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedPrice' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxWeightOz' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueLimit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateSummaryFragment, unknown>;
export const RateGroupsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateGroupsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maximumShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultShipDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupKey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'string' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'traits' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'affectedByUpsRateLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RateSummaryFragment' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableShipDates' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upsellRateSummary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'carrier' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstMailClass' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firstMailClass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packageType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageBasePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'best' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cheapest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crossedTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fastest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodStartDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'savings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surcharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'surchargeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedPrice' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxWeightOz' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueLimit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateGroupsFragment, unknown>;
export const CountryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountryFragment, unknown>;
export const BasicUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BasicUserFragment, unknown>;
export const BasicPlatformFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BasicPlatformFragment, unknown>;
export const CurrentUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CurrentUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicUserFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debuggingEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyPlaidPaymentSource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emulating' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activePlatforms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserFragment, unknown>;
export const DataGridSettingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataGridSettingsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sorting' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataGridSettingsFragment, unknown>;
export const DataGridResultUserSettingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataGridResultUserSettingsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataGridSettingsFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataGridSettingsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sorting' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataGridResultUserSettingsFragment, unknown>;
export const MerchantAccountFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantAccountFragment, unknown>;
export const PackageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PackageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PackageFragment, unknown>;
export const RegionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegionFragment, unknown>;
export const RunningProcessFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RunningProcessFragment, unknown>;
export const ShipmentPresetFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentPresetFragment, unknown>;
export const ShipmentStatusSummaryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentStatusSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundPendingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inTransitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToShipCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToPrintCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mobileCodeShowableCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentStatusSummaryFragment, unknown>;
export const AddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressFragment, unknown>;
export const WarehouseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WarehouseFragment, unknown>;
export const ChannelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelFragment, unknown>;
export const MappingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MappingFragment, unknown>;
export const BigcartelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcartelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcartelChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcartelChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BigcartelFragment, unknown>;
export const BigcommerceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BigcommerceFragment, unknown>;
export const CratejoyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CratejoyFragment, unknown>;
export const DiscogsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscogsFragment, unknown>;
export const EbayFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EbayFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EbayChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EbayChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EbayFragment, unknown>;
export const EcwidFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EcwidFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EcwidChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EcwidChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPaymentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcwidFragment, unknown>;
export const EtsyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EtsyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EtsyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EtsyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EtsyFragment, unknown>;
export const FakeshopFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FakeshopFragment, unknown>;
export const PaypalFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaypalFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaypalChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PaypalChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'genericLineItemEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaypalFragment, unknown>;
export const ShopifyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopifyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopifyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'override' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopifyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importOrdersNewerThan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulfillmentLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopifyFragment, unknown>;
export const SquareFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquareFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importCustomAttributes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SquareFragment, unknown>;
export const SquarespaceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SquarespaceFragment, unknown>;
export const SubblyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubblyFragment, unknown>;
export const WixFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WixFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WixFragment, unknown>;
export const WoocommerceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WoocommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WoocommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WoocommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WoocommerceFragment, unknown>;
export const PaymentApiMethodFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentApiMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentApiMethodFragment, unknown>;
export const PaymentSourceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentSourceFragment, unknown>;
export const PickupFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PickupFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseReadyTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseCloseTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageWeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'warehouse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PickupFragment, unknown>;
export const MailTemplateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplateFragment, unknown>;
export const SenderEmailMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SenderEmailMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SenderEmailMetadataFragment, unknown>;
export const CompanyUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyUserFragment, unknown>;
export const ConfirmTwoFactorAuthenticationProviderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmTwoFactorAuthenticationProviderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Provider' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmTwoFactorAuthenticationProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmTwoFactorAuthenticationProviderMutation,
  ConfirmTwoFactorAuthenticationProviderMutationVariables
>;
export const DeleteTwoFactorAuthenticationProviderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTwoFactorAuthenticationProviderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Provider' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTwoFactorAuthenticationProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTwoFactorAuthenticationProviderMutation,
  DeleteTwoFactorAuthenticationProviderMutationVariables
>;
export const InstallTwoFactorAuthenticationProviderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InstallTwoFactorAuthenticationProviderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Provider' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'installTwoFactorAuthenticationProvider' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'secret' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'qrCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'secret' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicUserFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InstallTwoFactorAuthenticationProviderMutation,
  InstallTwoFactorAuthenticationProviderMutationVariables
>;
export const ProvideOtpMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ProvideOtpMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'provideCode' } }],
      },
    },
  ],
} as unknown as DocumentNode<ProvideOtpMutation, ProvideOtpMutationVariables>;
export const TwoFactorAuthenticationConfigurationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TwoFactorAuthenticationConfigurationQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activeProvider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMultipleConfirmedProviders' } },
                { kind: 'Field', name: { kind: 'Name', value: 'staySignedIn' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TwoFactorAuthenticationConfigurationQuery,
  TwoFactorAuthenticationConfigurationQueryVariables
>;
export const SendResetPasswordLinkMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendResetPasswordLinkMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendResetPasswordLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendResetPasswordLinkMutation, SendResetPasswordLinkMutationVariables>;
export const UpdateAccountEmailMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccountEmailMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'otp' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'otp' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'otp' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAccountEmailMutation, UpdateAccountEmailMutationVariables>;
export const UpdateAccountProfileMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccountProfileMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAccountProfileMutation, UpdateAccountProfileMutationVariables>;
export const UpdateNotificationsSettingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNotificationsSettingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'carrierAdjustmentsNotificationEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'paymentReceiptsNotificationEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'paymentFailuresNotificationEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newLoginNotificationEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'carrierAdjustmentDisputesEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newFeaturesAnnouncementsNotificationEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotificationsSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'carrierAdjustmentsNotificationEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'carrierAdjustmentsNotificationEnabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentReceiptsNotificationEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'paymentReceiptsNotificationEnabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentFailuresNotificationEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'paymentFailuresNotificationEnabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newLoginNotificationEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'newLoginNotificationEnabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'carrierAdjustmentDisputesEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'carrierAdjustmentDisputesEnabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newFeaturesAnnouncementsNotificationEnabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'newFeaturesAnnouncementsNotificationEnabled' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carrierAdjustmentsNotificationEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentReceiptsNotificationEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentFailuresNotificationEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'newLoginNotificationEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carrierAdjustmentDisputesEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'newFeaturesAnnouncementsNotificationEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNotificationsSettingsMutation,
  UpdateNotificationsSettingsMutationVariables
>;
export const AccountSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timezones' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ianaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationsSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carrierAdjustmentsNotificationEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentReceiptsNotificationEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentFailuresNotificationEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'newLoginNotificationEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carrierAdjustmentDisputesEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'newFeaturesAnnouncementsNotificationEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountSettingsQuery, AccountSettingsQueryVariables>;
export const DisputeAdjustmentsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisputeAdjustmentsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'disputeReason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputeAdjustments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'disputeReason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'disputeReason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disputedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disputeStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisputeAdjustmentsMutation, DisputeAdjustmentsMutationVariables>;
export const EmulateViaShipmentMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmulateViaShipmentMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emulateViaShipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmulateViaShipmentMutation, EmulateViaShipmentMutationVariables>;
export const UpdateBlockedCountriesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBlockedCountriesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarrierKey' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'blockedCountries' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockedCountryInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlockedCountries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'carrierKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'blockedCountries' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'blockedCountries' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'twoCharIsoCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBlockedCountriesMutation,
  UpdateBlockedCountriesMutationVariables
>;
export const CaptainsNotesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CaptainsNotesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'captainsNotes' } }],
      },
    },
  ],
} as unknown as DocumentNode<CaptainsNotesQuery, CaptainsNotesQueryVariables>;
export const BlockedCountriesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BlockedCountriesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarrierKey' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockedCountries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'carrierKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'twoCharIsoCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockReason' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockedCountriesQuery, BlockedCountriesQueryVariables>;
export const NavbarLinksQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NavbarLinksQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navbarLinks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navbarMetaLinks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'spyglassLink' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NavbarLinksQuery, NavbarLinksQueryVariables>;
export const SupportSearchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SupportSearchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'term' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'term' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'term' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SupportSearchQuery, SupportSearchQueryVariables>;
export const UserQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CurrentUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twoFactorAuthenticationProviders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CurrentUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicUserFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debuggingEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyPlaidPaymentSource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emulating' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activePlatforms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const BatchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stepText' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDatePossibleNow' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouse' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AddressFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returnAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'poBox' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AddressFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dockOrderIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dataSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelFileFormat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelingArtifactType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spreadsheetMapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueOrMappingKey' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eligibleForInsurance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeSummary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deliveryConfirmationSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packagePreset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmationFlag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmation' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qualifiesAsMediaMail' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hazardousMaterialsEnabled' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customsItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hsTariffNumber' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'countryCodeOfOrigin' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'customsFormRequired' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customsFormSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'numCustomsForms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'itemSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxIdSummary' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentStatusSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorCount' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailNotificationPossible' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'offset' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insuranceDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isShippingCostInsured' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'foreignOrderId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shipmentLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscriptionLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platform' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReturnLabel' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipientAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AddressFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp3' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customsItemsObjects' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RateGroupsFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateGroupSortOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelFileFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packingListTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressCorrection' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsDelay' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmailTemplateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultChargeAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyPlaidPaymentSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFirstLabel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'merchantAccounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MerchantAccountFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activePaymentMethods' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentApiMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firstMailClass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packageType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageBasePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'best' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cheapest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crossedTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fastest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodStartDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'savings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surcharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'surchargeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedPrice' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxWeightOz' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueLimit' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateGroupsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maximumShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultShipDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupKey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'string' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'traits' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'affectedByUpsRateLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RateSummaryFragment' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableShipDates' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upsellRateSummary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'carrier' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstMailClass' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentApiMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchQuery, BatchQueryVariables>;
export const BuyBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuyBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rateSelection' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'RateSelectionInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'totalCharge' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mailTemplateId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buyBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rateSelection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rateSelection' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'totalCharge' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'totalCharge' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mailTemplateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mailTemplateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notifyRecipientsDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuyBatchMutation, BuyBatchMutationVariables>;
export const ModifyInsuranceOnRatedBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ModifyInsuranceOnRatedBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'insuredValue' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modifyInsuranceOnRatedBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'insuredValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'insuredValue' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stepText' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RateGroupsFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RateSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firstMailClass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'packageType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageBasePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'best' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cheapest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crossedTotalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fastest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodStartDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'savings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surcharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'surchargeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedPrice' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxWeightOz' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueLimit' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RateGroupsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maximumShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultShipDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupKey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'string' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'traits' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'affectedByUpsRateLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RateSummaryFragment' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableShipDates' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upsellRateSummary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'carrier' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstMailClass' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'mailClassTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModifyInsuranceOnRatedBatchMutation,
  ModifyInsuranceOnRatedBatchMutationVariables
>;
export const RerateBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RerateBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rerateBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDatePossibleNow' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RerateBatchMutation, RerateBatchMutationVariables>;
export const SetBatchToNewMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBatchToNewMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBatchToNew' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetBatchToNewMutation, SetBatchToNewMutationVariables>;
export const UpdateRateGroupSortOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRateGroupSortOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrder' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RateGroupSortOrder' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRateGroupSortOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrder' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrder' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateGroupSortOrder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRateGroupSortOrderMutation,
  UpdateRateGroupSortOrderMutationVariables
>;
export const DummyDataGridInputTypeUsageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DummyDataGridInputTypeUsageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridFilterInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorting' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridSortingInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'searchTerm' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filters' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'sorting' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sorting' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'offset' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodes' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receiptsReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'searchTerm' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filters' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'sorting' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sorting' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'offset' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DummyDataGridInputTypeUsageQuery,
  DummyDataGridInputTypeUsageQueryVariables
>;
export const ConsumeGtmEventsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConsumeGtmEventsMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'consumeGtmEvents' } }],
      },
    },
  ],
} as unknown as DocumentNode<ConsumeGtmEventsMutation, ConsumeGtmEventsMutationVariables>;
export const ConsumeMessagesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConsumeMessagesMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumeMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsumeMessagesMutation, ConsumeMessagesMutationVariables>;
export const CreateMappingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMappingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp1' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp2' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp3' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'additionalMapping' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AdditionalMappingInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMappings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rubberStamp1' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp1' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rubberStamp2' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp2' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rubberStamp3' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamp3' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'additionalMapping' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'additionalMapping' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ChannelInterface' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMappingsMutation, CreateMappingsMutationVariables>;
export const CreateOrUpdateUpsMerchantAccountMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrUpdateUpsMerchantAccountMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrUpdateUpsMerchantAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MerchantAccountFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateUpsMerchantAccountMutation,
  CreateOrUpdateUpsMerchantAccountMutationVariables
>;
export const AddUpsToMerchantAccountsAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddUpsToMerchantAccountsAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'merchantAccounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MerchantAccountFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddUpsToMerchantAccountsAfterCreateQuery,
  AddUpsToMerchantAccountsAfterCreateQueryVariables
>;
export const CreateShipmentPresetMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateShipmentPresetMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'default' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPresetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createShipmentPreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'default' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'default' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentPreset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPreset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateShipmentPresetMutation, CreateShipmentPresetMutationVariables>;
export const UpdateShipmentPresetsAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateShipmentPresetsAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShipmentPresetsAfterCreateQuery,
  UpdateShipmentPresetsAfterCreateQueryVariables
>;
export const CreateUspsMerchantAccountMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUspsMerchantAccountMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUspsMerchantAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MerchantAccountFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateUspsMerchantAccountMutation,
  CreateUspsMerchantAccountMutationVariables
>;
export const AddUspsToMerchantAccountsAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddUspsToMerchantAccountsAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'merchantAccounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MerchantAccountFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MerchantAccountFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MerchantAccount' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsOutdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddUspsToMerchantAccountsAfterCreateQuery,
  AddUspsToMerchantAccountsAfterCreateQueryVariables
>;
export const CreateWarehouseMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWarehouseMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveAddressForReuse' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnAddress' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWarehouse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useOriginAsReturnAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'useOriginAsReturnAddress' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'returnAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'returnAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'saveAddressForReuse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveAddressForReuse' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WarehouseFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWarehouseMutation, CreateWarehouseMutationVariables>;
export const UpdateWarehousesAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateWarehousesAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWarehousesAfterCreateQuery,
  UpdateWarehousesAfterCreateQueryVariables
>;
export const DeleteBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBatchMutation, DeleteBatchMutationVariables>;
export const SendConfirmationMailMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendConfirmationMailMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendConfirmationMail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendConfirmationMailMutation, SendConfirmationMailMutationVariables>;
export const UpdateBatchTitleMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBatchTitleMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBatchTitle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBatchTitleMutation, UpdateBatchTitleMutationVariables>;
export const UpdateBillingAddressMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBillingAddressMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBillingAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>;
export const UpdateChargeAmountMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChargeAmountMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChargeAmount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChargeAmountMutation, UpdateChargeAmountMutationVariables>;
export const UpdateChargeAmountAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateChargeAmountAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultChargeAmount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateChargeAmountAfterCreateQuery,
  UpdateChargeAmountAfterCreateQueryVariables
>;
export const UpdateDataGridUserSettingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDataGridUserSettingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gridId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDataGridUserSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gridId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'gridId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'settings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataGridSettingsFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataGridSettingsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataGridSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'columnOrder' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sorting' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDataGridUserSettingsMutation,
  UpdateDataGridUserSettingsMutationVariables
>;
export const UpdatePreferredUpsMerchantAccountAddressMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePreferredUpsMerchantAccountAddressMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePreferredUpsMerchantAccountAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePreferredUpsMerchantAccountAddressMutation,
  UpdatePreferredUpsMerchantAccountAddressMutationVariables
>;
export const UpdateShipmentPresetMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateShipmentPresetMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'default' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPresetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShipmentPreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'default' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'default' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentPreset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPreset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateShipmentPresetMutation, UpdateShipmentPresetMutationVariables>;
export const UpdateShipmentPresetsAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateShipmentPresetsAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShipmentPresetsAfterUpdateQuery,
  UpdateShipmentPresetsAfterUpdateQueryVariables
>;
export const ApplicationConfigurationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationConfigurationQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'turnstilePublicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'turnstileEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'loginWithGoogleEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inAppIdentityVerificationEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomAppId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'datadogClientToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'datadogRumApplicationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'datadogBrowserLoggingEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'datadogBrowserMonitoringEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationConfigurationQuery, ApplicationConfigurationQueryVariables>;
export const ApplicationInformationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationInformationQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'applicationHostname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationEnvironment' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationInformationQuery, ApplicationInformationQueryVariables>;
export const AutoRefundedShipmentsSummaryQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutoRefundedShipmentsSummaryQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoRefundedShipmentsSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AutoRefundedShipmentsSummaryQuery,
  AutoRefundedShipmentsSummaryQueryVariables
>;
export const BatchIdFromShipmentQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchIdFromShipmentQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'batch' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchIdFromShipmentQuery, BatchIdFromShipmentQueryVariables>;
export const BatchProcessStatusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchProcessStatusQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundBatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchProcessStatusQuery, BatchProcessStatusQueryVariables>;
export const BatchShipmentIdsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchShipmentIdsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchShipmentIdsQuery, BatchShipmentIdsQueryVariables>;
export const BatchStepQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchStepQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchStepQuery, BatchStepQueryVariables>;
export const BillingAddressQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BillingAddressQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BillingAddressQuery, BillingAddressQueryVariables>;
export const ChargeAmountOptionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChargeAmountOptionsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'chargeAmountOptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultChargeAmount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChargeAmountOptionsQuery, ChargeAmountOptionsQueryVariables>;
export const CountriesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CountriesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountriesQuery, CountriesQueryVariables>;
export const FailedShipmentsExportQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FailedShipmentsExportQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failedShipmentsExportStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'exportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FailedShipmentsExportQuery, FailedShipmentsExportQueryVariables>;
export const PackageTypesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PackageTypesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PackageTypesQuery, PackageTypesQueryVariables>;
export const PreferredMerchantAccountAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreferredMerchantAccountAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarrierKey' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preferredMerchantAccountAddress' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'carrierKey' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'carrierKey' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PreferredMerchantAccountAddressQuery,
  PreferredMerchantAccountAddressQueryVariables
>;
export const RegionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegionFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegionsQuery, RegionsQueryVariables>;
export const ShipmentBoundariesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentBoundariesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentBoundaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCombinedLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLengthPlusGirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minShortSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxShortSide' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentBoundariesQuery, ShipmentBoundariesQueryVariables>;
export const ShipmentPresetsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentPresetsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentPresetsQuery, ShipmentPresetsQueryVariables>;
export const WarehousesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WarehousesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WarehousesQuery, WarehousesQueryVariables>;
export const BatchDetailsPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchDetailsPageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelFileFormat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelingArtifactType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRefund' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundBatch' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouse' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AddressFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returnAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AddressFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dataSource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spreadsheetMapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueOrMappingKey' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeSummary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deliveryConfirmationSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packagePreset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PackageFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customsFormSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'numCustomsForms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'itemSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxIdSummary' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentStatusSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cleanupComplete' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailNotificationTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailNotificationPossible' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailNotificationSent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'containedMailClassGroupKeys' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'priceSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averagePrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKeys' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'surcharge' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pirateShipService' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'samePriceForAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'usedReturnPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReturnLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'returnsUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRefunded' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp3' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platform' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'additionalTrackingEmailCopy' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPrint' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canShowMobileCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalRefundNotice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trackingDataGrid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rowActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuspended' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PackageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentStatusSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundPendingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inTransitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToShipCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToPrintCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mobileCodeShowableCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchDetailsPageQuery, BatchDetailsPageQueryVariables>;
export const DataGridExportStatusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataGridExportStatusQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trackingDataExportUrl' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'exportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expire' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataGridExportStatusQuery, DataGridExportStatusQueryVariables>;
export const FetchShipmentStageDotsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FetchShipmentStageDotsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchShipmentStageDots' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchShipmentStageDotsMutation,
  FetchShipmentStageDotsMutationVariables
>;
export const MapQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MapQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'width' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'height' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'map' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'width' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'height' } },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MapQuery, MapQueryVariables>;
export const ShipmentContextualDropdownMenuQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentContextualDropdownMenuQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'shipmentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRedacted' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adjustments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disputeStatus' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShipmentContextualDropdownMenuQuery,
  ShipmentContextualDropdownMenuQueryVariables
>;
export const ShipmentDetailsPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentDetailsPageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelFileFormat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelingArtifactType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customsFormRequired' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouse' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dataSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'containedMailClassGroupKeys' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spreadsheetMapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueOrMappingKey' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minInsured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeSummary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deliveryConfirmationSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packagePreset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmationFlag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmation' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qualifiesAsMediaMail' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hazardousMaterialsEnabled' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customsItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hsTariffNumber' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'countryCodeOfOrigin' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customsFormSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'numCustomsForms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'itemSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxIdSummary' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cleanupComplete' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailNotificationTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailNotificationPossible' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailNotificationSent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'shipmentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingNr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReturnLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'foreignOrderId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'foreignOrderId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shipmentLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscriptionLink' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platform' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'additionalTrackingEmailCopy' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionXOriginal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionYOriginal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionZOriginal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp3' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passthroughFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightOriginal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adjustments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionXOriginal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionYOriginal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionZOriginal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disputedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disputeStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disputeReason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'eligibilityIssueMessage' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDisputable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disputeProcessedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightOriginal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientPriceChange' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPrint' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canShowMobileCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipientAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deliveryEstimation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrivalLocalDateTime' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pickupLocalDateTime' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'baseClientPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'baseClientPriceOriginal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalClientPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalClientPriceOriginal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packageTypeOriginal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packageType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailClassOriginal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailClass' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zoneOriginal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surcharges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isIgnored' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientPrice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientPriceOriginal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOriginalSurcharge' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalRefundNotice' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insuranceDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'insuredValueRequested' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValueType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasOnlyCarrierLiabilityInsurance' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'insuranceSurcharge' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIgnored' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientPrice' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clientPriceOriginal' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isOriginalSurcharge' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'helpLink' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isShipmentRefundable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customsItems' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customsItemsObjects' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentDetailsPageQuery, ShipmentDetailsPageQueryVariables>;
export const GeneralSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralSettingsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'areMobileCodesEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelFileFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packingListTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showLogoOnLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressCorrection' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GeneralSettingsQuery, GeneralSettingsQueryVariables>;
export const UpdateGeneralSettingsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGeneralSettingsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areMobileCodesEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentLabelSize' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentLabelFileFormat' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'packingListTemplate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showLogoOnLabel' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addressCorrection' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGeneralSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areMobileCodesEnabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areMobileCodesEnabled' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentLabelSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentLabelSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'packingListTemplate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'packingListTemplate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showLogoOnLabel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showLogoOnLabel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentLabelFileFormat' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shipmentLabelFileFormat' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addressCorrection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addressCorrection' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGeneralSettingsMutation, UpdateGeneralSettingsMutationVariables>;
export const UpdateCompanySettingsAfterGeneralSettingsUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateCompanySettingsAfterGeneralSettingsUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'areMobileCodesEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packingListTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showLogoOnLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentSpreadsheetFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelFileFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressCorrection' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCompanySettingsAfterGeneralSettingsUpdateQuery,
  UpdateCompanySettingsAfterGeneralSettingsUpdateQueryVariables
>;
export const GenerateJumioWebClientUrlMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateJumioWebClientUrlMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnPath' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateJumioWebClientUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'returnPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'returnPath' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateJumioWebClientUrlMutation,
  GenerateJumioWebClientUrlMutationVariables
>;
export const MarkJumioFlowAsDismissedMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkJumioFlowAsDismissedMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markJumioFlowAsDismissed' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkJumioFlowAsDismissedMutation,
  MarkJumioFlowAsDismissedMutationVariables
>;
export const MarkJumioFlowAsFinishedMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkJumioFlowAsFinishedMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowExecutionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markJumioFlowAsFinished' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowExecutionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowExecutionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkJumioFlowAsFinishedMutation,
  MarkJumioFlowAsFinishedMutationVariables
>;
export const ReturnPathQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReturnPathQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'returnPath' } }],
      },
    },
  ],
} as unknown as DocumentNode<ReturnPathQuery, ReturnPathQueryVariables>;
export const VerificationRequiredQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerificationRequiredQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationRequired' } }],
      },
    },
  ],
} as unknown as DocumentNode<VerificationRequiredQuery, VerificationRequiredQueryVariables>;
export const VerificationStatusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerificationStatusQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } }],
      },
    },
  ],
} as unknown as DocumentNode<VerificationStatusQuery, VerificationStatusQueryVariables>;
export const ChannelAutoSyncMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChannelAutoSyncMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'channelAutoSync' } }],
      },
    },
  ],
} as unknown as DocumentNode<ChannelAutoSyncMutation, ChannelAutoSyncMutationVariables>;
export const IgnoreOrdersMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IgnoreOrdersMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ignoreOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IgnoreOrdersMutation, IgnoreOrdersMutationVariables>;
export const TriggerChannelSyncMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerChannelSyncMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'triggerChannelSync' } }],
      },
    },
  ],
} as unknown as DocumentNode<TriggerChannelSyncMutation, TriggerChannelSyncMutationVariables>;
export const UnignoreOrdersMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnignoreOrdersMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unignoreOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnignoreOrdersMutation, UnignoreOrdersMutationVariables>;
export const ChannelSyncStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChannelSyncStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channelSyncStatus' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'info' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autosyncRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasError' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRunning' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelSyncStatusQuery, ChannelSyncStatusQueryVariables>;
export const ImportedOrdersBaseQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportedOrdersBaseQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gridMode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GridMode' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importedOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gridMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'gridMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metaData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportedOrdersBaseQuery, ImportedOrdersBaseQueryVariables>;
export const ShipmentForOrderQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentForOrderQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentForOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'batch' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentForOrderQuery, ShipmentForOrderQueryVariables>;
export const DeleteChannelMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteChannelMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ChannelInterface' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const UpdateChannelsAfterDeleteQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateChannelsAfterDeleteQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ChannelInterface' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateChannelsAfterDeleteQuery,
  UpdateChannelsAfterDeleteQueryVariables
>;
export const DisableChannelMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisableChannelMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ChannelInterface' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisableChannelMutation, DisableChannelMutationVariables>;
export const EnableChannelMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnableChannelMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ChannelInterface' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnableChannelMutation, EnableChannelMutationVariables>;
export const ConnectWoocommerceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConnectWoocommerceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shopUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectWoocommerceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shopUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shopUrl' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConnectWoocommerceMutation, ConnectWoocommerceMutationVariables>;
export const CreateBigcommerceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBigcommerceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBigcommerceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'apiUrl' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'apiUrl' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BigcommerceFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBigcommerceMutation, CreateBigcommerceMutationVariables>;
export const CreateBigcommerceAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateBigcommerceAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BigcommerceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBigcommerceAfterUpdateQuery,
  CreateBigcommerceAfterUpdateQueryVariables
>;
export const CreateCratejoyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCratejoyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCratejoyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skipFutureSubscriptions' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skipFutureSubscriptions' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CratejoyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCratejoyMutation, CreateCratejoyMutationVariables>;
export const CreateCratejoyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateCratejoyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CratejoyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCratejoyAfterUpdateQuery,
  CreateCratejoyAfterUpdateQueryVariables
>;
export const CreateDiscogsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDiscogsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDiscogsChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscogsFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDiscogsMutation, CreateDiscogsMutationVariables>;
export const CreateDiscogsAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateDiscogsAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscogsFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDiscogsAfterUpdateQuery, CreateDiscogsAfterUpdateQueryVariables>;
export const CreateFakeshopMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFakeshopMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderGroups' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFakeshopChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderGroups' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderGroups' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FakeshopFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFakeshopMutation, CreateFakeshopMutationVariables>;
export const CreateFakeshopAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateFakeshopAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FakeshopFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFakeshopAfterUpdateQuery,
  CreateFakeshopAfterUpdateQueryVariables
>;
export const CreateSquarespaceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSquarespaceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSquarespaceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SquarespaceFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSquarespaceMutation, CreateSquarespaceMutationVariables>;
export const CreateSquarespaceAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateSquarespaceAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SquarespaceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSquarespaceAfterUpdateQuery,
  CreateSquarespaceAfterUpdateQueryVariables
>;
export const CreateSubblyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSubblyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubblyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubblyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubblyMutation, CreateSubblyMutationVariables>;
export const CreateSubblyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateSubblyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubblyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubblyAfterUpdateQuery, CreateSubblyAfterUpdateQueryVariables>;
export const UpdateBigcartelMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBigcartelMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBigcartelChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BigcartelFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcartelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcartelChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcartelChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBigcartelMutation, UpdateBigcartelMutationVariables>;
export const UpdateBigcartelAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateBigcartelAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BigcartelFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcartelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcartelChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcartelChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBigcartelAfterUpdateQuery,
  UpdateBigcartelAfterUpdateQueryVariables
>;
export const UpdateBigcommerceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBigcommerceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBigcommerceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'apiUrl' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'apiUrl' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BigcommerceFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBigcommerceMutation, UpdateBigcommerceMutationVariables>;
export const UpdateBigcommerceAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateBigcommerceAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BigcommerceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBigcommerceAfterUpdateQuery,
  UpdateBigcommerceAfterUpdateQueryVariables
>;
export const UpdateCratejoyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCratejoyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCratejoyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skipFutureSubscriptions' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skipFutureSubscriptions' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CratejoyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCratejoyMutation, UpdateCratejoyMutationVariables>;
export const UpdateCratejoyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateCratejoyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CratejoyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCratejoyAfterUpdateQuery,
  UpdateCratejoyAfterUpdateQueryVariables
>;
export const UpdateDiscogsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDiscogsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDiscogsChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscogsFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDiscogsMutation, UpdateDiscogsMutationVariables>;
export const UpdateDiscogsAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateDiscogsAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscogsFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDiscogsAfterUpdateQuery, UpdateDiscogsAfterUpdateQueryVariables>;
export const UpdateEbayMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEbayMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEbayChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EbayFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EbayFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EbayChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EbayChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEbayMutation, UpdateEbayMutationVariables>;
export const UpdateEbayAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateEbayAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EbayFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EbayFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EbayChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EbayChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEbayAfterUpdateQuery, UpdateEbayAfterUpdateQueryVariables>;
export const UpdateEcwidMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEcwidMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEcwidChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EcwidFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EcwidFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EcwidChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EcwidChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPaymentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEcwidMutation, UpdateEcwidMutationVariables>;
export const UpdateEcwidAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateEcwidAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EcwidFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EcwidFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EcwidChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EcwidChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPaymentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEcwidAfterUpdateQuery, UpdateEcwidAfterUpdateQueryVariables>;
export const UpdateEtsyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEtsyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEtsyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EtsyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EtsyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EtsyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EtsyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEtsyMutation, UpdateEtsyMutationVariables>;
export const UpdateEtsyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateEtsyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EtsyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EtsyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EtsyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EtsyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEtsyAfterUpdateQuery, UpdateEtsyAfterUpdateQueryVariables>;
export const UpdateFakeshopMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFakeshopMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderGroups' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFakeshopChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderGroups' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderGroups' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FakeshopFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFakeshopMutation, UpdateFakeshopMutationVariables>;
export const UpdateFakeshopAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateFakeshopAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FakeshopFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFakeshopAfterUpdateQuery,
  UpdateFakeshopAfterUpdateQueryVariables
>;
export const UpdatePaypalMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePaypalMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'genericLineItemEnabled' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaypalChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'genericLineItemEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'genericLineItemEnabled' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaypalFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaypalFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaypalChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PaypalChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'genericLineItemEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaypalMutation, UpdatePaypalMutationVariables>;
export const UpdatePayPalAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePayPalAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaypalFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaypalFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaypalChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PaypalChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'genericLineItemEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePayPalAfterUpdateQuery, UpdatePayPalAfterUpdateQueryVariables>;
export const UpdateShopifyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateShopifyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationsToImport' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'importOrdersNewerThan' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShopifyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'locationsToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'locationsToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'importOrdersNewerThan' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'importOrdersNewerThan' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShopifyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopifyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopifyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'override' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopifyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importOrdersNewerThan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulfillmentLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateShopifyMutation, UpdateShopifyMutationVariables>;
export const UpdateShopifyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateShopifyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShopifyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopifyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopifyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'override' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopifyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importOrdersNewerThan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulfillmentLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateShopifyAfterUpdateQuery, UpdateShopifyAfterUpdateQueryVariables>;
export const UpdateSquareMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSquareMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationsToImport' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'importCustomAttributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSquareChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'locationsToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'locationsToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'importCustomAttributes' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'importCustomAttributes' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SquareFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquareFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importCustomAttributes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSquareMutation, UpdateSquareMutationVariables>;
export const UpdateSquareAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSquareAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SquareFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquareFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importCustomAttributes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSquareAfterUpdateQuery, UpdateSquareAfterUpdateQueryVariables>;
export const UpdateSquarespaceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSquarespaceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSquarespaceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SquarespaceFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSquarespaceMutation, UpdateSquarespaceMutationVariables>;
export const UpdateSquarespaceAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSquarespaceAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SquarespaceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSquarespaceAfterUpdateQuery,
  UpdateSquarespaceAfterUpdateQueryVariables
>;
export const UpdateSubblyMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSubblyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubblyChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientSecret' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientSecret' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubblyFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubblyMutation, UpdateSubblyMutationVariables>;
export const UpdateSubblyAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSubblyAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubblyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubblyAfterUpdateQuery, UpdateSubblyAfterUpdateQueryVariables>;
export const UpdateWixMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWixMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWixChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WixFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WixFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWixMutation, UpdateWixMutationVariables>;
export const UpdateWixAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateWixAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WixFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WixFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWixAfterUpdateQuery, UpdateWixAfterUpdateQueryVariables>;
export const UpdateWoocommerceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWoocommerceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shopUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statusesToImport' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWoocommerceChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'channelId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shopUrl' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shopUrl' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'statusesToImport' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'statusesToImport' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'trackingEmailsEnabled' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'autoSyncEnabled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WoocommerceFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WoocommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WoocommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WoocommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWoocommerceMutation, UpdateWoocommerceMutationVariables>;
export const UpdateWoocommerceAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateWoocommerceAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WoocommerceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WoocommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WoocommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WoocommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWoocommerceAfterUpdateQuery,
  UpdateWoocommerceAfterUpdateQueryVariables
>;
export const ChannelsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChannelsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ChannelInterface' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ChannelFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'reconnectUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelsQuery, ChannelsQueryVariables>;
export const PlatformsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlatformsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platforms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'installUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reconnectSupported' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailSupported' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlatformsQuery, PlatformsQueryVariables>;
export const BigcartelQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BigcartelQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BigcartelFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcartelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcartelChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcartelChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BigcartelQuery, BigcartelQueryVariables>;
export const BigcommerceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BigcommerceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BigcommerceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BigcommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigcommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BigcommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BigcommerceQuery, BigcommerceQueryVariables>;
export const CratejoyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CratejoyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CratejoyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CratejoyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CratejoyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CratejoyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skipFutureSubscriptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CratejoyQuery, CratejoyQueryVariables>;
export const DiscogsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiscogsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DiscogsFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscogsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscogsChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DiscogsChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscogsQuery, DiscogsQueryVariables>;
export const EbayQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EbayQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EbayFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EbayFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EbayChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EbayChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EbayQuery, EbayQueryVariables>;
export const EcwidQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EcwidQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EcwidFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EcwidFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EcwidChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EcwidChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatusesToImport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPaymentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFulfillmentStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcwidQuery, EcwidQueryVariables>;
export const EtsyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EtsyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EtsyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EtsyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EtsyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EtsyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EtsyQuery, EtsyQueryVariables>;
export const FakeshopQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FakeshopQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FakeshopFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FakeshopFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FakeshopChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FakeshopChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FakeshopQuery, FakeshopQueryVariables>;
export const PaypalQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaypalQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaypalFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaypalFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaypalChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PaypalChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'genericLineItemEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaypalQuery, PaypalQueryVariables>;
export const ShopifyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShopifyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShopifyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopifyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopifyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BasicPlatformFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mappableFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rubberstampConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'override' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopifyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importLineItemsNotRequireShippingEnabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importOrdersNewerThan' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulfillmentLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopifyQuery, ShopifyQueryVariables>;
export const SquareQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SquareQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SquareFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquareFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquareChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationsToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importCustomAttributes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SquareQuery, SquareQueryVariables>;
export const SquarespaceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SquarespaceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SquarespaceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SquarespaceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SquarespaceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SquarespaceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SquarespaceQuery, SquarespaceQueryVariables>;
export const SubblyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubblyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubblyFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubblyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SubblyChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SubblyChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubblyQuery, SubblyQueryVariables>;
export const WixQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WixQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WixFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WixFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WixChannel' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WixQuery, WixQueryVariables>;
export const WoocommerceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WoocommerceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WoocommerceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicPlatformFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicPlatformFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'autoSyncEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MappingFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rubberstampConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rubberstamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredField' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WoocommerceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WoocommerceChannel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChannelInterface' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChannelFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MappingFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shopUrl' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WoocommerceChannel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statusesToImport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingEmailsEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WoocommerceQuery, WoocommerceQueryVariables>;
export const WoocommerceEgressIpsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WoocommerceEgressIpsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'woocommerceEgressIps' } }],
      },
    },
  ],
} as unknown as DocumentNode<WoocommerceEgressIpsQuery, WoocommerceEgressIpsQueryVariables>;
export const IntercomArticleQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IntercomArticleQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intercomArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IntercomArticleQuery, IntercomArticleQueryVariables>;
export const AcceptTermsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcceptTermsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accepted' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptTerms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accepted' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accepted' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const LatestTermsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestTermsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestTerms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'terms' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestTermsQuery, LatestTermsQueryVariables>;
export const AreMobileCodesEnabledQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AreMobileCodesEnabledQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'areMobileCodesEnabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreMobileCodesEnabledQuery, AreMobileCodesEnabledQueryVariables>;
export const BatchMobileCodeModalQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchMobileCodeModalQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'containedMailClassGroupKeys' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'downloadableOnly' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp3' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipientAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packageType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchMobileCodeModalQuery, BatchMobileCodeModalQueryVariables>;
export const DownloadMobileCodeForShipmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DownloadMobileCodeForShipment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'downloadMobileCodeForShipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mobileCodeDataUri' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadMobileCodeForShipmentMutation,
  DownloadMobileCodeForShipmentMutationVariables
>;
export const DownloadMobileCodesForBatchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DownloadMobileCodesForBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'downloadMobileCodesForBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mobileCodeDataUri' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadMobileCodesForBatchMutation,
  DownloadMobileCodesForBatchMutationVariables
>;
export const ShipmentAfterMobileCodeDownloadQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentAfterMobileCodeDownloadQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShipmentAfterMobileCodeDownloadQuery,
  ShipmentAfterMobileCodeDownloadQueryVariables
>;
export const AddCreditToPaymentSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddCreditToPaymentSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addCreditAmount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCreditToPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addCreditAmount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addCreditAmount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddCreditToPaymentSourceMutation,
  AddCreditToPaymentSourceMutationVariables
>;
export const CreateCcPaymentSourceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCcPaymentSourceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ccReference' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCcPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ccReference' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ccReference' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cp' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cp' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCcPaymentSourceMutation, CreateCcPaymentSourceMutationVariables>;
export const UpdateCcPaymentSourceAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateCcPaymentSourceAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCcPaymentSourceAfterCreateQuery,
  UpdateCcPaymentSourceAfterCreateQueryVariables
>;
export const CreatePayPalPaymentSourceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePayPalPaymentSourceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nonce' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPayPalPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nonce' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nonce' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePayPalPaymentSourceMutation,
  CreatePayPalPaymentSourceMutationVariables
>;
export const UpdatePayPalPaymentSourceAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePayPalPaymentSourceAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePayPalPaymentSourceAfterCreateQuery,
  UpdatePayPalPaymentSourceAfterCreateQueryVariables
>;
export const CreatePlaidAccessTokenMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlaidAccessTokenMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'publicToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'handle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlaidAccessToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'publicToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'handle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'handle' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'handle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mask' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePlaidAccessTokenMutation,
  CreatePlaidAccessTokenMutationVariables
>;
export const CreatePlaidActivationMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlaidActivationMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlaidActivation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'origin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'handle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePlaidActivationMutation, CreatePlaidActivationMutationVariables>;
export const CreatePlaidConsentMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlaidConsentMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlaidConsent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePlaidConsentMutation, CreatePlaidConsentMutationVariables>;
export const UpdatePlaidPaymentSourceAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePlaidPaymentSourceAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaidPaymentSourceAfterCreateQuery,
  UpdatePlaidPaymentSourceAfterCreateQueryVariables
>;
export const CreatePlaidValidationActivationMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlaidValidationActivationMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlaidValidationActivation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'origin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'handle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePlaidValidationActivationMutation,
  CreatePlaidValidationActivationMutationVariables
>;
export const CreateVenmoPaymentSourceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateVenmoPaymentSourceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nonce' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVenmoPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nonce' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nonce' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateVenmoPaymentSourceMutation,
  CreateVenmoPaymentSourceMutationVariables
>;
export const UpdateVenmoSourceAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateVenmoSourceAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVenmoSourceAfterCreateQuery,
  UpdateVenmoSourceAfterCreateQueryVariables
>;
export const DeletePaymentSourceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePaymentSourceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePaymentSourceMutation, DeletePaymentSourceMutationVariables>;
export const UpdatePaymentSourcesAfterDeleteQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePaymentSourcesAfterDeleteQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePaymentSourcesAfterDeleteQuery,
  UpdatePaymentSourcesAfterDeleteQueryVariables
>;
export const RefundCreditFromPaymentSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefundCreditFromPaymentSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'refundCreditAmount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refundCreditFromPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'refundCreditAmount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'refundCreditAmount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefundCreditFromPaymentSourceMutation,
  RefundCreditFromPaymentSourceMutationVariables
>;
export const ResetNicknameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetNickname' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetNickname' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetNicknameMutation, ResetNicknameMutationVariables>;
export const SetDefaultPaymentSourceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDefaultPaymentSourceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDefaultPaymentSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDefaultPaymentSourceMutation,
  SetDefaultPaymentSourceMutationVariables
>;
export const UpdateSettingsAfterDefaultPaymentSourceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSettingsAfterDefaultPaymentSourceQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSettingsAfterDefaultPaymentSourceQuery,
  UpdateSettingsAfterDefaultPaymentSourceQueryVariables
>;
export const SetPaymentSourceNicknameMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetPaymentSourceNicknameMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nickname' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setNickname' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nickname' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nickname' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetPaymentSourceNicknameMutation,
  SetPaymentSourceNicknameMutationVariables
>;
export const BillingPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BillingPageQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'chargeAmountOptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultDestinationCountryCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultChargeAmount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activePaymentMethods' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentApiMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentApiMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BillingPageQuery, BillingPageQueryVariables>;
export const PaymentModalQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentModalQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'chargeAmountOptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activePaymentMethods' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentApiMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentApiMethodFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentApiMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentModalQuery, PaymentModalQueryVariables>;
export const PaymentReceiptsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentReceiptsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentReceipts' } }],
      },
    },
  ],
} as unknown as DocumentNode<PaymentReceiptsQuery, PaymentReceiptsQueryVariables>;
export const SpreedlyIframeParametersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SpreedlyIframeParametersQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spreedlyIframeParameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nonce' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpreedlyIframeParametersQuery, SpreedlyIframeParametersQueryVariables>;
export const CancelPickupMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelPickupMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelPickup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelPickupMutation, CancelPickupMutationVariables>;
export const UpdatePickupsAfterCancelQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePickupsAfterCancelQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PickupFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PickupFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseReadyTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseCloseTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageWeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'warehouse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePickupsAfterCancelQuery, UpdatePickupsAfterCancelQueryVariables>;
export const PickupCreationQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PickupCreationQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activePaymentMethods' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'merchantAccounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsAndConditionsOutdated' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentSourceFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultChargeAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentSourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailClasses' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'topLevelOnly' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceLevel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedPickupDates' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentApiMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentSourceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nickname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConsented' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PickupCreationQuery, PickupCreationQueryVariables>;
export const PickupsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PickupsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PickupFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PickupFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseReadyTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseCloseTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageWeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'warehouse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PickupsQuery, PickupsQueryVariables>;
export const RatePickupMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RatePickupMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pickupRequest' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ratePickup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pickupRequest' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pickupRequest' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedOutBasePrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedOutTotalPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surcharges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'crossedOutPrice' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RatePickupMutation, RatePickupMutationVariables>;
export const RequestPickupMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestPickupMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pickupRequest' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequestInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'totalCharge' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestPickup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pickupRequest' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pickupRequest' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'totalCharge' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'totalCharge' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PickupFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PickupFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseReadyTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseCloseTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageWeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'warehouse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestPickupMutation, RequestPickupMutationVariables>;
export const UpdatePickupsAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdatePickupsAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PickupFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PickupFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PickupRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneTimePickupDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseReadyTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warehouseCloseTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageWeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalPackageCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'warehouse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carrier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePickupsAfterCreateQuery, UpdatePickupsAfterCreateQueryVariables>;
export const UpsPickupPrefillQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpsPickupPrefillQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickupSummary' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'carrierKey' },
                      value: { kind: 'EnumValue', value: 'ups' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailClassCounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mailClass' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overweightShipmentIncluded' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsPickupPrefillQuery, UpsPickupPrefillQueryVariables>;
export const UspsPickupPrefillQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UspsPickupPrefillQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pickupSummary' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'carrierKey' },
                      value: { kind: 'EnumValue', value: 'usps' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overweightShipmentIncluded' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWeightOz' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWeightLbs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UspsPickupPrefillQuery, UspsPickupPrefillQueryVariables>;
export const BatchesAfterLabelDownloadQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchesAfterLabelDownloadQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundBatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRefund' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusText' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentStatusSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPrint' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isShipmentRefundable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuspended' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentStatusSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundPendingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inTransitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToShipCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToPrintCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mobileCodeShowableCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BatchesAfterLabelDownloadQuery,
  BatchesAfterLabelDownloadQueryVariables
>;
export const GenerateOrGetShareLinkMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateOrGetShareLinkMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'downloadId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateOrGetShareLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'downloadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'downloadId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateOrGetShareLinkMutation,
  GenerateOrGetShareLinkMutationVariables
>;
export const LabelsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LabelsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'downloadId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isViaAdminBar' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'downloadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'downloadId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shareToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isViaAdminBar' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isViaAdminBar' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileFormat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabelsQuery, LabelsQueryVariables>;
export const PrintSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PrintSettingsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelFileFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packingListTemplate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrintSettingsQuery, PrintSettingsQueryVariables>;
export const ScanFormByBatchQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScanFormByBatchQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanFormByBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreateScanForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanFormUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScanFormByBatchQuery, ScanFormByBatchQueryVariables>;
export const ScanFormByShareTokenAfterLabelDownloadQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScanFormByShareTokenAfterLabelDownloadQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanFormByShareToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shareToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreateScanForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanFormUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScanFormByShareTokenAfterLabelDownloadQuery,
  ScanFormByShareTokenAfterLabelDownloadQueryVariables
>;
export const ShipmentsAfterLabelDownloadQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentsAfterLabelDownloadQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canPrint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isShipmentRefundable' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShipmentsAfterLabelDownloadQuery,
  ShipmentsAfterLabelDownloadQueryVariables
>;
export const TriggerDownloadLabelsByBatchesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerDownloadLabelsByBatchesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLayout' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerLabelCreationByBatches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageLayout' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TriggerDownloadLabelsByBatchesMutation,
  TriggerDownloadLabelsByBatchesMutationVariables
>;
export const TriggerDownloadLabelsByShareTokenMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerDownloadLabelsByShareTokenMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLayout' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerLabelCreationByShareToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shareToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shareToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageLayout' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TriggerDownloadLabelsByShareTokenMutation,
  TriggerDownloadLabelsByShareTokenMutationVariables
>;
export const TriggerDownloadLabelsByShipmentsMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerDownloadLabelsByShipmentsMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLayout' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isViaAdminBar' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerLabelCreationByShipments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageLayout' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageLayout' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isViaAdminBar' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isViaAdminBar' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TriggerDownloadLabelsByShipmentsMutation,
  TriggerDownloadLabelsByShipmentsMutationVariables
>;
export const RatesConfigQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RatesConfigQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailClasses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultDestinationCountryCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentBoundaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCombinedLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLengthPlusGirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minShortSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxShortSide' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RatesConfigQuery, RatesConfigQueryVariables>;
export const RatesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RatesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originZip' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originCity' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originRegionCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationZip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isResidential' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationCountryCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'weight' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionX' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionY' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionZ' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mailClassKeys' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'packageTypeKeys' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pricingTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showUpsRatesWhen2x7Selected' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originZip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originZip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originCity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originCity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originRegionCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originRegionCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationZip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'destinationZip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isResidential' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isResidential' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationCountryCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'destinationCountryCode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'weight' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'weight' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dimensionX' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionX' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dimensionY' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionY' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dimensionZ' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dimensionZ' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mailClassKeys' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mailClassKeys' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'packageTypeKeys' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'packageTypeKeys' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pricingTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pricingTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showUpsRatesWhen2x7Selected' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showUpsRatesWhen2x7Selected' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pricingDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cubicTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mailClassKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailClass' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accuracy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'international' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surcharges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carrier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceBaseTypeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'crossedTotalPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pricingSubType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ratePeriodId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'learnMoreUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cheapest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fastest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'best' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RatesQuery, RatesQueryVariables>;
export const RefundBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefundBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refundBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefundBatchMutation, RefundBatchMutationVariables>;
export const RefundShipmentMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefundShipmentMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refundShipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRefund' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundBatch' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentStatusSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'refundableCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'printableCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPrint' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canShowMobileCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isShipmentRefundable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canInstantRefundShipment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalRefundNotice' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefundShipmentMutation, RefundShipmentMutationVariables>;
export const AverageCostChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AverageCostChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'averageCostChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'charts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AverageCostChartQuery, AverageCostChartQueryVariables>;
export const CompanySavingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanySavingsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companySavings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanySavingsQuery, CompanySavingsQueryVariables>;
export const CountryDistributionChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CountryDistributionChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryDistributionChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryDistributions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountryDistributionChartQuery, CountryDistributionChartQueryVariables>;
export const NumbersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NumbersQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrierAdjustmentsAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payments' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returns' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refunds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentsTotalAmount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'netLabelCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netLabelTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netLabelAverage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netLabelAverageDom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netLabelAverageInt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NumbersQuery, NumbersQueryVariables>;
export const PaymentChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'charts' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentChartQuery, PaymentChartQueryVariables>;
export const ReceiptQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReceiptQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chargeError' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'refundTotal' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reconciliationRunId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reversals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'action' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'newPaymentStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coveringAccountingTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentSuccessful' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCharged' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReceiptQuery, ReceiptQueryVariables>;
export const ReportsPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportsPageQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountBalance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsPageQuery, ReportsPageQueryVariables>;
export const ShipmentChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'charts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentChartQuery, ShipmentChartQueryVariables>;
export const ShipmentPieChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentPieChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentPieChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'charts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentPieChartQuery, ShipmentPieChartQueryVariables>;
export const ShipmentTrackingNumbersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentTrackingNumbersQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentTrackingNumbers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentsTransit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentsDelivered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentsNew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentsDeliveryIssue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentTrackingNumbersQuery, ShipmentTrackingNumbersQueryVariables>;
export const StateDistributionChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StateDistributionChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateDistributionChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stateDistributions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StateDistributionChartQuery, StateDistributionChartQueryVariables>;
export const ZoneChartQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ZoneChartQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DatetimeRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'zoneChart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'datetimeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'datetimeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'labels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'charts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colors' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ZoneChartQuery, ZoneChartQueryVariables>;
export const CreateScanFormMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScanFormMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScanForm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'warehouseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'printableShipmentIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateScanFormMutation, CreateScanFormMutationVariables>;
export const CreateScanFormByBatchMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScanFormByBatchMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScanFormByBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreateScanForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanFormUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateScanFormByBatchMutation, CreateScanFormByBatchMutationVariables>;
export const ScanFormsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScanFormsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'withScanFormsAvailable' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalAvailableLabelsForScanForm' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scanForms' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shipmentCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shipDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'printableShipmentIds' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScanFormsQuery, ScanFormsQueryVariables>;
export const AbortChallengeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AbortChallengeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'abortChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AbortChallengeMutation, AbortChallengeMutationVariables>;
export const ChallengesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChallengesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChallengesQuery, ChallengesQueryVariables>;
export const HasBatchesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasBatchesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasBatches' } }],
      },
    },
  ],
} as unknown as DocumentNode<HasBatchesQuery, HasBatchesQueryVariables>;
export const LatestBatchesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestBatchesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageIndex' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuspended' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestBatches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageIndex' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageIndex' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'batches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelingArtifactType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'runningProcess' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCreateLabels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCreateMobileCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cleanupComplete' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBeenDownloaded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrierLogoClasses' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'containedMailClassGroupKeys' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shipmentStatusSummary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shipments' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'limit' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'trackingNr' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentStatusSummaryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentStatusSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refundPendingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inTransitCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToShipCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToPrintCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printableCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mobileCodeShowableCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestBatchesQuery, LatestBatchesQueryVariables>;
export const SucceedAtChallengeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SucceedAtChallengeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'succeedAtChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SucceedAtChallengeMutation, SucceedAtChallengeMutationVariables>;
export const BatchUploadFormQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BatchUploadFormQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customsFormRequired' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customsFormRequiredForAllShipments' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelingArtifactType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numShipments' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upload' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'packagePreset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmationFlag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deliveryConfirmation' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qualifiesAsMediaMail' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hazardousMaterialsEnabled' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customsItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hsTariffNumber' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'countryCodeOfOrigin' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouse' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentBoundaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCombinedLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLengthPlusGirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minShortSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxShortSide' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BatchUploadFormQuery, BatchUploadFormQueryVariables>;
export const CompleteBatchFromUploadMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteBatchFromUploadMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeBatchFromUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchTitle' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'warehouseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentPresetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteBatchFromUploadMutation,
  CompleteBatchFromUploadMutationVariables
>;
export const CreateBatchFromImportMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBatchFromImportMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'overrideMultiple' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBatchFromImport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'warehouseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentPresetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'overrideMultiple' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'overrideMultiple' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningProcessFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningProcessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Batch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runningProcess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsInProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemsTotalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsLeft' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBatchFromImportMutation, CreateBatchFromImportMutationVariables>;
export const CreateBatchFromSingleShipmentMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBatchFromSingleShipmentMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipToAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RecipientAddressInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamps' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RubberStampsInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'validatedAddressId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipCorrection' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBatchFromSingleShipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'warehouseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipmentPresetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPresetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shipToAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipToAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rubberStamps' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rubberStamps' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'validatedAddressId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'validatedAddressId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skipCorrection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skipCorrection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBatchFromSingleShipmentMutation,
  CreateBatchFromSingleShipmentMutationVariables
>;
export const CreateBatchFromUploadMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBatchFromUploadMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mapping' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentMappingInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBatchFromUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mapping' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mapping' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upload' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueOrMappingKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shipmentKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userFriendlyShipmentKey' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBatchFromUploadMutation, CreateBatchFromUploadMutationVariables>;
export const CreateScopedShipmentPresetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScopedShipmentPreset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originalPresetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPresetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScopedShipmentPreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originalPresetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originalPresetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'values' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shipmentPreset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateScopedShipmentPresetMutation,
  CreateScopedShipmentPresetMutationVariables
>;
export const DeleteShipmentPresetMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteShipmentPresetMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShipmentPreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteShipmentPresetMutation, DeleteShipmentPresetMutationVariables>;
export const UpdateShipmentPresetsAfterDeleteQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateShipmentPresetsAfterDeleteQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShipmentPresetsAfterDeleteQuery,
  UpdateShipmentPresetsAfterDeleteQueryVariables
>;
export const DeleteSuggestedAddressMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSuggestedAddressMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSuggestedAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addressId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSuggestedAddressMutation,
  DeleteSuggestedAddressMutationVariables
>;
export const DeleteWarehouseMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWarehouseMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWarehouse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'warehouseId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>;
export const UpdateWarehousesAfterDeleteQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateWarehousesAfterDeleteQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWarehousesAfterDeleteQuery,
  UpdateWarehousesAfterDeleteQueryVariables
>;
export const HideHistoricShipmentAddressesMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HideHistoricShipmentAddressesMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideHistoricShipmentAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HideHistoricShipmentAddressesMutation,
  HideHistoricShipmentAddressesMutationVariables
>;
export const HistoricShipmentAddressesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HistoricShipmentAddressesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchField' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HistoricShipmentAddressSearchField' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'historicShipmentAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchField' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchField' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HistoricShipmentAddressesQuery,
  HistoricShipmentAddressesQueryVariables
>;
export const ImportFormQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportFormQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domesticCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internationalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customsFormRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customsFormRequiredCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overrideable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedBatchTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedShipmentPreset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uniquePlatformKeys' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueWeights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueValues' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWeightFormatted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeightFormatted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minValueFormatted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxValueFormatted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueOrderItemTexts' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uniqueCustomsItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'qty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'harmonization' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notOverrideableReasons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platform' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platformLinks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'foreignOrderId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderItemsText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rubberStamp3' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platform' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformKey' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platformLinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'platform' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'foreignOrderId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderLink' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptionLink' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shipmentLink' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentBoundaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCombinedLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLengthPlusGirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minShortSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxShortSide' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceUnsupportedCountries' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportFormQuery, ImportFormQueryVariables>;
export const MappableShipmentFieldsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MappableShipmentFieldsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mappableShipmentFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMappings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MappableShipmentFieldsQuery, MappableShipmentFieldsQueryVariables>;
export const ParsedAddressQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ParsedAddressQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parsedAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParsedAddressQuery, ParsedAddressQueryVariables>;
export const SetDefaultWarehouseMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDefaultWarehouseMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDefaultWarehouse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'warehouseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDefaultWarehouseMutation, SetDefaultWarehouseMutationVariables>;
export const UpdateSettingsAfterDefaultWarehouseQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSettingsAfterDefaultWarehouseQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSettingsAfterDefaultWarehouseQuery,
  UpdateSettingsAfterDefaultWarehouseQueryVariables
>;
export const ShipmentPresetQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShipmentPresetQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShipmentPresetQuery, ShipmentPresetQueryVariables>;
export const SingleShipmentFormQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SingleShipmentFormQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxIdRequiringCountries' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addressAutocompleteSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeCarriers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentLabelSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultShipmentPresetId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipmentPresets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShipmentPresetFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentBoundaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCombinedLength' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLengthPlusGirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxLongSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxMiddleSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minShortSide' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxShortSide' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carriers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'carrierKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'packageTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightRequired' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dimensionsRequired' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'usRegions' },
            name: { kind: 'Name', value: 'regions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode' },
                value: { kind: 'StringValue', value: 'US', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CountryFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'insuranceUnsupportedCountries' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShipmentPresetFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShipmentPreset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'packageTypeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionY' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dimensionZ' } },
          { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryConfirmationFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'irregularPackage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insuredValueFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnLabelFlag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsFormEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsSigner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customsContentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customsItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hsTariffNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodeOfOrigin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exporterTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTaxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'qualifiesAsMediaMail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hazardousMaterialsEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CountryFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode' },
            name: { kind: 'Name', value: 'isoAlpha2Code' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'countryCode3' },
            name: { kind: 'Name', value: 'isoAlpha3Code' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postcodeRequired' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentCountry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SingleShipmentFormQuery, SingleShipmentFormQueryVariables>;
export const SuggestedMappingQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SuggestedMappingQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipmentUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedMapping' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shipmentKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userFriendlyShipmentKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueOrMappingKey' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SuggestedMappingQuery, SuggestedMappingQueryVariables>;
export const UpdateWarehouseMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWarehouseMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'originAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnAddress' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWarehouse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useOriginAsReturnAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'useOriginAsReturnAddress' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'originAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'originAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'returnAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'returnAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WarehouseFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>;
export const UpdateWarehousesAfterUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateWarehousesAfterUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWarehousesAfterUpdateQuery,
  UpdateWarehousesAfterUpdateQueryVariables
>;
export const WarehouseQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WarehouseQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultWarehouseId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warehouses' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WarehouseFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicAddressInterface' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WarehouseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Warehouse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOriginAsReturnAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WarehouseQuery, WarehouseQueryVariables>;
export const IsEuQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsEuQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEu' } }],
      },
    },
  ],
} as unknown as DocumentNode<IsEuQuery, IsEuQueryVariables>;
export const CancelEmailNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cancelEmailNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelEmailNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailNotificationTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelEmailNotificationMutation,
  CancelEmailNotificationMutationVariables
>;
export const CreateMailTemplateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMailTemplateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asDefault' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderEmail' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateHtml' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bccEmail' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMailTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asDefault' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asDefault' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subject' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateHtml' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateHtml' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bccEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'bccEmail' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MailTemplateFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;
export const UpdateMailTemplatesAfterCreateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateMailTemplatesAfterCreateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmailTemplateId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MailTemplateFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMailTemplatesAfterCreateQuery,
  UpdateMailTemplatesAfterCreateQueryVariables
>;
export const CreateSenderEmailMetadataMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSenderEmailMetadataMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSenderEmailMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SenderEmailMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSenderEmailMetadataMutation,
  CreateSenderEmailMetadataMutationVariables
>;
export const DefaultTrackingEmailDelayQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DefaultTrackingEmailDelayQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsDelay' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DefaultTrackingEmailDelayQuery,
  DefaultTrackingEmailDelayQueryVariables
>;
export const DeleteMailTemplateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMailTemplateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMailTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;
export const UpdateMailTemplatesAfterDeleteQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateMailTemplatesAfterDeleteQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MailTemplateFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMailTemplatesAfterDeleteQuery,
  UpdateMailTemplatesAfterDeleteQueryVariables
>;
export const FetchSenderEmailMetadataMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FetchSenderEmailMetadataMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchSenderEmailMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SenderEmailMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSenderEmailMetadataMutation,
  FetchSenderEmailMetadataMutationVariables
>;
export const MailTemplateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MailTemplateQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'globalSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'plainText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MailTemplateFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplateQuery, MailTemplateQueryVariables>;
export const MailTemplatesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MailTemplatesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsDelay' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmailTemplateId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MailTemplateFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplatesQuery, MailTemplatesQueryVariables>;
export const SendPreviewEmailMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPreviewEmailMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendPreviewEmailMutation, SendPreviewEmailMutationVariables>;
export const SenderEmailMetadataQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SenderEmailMetadataQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderEmailMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SenderEmailMetadataQuery, SenderEmailMetadataQueryVariables>;
export const TrackingEmailsPageSettingsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TrackingEmailsPageSettingsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trackingEmailBrandingEnabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackingEmailsPageSettingsQuery,
  TrackingEmailsPageSettingsQueryVariables
>;
export const UpdateDefaultTrackingEmailsDelayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDefaultTrackingEmailsDelay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inAdvance' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultTrackingEmailsDelay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inAdvance' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inAdvance' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDefaultTrackingEmailsDelayMutation,
  UpdateDefaultTrackingEmailsDelayMutationVariables
>;
export const UpdateDefaultTrackingEmailsEnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDefaultTrackingEmailsEnabled' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultTrackingEmailsEnabled' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDefaultTrackingEmailsEnabledMutation,
  UpdateDefaultTrackingEmailsEnabledMutationVariables
>;
export const UpdateDefaultTrackingEmailsEnabledUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateDefaultTrackingEmailsEnabledUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultTrackingEmailsEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDefaultTrackingEmailsEnabledUpdateQuery,
  UpdateDefaultTrackingEmailsEnabledUpdateQueryVariables
>;
export const UpdateEmailNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEmailNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mailTemplateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledDateTime' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmailNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mailTemplateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mailTemplateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduledDateTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduledDateTime' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notifyRecipientsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailNotificationTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEmailNotificationMutation,
  UpdateEmailNotificationMutationVariables
>;
export const UpdateMailTemplateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMailTemplateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asDefault' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderEmail' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateHtml' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bccEmail' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendTemplatePreview' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMailTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asDefault' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asDefault' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subject' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateHtml' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateHtml' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bccEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'bccEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendTemplatePreview' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sendTemplatePreview' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MailTemplateFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;
export const UpdateSettingsAfterUpdateMailTemplateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateSettingsAfterUpdateMailTemplateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmailTemplateId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mailTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MailTemplateFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MailTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MailTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateHtml' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSettingsAfterUpdateMailTemplateQuery,
  UpdateSettingsAfterUpdateMailTemplateQueryVariables
>;
export const UpdateSenderEmailMetadataMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSenderEmailMetadataMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSenderEmailMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'senderName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SenderEmailMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SenderEmailMetadata' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'verificationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimHost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimTextValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dkimVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainCnameValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnPathDomainVerified' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSenderEmailMetadataMutation,
  UpdateSenderEmailMetadataMutationVariables
>;
export const UpdateTrackingEmailBrandingEnabledMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTrackingEmailBrandingEnabledMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTrackingEmailBrandingEnabled' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTrackingEmailBrandingEnabledMutation,
  UpdateTrackingEmailBrandingEnabledMutationVariables
>;
export const UpdateTrackingEmailBrandingEnabledUpdateQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateTrackingEmailBrandingEnabledUpdateQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trackingEmailBrandingEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTrackingEmailBrandingEnabledUpdateQuery,
  UpdateTrackingEmailBrandingEnabledUpdateQueryVariables
>;
export const BuyRedirectPackageToNewAddressMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuyRedirectPackageToNewAddressMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buyRedirectPackageToNewAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trackingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuyRedirectPackageToNewAddressMutation,
  BuyRedirectPackageToNewAddressMutationVariables
>;
export const BuyReturnPackageToSenderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuyReturnPackageToSenderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buyReturnPackageToSender' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trackingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuyReturnPackageToSenderMutation,
  BuyReturnPackageToSenderMutationVariables
>;
export const InterceptPriceQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InterceptPriceQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interceptPrice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trackingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCharge' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chargeCurrency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interceptCharge' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InterceptPriceQuery, InterceptPriceQueryVariables>;
export const RedirectOptionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RedirectOptionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectOptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trackingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'trackingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'canReturnToSender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRedirectToNewAddress' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RedirectOptionsQuery, RedirectOptionsQueryVariables>;
export const SendUserEmailVerificationLinkMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendUserEmailVerificationLinkMutation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sendUserEmailVerificationLink' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendUserEmailVerificationLinkMutation,
  SendUserEmailVerificationLinkMutationVariables
>;
export const CreateUserMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUserMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstname' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastname' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstname' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstname' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastname' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastname' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUserMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResendUserInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendUserInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendUserInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;
export const UsersQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UsersQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompanyUserFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyUserFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AddressInterface: ['Address', 'DockOrder', 'Shipment'],
    BasicAddressInterface: [
      'Address',
      'BasicAddress',
      'DockOrder',
      'HistoricShipmentAddress',
      'RecipientAddress',
      'Shipment',
    ],
    ChannelInterface: [
      'BigcartelChannel',
      'BigcommerceChannel',
      'Channel',
      'CratejoyChannel',
      'DiscogsChannel',
      'EbayChannel',
      'EcwidChannel',
      'EtsyChannel',
      'FakeshopChannel',
      'PaypalChannel',
      'ShopifyChannel',
      'SquareChannel',
      'SquarespaceChannel',
      'SubblyChannel',
      'WixChannel',
      'WoocommerceChannel',
    ],
    ChannelUnion: [
      'BigcartelChannel',
      'BigcommerceChannel',
      'CratejoyChannel',
      'DiscogsChannel',
      'EbayChannel',
      'EcwidChannel',
      'EtsyChannel',
      'FakeshopChannel',
      'PaypalChannel',
      'ShopifyChannel',
      'SquareChannel',
      'SquarespaceChannel',
      'SubblyChannel',
      'WixChannel',
      'WoocommerceChannel',
    ],
    EcwidOrderStatus: ['EcwidOrderStatusImpl'],
  },
};
export default result;

export const namedOperations = {
  Query: {
    TwoFactorAuthenticationConfigurationQuery: 'TwoFactorAuthenticationConfigurationQuery' as const,
    AccountSettingsQuery: 'AccountSettingsQuery' as const,
    CaptainsNotesQuery: 'CaptainsNotesQuery' as const,
    BlockedCountriesQuery: 'BlockedCountriesQuery' as const,
    NavbarLinksQuery: 'NavbarLinksQuery' as const,
    SupportSearchQuery: 'SupportSearchQuery' as const,
    UserQuery: 'UserQuery' as const,
    BatchQuery: 'BatchQuery' as const,
    DummyDataGridInputTypeUsageQuery: 'DummyDataGridInputTypeUsageQuery' as const,
    AddUpsToMerchantAccountsAfterCreateQuery: 'AddUpsToMerchantAccountsAfterCreateQuery' as const,
    UpdateShipmentPresetsAfterCreateQuery: 'UpdateShipmentPresetsAfterCreateQuery' as const,
    AddUspsToMerchantAccountsAfterCreateQuery: 'AddUspsToMerchantAccountsAfterCreateQuery' as const,
    UpdateWarehousesAfterCreateQuery: 'UpdateWarehousesAfterCreateQuery' as const,
    UpdateChargeAmountAfterCreateQuery: 'UpdateChargeAmountAfterCreateQuery' as const,
    UpdateShipmentPresetsAfterUpdateQuery: 'UpdateShipmentPresetsAfterUpdateQuery' as const,
    ApplicationConfigurationQuery: 'ApplicationConfigurationQuery' as const,
    ApplicationInformationQuery: 'ApplicationInformationQuery' as const,
    AutoRefundedShipmentsSummaryQuery: 'AutoRefundedShipmentsSummaryQuery' as const,
    BatchIdFromShipmentQuery: 'BatchIdFromShipmentQuery' as const,
    BatchProcessStatusQuery: 'BatchProcessStatusQuery' as const,
    BatchShipmentIdsQuery: 'BatchShipmentIdsQuery' as const,
    BatchStepQuery: 'BatchStepQuery' as const,
    BillingAddressQuery: 'BillingAddressQuery' as const,
    ChargeAmountOptionsQuery: 'ChargeAmountOptionsQuery' as const,
    CountriesQuery: 'CountriesQuery' as const,
    FailedShipmentsExportQuery: 'FailedShipmentsExportQuery' as const,
    PackageTypesQuery: 'PackageTypesQuery' as const,
    PreferredMerchantAccountAddress: 'PreferredMerchantAccountAddress' as const,
    RegionsQuery: 'RegionsQuery' as const,
    ShipmentBoundariesQuery: 'ShipmentBoundariesQuery' as const,
    ShipmentPresetsQuery: 'ShipmentPresetsQuery' as const,
    WarehousesQuery: 'WarehousesQuery' as const,
    BatchDetailsPageQuery: 'BatchDetailsPageQuery' as const,
    DataGridExportStatusQuery: 'DataGridExportStatusQuery' as const,
    MapQuery: 'MapQuery' as const,
    ShipmentContextualDropdownMenuQuery: 'ShipmentContextualDropdownMenuQuery' as const,
    ShipmentDetailsPageQuery: 'ShipmentDetailsPageQuery' as const,
    GeneralSettingsQuery: 'GeneralSettingsQuery' as const,
    UpdateCompanySettingsAfterGeneralSettingsUpdateQuery:
      'UpdateCompanySettingsAfterGeneralSettingsUpdateQuery' as const,
    ReturnPathQuery: 'ReturnPathQuery' as const,
    VerificationRequiredQuery: 'VerificationRequiredQuery' as const,
    VerificationStatusQuery: 'VerificationStatusQuery' as const,
    ChannelSyncStatus: 'ChannelSyncStatus' as const,
    ImportedOrdersBaseQuery: 'ImportedOrdersBaseQuery' as const,
    ShipmentForOrderQuery: 'ShipmentForOrderQuery' as const,
    UpdateChannelsAfterDeleteQuery: 'UpdateChannelsAfterDeleteQuery' as const,
    CreateBigcommerceAfterUpdateQuery: 'CreateBigcommerceAfterUpdateQuery' as const,
    CreateCratejoyAfterUpdateQuery: 'CreateCratejoyAfterUpdateQuery' as const,
    CreateDiscogsAfterUpdateQuery: 'CreateDiscogsAfterUpdateQuery' as const,
    CreateFakeshopAfterUpdateQuery: 'CreateFakeshopAfterUpdateQuery' as const,
    CreateSquarespaceAfterUpdateQuery: 'CreateSquarespaceAfterUpdateQuery' as const,
    CreateSubblyAfterUpdateQuery: 'CreateSubblyAfterUpdateQuery' as const,
    UpdateBigcartelAfterUpdateQuery: 'UpdateBigcartelAfterUpdateQuery' as const,
    UpdateBigcommerceAfterUpdateQuery: 'UpdateBigcommerceAfterUpdateQuery' as const,
    UpdateCratejoyAfterUpdateQuery: 'UpdateCratejoyAfterUpdateQuery' as const,
    UpdateDiscogsAfterUpdateQuery: 'UpdateDiscogsAfterUpdateQuery' as const,
    UpdateEbayAfterUpdateQuery: 'UpdateEbayAfterUpdateQuery' as const,
    UpdateEcwidAfterUpdateQuery: 'UpdateEcwidAfterUpdateQuery' as const,
    UpdateEtsyAfterUpdateQuery: 'UpdateEtsyAfterUpdateQuery' as const,
    UpdateFakeshopAfterUpdateQuery: 'UpdateFakeshopAfterUpdateQuery' as const,
    UpdatePayPalAfterUpdateQuery: 'UpdatePayPalAfterUpdateQuery' as const,
    UpdateShopifyAfterUpdateQuery: 'UpdateShopifyAfterUpdateQuery' as const,
    UpdateSquareAfterUpdateQuery: 'UpdateSquareAfterUpdateQuery' as const,
    UpdateSquarespaceAfterUpdateQuery: 'UpdateSquarespaceAfterUpdateQuery' as const,
    UpdateSubblyAfterUpdateQuery: 'UpdateSubblyAfterUpdateQuery' as const,
    UpdateWixAfterUpdateQuery: 'UpdateWixAfterUpdateQuery' as const,
    UpdateWoocommerceAfterUpdateQuery: 'UpdateWoocommerceAfterUpdateQuery' as const,
    ChannelsQuery: 'ChannelsQuery' as const,
    PlatformsQuery: 'PlatformsQuery' as const,
    BigcartelQuery: 'BigcartelQuery' as const,
    BigcommerceQuery: 'BigcommerceQuery' as const,
    CratejoyQuery: 'CratejoyQuery' as const,
    DiscogsQuery: 'DiscogsQuery' as const,
    EbayQuery: 'EbayQuery' as const,
    EcwidQuery: 'EcwidQuery' as const,
    EtsyQuery: 'EtsyQuery' as const,
    FakeshopQuery: 'FakeshopQuery' as const,
    PaypalQuery: 'PaypalQuery' as const,
    ShopifyQuery: 'ShopifyQuery' as const,
    SquareQuery: 'SquareQuery' as const,
    SquarespaceQuery: 'SquarespaceQuery' as const,
    SubblyQuery: 'SubblyQuery' as const,
    WixQuery: 'WixQuery' as const,
    WoocommerceQuery: 'WoocommerceQuery' as const,
    WoocommerceEgressIpsQuery: 'WoocommerceEgressIpsQuery' as const,
    IntercomArticleQuery: 'IntercomArticleQuery' as const,
    LatestTermsQuery: 'LatestTermsQuery' as const,
    AreMobileCodesEnabledQuery: 'AreMobileCodesEnabledQuery' as const,
    BatchMobileCodeModalQuery: 'BatchMobileCodeModalQuery' as const,
    ShipmentAfterMobileCodeDownloadQuery: 'ShipmentAfterMobileCodeDownloadQuery' as const,
    UpdateCcPaymentSourceAfterCreateQuery: 'UpdateCcPaymentSourceAfterCreateQuery' as const,
    UpdatePayPalPaymentSourceAfterCreateQuery: 'UpdatePayPalPaymentSourceAfterCreateQuery' as const,
    UpdatePlaidPaymentSourceAfterCreateQuery: 'UpdatePlaidPaymentSourceAfterCreateQuery' as const,
    UpdateVenmoSourceAfterCreateQuery: 'UpdateVenmoSourceAfterCreateQuery' as const,
    UpdatePaymentSourcesAfterDeleteQuery: 'UpdatePaymentSourcesAfterDeleteQuery' as const,
    UpdateSettingsAfterDefaultPaymentSourceQuery:
      'UpdateSettingsAfterDefaultPaymentSourceQuery' as const,
    BillingPageQuery: 'BillingPageQuery' as const,
    PaymentModalQuery: 'PaymentModalQuery' as const,
    PaymentReceiptsQuery: 'PaymentReceiptsQuery' as const,
    SpreedlyIframeParametersQuery: 'SpreedlyIframeParametersQuery' as const,
    UpdatePickupsAfterCancelQuery: 'UpdatePickupsAfterCancelQuery' as const,
    PickupCreationQuery: 'PickupCreationQuery' as const,
    PickupsQuery: 'PickupsQuery' as const,
    UpdatePickupsAfterCreateQuery: 'UpdatePickupsAfterCreateQuery' as const,
    UpsPickupPrefillQuery: 'UpsPickupPrefillQuery' as const,
    UspsPickupPrefillQuery: 'UspsPickupPrefillQuery' as const,
    BatchesAfterLabelDownloadQuery: 'BatchesAfterLabelDownloadQuery' as const,
    LabelsQuery: 'LabelsQuery' as const,
    PrintSettingsQuery: 'PrintSettingsQuery' as const,
    ScanFormByBatchQuery: 'ScanFormByBatchQuery' as const,
    ScanFormByShareTokenAfterLabelDownloadQuery:
      'ScanFormByShareTokenAfterLabelDownloadQuery' as const,
    ShipmentsAfterLabelDownloadQuery: 'ShipmentsAfterLabelDownloadQuery' as const,
    RatesConfigQuery: 'RatesConfigQuery' as const,
    RatesQuery: 'RatesQuery' as const,
    AverageCostChartQuery: 'AverageCostChartQuery' as const,
    CompanySavingsQuery: 'CompanySavingsQuery' as const,
    CountryDistributionChartQuery: 'CountryDistributionChartQuery' as const,
    NumbersQuery: 'NumbersQuery' as const,
    PaymentChartQuery: 'PaymentChartQuery' as const,
    ReceiptQuery: 'ReceiptQuery' as const,
    ReportsPageQuery: 'ReportsPageQuery' as const,
    ShipmentChartQuery: 'ShipmentChartQuery' as const,
    ShipmentPieChartQuery: 'ShipmentPieChartQuery' as const,
    ShipmentTrackingNumbersQuery: 'ShipmentTrackingNumbersQuery' as const,
    StateDistributionChartQuery: 'StateDistributionChartQuery' as const,
    ZoneChartQuery: 'ZoneChartQuery' as const,
    ScanFormsQuery: 'ScanFormsQuery' as const,
    ChallengesQuery: 'ChallengesQuery' as const,
    HasBatchesQuery: 'HasBatchesQuery' as const,
    LatestBatchesQuery: 'LatestBatchesQuery' as const,
    BatchUploadFormQuery: 'BatchUploadFormQuery' as const,
    UpdateShipmentPresetsAfterDeleteQuery: 'UpdateShipmentPresetsAfterDeleteQuery' as const,
    UpdateWarehousesAfterDeleteQuery: 'UpdateWarehousesAfterDeleteQuery' as const,
    HistoricShipmentAddressesQuery: 'HistoricShipmentAddressesQuery' as const,
    ImportFormQuery: 'ImportFormQuery' as const,
    MappableShipmentFieldsQuery: 'MappableShipmentFieldsQuery' as const,
    ParsedAddressQuery: 'ParsedAddressQuery' as const,
    UpdateSettingsAfterDefaultWarehouseQuery: 'UpdateSettingsAfterDefaultWarehouseQuery' as const,
    ShipmentPresetQuery: 'ShipmentPresetQuery' as const,
    SingleShipmentFormQuery: 'SingleShipmentFormQuery' as const,
    SuggestedMappingQuery: 'SuggestedMappingQuery' as const,
    UpdateWarehousesAfterUpdateQuery: 'UpdateWarehousesAfterUpdateQuery' as const,
    WarehouseQuery: 'WarehouseQuery' as const,
    IsEuQuery: 'IsEuQuery' as const,
    UpdateMailTemplatesAfterCreateQuery: 'UpdateMailTemplatesAfterCreateQuery' as const,
    DefaultTrackingEmailDelayQuery: 'DefaultTrackingEmailDelayQuery' as const,
    UpdateMailTemplatesAfterDeleteQuery: 'UpdateMailTemplatesAfterDeleteQuery' as const,
    MailTemplateQuery: 'MailTemplateQuery' as const,
    MailTemplatesQuery: 'MailTemplatesQuery' as const,
    SenderEmailMetadataQuery: 'SenderEmailMetadataQuery' as const,
    TrackingEmailsPageSettingsQuery: 'TrackingEmailsPageSettingsQuery' as const,
    UpdateDefaultTrackingEmailsEnabledUpdateQuery:
      'UpdateDefaultTrackingEmailsEnabledUpdateQuery' as const,
    UpdateSettingsAfterUpdateMailTemplateQuery:
      'UpdateSettingsAfterUpdateMailTemplateQuery' as const,
    UpdateTrackingEmailBrandingEnabledUpdateQuery:
      'UpdateTrackingEmailBrandingEnabledUpdateQuery' as const,
    InterceptPriceQuery: 'InterceptPriceQuery' as const,
    RedirectOptionsQuery: 'RedirectOptionsQuery' as const,
    UsersQuery: 'UsersQuery' as const,
  },
  Mutation: {
    ConfirmTwoFactorAuthenticationProviderMutation:
      'ConfirmTwoFactorAuthenticationProviderMutation' as const,
    DeleteTwoFactorAuthenticationProviderMutation:
      'DeleteTwoFactorAuthenticationProviderMutation' as const,
    InstallTwoFactorAuthenticationProviderMutation:
      'InstallTwoFactorAuthenticationProviderMutation' as const,
    ProvideOtpMutation: 'ProvideOtpMutation' as const,
    SendResetPasswordLinkMutation: 'SendResetPasswordLinkMutation' as const,
    UpdateAccountEmailMutation: 'UpdateAccountEmailMutation' as const,
    UpdateAccountProfileMutation: 'UpdateAccountProfileMutation' as const,
    UpdateNotificationsSettingsMutation: 'UpdateNotificationsSettingsMutation' as const,
    DisputeAdjustmentsMutation: 'DisputeAdjustmentsMutation' as const,
    EmulateViaShipmentMutation: 'EmulateViaShipmentMutation' as const,
    UpdateBlockedCountriesMutation: 'UpdateBlockedCountriesMutation' as const,
    BuyBatchMutation: 'BuyBatchMutation' as const,
    ModifyInsuranceOnRatedBatchMutation: 'ModifyInsuranceOnRatedBatchMutation' as const,
    RerateBatchMutation: 'RerateBatchMutation' as const,
    SetBatchToNewMutation: 'SetBatchToNewMutation' as const,
    UpdateRateGroupSortOrder: 'UpdateRateGroupSortOrder' as const,
    ConsumeGtmEventsMutation: 'ConsumeGtmEventsMutation' as const,
    ConsumeMessagesMutation: 'ConsumeMessagesMutation' as const,
    CreateMappingsMutation: 'CreateMappingsMutation' as const,
    CreateOrUpdateUpsMerchantAccountMutation: 'CreateOrUpdateUpsMerchantAccountMutation' as const,
    CreateShipmentPresetMutation: 'CreateShipmentPresetMutation' as const,
    CreateUspsMerchantAccountMutation: 'CreateUspsMerchantAccountMutation' as const,
    CreateWarehouseMutation: 'CreateWarehouseMutation' as const,
    DeleteBatchMutation: 'DeleteBatchMutation' as const,
    SendConfirmationMailMutation: 'SendConfirmationMailMutation' as const,
    UpdateBatchTitleMutation: 'UpdateBatchTitleMutation' as const,
    UpdateBillingAddressMutation: 'UpdateBillingAddressMutation' as const,
    UpdateChargeAmountMutation: 'UpdateChargeAmountMutation' as const,
    UpdateDataGridUserSettingsMutation: 'UpdateDataGridUserSettingsMutation' as const,
    UpdatePreferredUpsMerchantAccountAddressMutation:
      'UpdatePreferredUpsMerchantAccountAddressMutation' as const,
    UpdateShipmentPresetMutation: 'UpdateShipmentPresetMutation' as const,
    FetchShipmentStageDotsMutation: 'FetchShipmentStageDotsMutation' as const,
    UpdateGeneralSettingsMutation: 'UpdateGeneralSettingsMutation' as const,
    GenerateJumioWebClientUrlMutation: 'GenerateJumioWebClientUrlMutation' as const,
    MarkJumioFlowAsDismissedMutation: 'MarkJumioFlowAsDismissedMutation' as const,
    MarkJumioFlowAsFinishedMutation: 'MarkJumioFlowAsFinishedMutation' as const,
    ChannelAutoSyncMutation: 'ChannelAutoSyncMutation' as const,
    IgnoreOrdersMutation: 'IgnoreOrdersMutation' as const,
    TriggerChannelSyncMutation: 'TriggerChannelSyncMutation' as const,
    UnignoreOrdersMutation: 'UnignoreOrdersMutation' as const,
    DeleteChannelMutation: 'DeleteChannelMutation' as const,
    DisableChannelMutation: 'DisableChannelMutation' as const,
    EnableChannelMutation: 'EnableChannelMutation' as const,
    ConnectWoocommerceMutation: 'ConnectWoocommerceMutation' as const,
    CreateBigcommerceMutation: 'CreateBigcommerceMutation' as const,
    CreateCratejoyMutation: 'CreateCratejoyMutation' as const,
    CreateDiscogsMutation: 'CreateDiscogsMutation' as const,
    CreateFakeshopMutation: 'CreateFakeshopMutation' as const,
    CreateSquarespaceMutation: 'CreateSquarespaceMutation' as const,
    CreateSubblyMutation: 'CreateSubblyMutation' as const,
    UpdateBigcartelMutation: 'UpdateBigcartelMutation' as const,
    UpdateBigcommerceMutation: 'UpdateBigcommerceMutation' as const,
    UpdateCratejoyMutation: 'UpdateCratejoyMutation' as const,
    UpdateDiscogsMutation: 'UpdateDiscogsMutation' as const,
    UpdateEbayMutation: 'UpdateEbayMutation' as const,
    UpdateEcwidMutation: 'UpdateEcwidMutation' as const,
    UpdateEtsyMutation: 'UpdateEtsyMutation' as const,
    UpdateFakeshopMutation: 'UpdateFakeshopMutation' as const,
    UpdatePaypalMutation: 'UpdatePaypalMutation' as const,
    UpdateShopifyMutation: 'UpdateShopifyMutation' as const,
    UpdateSquareMutation: 'UpdateSquareMutation' as const,
    UpdateSquarespaceMutation: 'UpdateSquarespaceMutation' as const,
    UpdateSubblyMutation: 'UpdateSubblyMutation' as const,
    UpdateWixMutation: 'UpdateWixMutation' as const,
    UpdateWoocommerceMutation: 'UpdateWoocommerceMutation' as const,
    AcceptTermsMutation: 'AcceptTermsMutation' as const,
    DownloadMobileCodeForShipment: 'DownloadMobileCodeForShipment' as const,
    DownloadMobileCodesForBatch: 'DownloadMobileCodesForBatch' as const,
    AddCreditToPaymentSource: 'AddCreditToPaymentSource' as const,
    CreateCcPaymentSourceMutation: 'CreateCcPaymentSourceMutation' as const,
    CreatePayPalPaymentSourceMutation: 'CreatePayPalPaymentSourceMutation' as const,
    CreatePlaidAccessTokenMutation: 'CreatePlaidAccessTokenMutation' as const,
    CreatePlaidActivationMutation: 'CreatePlaidActivationMutation' as const,
    CreatePlaidConsentMutation: 'CreatePlaidConsentMutation' as const,
    CreatePlaidValidationActivationMutation: 'CreatePlaidValidationActivationMutation' as const,
    CreateVenmoPaymentSourceMutation: 'CreateVenmoPaymentSourceMutation' as const,
    DeletePaymentSourceMutation: 'DeletePaymentSourceMutation' as const,
    RefundCreditFromPaymentSource: 'RefundCreditFromPaymentSource' as const,
    resetNickname: 'resetNickname' as const,
    SetDefaultPaymentSourceMutation: 'SetDefaultPaymentSourceMutation' as const,
    SetPaymentSourceNicknameMutation: 'SetPaymentSourceNicknameMutation' as const,
    CancelPickupMutation: 'CancelPickupMutation' as const,
    RatePickupMutation: 'RatePickupMutation' as const,
    RequestPickupMutation: 'RequestPickupMutation' as const,
    GenerateOrGetShareLinkMutation: 'GenerateOrGetShareLinkMutation' as const,
    TriggerDownloadLabelsByBatchesMutation: 'TriggerDownloadLabelsByBatchesMutation' as const,
    TriggerDownloadLabelsByShareTokenMutation: 'TriggerDownloadLabelsByShareTokenMutation' as const,
    TriggerDownloadLabelsByShipmentsMutation: 'TriggerDownloadLabelsByShipmentsMutation' as const,
    RefundBatchMutation: 'RefundBatchMutation' as const,
    RefundShipmentMutation: 'RefundShipmentMutation' as const,
    CreateScanFormMutation: 'CreateScanFormMutation' as const,
    CreateScanFormByBatchMutation: 'CreateScanFormByBatchMutation' as const,
    AbortChallengeMutation: 'AbortChallengeMutation' as const,
    SucceedAtChallengeMutation: 'SucceedAtChallengeMutation' as const,
    CompleteBatchFromUploadMutation: 'CompleteBatchFromUploadMutation' as const,
    CreateBatchFromImportMutation: 'CreateBatchFromImportMutation' as const,
    CreateBatchFromSingleShipmentMutation: 'CreateBatchFromSingleShipmentMutation' as const,
    CreateBatchFromUploadMutation: 'CreateBatchFromUploadMutation' as const,
    CreateScopedShipmentPreset: 'CreateScopedShipmentPreset' as const,
    DeleteShipmentPresetMutation: 'DeleteShipmentPresetMutation' as const,
    DeleteSuggestedAddressMutation: 'DeleteSuggestedAddressMutation' as const,
    DeleteWarehouseMutation: 'DeleteWarehouseMutation' as const,
    HideHistoricShipmentAddressesMutation: 'HideHistoricShipmentAddressesMutation' as const,
    SetDefaultWarehouseMutation: 'SetDefaultWarehouseMutation' as const,
    UpdateWarehouseMutation: 'UpdateWarehouseMutation' as const,
    cancelEmailNotification: 'cancelEmailNotification' as const,
    CreateMailTemplateMutation: 'CreateMailTemplateMutation' as const,
    CreateSenderEmailMetadataMutation: 'CreateSenderEmailMetadataMutation' as const,
    DeleteMailTemplateMutation: 'DeleteMailTemplateMutation' as const,
    FetchSenderEmailMetadataMutation: 'FetchSenderEmailMetadataMutation' as const,
    SendPreviewEmailMutation: 'SendPreviewEmailMutation' as const,
    UpdateDefaultTrackingEmailsDelay: 'UpdateDefaultTrackingEmailsDelay' as const,
    UpdateDefaultTrackingEmailsEnabled: 'UpdateDefaultTrackingEmailsEnabled' as const,
    updateEmailNotification: 'updateEmailNotification' as const,
    UpdateMailTemplateMutation: 'UpdateMailTemplateMutation' as const,
    UpdateSenderEmailMetadataMutation: 'UpdateSenderEmailMetadataMutation' as const,
    UpdateTrackingEmailBrandingEnabledMutation:
      'UpdateTrackingEmailBrandingEnabledMutation' as const,
    BuyRedirectPackageToNewAddressMutation: 'BuyRedirectPackageToNewAddressMutation' as const,
    BuyReturnPackageToSenderMutation: 'BuyReturnPackageToSenderMutation' as const,
    SendUserEmailVerificationLinkMutation: 'SendUserEmailVerificationLinkMutation' as const,
    CreateUserMutation: 'CreateUserMutation' as const,
    DeleteUserMutation: 'DeleteUserMutation' as const,
    ResendUserInvitation: 'ResendUserInvitation' as const,
  },
  Fragment: {
    RateGroupsFragment: 'RateGroupsFragment' as const,
    AddressFragment: 'AddressFragment' as const,
    BasicPlatformFragment: 'BasicPlatformFragment' as const,
    BasicUserFragment: 'BasicUserFragment' as const,
    CountryFragment: 'CountryFragment' as const,
    CurrentUserFragment: 'CurrentUserFragment' as const,
    DataGridResultUserSettingsFragment: 'DataGridResultUserSettingsFragment' as const,
    DataGridSettingsFragment: 'DataGridSettingsFragment' as const,
    MerchantAccountFragment: 'MerchantAccountFragment' as const,
    PackageFragment: 'PackageFragment' as const,
    RateSummaryFragment: 'RateSummaryFragment' as const,
    RegionFragment: 'RegionFragment' as const,
    RunningProcessFragment: 'RunningProcessFragment' as const,
    ShipmentPresetFragment: 'ShipmentPresetFragment' as const,
    ShipmentStatusSummaryFragment: 'ShipmentStatusSummaryFragment' as const,
    WarehouseFragment: 'WarehouseFragment' as const,
    ChannelFragment: 'ChannelFragment' as const,
    MappingFragment: 'MappingFragment' as const,
    BigcartelFragment: 'BigcartelFragment' as const,
    BigcommerceFragment: 'BigcommerceFragment' as const,
    CratejoyFragment: 'CratejoyFragment' as const,
    DiscogsFragment: 'DiscogsFragment' as const,
    EbayFragment: 'EbayFragment' as const,
    EcwidFragment: 'EcwidFragment' as const,
    EtsyFragment: 'EtsyFragment' as const,
    FakeshopFragment: 'FakeshopFragment' as const,
    PaypalFragment: 'PaypalFragment' as const,
    ShopifyFragment: 'ShopifyFragment' as const,
    SquareFragment: 'SquareFragment' as const,
    SquarespaceFragment: 'SquarespaceFragment' as const,
    SubblyFragment: 'SubblyFragment' as const,
    WixFragment: 'WixFragment' as const,
    WoocommerceFragment: 'WoocommerceFragment' as const,
    PaymentApiMethodFragment: 'PaymentApiMethodFragment' as const,
    PaymentSourceFragment: 'PaymentSourceFragment' as const,
    PickupFragment: 'PickupFragment' as const,
    MailTemplateFragment: 'MailTemplateFragment' as const,
    SenderEmailMetadataFragment: 'SenderEmailMetadataFragment' as const,
    CompanyUserFragment: 'CompanyUserFragment' as const,
  },
};
export type AccountingTransactionKeySpecifier = (
  | 'amount'
  | 'balance'
  | 'batchId'
  | 'carrierId'
  | 'companyId'
  | 'createdAt'
  | 'identifier'
  | 'isMoneyTransferred'
  | 'isProfit'
  | 'isTopLevel'
  | 'moreLink'
  | 'note'
  | 'paymentId'
  | 'pickupRequestId'
  | 'reconciliationAdjustmentId'
  | 'reconciliationRunId'
  | 'referenceId'
  | 'shipmentId'
  | 'timestamp'
  | 'title'
  | 'transactionCount'
  | 'transactionType'
  | 'updatedAt'
  | 'userId'
  | AccountingTransactionKeySpecifier
)[];
export type AccountingTransactionFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  balance?: FieldPolicy<any> | FieldReadFunction<any>;
  batchId?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierId?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  isMoneyTransferred?: FieldPolicy<any> | FieldReadFunction<any>;
  isProfit?: FieldPolicy<any> | FieldReadFunction<any>;
  isTopLevel?: FieldPolicy<any> | FieldReadFunction<any>;
  moreLink?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentId?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupRequestId?: FieldPolicy<any> | FieldReadFunction<any>;
  reconciliationAdjustmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  reconciliationRunId?: FieldPolicy<any> | FieldReadFunction<any>;
  referenceId?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  transactionCount?: FieldPolicy<any> | FieldReadFunction<any>;
  transactionType?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddressKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'addressType'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'fullName'
  | 'id'
  | 'location'
  | 'origin'
  | 'originalId'
  | 'phone'
  | 'poBox'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'timeZone'
  | 'valid'
  | 'validationError'
  | 'warehouse'
  | 'zip4'
  | AddressKeySpecifier
)[];
export type AddressFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  addressType?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  origin?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  poBox?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  timeZone?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  validationError?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddressAutocompleteSettingsKeySpecifier = (
  | 'apiKey'
  | 'provider'
  | AddressAutocompleteSettingsKeySpecifier
)[];
export type AddressAutocompleteSettingsFieldPolicy = {
  apiKey?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddressInterfaceKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'addressType'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'fullName'
  | 'id'
  | 'location'
  | 'origin'
  | 'originalId'
  | 'phone'
  | 'poBox'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'timeZone'
  | 'valid'
  | 'validationError'
  | 'warehouse'
  | 'zip4'
  | AddressInterfaceKeySpecifier
)[];
export type AddressInterfaceFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  addressType?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  origin?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  poBox?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  timeZone?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  validationError?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdjustmentReasonKeySpecifier = (
  | 'description'
  | 'explanation'
  | 'reference'
  | 'type'
  | AdjustmentReasonKeySpecifier
)[];
export type AdjustmentReasonFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  explanation?: FieldPolicy<any> | FieldReadFunction<any>;
  reference?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdjustmentReasonReferenceKeySpecifier = (
  | 'type'
  | 'value'
  | AdjustmentReasonReferenceKeySpecifier
)[];
export type AdjustmentReasonReferenceFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplicationConfigurationKeySpecifier = (
  | 'datadogBrowserLoggingEnabled'
  | 'datadogBrowserMonitoringEnabled'
  | 'datadogClientToken'
  | 'datadogRumApplicationId'
  | 'inAppIdentityVerificationEnabled'
  | 'intercomAppId'
  | 'intercomEnabled'
  | 'loginWithGoogleEnabled'
  | 'turnstileEnabled'
  | 'turnstilePublicKey'
  | ApplicationConfigurationKeySpecifier
)[];
export type ApplicationConfigurationFieldPolicy = {
  datadogBrowserLoggingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  datadogBrowserMonitoringEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  datadogClientToken?: FieldPolicy<any> | FieldReadFunction<any>;
  datadogRumApplicationId?: FieldPolicy<any> | FieldReadFunction<any>;
  inAppIdentityVerificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  intercomAppId?: FieldPolicy<any> | FieldReadFunction<any>;
  intercomEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  loginWithGoogleEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  turnstileEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  turnstilePublicKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssociatedCompanyKeySpecifier = ('address' | 'title' | AssociatedCompanyKeySpecifier)[];
export type AssociatedCompanyFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BasicAddressKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'fullName'
  | 'phone'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'valid'
  | 'zip4'
  | BasicAddressKeySpecifier
)[];
export type BasicAddressFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BasicAddressInterfaceKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'fullName'
  | 'phone'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'valid'
  | 'zip4'
  | BasicAddressInterfaceKeySpecifier
)[];
export type BasicAddressInterfaceFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BatchKeySpecifier = (
  | 'canCreateLabels'
  | 'canCreateMobileCodes'
  | 'canInstantRefundBatch'
  | 'canRefund'
  | 'carrierLogoClasses'
  | 'cleanupComplete'
  | 'cleanupOriginal'
  | 'containedMailClassGroupKeys'
  | 'containsGroundSaver'
  | 'createdAt'
  | 'customsFormRequired'
  | 'customsFormRequiredForAllShipments'
  | 'customsFormSummary'
  | 'dataSource'
  | 'defaultShipDate'
  | 'deleted'
  | 'dockOrderIds'
  | 'eligibleForInsurance'
  | 'emailNotificationPossible'
  | 'emailNotificationSent'
  | 'emailNotificationStatus'
  | 'emailNotificationTemplate'
  | 'failedShipmentsExportStatus'
  | 'hasBeenDownloaded'
  | 'id'
  | 'labelFileFormat'
  | 'labelSize'
  | 'labelingArtifactType'
  | 'notifyRecipientsDate'
  | 'numShipments'
  | 'originAddress'
  | 'packageSummary'
  | 'percentageDelivered'
  | 'priceSummary'
  | 'rateGroups'
  | 'refundSuccessMessages'
  | 'returnAddress'
  | 'rubberStamps'
  | 'runningProcess'
  | 'shipDate'
  | 'shipDatePossibleNow'
  | 'shipmentStatusSummary'
  | 'shipments'
  | 'spreadsheetMapping'
  | 'status'
  | 'statusText'
  | 'step'
  | 'stepText'
  | 'title'
  | 'trackingDataGrid'
  | 'upload'
  | 'warehouse'
  | BatchKeySpecifier
)[];
export type BatchFieldPolicy = {
  canCreateLabels?: FieldPolicy<any> | FieldReadFunction<any>;
  canCreateMobileCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  canInstantRefundBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  canRefund?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierLogoClasses?: FieldPolicy<any> | FieldReadFunction<any>;
  cleanupComplete?: FieldPolicy<any> | FieldReadFunction<any>;
  cleanupOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  containedMailClassGroupKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  containsGroundSaver?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormRequiredForAllShipments?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  dataSource?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultShipDate?: FieldPolicy<any> | FieldReadFunction<any>;
  deleted?: FieldPolicy<any> | FieldReadFunction<any>;
  dockOrderIds?: FieldPolicy<any> | FieldReadFunction<any>;
  eligibleForInsurance?: FieldPolicy<any> | FieldReadFunction<any>;
  emailNotificationPossible?: FieldPolicy<any> | FieldReadFunction<any>;
  emailNotificationSent?: FieldPolicy<any> | FieldReadFunction<any>;
  emailNotificationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  emailNotificationTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  failedShipmentsExportStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBeenDownloaded?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labelFileFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  labelSize?: FieldPolicy<any> | FieldReadFunction<any>;
  labelingArtifactType?: FieldPolicy<any> | FieldReadFunction<any>;
  notifyRecipientsDate?: FieldPolicy<any> | FieldReadFunction<any>;
  numShipments?: FieldPolicy<any> | FieldReadFunction<any>;
  originAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  packageSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  percentageDelivered?: FieldPolicy<any> | FieldReadFunction<any>;
  priceSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  rateGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  refundSuccessMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  returnAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamps?: FieldPolicy<any> | FieldReadFunction<any>;
  runningProcess?: FieldPolicy<any> | FieldReadFunction<any>;
  shipDate?: FieldPolicy<any> | FieldReadFunction<any>;
  shipDatePossibleNow?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentStatusSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  shipments?: FieldPolicy<any> | FieldReadFunction<any>;
  spreadsheetMapping?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusText?: FieldPolicy<any> | FieldReadFunction<any>;
  step?: FieldPolicy<any> | FieldReadFunction<any>;
  stepText?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingDataGrid?: FieldPolicy<any> | FieldReadFunction<any>;
  upload?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BatchCustomsFormSummaryKeySpecifier = (
  | 'contentType'
  | 'exporterTaxIdSummary'
  | 'itemSummary'
  | 'numCustomsForms'
  | 'signer'
  | 'title'
  | BatchCustomsFormSummaryKeySpecifier
)[];
export type BatchCustomsFormSummaryFieldPolicy = {
  contentType?: FieldPolicy<any> | FieldReadFunction<any>;
  exporterTaxIdSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  itemSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  numCustomsForms?: FieldPolicy<any> | FieldReadFunction<any>;
  signer?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BatchPackageSummaryKeySpecifier = (
  | 'deliveryConfirmationSummary'
  | 'dimensionsSummary'
  | 'maxInsured'
  | 'maxWeight'
  | 'minInsured'
  | 'minWeight'
  | 'packagePreset'
  | 'packageTypeSummary'
  | BatchPackageSummaryKeySpecifier
)[];
export type BatchPackageSummaryFieldPolicy = {
  deliveryConfirmationSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionsSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  maxInsured?: FieldPolicy<any> | FieldReadFunction<any>;
  maxWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  minInsured?: FieldPolicy<any> | FieldReadFunction<any>;
  minWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  packagePreset?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeSummary?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BatchPriceSummaryKeySpecifier = (
  | 'averagePrice'
  | 'carrierKeys'
  | 'isRefunded'
  | 'isReturnLabel'
  | 'pirateShipService'
  | 'returnsUsed'
  | 'samePriceForAll'
  | 'shipmentCount'
  | 'surcharge'
  | 'title'
  | 'totalPrice'
  | 'usedReturnPrice'
  | BatchPriceSummaryKeySpecifier
)[];
export type BatchPriceSummaryFieldPolicy = {
  averagePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  isRefunded?: FieldPolicy<any> | FieldReadFunction<any>;
  isReturnLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  pirateShipService?: FieldPolicy<any> | FieldReadFunction<any>;
  returnsUsed?: FieldPolicy<any> | FieldReadFunction<any>;
  samePriceForAll?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
  surcharge?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  usedReturnPrice?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BatchProcessKeySpecifier = (
  | 'itemsInProgressCount'
  | 'itemsTotalCount'
  | 'key'
  | 'processKey'
  | 'progressPercentage'
  | 'progressTitle'
  | 'secondsLeft'
  | 'status'
  | BatchProcessKeySpecifier
)[];
export type BatchProcessFieldPolicy = {
  itemsInProgressCount?: FieldPolicy<any> | FieldReadFunction<any>;
  itemsTotalCount?: FieldPolicy<any> | FieldReadFunction<any>;
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  processKey?: FieldPolicy<any> | FieldReadFunction<any>;
  progressPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  progressTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  secondsLeft?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BigcartelChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'plan'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | BigcartelChannelKeySpecifier
)[];
export type BigcartelChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  plan?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BigcommerceChannelKeySpecifier = (
  | 'active'
  | 'apiUrl'
  | 'autoSyncEnabled'
  | 'clientSecret'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | BigcommerceChannelKeySpecifier
)[];
export type BigcommerceChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  apiUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BlockedCountryKeySpecifier = (
  | 'blockReason'
  | 'twoCharIsoCode'
  | BlockedCountryKeySpecifier
)[];
export type BlockedCountryFieldPolicy = {
  blockReason?: FieldPolicy<any> | FieldReadFunction<any>;
  twoCharIsoCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CarrierKeySpecifier = (
  | 'allowedPickupDateCutOff'
  | 'allowedPickupDates'
  | 'carrierKey'
  | 'createdAt'
  | 'id'
  | 'mailClasses'
  | 'packageTypes'
  | 'title'
  | 'updatedAt'
  | CarrierKeySpecifier
)[];
export type CarrierFieldPolicy = {
  allowedPickupDateCutOff?: FieldPolicy<any> | FieldReadFunction<any>;
  allowedPickupDates?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierKey?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClasses?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CarrierMailClassKeySpecifier = (
  | 'accuracy'
  | 'averageDeliveryDays'
  | 'carrierTitle'
  | 'createdAt'
  | 'groupKey'
  | 'id'
  | 'international'
  | 'mailClassKey'
  | 'serviceLevel'
  | 'sortOrder'
  | 'title'
  | 'updatedAt'
  | CarrierMailClassKeySpecifier
)[];
export type CarrierMailClassFieldPolicy = {
  accuracy?: FieldPolicy<any> | FieldReadFunction<any>;
  averageDeliveryDays?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  groupKey?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  international?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassKey?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceLevel?: FieldPolicy<any> | FieldReadFunction<any>;
  sortOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CarrierPackageTypeKeySpecifier = (
  | 'carrierId'
  | 'description'
  | 'dimensionsRequired'
  | 'heightRequired'
  | 'id'
  | 'packageTypeKey'
  | 'title'
  | 'weightRequired'
  | CarrierPackageTypeKeySpecifier
)[];
export type CarrierPackageTypeFieldPolicy = {
  carrierId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionsRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  heightRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  weightRequired?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChallengeKeySpecifier = (
  | 'action'
  | 'createdAt'
  | 'id'
  | 'key'
  | ChallengeKeySpecifier
)[];
export type ChallengeFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  key?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChallengeStateKeySpecifier = ('isCompleted' | 'key' | ChallengeStateKeySpecifier)[];
export type ChallengeStateFieldPolicy = {
  isCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
  key?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'title'
  | 'updatedAt'
  | 'valid'
  | ChannelKeySpecifier
)[];
export type ChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChannelInterfaceKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'title'
  | 'updatedAt'
  | 'valid'
  | ChannelInterfaceKeySpecifier
)[];
export type ChannelInterfaceFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChannelRubberstampConfigKeySpecifier = (
  | 'configuredField'
  | 'rubberstamp'
  | ChannelRubberstampConfigKeySpecifier
)[];
export type ChannelRubberstampConfigFieldPolicy = {
  configuredField?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChannelSyncKeySpecifier = (
  | 'date'
  | 'info'
  | 'message'
  | 'status'
  | ChannelSyncKeySpecifier
)[];
export type ChannelSyncFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  info?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChartKeySpecifier = ('charts' | 'colors' | 'labels' | ChartKeySpecifier)[];
export type ChartFieldPolicy = {
  charts?: FieldPolicy<any> | FieldReadFunction<any>;
  colors?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClaimInsuranceLinkResultKeySpecifier = ('url' | ClaimInsuranceLinkResultKeySpecifier)[];
export type ClaimInsuranceLinkResultFieldPolicy = {
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyKeySpecifier = (
  | 'accountBalance'
  | 'activeCarriers'
  | 'activePaymentMethods'
  | 'address'
  | 'channels'
  | 'createdAt'
  | 'debuggingEnabled'
  | 'email'
  | 'emulating'
  | 'features'
  | 'fraudScore'
  | 'fraudStatus'
  | 'hasAnyPlaidPaymentSource'
  | 'id'
  | 'isFirstLabel'
  | 'isSuspended'
  | 'mailTemplates'
  | 'merchantAccounts'
  | 'paymentSources'
  | 'phone'
  | 'pickupSummary'
  | 'pickups'
  | 'preferredMerchantAccountAddress'
  | 'settings'
  | 'shipmentPresets'
  | 'shipmentSummary'
  | 'title'
  | 'updatedAt'
  | 'warehouses'
  | CompanyKeySpecifier
)[];
export type CompanyFieldPolicy = {
  accountBalance?: FieldPolicy<any> | FieldReadFunction<any>;
  activeCarriers?: FieldPolicy<any> | FieldReadFunction<any>;
  activePaymentMethods?: FieldPolicy<any> | FieldReadFunction<any>;
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  debuggingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  emulating?: FieldPolicy<any> | FieldReadFunction<any>;
  features?: FieldPolicy<any> | FieldReadFunction<any>;
  fraudScore?: FieldPolicy<any> | FieldReadFunction<any>;
  fraudStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  hasAnyPlaidPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isFirstLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  isSuspended?: FieldPolicy<any> | FieldReadFunction<any>;
  mailTemplates?: FieldPolicy<any> | FieldReadFunction<any>;
  merchantAccounts?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSources?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  pickups?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredMerchantAccountAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentPresets?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouses?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanySettingsKeySpecifier = (
  | 'addressCorrection'
  | 'areMobileCodesEnabled'
  | 'defaultChargeAmount'
  | 'defaultDestinationCountryCode'
  | 'defaultEmailTemplateId'
  | 'defaultPaymentSourceId'
  | 'defaultShipmentPresetId'
  | 'defaultTrackingEmailsDelay'
  | 'defaultTrackingEmailsEnabled'
  | 'defaultWarehouseId'
  | 'packingListTemplate'
  | 'shipmentLabelFileFormat'
  | 'shipmentLabelFormat'
  | 'shipmentLabelSize'
  | 'shipmentSpreadsheetFormat'
  | 'showLogoOnLabel'
  | 'trackingEmailBrandingEnabled'
  | CompanySettingsKeySpecifier
)[];
export type CompanySettingsFieldPolicy = {
  addressCorrection?: FieldPolicy<any> | FieldReadFunction<any>;
  areMobileCodesEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultChargeAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultDestinationCountryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultEmailTemplateId?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultPaymentSourceId?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultShipmentPresetId?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultTrackingEmailsDelay?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultTrackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultWarehouseId?: FieldPolicy<any> | FieldReadFunction<any>;
  packingListTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentLabelFileFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentLabelFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentLabelSize?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentSpreadsheetFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  showLogoOnLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailBrandingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyUserKeySpecifier = (
  | 'email'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'status'
  | CompanyUserKeySpecifier
)[];
export type CompanyUserFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CountryKeySpecifier = (
  | 'id'
  | 'isoAlpha2Code'
  | 'isoAlpha3Code'
  | 'isoNumericCode'
  | 'name'
  | 'parentCountry'
  | 'postcodeRequired'
  | CountryKeySpecifier
)[];
export type CountryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isoAlpha2Code?: FieldPolicy<any> | FieldReadFunction<any>;
  isoAlpha3Code?: FieldPolicy<any> | FieldReadFunction<any>;
  isoNumericCode?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentCountry?: FieldPolicy<any> | FieldReadFunction<any>;
  postcodeRequired?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CountryDistributionChartKeySpecifier = (
  | 'countryDistributions'
  | 'totalCount'
  | CountryDistributionChartKeySpecifier
)[];
export type CountryDistributionChartFieldPolicy = {
  countryDistributions?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CratejoyChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'clientId'
  | 'clientSecret'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'skipFutureSubscriptions'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | CratejoyChannelKeySpecifier
)[];
export type CratejoyChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clientId?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  skipFutureSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePaymentSourceResponseKeySpecifier = (
  | 'isDefault'
  | 'paymentSource'
  | CreatePaymentSourceResponseKeySpecifier
)[];
export type CreatePaymentSourceResponseFieldPolicy = {
  isDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePaymentSourceResultKeySpecifier = (
  | 'default'
  | 'paymentSource'
  | CreatePaymentSourceResultKeySpecifier
)[];
export type CreatePaymentSourceResultFieldPolicy = {
  default?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateShipmentPresetResultKeySpecifier = (
  | 'default'
  | 'shipmentPreset'
  | CreateShipmentPresetResultKeySpecifier
)[];
export type CreateShipmentPresetResultFieldPolicy = {
  default?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomOptionKeySpecifier = (
  | 'channelId'
  | 'createdAt'
  | 'id'
  | 'name'
  | 'override'
  | 'sourceKey'
  | 'status'
  | 'updatedAt'
  | 'valueType'
  | CustomOptionKeySpecifier
)[];
export type CustomOptionFieldPolicy = {
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  override?: FieldPolicy<any> | FieldReadFunction<any>;
  sourceKey?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valueType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomsItemKeySpecifier = (
  | 'countryCodeOfOrigin'
  | 'createdAt'
  | 'hsTariffNumber'
  | 'id'
  | 'itemValue'
  | 'quantity'
  | 'title'
  | 'updatedAt'
  | 'weight'
  | CustomsItemKeySpecifier
)[];
export type CustomsItemFieldPolicy = {
  countryCodeOfOrigin?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  hsTariffNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  itemValue?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridColumnKeySpecifier = (
  | 'alternativeSortingField'
  | 'exactMatch'
  | 'field'
  | 'hidden'
  | 'label'
  | 'multiCheck'
  | 'sortable'
  | 'type'
  | 'width'
  | DataGridColumnKeySpecifier
)[];
export type DataGridColumnFieldPolicy = {
  alternativeSortingField?: FieldPolicy<any> | FieldReadFunction<any>;
  exactMatch?: FieldPolicy<any> | FieldReadFunction<any>;
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  hidden?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  multiCheck?: FieldPolicy<any> | FieldReadFunction<any>;
  sortable?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  width?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridColumnOverrideKeySpecifier = (
  | 'field'
  | 'hidden'
  | 'width'
  | DataGridColumnOverrideKeySpecifier
)[];
export type DataGridColumnOverrideFieldPolicy = {
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  hidden?: FieldPolicy<any> | FieldReadFunction<any>;
  width?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridExportStatusKeySpecifier = (
  | 'downloadable'
  | 'expire'
  | 'exportId'
  | 'filename'
  | 'url'
  | DataGridExportStatusKeySpecifier
)[];
export type DataGridExportStatusFieldPolicy = {
  downloadable?: FieldPolicy<any> | FieldReadFunction<any>;
  expire?: FieldPolicy<any> | FieldReadFunction<any>;
  exportId?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridFilterKeySpecifier = (
  | 'field'
  | 'operator'
  | 'values'
  | DataGridFilterKeySpecifier
)[];
export type DataGridFilterFieldPolicy = {
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridFilterOptionKeySpecifier = (
  | 'count'
  | 'disabled'
  | 'label'
  | 'value'
  | DataGridFilterOptionKeySpecifier
)[];
export type DataGridFilterOptionFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridMetaDataKeySpecifier = ('key' | 'value' | DataGridMetaDataKeySpecifier)[];
export type DataGridMetaDataFieldPolicy = {
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridResultKeySpecifier = (
  | 'columns'
  | 'exportAllowed'
  | 'exportUrl'
  | 'gridActions'
  | 'id'
  | 'localFiltersEnabled'
  | 'maxPageSize'
  | 'metaData'
  | 'multiCheckOptions'
  | 'rowActions'
  | 'rows'
  | 'staticFilters'
  | 'userSettings'
  | DataGridResultKeySpecifier
)[];
export type DataGridResultFieldPolicy = {
  columns?: FieldPolicy<any> | FieldReadFunction<any>;
  exportAllowed?: FieldPolicy<any> | FieldReadFunction<any>;
  exportUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  gridActions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  localFiltersEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  maxPageSize?: FieldPolicy<any> | FieldReadFunction<any>;
  metaData?: FieldPolicy<any> | FieldReadFunction<any>;
  multiCheckOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  rowActions?: FieldPolicy<any> | FieldReadFunction<any>;
  rows?: FieldPolicy<any> | FieldReadFunction<any>;
  staticFilters?: FieldPolicy<any> | FieldReadFunction<any>;
  userSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridResultRowsKeySpecifier = (
  | 'checkableIds'
  | 'nodes'
  | 'totalCount'
  | DataGridResultRowsKeySpecifier
)[];
export type DataGridResultRowsFieldPolicy = {
  checkableIds?: FieldPolicy<any> | FieldReadFunction<any>;
  nodes?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridRowActionKeySpecifier = (
  | 'fullWidth'
  | 'id'
  | 'label'
  | 'variant'
  | DataGridRowActionKeySpecifier
)[];
export type DataGridRowActionFieldPolicy = {
  fullWidth?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  variant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridSettingsKeySpecifier = (
  | 'columnOrder'
  | 'columns'
  | 'pageSize'
  | 'sorting'
  | DataGridSettingsKeySpecifier
)[];
export type DataGridSettingsFieldPolicy = {
  columnOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  columns?: FieldPolicy<any> | FieldReadFunction<any>;
  pageSize?: FieldPolicy<any> | FieldReadFunction<any>;
  sorting?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DataGridSortingKeySpecifier = ('direction' | 'field' | DataGridSortingKeySpecifier)[];
export type DataGridSortingFieldPolicy = {
  direction?: FieldPolicy<any> | FieldReadFunction<any>;
  field?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DateTimeRangeKeySpecifier = (
  | 'endDatetime'
  | 'startDatetime'
  | DateTimeRangeKeySpecifier
)[];
export type DateTimeRangeFieldPolicy = {
  endDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  startDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeliveryEstimationKeySpecifier = (
  | 'arrivalLocalDateTime'
  | 'pickupLocalDateTime'
  | DeliveryEstimationKeySpecifier
)[];
export type DeliveryEstimationFieldPolicy = {
  arrivalLocalDateTime?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupLocalDateTime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DiscogsChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'clientSecret'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | DiscogsChannelKeySpecifier
)[];
export type DiscogsChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DistributionChartItemKeySpecifier = (
  | 'count'
  | 'key'
  | 'name'
  | 'percent'
  | 'price'
  | DistributionChartItemKeySpecifier
)[];
export type DistributionChartItemFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  percent?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DockOrderKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'address3'
  | 'addressType'
  | 'channelId'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'countryId'
  | 'coupon'
  | 'email'
  | 'foreignOrderId'
  | 'fullName'
  | 'id'
  | 'location'
  | 'orderItemsText'
  | 'orderLink'
  | 'orderValue'
  | 'origin'
  | 'originalId'
  | 'phone'
  | 'platform'
  | 'platformKey'
  | 'platformLinks'
  | 'poBox'
  | 'postcode'
  | 'regionCode'
  | 'regionId'
  | 'residential'
  | 'rubberStamp1'
  | 'rubberStamp2'
  | 'rubberStamp3'
  | 'shipmentLink'
  | 'subscriptionLink'
  | 'timeZone'
  | 'valid'
  | 'validationError'
  | 'warehouse'
  | 'weight'
  | 'zip4'
  | DockOrderKeySpecifier
)[];
export type DockOrderFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  address3?: FieldPolicy<any> | FieldReadFunction<any>;
  addressType?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  countryId?: FieldPolicy<any> | FieldReadFunction<any>;
  coupon?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  foreignOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  orderItemsText?: FieldPolicy<any> | FieldReadFunction<any>;
  orderLink?: FieldPolicy<any> | FieldReadFunction<any>;
  orderValue?: FieldPolicy<any> | FieldReadFunction<any>;
  origin?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  platformKey?: FieldPolicy<any> | FieldReadFunction<any>;
  platformLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  poBox?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionId?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp1?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp2?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp3?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentLink?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionLink?: FieldPolicy<any> | FieldReadFunction<any>;
  timeZone?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  validationError?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EbayChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'updatedAt'
  | 'valid'
  | EbayChannelKeySpecifier
)[];
export type EbayChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EcwidChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customFulfillmentStatuses'
  | 'customFulfillmentStatusesToImport'
  | 'customOptions'
  | 'customPaymentStatuses'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'username'
  | 'valid'
  | EcwidChannelKeySpecifier
)[];
export type EcwidChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customFulfillmentStatuses?: FieldPolicy<any> | FieldReadFunction<any>;
  customFulfillmentStatusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  customPaymentStatuses?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  username?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EcwidOrderStatusKeySpecifier = ('id' | 'name' | EcwidOrderStatusKeySpecifier)[];
export type EcwidOrderStatusFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EcwidOrderStatusImplKeySpecifier = ('id' | 'name' | EcwidOrderStatusImplKeySpecifier)[];
export type EcwidOrderStatusImplFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmailTemplateKeySpecifier = (
  | 'html'
  | 'plainText'
  | 'subject'
  | EmailTemplateKeySpecifier
)[];
export type EmailTemplateFieldPolicy = {
  html?: FieldPolicy<any> | FieldReadFunction<any>;
  plainText?: FieldPolicy<any> | FieldReadFunction<any>;
  subject?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EtsyChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | EtsyChannelKeySpecifier
)[];
export type EtsyChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FakeshopChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'orderGroups'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'title'
  | 'updatedAt'
  | 'valid'
  | FakeshopChannelKeySpecifier
)[];
export type FakeshopChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  orderGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FeatureKeySpecifier = ('key' | 'value' | FeatureKeySpecifier)[];
export type FeatureFieldPolicy = {
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FlashMessageKeySpecifier = ('message' | 'variant' | FlashMessageKeySpecifier)[];
export type FlashMessageFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  variant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GlobalSettingsKeySpecifier = ('emailTemplate' | GlobalSettingsKeySpecifier)[];
export type GlobalSettingsFieldPolicy = {
  emailTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HistoricShipmentAddressKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'email'
  | 'fullName'
  | 'ids'
  | 'phone'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'valid'
  | 'zip4'
  | HistoricShipmentAddressKeySpecifier
)[];
export type HistoricShipmentAddressFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  ids?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IgnoreOrderResultKeySpecifier = (
  | 'count'
  | 'ids'
  | 'success'
  | IgnoreOrderResultKeySpecifier
)[];
export type IgnoreOrderResultFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  ids?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InstallTwoFactorAuthenticationResultTypeKeySpecifier = (
  | 'secret'
  | 'user'
  | InstallTwoFactorAuthenticationResultTypeKeySpecifier
)[];
export type InstallTwoFactorAuthenticationResultTypeFieldPolicy = {
  secret?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InsuranceDetailsTypeKeySpecifier = (
  | 'hasOnlyCarrierLiabilityInsurance'
  | 'insuranceSurcharge'
  | 'insuredValue'
  | 'insuredValueRequested'
  | 'insuredValueType'
  | 'isShippingCostInsured'
  | InsuranceDetailsTypeKeySpecifier
)[];
export type InsuranceDetailsTypeFieldPolicy = {
  hasOnlyCarrierLiabilityInsurance?: FieldPolicy<any> | FieldReadFunction<any>;
  insuranceSurcharge?: FieldPolicy<any> | FieldReadFunction<any>;
  insuredValue?: FieldPolicy<any> | FieldReadFunction<any>;
  insuredValueRequested?: FieldPolicy<any> | FieldReadFunction<any>;
  insuredValueType?: FieldPolicy<any> | FieldReadFunction<any>;
  isShippingCostInsured?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InterceptOptionsTypeKeySpecifier = (
  | 'canRedirectToNewAddress'
  | 'canReturnToSender'
  | InterceptOptionsTypeKeySpecifier
)[];
export type InterceptOptionsTypeFieldPolicy = {
  canRedirectToNewAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  canReturnToSender?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InterceptPriceTypeKeySpecifier = (
  | 'chargeCurrency'
  | 'interceptCharge'
  | 'totalCharge'
  | InterceptPriceTypeKeySpecifier
)[];
export type InterceptPriceTypeFieldPolicy = {
  chargeCurrency?: FieldPolicy<any> | FieldReadFunction<any>;
  interceptCharge?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCharge?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelsTypeKeySpecifier = (
  | 'fileFormat'
  | 'id'
  | 'pageLayout'
  | 'status'
  | 'url'
  | LabelsTypeKeySpecifier
)[];
export type LabelsTypeFieldPolicy = {
  fileFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  pageLayout?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LinkKeySpecifier = ('text' | 'url' | LinkKeySpecifier)[];
export type LinkFieldPolicy = {
  text?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationKeySpecifier = ('latitude' | 'longitude' | LocationKeySpecifier)[];
export type LocationFieldPolicy = {
  latitude?: FieldPolicy<any> | FieldReadFunction<any>;
  longitude?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MailClassCountKeySpecifier = (
  | 'mailClass'
  | 'shipmentCount'
  | MailClassCountKeySpecifier
)[];
export type MailClassCountFieldPolicy = {
  mailClass?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MailTemplateKeySpecifier = (
  | 'asDefault'
  | 'bccEmail'
  | 'companyId'
  | 'createdAt'
  | 'id'
  | 'name'
  | 'replyToEmail'
  | 'senderEmail'
  | 'senderName'
  | 'subject'
  | 'templateHtml'
  | 'templateText'
  | 'updatedAt'
  | 'userId'
  | MailTemplateKeySpecifier
)[];
export type MailTemplateFieldPolicy = {
  asDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  bccEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  senderEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  senderName?: FieldPolicy<any> | FieldReadFunction<any>;
  subject?: FieldPolicy<any> | FieldReadFunction<any>;
  templateHtml?: FieldPolicy<any> | FieldReadFunction<any>;
  templateText?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MappableShipmentFieldKeySpecifier = (
  | 'key'
  | 'maxMappings'
  | 'required'
  | 'title'
  | MappableShipmentFieldKeySpecifier
)[];
export type MappableShipmentFieldFieldPolicy = {
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  maxMappings?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MerchantAccountKeySpecifier = (
  | 'accountStatus'
  | 'carrierKey'
  | 'errorCategory'
  | 'errorMessage'
  | 'id'
  | 'termsAndConditionsLastAcceptedAt'
  | 'termsAndConditionsOutdated'
  | MerchantAccountKeySpecifier
)[];
export type MerchantAccountFieldPolicy = {
  accountStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierKey?: FieldPolicy<any> | FieldReadFunction<any>;
  errorCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  termsAndConditionsLastAcceptedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  termsAndConditionsOutdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'abortChallenge'
  | 'acceptTerms'
  | 'addCreditToPaymentSource'
  | 'buyBatch'
  | 'buyRedirectPackageToNewAddress'
  | 'buyReturnPackageToSender'
  | 'cancelEmailNotification'
  | 'cancelPickup'
  | 'channelAutoSync'
  | 'completeBatchFromUpload'
  | 'confirmTwoFactorAuthenticationProvider'
  | 'connectWoocommerceChannel'
  | 'consumeGtmEvents'
  | 'consumeMessages'
  | 'createBatchFromImport'
  | 'createBatchFromSingleShipment'
  | 'createBatchFromUpload'
  | 'createBigcommerceChannel'
  | 'createCcPaymentSource'
  | 'createCratejoyChannel'
  | 'createDiscogsChannel'
  | 'createFakeshopChannel'
  | 'createMailTemplate'
  | 'createMappings'
  | 'createOfflinePaymentSource'
  | 'createOrUpdateUpsMerchantAccount'
  | 'createPayPalPaymentSource'
  | 'createPlaidAccessToken'
  | 'createPlaidActivation'
  | 'createPlaidConsent'
  | 'createPlaidValidationActivation'
  | 'createScanForm'
  | 'createScanFormByBatch'
  | 'createScopedShipmentPreset'
  | 'createSenderEmailMetadata'
  | 'createShipmentPreset'
  | 'createSquarespaceChannel'
  | 'createSubblyChannel'
  | 'createTestBatch'
  | 'createTestShipment'
  | 'createTestShipmentFromFixture'
  | 'createUser'
  | 'createUspsMerchantAccount'
  | 'createVenmoPaymentSource'
  | 'createWarehouse'
  | 'deleteBatch'
  | 'deleteChannel'
  | 'deleteMailTemplate'
  | 'deletePaymentSource'
  | 'deleteShipmentPreset'
  | 'deleteSuggestedAddress'
  | 'deleteTestBatch'
  | 'deleteTwoFactorAuthenticationProvider'
  | 'deleteUser'
  | 'deleteWarehouse'
  | 'disableChannel'
  | 'disablePlaidPromotionForCurrentCompany'
  | 'disputeAdjustments'
  | 'downloadMobileCodeForShipment'
  | 'downloadMobileCodesForBatch'
  | 'emulateViaShipment'
  | 'enableChannel'
  | 'fetchSenderEmailMetadata'
  | 'fetchShipmentStageDots'
  | 'generateJumioWebClientUrl'
  | 'generateOrGetShareLink'
  | 'hideHistoricShipmentAddresses'
  | 'ignoreOrders'
  | 'installTwoFactorAuthenticationProvider'
  | 'markJumioFlowAsDismissed'
  | 'markJumioFlowAsFinished'
  | 'markMobileCodeBatchAsDownloaded'
  | 'markMobileCodeShipmentAsDownloaded'
  | 'modifyInsuranceOnRatedBatch'
  | 'provideCode'
  | 'ratePickup'
  | 'refundBatch'
  | 'refundCreditFromPaymentSource'
  | 'refundShipment'
  | 'requestPickup'
  | 'rerateBatch'
  | 'resendUserInvitation'
  | 'resetNickname'
  | 'sendConfirmationMail'
  | 'sendEmail'
  | 'sendResetPasswordLink'
  | 'sendUserEmailVerificationLink'
  | 'setBatchToNew'
  | 'setDefaultPaymentSource'
  | 'setDefaultWarehouse'
  | 'setNickname'
  | 'setShipmentUploadMapping'
  | 'succeedAtChallenge'
  | 'triggerChannelSync'
  | 'triggerLabelCreationByBatches'
  | 'triggerLabelCreationByShareToken'
  | 'triggerLabelCreationByShipments'
  | 'unignoreOrders'
  | 'updateAccountEmail'
  | 'updateAccountProfile'
  | 'updateBatchTitle'
  | 'updateBigcartelChannel'
  | 'updateBigcommerceChannel'
  | 'updateBillingAddress'
  | 'updateBlockedCountries'
  | 'updateChargeAmount'
  | 'updateCratejoyChannel'
  | 'updateDataGridUserSettings'
  | 'updateDefaultTrackingEmailsDelay'
  | 'updateDefaultTrackingEmailsEnabled'
  | 'updateDiscogsChannel'
  | 'updateEbayChannel'
  | 'updateEcwidChannel'
  | 'updateEmailNotification'
  | 'updateEtsyChannel'
  | 'updateFakeshopChannel'
  | 'updateGeneralSettings'
  | 'updateMailTemplate'
  | 'updateNotificationsSettings'
  | 'updatePaypalChannel'
  | 'updatePreferredUpsMerchantAccountAddress'
  | 'updateRateGroupSortOrder'
  | 'updateSenderEmailMetadata'
  | 'updateShipmentPreset'
  | 'updateShopifyChannel'
  | 'updateSquareChannel'
  | 'updateSquarespaceChannel'
  | 'updateSubblyChannel'
  | 'updateTrackingEmailBrandingEnabled'
  | 'updateWarehouse'
  | 'updateWixChannel'
  | 'updateWoocommerceChannel'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  abortChallenge?: FieldPolicy<any> | FieldReadFunction<any>;
  acceptTerms?: FieldPolicy<any> | FieldReadFunction<any>;
  addCreditToPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  buyBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  buyRedirectPackageToNewAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  buyReturnPackageToSender?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelEmailNotification?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelPickup?: FieldPolicy<any> | FieldReadFunction<any>;
  channelAutoSync?: FieldPolicy<any> | FieldReadFunction<any>;
  completeBatchFromUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmTwoFactorAuthenticationProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  connectWoocommerceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  consumeGtmEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  consumeMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  createBatchFromImport?: FieldPolicy<any> | FieldReadFunction<any>;
  createBatchFromSingleShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  createBatchFromUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  createBigcommerceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createCcPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  createCratejoyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createDiscogsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createFakeshopChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createMailTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  createMappings?: FieldPolicy<any> | FieldReadFunction<any>;
  createOfflinePaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  createOrUpdateUpsMerchantAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  createPayPalPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlaidAccessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlaidActivation?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlaidConsent?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlaidValidationActivation?: FieldPolicy<any> | FieldReadFunction<any>;
  createScanForm?: FieldPolicy<any> | FieldReadFunction<any>;
  createScanFormByBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  createScopedShipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  createSenderEmailMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  createShipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  createSquarespaceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createSubblyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  createTestBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  createTestShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  createTestShipmentFromFixture?: FieldPolicy<any> | FieldReadFunction<any>;
  createUser?: FieldPolicy<any> | FieldReadFunction<any>;
  createUspsMerchantAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  createVenmoPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  createWarehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteMailTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteSuggestedAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteTestBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteTwoFactorAuthenticationProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteUser?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteWarehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  disableChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  disablePlaidPromotionForCurrentCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadMobileCodeForShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadMobileCodesForBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  emulateViaShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  enableChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  fetchSenderEmailMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  fetchShipmentStageDots?: FieldPolicy<any> | FieldReadFunction<any>;
  generateJumioWebClientUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  generateOrGetShareLink?: FieldPolicy<any> | FieldReadFunction<any>;
  hideHistoricShipmentAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  ignoreOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  installTwoFactorAuthenticationProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  markJumioFlowAsDismissed?: FieldPolicy<any> | FieldReadFunction<any>;
  markJumioFlowAsFinished?: FieldPolicy<any> | FieldReadFunction<any>;
  markMobileCodeBatchAsDownloaded?: FieldPolicy<any> | FieldReadFunction<any>;
  markMobileCodeShipmentAsDownloaded?: FieldPolicy<any> | FieldReadFunction<any>;
  modifyInsuranceOnRatedBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  provideCode?: FieldPolicy<any> | FieldReadFunction<any>;
  ratePickup?: FieldPolicy<any> | FieldReadFunction<any>;
  refundBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  refundCreditFromPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  refundShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  requestPickup?: FieldPolicy<any> | FieldReadFunction<any>;
  rerateBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  resendUserInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  resetNickname?: FieldPolicy<any> | FieldReadFunction<any>;
  sendConfirmationMail?: FieldPolicy<any> | FieldReadFunction<any>;
  sendEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  sendResetPasswordLink?: FieldPolicy<any> | FieldReadFunction<any>;
  sendUserEmailVerificationLink?: FieldPolicy<any> | FieldReadFunction<any>;
  setBatchToNew?: FieldPolicy<any> | FieldReadFunction<any>;
  setDefaultPaymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  setDefaultWarehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  setNickname?: FieldPolicy<any> | FieldReadFunction<any>;
  setShipmentUploadMapping?: FieldPolicy<any> | FieldReadFunction<any>;
  succeedAtChallenge?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerChannelSync?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerLabelCreationByBatches?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerLabelCreationByShareToken?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerLabelCreationByShipments?: FieldPolicy<any> | FieldReadFunction<any>;
  unignoreOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAccountEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAccountProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBatchTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBigcartelChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBigcommerceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBillingAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBlockedCountries?: FieldPolicy<any> | FieldReadFunction<any>;
  updateChargeAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCratejoyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDataGridUserSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDefaultTrackingEmailsDelay?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDefaultTrackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDiscogsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEbayChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEcwidChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEmailNotification?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEtsyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateFakeshopChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateGeneralSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateMailTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  updateNotificationsSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePaypalChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePreferredUpsMerchantAccountAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRateGroupSortOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSenderEmailMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShopifyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSquareChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSquarespaceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSubblyChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateTrackingEmailBrandingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updateWarehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  updateWixChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateWoocommerceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NavbarLinkKeySpecifier = ('children' | 'text' | 'url' | NavbarLinkKeySpecifier)[];
export type NavbarLinkFieldPolicy = {
  children?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NotOverrideableReasonKeySpecifier = (
  | 'order'
  | 'orderId'
  | 'reasons'
  | NotOverrideableReasonKeySpecifier
)[];
export type NotOverrideableReasonFieldPolicy = {
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  orderId?: FieldPolicy<any> | FieldReadFunction<any>;
  reasons?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NotificationsSettingsKeySpecifier = (
  | 'carrierAdjustmentDisputesEnabled'
  | 'carrierAdjustmentsNotificationEnabled'
  | 'newFeaturesAnnouncementsNotificationEnabled'
  | 'newLoginNotificationEnabled'
  | 'paymentFailuresNotificationEnabled'
  | 'paymentReceiptsNotificationEnabled'
  | NotificationsSettingsKeySpecifier
)[];
export type NotificationsSettingsFieldPolicy = {
  carrierAdjustmentDisputesEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierAdjustmentsNotificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  newFeaturesAnnouncementsNotificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  newLoginNotificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentFailuresNotificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentReceiptsNotificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumbersKeySpecifier = (
  | 'carrierAdjustmentsAmount'
  | 'netLabelAverage'
  | 'netLabelAverageDom'
  | 'netLabelAverageInt'
  | 'netLabelCount'
  | 'netLabelTotal'
  | 'payments'
  | 'pendingNumbers'
  | NumbersKeySpecifier
)[];
export type NumbersFieldPolicy = {
  carrierAdjustmentsAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  netLabelAverage?: FieldPolicy<any> | FieldReadFunction<any>;
  netLabelAverageDom?: FieldPolicy<any> | FieldReadFunction<any>;
  netLabelAverageInt?: FieldPolicy<any> | FieldReadFunction<any>;
  netLabelCount?: FieldPolicy<any> | FieldReadFunction<any>;
  netLabelTotal?: FieldPolicy<any> | FieldReadFunction<any>;
  payments?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingNumbers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderKeySpecifier = (
  | 'foreignOrderId'
  | 'id'
  | 'orderItems'
  | 'orderLink'
  | 'platform'
  | 'platformKey'
  | 'shipmentLink'
  | 'subscriptionLink'
  | OrderKeySpecifier
)[];
export type OrderFieldPolicy = {
  foreignOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  orderItems?: FieldPolicy<any> | FieldReadFunction<any>;
  orderLink?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  platformKey?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentLink?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionLink?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderItemKeySpecifier = ('id' | 'quantity' | 'sku' | 'title' | OrderItemKeySpecifier)[];
export type OrderItemFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderSummaryKeySpecifier = (
  | 'count'
  | 'customsFormRequired'
  | 'customsFormRequiredCount'
  | 'domesticCount'
  | 'exporterTaxId'
  | 'hSCodeRequired'
  | 'internationalCount'
  | 'maxValue'
  | 'maxValueFormatted'
  | 'maxWeight'
  | 'maxWeightFormatted'
  | 'minValue'
  | 'minValueFormatted'
  | 'minWeight'
  | 'minWeightFormatted'
  | 'notOverrideableReasons'
  | 'order'
  | 'orderIds'
  | 'ordersSimilar'
  | 'overrideable'
  | 'suggestedBatchTitle'
  | 'suggestedShipmentPreset'
  | 'uniqueCustomsItems'
  | 'uniqueOrderItemTexts'
  | 'uniquePlatformKeys'
  | 'uniqueValues'
  | 'uniqueWeights'
  | OrderSummaryKeySpecifier
)[];
export type OrderSummaryFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormRequiredCount?: FieldPolicy<any> | FieldReadFunction<any>;
  domesticCount?: FieldPolicy<any> | FieldReadFunction<any>;
  exporterTaxId?: FieldPolicy<any> | FieldReadFunction<any>;
  hSCodeRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  internationalCount?: FieldPolicy<any> | FieldReadFunction<any>;
  maxValue?: FieldPolicy<any> | FieldReadFunction<any>;
  maxValueFormatted?: FieldPolicy<any> | FieldReadFunction<any>;
  maxWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  maxWeightFormatted?: FieldPolicy<any> | FieldReadFunction<any>;
  minValue?: FieldPolicy<any> | FieldReadFunction<any>;
  minValueFormatted?: FieldPolicy<any> | FieldReadFunction<any>;
  minWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  minWeightFormatted?: FieldPolicy<any> | FieldReadFunction<any>;
  notOverrideableReasons?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  orderIds?: FieldPolicy<any> | FieldReadFunction<any>;
  ordersSimilar?: FieldPolicy<any> | FieldReadFunction<any>;
  overrideable?: FieldPolicy<any> | FieldReadFunction<any>;
  suggestedBatchTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  suggestedShipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCustomsItems?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueOrderItemTexts?: FieldPolicy<any> | FieldReadFunction<any>;
  uniquePlatformKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueValues?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueWeights?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderSummaryCustomsItemKeySpecifier = (
  | 'description'
  | 'harmonization'
  | 'origin'
  | 'qty'
  | 'value'
  | 'weight'
  | OrderSummaryCustomsItemKeySpecifier
)[];
export type OrderSummaryCustomsItemFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  harmonization?: FieldPolicy<any> | FieldReadFunction<any>;
  origin?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaginatedBatchesKeySpecifier = ('batches' | PaginatedBatchesKeySpecifier)[];
export type PaginatedBatchesFieldPolicy = {
  batches?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentKeySpecifier = (
  | 'apiMethodId'
  | 'authorizedAmount'
  | 'batchId'
  | 'batchRatedAmount'
  | 'chargeError'
  | 'chargebackFeeClient'
  | 'chargebackFeePirate'
  | 'chargedAmount'
  | 'companyId'
  | 'createdAt'
  | 'debtDue'
  | 'fee'
  | 'feeDate'
  | 'gatewayId'
  | 'groupPaymentId'
  | 'id'
  | 'isCompleted'
  | 'moreLink'
  | 'note'
  | 'paymentSourceId'
  | 'receipt'
  | 'reconciliationRunId'
  | 'refundTotal'
  | 'status'
  | 'strategy'
  | 'title'
  | 'total'
  | 'updatedAt'
  | 'userId'
  | PaymentKeySpecifier
)[];
export type PaymentFieldPolicy = {
  apiMethodId?: FieldPolicy<any> | FieldReadFunction<any>;
  authorizedAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  batchId?: FieldPolicy<any> | FieldReadFunction<any>;
  batchRatedAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  chargeError?: FieldPolicy<any> | FieldReadFunction<any>;
  chargebackFeeClient?: FieldPolicy<any> | FieldReadFunction<any>;
  chargebackFeePirate?: FieldPolicy<any> | FieldReadFunction<any>;
  chargedAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  debtDue?: FieldPolicy<any> | FieldReadFunction<any>;
  fee?: FieldPolicy<any> | FieldReadFunction<any>;
  feeDate?: FieldPolicy<any> | FieldReadFunction<any>;
  gatewayId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupPaymentId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
  moreLink?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSourceId?: FieldPolicy<any> | FieldReadFunction<any>;
  receipt?: FieldPolicy<any> | FieldReadFunction<any>;
  reconciliationRunId?: FieldPolicy<any> | FieldReadFunction<any>;
  refundTotal?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  strategy?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentActionKeySpecifier = (
  | 'actionType'
  | 'applicationErrorCode'
  | 'createdAt'
  | 'errorMessage'
  | 'gatewayToken'
  | 'httpErrorCode'
  | 'identifier'
  | 'newPaymentStatus'
  | 'paymentId'
  | 'remoteReferenceId'
  | 'remoteTransactionId'
  | 'success'
  | 'userId'
  | PaymentActionKeySpecifier
)[];
export type PaymentActionFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  applicationErrorCode?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  gatewayToken?: FieldPolicy<any> | FieldReadFunction<any>;
  httpErrorCode?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  newPaymentStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentId?: FieldPolicy<any> | FieldReadFunction<any>;
  remoteReferenceId?: FieldPolicy<any> | FieldReadFunction<any>;
  remoteTransactionId?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentApiMethodKeySpecifier = (
  | 'apiKey'
  | 'apiTitle'
  | 'code'
  | 'id'
  | PaymentApiMethodKeySpecifier
)[];
export type PaymentApiMethodFieldPolicy = {
  apiKey?: FieldPolicy<any> | FieldReadFunction<any>;
  apiTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentSourceKeySpecifier = (
  | 'bankAccountType'
  | 'billingZipcode'
  | 'billingZipcodeVerification'
  | 'brand'
  | 'countryCode'
  | 'createdAt'
  | 'email'
  | 'expMonth'
  | 'expYear'
  | 'first6'
  | 'funding'
  | 'hasConsented'
  | 'id'
  | 'last4'
  | 'nickname'
  | 'paymentMethodType'
  | 'refundableAmount'
  | 'resultMessage'
  | 'shortTitle'
  | 'title'
  | 'updatedAt'
  | 'validationStatus'
  | PaymentSourceKeySpecifier
)[];
export type PaymentSourceFieldPolicy = {
  bankAccountType?: FieldPolicy<any> | FieldReadFunction<any>;
  billingZipcode?: FieldPolicy<any> | FieldReadFunction<any>;
  billingZipcodeVerification?: FieldPolicy<any> | FieldReadFunction<any>;
  brand?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  expMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  expYear?: FieldPolicy<any> | FieldReadFunction<any>;
  first6?: FieldPolicy<any> | FieldReadFunction<any>;
  funding?: FieldPolicy<any> | FieldReadFunction<any>;
  hasConsented?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  last4?: FieldPolicy<any> | FieldReadFunction<any>;
  nickname?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>;
  refundableAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  resultMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  shortTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  validationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaypalChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'genericLineItemEnabled'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | PaypalChannelKeySpecifier
)[];
export type PaypalChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  genericLineItemEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PendingNumbersKeySpecifier = (
  | 'paymentsTotalAmount'
  | 'refunds'
  | 'returns'
  | PendingNumbersKeySpecifier
)[];
export type PendingNumbersFieldPolicy = {
  paymentsTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  refunds?: FieldPolicy<any> | FieldReadFunction<any>;
  returns?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupRateResultKeySpecifier = (
  | 'basePrice'
  | 'crossedOutBasePrice'
  | 'crossedOutTotalPrice'
  | 'surcharges'
  | 'totalPrice'
  | PickupRateResultKeySpecifier
)[];
export type PickupRateResultFieldPolicy = {
  basePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  crossedOutBasePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  crossedOutTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  surcharges?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupRequestKeySpecifier = (
  | 'canCancel'
  | 'carrier'
  | 'confirmationNumber'
  | 'createdAt'
  | 'errorMessage'
  | 'foreignId'
  | 'frequency'
  | 'hasUpsOverweightPackages'
  | 'highestServiceLevel'
  | 'id'
  | 'oneTimePickupDate'
  | 'packageLocation'
  | 'previouslyRatedPrice'
  | 'rate'
  | 'recurringPickupDays'
  | 'specialInstructions'
  | 'status'
  | 'totalPackageCount'
  | 'totalPackageWeight'
  | 'updatedAt'
  | 'warehouse'
  | 'warehouseCloseTime'
  | 'warehouseReadyTime'
  | PickupRequestKeySpecifier
)[];
export type PickupRequestFieldPolicy = {
  canCancel?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmationNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  foreignId?: FieldPolicy<any> | FieldReadFunction<any>;
  frequency?: FieldPolicy<any> | FieldReadFunction<any>;
  hasUpsOverweightPackages?: FieldPolicy<any> | FieldReadFunction<any>;
  highestServiceLevel?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  oneTimePickupDate?: FieldPolicy<any> | FieldReadFunction<any>;
  packageLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  previouslyRatedPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  rate?: FieldPolicy<any> | FieldReadFunction<any>;
  recurringPickupDays?: FieldPolicy<any> | FieldReadFunction<any>;
  specialInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPackageCount?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPackageWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouseCloseTime?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouseReadyTime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupSurchargeKeySpecifier = (
  | 'crossedOutPrice'
  | 'helpLink'
  | 'id'
  | 'name'
  | 'price'
  | PickupSurchargeKeySpecifier
)[];
export type PickupSurchargeFieldPolicy = {
  crossedOutPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  helpLink?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaidActivationKeySpecifier = (
  | 'handle'
  | 'linkToken'
  | 'mask'
  | 'name'
  | 'paymentSource'
  | 'publicToken'
  | PlaidActivationKeySpecifier
)[];
export type PlaidActivationFieldPolicy = {
  handle?: FieldPolicy<any> | FieldReadFunction<any>;
  linkToken?: FieldPolicy<any> | FieldReadFunction<any>;
  mask?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  publicToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlatformKeySpecifier = (
  | 'additionalTrackingEmailCopy'
  | 'id'
  | 'installUrl'
  | 'module'
  | 'platformKey'
  | 'reconnectSupported'
  | 'title'
  | 'trackingEmailSupported'
  | PlatformKeySpecifier
)[];
export type PlatformFieldPolicy = {
  additionalTrackingEmailCopy?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  installUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  module?: FieldPolicy<any> | FieldReadFunction<any>;
  platformKey?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectSupported?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailSupported?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlatformLinkKeySpecifier = (
  | 'identifier'
  | 'platform'
  | 'type'
  | 'url'
  | PlatformLinkKeySpecifier
)[];
export type PlatformLinkFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlatformMappableFieldKeySpecifier = (
  | 'field'
  | 'label'
  | PlatformMappableFieldKeySpecifier
)[];
export type PlatformMappableFieldFieldPolicy = {
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlatformOverrideFieldKeySpecifier = (
  | 'field'
  | 'label'
  | PlatformOverrideFieldKeySpecifier
)[];
export type PlatformOverrideFieldFieldPolicy = {
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PossibleScanFormResultKeySpecifier = (
  | 'canCreateScanForm'
  | 'id'
  | 'scanFormUrl'
  | PossibleScanFormResultKeySpecifier
)[];
export type PossibleScanFormResultFieldPolicy = {
  canCreateScanForm?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  scanFormUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'addressAutocompleteSettings'
  | 'adminShipmentsReport'
  | 'applicationConfiguration'
  | 'applicationEnvironment'
  | 'applicationHostname'
  | 'autoRefundedShipmentsSummary'
  | 'averageCostChart'
  | 'batch'
  | 'batches'
  | 'blockedCountries'
  | 'boughtBatchShipmentsGrid'
  | 'captainsNotes'
  | 'carrier'
  | 'carrierAdjustmentReport'
  | 'carrierAdjustments'
  | 'carriers'
  | 'challenges'
  | 'channel'
  | 'channelSyncStatus'
  | 'chargeAmountOptions'
  | 'clientsGrid'
  | 'company'
  | 'companySavings'
  | 'countries'
  | 'countryDistributionChart'
  | 'globalSettings'
  | 'hasBatches'
  | 'historicShipmentAddresses'
  | 'importedOrders'
  | 'insuranceUnsupportedCountries'
  | 'interceptPrice'
  | 'intercomArticle'
  | 'isEu'
  | 'labels'
  | 'latestBatches'
  | 'latestTerms'
  | 'mappableShipmentFields'
  | 'navbarLinks'
  | 'navbarMetaLinks'
  | 'notificationsSettings'
  | 'numbers'
  | 'orderSummary'
  | 'parsedAddress'
  | 'paymentApiMethods'
  | 'paymentChart'
  | 'paymentReceipts'
  | 'platforms'
  | 'rates'
  | 'receipt'
  | 'receiptsReport'
  | 'recipientTaxIdRequiringCountries'
  | 'redirectOptions'
  | 'refundReport'
  | 'refunds'
  | 'regions'
  | 'returnLabelsReport'
  | 'returnPath'
  | 'returns'
  | 'scanFormByBatch'
  | 'scanFormByShareToken'
  | 'senderEmailMetadata'
  | 'shipment'
  | 'shipmentBoundaries'
  | 'shipmentChart'
  | 'shipmentForOrder'
  | 'shipmentPieChart'
  | 'shipmentReport'
  | 'shipmentTrackingNumbers'
  | 'shipmentUpload'
  | 'shipments'
  | 'spreedlyIframeParameters'
  | 'spyglassLink'
  | 'stateDistributionChart'
  | 'supportSearch'
  | 'timezones'
  | 'transactionHistory'
  | 'twoFactorAuthenticationConfiguration'
  | 'user'
  | 'users'
  | 'verificationRequired'
  | 'verificationStatus'
  | 'woocommerceEgressIps'
  | 'zoneChart'
  | 'zoneForRoute'
  | 'zoneMapForOrigin'
  | 'zoneTable'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  addressAutocompleteSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  adminShipmentsReport?: FieldPolicy<any> | FieldReadFunction<any>;
  applicationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  applicationEnvironment?: FieldPolicy<any> | FieldReadFunction<any>;
  applicationHostname?: FieldPolicy<any> | FieldReadFunction<any>;
  autoRefundedShipmentsSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  averageCostChart?: FieldPolicy<any> | FieldReadFunction<any>;
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  batches?: FieldPolicy<any> | FieldReadFunction<any>;
  blockedCountries?: FieldPolicy<any> | FieldReadFunction<any>;
  boughtBatchShipmentsGrid?: FieldPolicy<any> | FieldReadFunction<any>;
  captainsNotes?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierAdjustmentReport?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierAdjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  carriers?: FieldPolicy<any> | FieldReadFunction<any>;
  challenges?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelSyncStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  chargeAmountOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  clientsGrid?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  companySavings?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  countryDistributionChart?: FieldPolicy<any> | FieldReadFunction<any>;
  globalSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBatches?: FieldPolicy<any> | FieldReadFunction<any>;
  historicShipmentAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  importedOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  insuranceUnsupportedCountries?: FieldPolicy<any> | FieldReadFunction<any>;
  interceptPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  intercomArticle?: FieldPolicy<any> | FieldReadFunction<any>;
  isEu?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
  latestBatches?: FieldPolicy<any> | FieldReadFunction<any>;
  latestTerms?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableShipmentFields?: FieldPolicy<any> | FieldReadFunction<any>;
  navbarLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  navbarMetaLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  notificationsSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  numbers?: FieldPolicy<any> | FieldReadFunction<any>;
  orderSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  parsedAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentApiMethods?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentChart?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentReceipts?: FieldPolicy<any> | FieldReadFunction<any>;
  platforms?: FieldPolicy<any> | FieldReadFunction<any>;
  rates?: FieldPolicy<any> | FieldReadFunction<any>;
  receipt?: FieldPolicy<any> | FieldReadFunction<any>;
  receiptsReport?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientTaxIdRequiringCountries?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  refundReport?: FieldPolicy<any> | FieldReadFunction<any>;
  refunds?: FieldPolicy<any> | FieldReadFunction<any>;
  regions?: FieldPolicy<any> | FieldReadFunction<any>;
  returnLabelsReport?: FieldPolicy<any> | FieldReadFunction<any>;
  returnPath?: FieldPolicy<any> | FieldReadFunction<any>;
  returns?: FieldPolicy<any> | FieldReadFunction<any>;
  scanFormByBatch?: FieldPolicy<any> | FieldReadFunction<any>;
  scanFormByShareToken?: FieldPolicy<any> | FieldReadFunction<any>;
  senderEmailMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  shipment?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentBoundaries?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentChart?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentForOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentPieChart?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentReport?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentTrackingNumbers?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  shipments?: FieldPolicy<any> | FieldReadFunction<any>;
  spreedlyIframeParameters?: FieldPolicy<any> | FieldReadFunction<any>;
  spyglassLink?: FieldPolicy<any> | FieldReadFunction<any>;
  stateDistributionChart?: FieldPolicy<any> | FieldReadFunction<any>;
  supportSearch?: FieldPolicy<any> | FieldReadFunction<any>;
  timezones?: FieldPolicy<any> | FieldReadFunction<any>;
  transactionHistory?: FieldPolicy<any> | FieldReadFunction<any>;
  twoFactorAuthenticationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  users?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  woocommerceEgressIps?: FieldPolicy<any> | FieldReadFunction<any>;
  zoneChart?: FieldPolicy<any> | FieldReadFunction<any>;
  zoneForRoute?: FieldPolicy<any> | FieldReadFunction<any>;
  zoneMapForOrigin?: FieldPolicy<any> | FieldReadFunction<any>;
  zoneTable?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateGroupKeySpecifier = (
  | 'affectedByUpsRateLimit'
  | 'defaultShipDate'
  | 'groupId'
  | 'groupKey'
  | 'label'
  | 'maximumShipments'
  | 'rateSummaries'
  | RateGroupKeySpecifier
)[];
export type RateGroupFieldPolicy = {
  affectedByUpsRateLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultShipDate?: FieldPolicy<any> | FieldReadFunction<any>;
  groupId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupKey?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  maximumShipments?: FieldPolicy<any> | FieldReadFunction<any>;
  rateSummaries?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateGroupKeyKeySpecifier = ('string' | 'traits' | RateGroupKeyKeySpecifier)[];
export type RateGroupKeyFieldPolicy = {
  string?: FieldPolicy<any> | FieldReadFunction<any>;
  traits?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateGroupTraitKeySpecifier = ('layer' | 'value' | RateGroupTraitKeySpecifier)[];
export type RateGroupTraitFieldPolicy = {
  layer?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateResultKeySpecifier = (
  | 'arrivalLocalTime'
  | 'basePrice'
  | 'best'
  | 'carrier'
  | 'cheapest'
  | 'crossedTotalPrice'
  | 'cubicTier'
  | 'deliveryDescription'
  | 'fastest'
  | 'isGuaranteedDelivery'
  | 'isSaturdayDelivery'
  | 'learnMoreUrl'
  | 'mailClass'
  | 'mailClassKey'
  | 'packageTypeKey'
  | 'pickupLocalTime'
  | 'priceBaseTypeKey'
  | 'pricingDescription'
  | 'pricingSubType'
  | 'pricingType'
  | 'ratePeriodId'
  | 'serviceDescription'
  | 'surcharges'
  | 'title'
  | 'totalPrice'
  | 'trackingDescription'
  | 'zone'
  | RateResultKeySpecifier
)[];
export type RateResultFieldPolicy = {
  arrivalLocalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  basePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  best?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  cheapest?: FieldPolicy<any> | FieldReadFunction<any>;
  crossedTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  cubicTier?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  fastest?: FieldPolicy<any> | FieldReadFunction<any>;
  isGuaranteedDelivery?: FieldPolicy<any> | FieldReadFunction<any>;
  isSaturdayDelivery?: FieldPolicy<any> | FieldReadFunction<any>;
  learnMoreUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClass?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassKey?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupLocalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  priceBaseTypeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  pricingDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  pricingSubType?: FieldPolicy<any> | FieldReadFunction<any>;
  pricingType?: FieldPolicy<any> | FieldReadFunction<any>;
  ratePeriodId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  surcharges?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  zone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateSelectionKeySpecifier = (
  | 'groupKey'
  | 'mailClassId'
  | 'packageTypeId'
  | 'saturdayDelivery'
  | RateSelectionKeySpecifier
)[];
export type RateSelectionFieldPolicy = {
  groupKey?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassId?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeId?: FieldPolicy<any> | FieldReadFunction<any>;
  saturdayDelivery?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateSummaryKeySpecifier = (
  | 'availableShipDates'
  | 'averageBasePrice'
  | 'averageTotalPrice'
  | 'basePrice'
  | 'best'
  | 'carrier'
  | 'cheapest'
  | 'crossedTotalPrice'
  | 'deliveryDays'
  | 'errorMessage'
  | 'fastest'
  | 'firstMailClass'
  | 'firstZone'
  | 'flatPrice'
  | 'mailClassTitle'
  | 'maxWeightOz'
  | 'packageType'
  | 'ratePeriodEndDate'
  | 'ratePeriodStartDate'
  | 'savings'
  | 'serviceTitle'
  | 'shipmentCount'
  | 'surcharges'
  | 'surchargesPrice'
  | 'totalPrice'
  | 'uniqueId'
  | 'upsellRateSummary'
  | 'valueLimit'
  | RateSummaryKeySpecifier
)[];
export type RateSummaryFieldPolicy = {
  availableShipDates?: FieldPolicy<any> | FieldReadFunction<any>;
  averageBasePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  averageTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  basePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  best?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  cheapest?: FieldPolicy<any> | FieldReadFunction<any>;
  crossedTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryDays?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  fastest?: FieldPolicy<any> | FieldReadFunction<any>;
  firstMailClass?: FieldPolicy<any> | FieldReadFunction<any>;
  firstZone?: FieldPolicy<any> | FieldReadFunction<any>;
  flatPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  maxWeightOz?: FieldPolicy<any> | FieldReadFunction<any>;
  packageType?: FieldPolicy<any> | FieldReadFunction<any>;
  ratePeriodEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  ratePeriodStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  savings?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
  surcharges?: FieldPolicy<any> | FieldReadFunction<any>;
  surchargesPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueId?: FieldPolicy<any> | FieldReadFunction<any>;
  upsellRateSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  valueLimit?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateSurchargeKeySpecifier = (
  | 'parentSurchargeId'
  | 'price'
  | 'surchargeKey'
  | 'title'
  | RateSurchargeKeySpecifier
)[];
export type RateSurchargeFieldPolicy = {
  parentSurchargeId?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  surchargeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RateSurchargeSummaryKeySpecifier = (
  | 'averagePrice'
  | 'crossedPrice'
  | 'helpLink'
  | 'price'
  | 'shipmentCount'
  | 'surchargeId'
  | 'surchargeKey'
  | 'title'
  | RateSurchargeSummaryKeySpecifier
)[];
export type RateSurchargeSummaryFieldPolicy = {
  averagePrice?: FieldPolicy<any> | FieldReadFunction<any>;
  crossedPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  helpLink?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
  surchargeId?: FieldPolicy<any> | FieldReadFunction<any>;
  surchargeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReceiptKeySpecifier = (
  | 'billingAddress'
  | 'chargeSuccessful'
  | 'company'
  | 'endBalance'
  | 'isCharged'
  | 'payment'
  | 'paymentSuccessful'
  | 'reversals'
  | 'startBalance'
  | 'transactions'
  | ReceiptKeySpecifier
)[];
export type ReceiptFieldPolicy = {
  billingAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  chargeSuccessful?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  endBalance?: FieldPolicy<any> | FieldReadFunction<any>;
  isCharged?: FieldPolicy<any> | FieldReadFunction<any>;
  payment?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSuccessful?: FieldPolicy<any> | FieldReadFunction<any>;
  reversals?: FieldPolicy<any> | FieldReadFunction<any>;
  startBalance?: FieldPolicy<any> | FieldReadFunction<any>;
  transactions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RecipientAddressKeySpecifier = (
  | 'address1'
  | 'address2'
  | 'address3'
  | 'city'
  | 'company'
  | 'countryCode'
  | 'email'
  | 'fullName'
  | 'location'
  | 'phone'
  | 'postcode'
  | 'regionCode'
  | 'residential'
  | 'valid'
  | 'zip4'
  | RecipientAddressKeySpecifier
)[];
export type RecipientAddressFieldPolicy = {
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  address3?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReconciliationAdjustmentKeySpecifier = (
  | 'adjustmentReasons'
  | 'clientPriceChange'
  | 'createdAt'
  | 'dimensionX'
  | 'dimensionXOriginal'
  | 'dimensionY'
  | 'dimensionYOriginal'
  | 'dimensionZ'
  | 'dimensionZOriginal'
  | 'disputeProcessedAt'
  | 'disputeReason'
  | 'disputeStatus'
  | 'disputedAt'
  | 'eligibilityIssueMessage'
  | 'id'
  | 'isDisputable'
  | 'notes'
  | 'processedAt'
  | 'weight'
  | 'weightOriginal'
  | ReconciliationAdjustmentKeySpecifier
)[];
export type ReconciliationAdjustmentFieldPolicy = {
  adjustmentReasons?: FieldPolicy<any> | FieldReadFunction<any>;
  clientPriceChange?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionX?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionXOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionY?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionYOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionZ?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionZOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeProcessedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeReason?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  disputedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  eligibilityIssueMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDisputable?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
  processedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
  weightOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegionKeySpecifier = (
  | 'countryCode'
  | 'id'
  | 'name'
  | 'regionCode'
  | RegionKeySpecifier
)[];
export type RegionFieldPolicy = {
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReversalTypeKeySpecifier = (
  | 'action'
  | 'amount'
  | 'coveringAccountingTransaction'
  | ReversalTypeKeySpecifier
)[];
export type ReversalTypeFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>;
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  coveringAccountingTransaction?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RubberStampsKeySpecifier = (
  | 'rubberStamp1'
  | 'rubberStamp2'
  | RubberStampsKeySpecifier
)[];
export type RubberStampsFieldPolicy = {
  rubberStamp1?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp2?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScanFormKeySpecifier = (
  | 'id'
  | 'isNew'
  | 'printableShipmentIds'
  | 'shipDate'
  | 'shipmentCount'
  | 'updatedAt'
  | 'url'
  | ScanFormKeySpecifier
)[];
export type ScanFormFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isNew?: FieldPolicy<any> | FieldReadFunction<any>;
  printableShipmentIds?: FieldPolicy<any> | FieldReadFunction<any>;
  shipDate?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScanFormFileKeySpecifier = (
  | 'downloadUrl'
  | 'fileType'
  | 'id'
  | ScanFormFileKeySpecifier
)[];
export type ScanFormFileFieldPolicy = {
  downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  fileType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScanFormResultKeySpecifier = (
  | 'id'
  | 'printableShipmentIds'
  | 'shipDate'
  | 'shipmentCount'
  | 'updatedAt'
  | 'url'
  | ScanFormResultKeySpecifier
)[];
export type ScanFormResultFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  printableShipmentIds?: FieldPolicy<any> | FieldReadFunction<any>;
  shipDate?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentCount?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SecretTypeKeySpecifier = ('qrCode' | 'secret' | SecretTypeKeySpecifier)[];
export type SecretTypeFieldPolicy = {
  qrCode?: FieldPolicy<any> | FieldReadFunction<any>;
  secret?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectOptionKeySpecifier = ('label' | 'value' | SelectOptionKeySpecifier)[];
export type SelectOptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SenderEmailMetadataKeySpecifier = (
  | 'dkimHost'
  | 'dkimTextValue'
  | 'dkimVerified'
  | 'domain'
  | 'errorMessage'
  | 'id'
  | 'returnPathDomain'
  | 'returnPathDomainCnameValue'
  | 'returnPathDomainVerified'
  | 'senderName'
  | 'verificationStatus'
  | SenderEmailMetadataKeySpecifier
)[];
export type SenderEmailMetadataFieldPolicy = {
  dkimHost?: FieldPolicy<any> | FieldReadFunction<any>;
  dkimTextValue?: FieldPolicy<any> | FieldReadFunction<any>;
  dkimVerified?: FieldPolicy<any> | FieldReadFunction<any>;
  domain?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  returnPathDomain?: FieldPolicy<any> | FieldReadFunction<any>;
  returnPathDomainCnameValue?: FieldPolicy<any> | FieldReadFunction<any>;
  returnPathDomainVerified?: FieldPolicy<any> | FieldReadFunction<any>;
  senderName?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentKeySpecifier = (
  | 'additionalRefundNotice'
  | 'address1'
  | 'address2'
  | 'addressType'
  | 'adjustments'
  | 'baseClientPrice'
  | 'baseClientPriceOriginal'
  | 'batch'
  | 'canDisplayPrices'
  | 'canInstantRefundShipment'
  | 'canPrint'
  | 'canShowMobileCode'
  | 'carrierKey'
  | 'carrierTitle'
  | 'city'
  | 'company'
  | 'companyId'
  | 'countryCode'
  | 'countryId'
  | 'countryIdOriginal'
  | 'customsContentType'
  | 'customsFormEnabled'
  | 'customsItems'
  | 'customsItemsObjects'
  | 'customsSigner'
  | 'deliveryEstimation'
  | 'dimensionX'
  | 'dimensionXOriginal'
  | 'dimensionY'
  | 'dimensionYOriginal'
  | 'dimensionZ'
  | 'dimensionZOriginal'
  | 'errorMessage'
  | 'exporterTaxId'
  | 'foreignOrderId'
  | 'fullName'
  | 'hasBeenDownloaded'
  | 'id'
  | 'insuranceDetails'
  | 'isGroundSaver'
  | 'isRedacted'
  | 'isReturnLabel'
  | 'isShipmentRefundable'
  | 'location'
  | 'mailClass'
  | 'mailClassKey'
  | 'mailClassOriginal'
  | 'map'
  | 'notificationEmailSent'
  | 'order'
  | 'origin'
  | 'originalId'
  | 'packageType'
  | 'packageTypeOriginal'
  | 'passthroughFields'
  | 'phone'
  | 'poBox'
  | 'postcode'
  | 'recipientAddress'
  | 'recipientTaxId'
  | 'refundTimeNoticeShipmentDescription'
  | 'refundTimeNoticeShipmentTitle'
  | 'regionCode'
  | 'residential'
  | 'rubberStamp1'
  | 'rubberStamp2'
  | 'rubberStamp3'
  | 'stageDotsStatus'
  | 'status'
  | 'surcharges'
  | 'timeZone'
  | 'totalClientPrice'
  | 'totalClientPriceOriginal'
  | 'trackingDataExportUrl'
  | 'trackingLink'
  | 'trackingNr'
  | 'valid'
  | 'validationError'
  | 'warehouse'
  | 'weight'
  | 'weightOriginal'
  | 'zip4'
  | 'zone'
  | 'zoneOriginal'
  | ShipmentKeySpecifier
)[];
export type ShipmentFieldPolicy = {
  additionalRefundNotice?: FieldPolicy<any> | FieldReadFunction<any>;
  address1?: FieldPolicy<any> | FieldReadFunction<any>;
  address2?: FieldPolicy<any> | FieldReadFunction<any>;
  addressType?: FieldPolicy<any> | FieldReadFunction<any>;
  adjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  baseClientPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  baseClientPriceOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  canDisplayPrices?: FieldPolicy<any> | FieldReadFunction<any>;
  canInstantRefundShipment?: FieldPolicy<any> | FieldReadFunction<any>;
  canPrint?: FieldPolicy<any> | FieldReadFunction<any>;
  canShowMobileCode?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierKey?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>;
  countryId?: FieldPolicy<any> | FieldReadFunction<any>;
  countryIdOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  customsContentType?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  customsItems?: FieldPolicy<any> | FieldReadFunction<any>;
  customsItemsObjects?: FieldPolicy<any> | FieldReadFunction<any>;
  customsSigner?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryEstimation?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionX?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionXOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionY?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionYOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionZ?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionZOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  exporterTaxId?: FieldPolicy<any> | FieldReadFunction<any>;
  foreignOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBeenDownloaded?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  insuranceDetails?: FieldPolicy<any> | FieldReadFunction<any>;
  isGroundSaver?: FieldPolicy<any> | FieldReadFunction<any>;
  isRedacted?: FieldPolicy<any> | FieldReadFunction<any>;
  isReturnLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  isShipmentRefundable?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClass?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassKey?: FieldPolicy<any> | FieldReadFunction<any>;
  mailClassOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  map?: FieldPolicy<any> | FieldReadFunction<any>;
  notificationEmailSent?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  origin?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  packageType?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  passthroughFields?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  poBox?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientTaxId?: FieldPolicy<any> | FieldReadFunction<any>;
  refundTimeNoticeShipmentDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  refundTimeNoticeShipmentTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  regionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  residential?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp1?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp2?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberStamp3?: FieldPolicy<any> | FieldReadFunction<any>;
  stageDotsStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  surcharges?: FieldPolicy<any> | FieldReadFunction<any>;
  timeZone?: FieldPolicy<any> | FieldReadFunction<any>;
  totalClientPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  totalClientPriceOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingDataExportUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingLink?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingNr?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
  validationError?: FieldPolicy<any> | FieldReadFunction<any>;
  warehouse?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
  weightOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  zip4?: FieldPolicy<any> | FieldReadFunction<any>;
  zone?: FieldPolicy<any> | FieldReadFunction<any>;
  zoneOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentBoundariesKeySpecifier = (
  | 'maxCombinedLength'
  | 'maxLengthPlusGirth'
  | 'maxLongSide'
  | 'maxMiddleSide'
  | 'maxShortSide'
  | 'maxWeight'
  | 'minLongSide'
  | 'minMiddleSide'
  | 'minShortSide'
  | ShipmentBoundariesKeySpecifier
)[];
export type ShipmentBoundariesFieldPolicy = {
  maxCombinedLength?: FieldPolicy<any> | FieldReadFunction<any>;
  maxLengthPlusGirth?: FieldPolicy<any> | FieldReadFunction<any>;
  maxLongSide?: FieldPolicy<any> | FieldReadFunction<any>;
  maxMiddleSide?: FieldPolicy<any> | FieldReadFunction<any>;
  maxShortSide?: FieldPolicy<any> | FieldReadFunction<any>;
  maxWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  minLongSide?: FieldPolicy<any> | FieldReadFunction<any>;
  minMiddleSide?: FieldPolicy<any> | FieldReadFunction<any>;
  minShortSide?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentMappingKeySpecifier = (
  | 'firstValue'
  | 'id'
  | 'ordering'
  | 'shipmentKey'
  | 'userFriendlyShipmentKey'
  | 'valueOrMappingKey'
  | ShipmentMappingKeySpecifier
)[];
export type ShipmentMappingFieldPolicy = {
  firstValue?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  ordering?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentKey?: FieldPolicy<any> | FieldReadFunction<any>;
  userFriendlyShipmentKey?: FieldPolicy<any> | FieldReadFunction<any>;
  valueOrMappingKey?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentMobileCodeKeySpecifier = (
  | 'mobileCodeDataUri'
  | 'shipmentId'
  | ShipmentMobileCodeKeySpecifier
)[];
export type ShipmentMobileCodeFieldPolicy = {
  mobileCodeDataUri?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentPassthroughFieldTypeKeySpecifier = (
  | 'fieldName'
  | 'value'
  | ShipmentPassthroughFieldTypeKeySpecifier
)[];
export type ShipmentPassthroughFieldTypeFieldPolicy = {
  fieldName?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentPresetKeySpecifier = (
  | 'availableReturnLabelOptions'
  | 'createdAt'
  | 'customsContentType'
  | 'customsFormEnabled'
  | 'customsItems'
  | 'customsSigner'
  | 'deliveryConfirmation'
  | 'deliveryConfirmationFlag'
  | 'deliveryConfirmationTitle'
  | 'description'
  | 'dimensionX'
  | 'dimensionY'
  | 'dimensionZ'
  | 'exporterTaxId'
  | 'hazardousMaterialsEnabled'
  | 'id'
  | 'insuredValue'
  | 'insuredValueFlag'
  | 'irregularPackage'
  | 'originalId'
  | 'packageTypeId'
  | 'packageTypeKey'
  | 'qualifiesAsMediaMail'
  | 'recipientTaxId'
  | 'returnLabel'
  | 'returnLabelFlag'
  | 'shy'
  | 'title'
  | 'updatedAt'
  | 'weight'
  | ShipmentPresetKeySpecifier
)[];
export type ShipmentPresetFieldPolicy = {
  availableReturnLabelOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customsContentType?: FieldPolicy<any> | FieldReadFunction<any>;
  customsFormEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  customsItems?: FieldPolicy<any> | FieldReadFunction<any>;
  customsSigner?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryConfirmation?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryConfirmationFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryConfirmationTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionX?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionY?: FieldPolicy<any> | FieldReadFunction<any>;
  dimensionZ?: FieldPolicy<any> | FieldReadFunction<any>;
  exporterTaxId?: FieldPolicy<any> | FieldReadFunction<any>;
  hazardousMaterialsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  insuredValue?: FieldPolicy<any> | FieldReadFunction<any>;
  insuredValueFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  irregularPackage?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeId?: FieldPolicy<any> | FieldReadFunction<any>;
  packageTypeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiesAsMediaMail?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientTaxId?: FieldPolicy<any> | FieldReadFunction<any>;
  returnLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  returnLabelFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  shy?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentPriceKeySpecifier = (
  | 'apiKey'
  | 'clientPrice'
  | 'clientPriceOriginal'
  | 'createdAt'
  | 'helpLink'
  | 'isIgnored'
  | 'isOriginalSurcharge'
  | 'title'
  | 'updatedAt'
  | ShipmentPriceKeySpecifier
)[];
export type ShipmentPriceFieldPolicy = {
  apiKey?: FieldPolicy<any> | FieldReadFunction<any>;
  clientPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  clientPriceOriginal?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  helpLink?: FieldPolicy<any> | FieldReadFunction<any>;
  isIgnored?: FieldPolicy<any> | FieldReadFunction<any>;
  isOriginalSurcharge?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentStatusSummaryKeySpecifier = (
  | 'deliveredCount'
  | 'errorCount'
  | 'inTransitCount'
  | 'mobileCodeShowableCount'
  | 'printableCount'
  | 'readyToPrintCount'
  | 'readyToShipCount'
  | 'refundPendingCount'
  | 'refundableCount'
  | 'refundedCount'
  | ShipmentStatusSummaryKeySpecifier
)[];
export type ShipmentStatusSummaryFieldPolicy = {
  deliveredCount?: FieldPolicy<any> | FieldReadFunction<any>;
  errorCount?: FieldPolicy<any> | FieldReadFunction<any>;
  inTransitCount?: FieldPolicy<any> | FieldReadFunction<any>;
  mobileCodeShowableCount?: FieldPolicy<any> | FieldReadFunction<any>;
  printableCount?: FieldPolicy<any> | FieldReadFunction<any>;
  readyToPrintCount?: FieldPolicy<any> | FieldReadFunction<any>;
  readyToShipCount?: FieldPolicy<any> | FieldReadFunction<any>;
  refundPendingCount?: FieldPolicy<any> | FieldReadFunction<any>;
  refundableCount?: FieldPolicy<any> | FieldReadFunction<any>;
  refundedCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentSummaryKeySpecifier = (
  | 'mailClassCounts'
  | 'overweightShipmentIncluded'
  | 'totalCount'
  | 'totalWeightLbs'
  | 'totalWeightOz'
  | ShipmentSummaryKeySpecifier
)[];
export type ShipmentSummaryFieldPolicy = {
  mailClassCounts?: FieldPolicy<any> | FieldReadFunction<any>;
  overweightShipmentIncluded?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
  totalWeightLbs?: FieldPolicy<any> | FieldReadFunction<any>;
  totalWeightOz?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentTrackingNumbersKeySpecifier = (
  | 'shipmentsDelivered'
  | 'shipmentsDeliveryIssue'
  | 'shipmentsNew'
  | 'shipmentsTransit'
  | ShipmentTrackingNumbersKeySpecifier
)[];
export type ShipmentTrackingNumbersFieldPolicy = {
  shipmentsDelivered?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentsDeliveryIssue?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentsNew?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentsTransit?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentUploadKeySpecifier = (
  | 'batch'
  | 'errorMessage'
  | 'fileFormat'
  | 'filename'
  | 'id'
  | 'mapping'
  | 'suggestedMapping'
  | 'uploadStatus'
  | ShipmentUploadKeySpecifier
)[];
export type ShipmentUploadFieldPolicy = {
  batch?: FieldPolicy<any> | FieldReadFunction<any>;
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  fileFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  mapping?: FieldPolicy<any> | FieldReadFunction<any>;
  suggestedMapping?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShippingCustomsItemKeySpecifier = (
  | 'countryCodeOfOrigin'
  | 'hsTariffNumber'
  | 'id'
  | 'itemValue'
  | 'quantity'
  | 'title'
  | 'weight'
  | ShippingCustomsItemKeySpecifier
)[];
export type ShippingCustomsItemFieldPolicy = {
  countryCodeOfOrigin?: FieldPolicy<any> | FieldReadFunction<any>;
  hsTariffNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  itemValue?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopifyChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'fulfillmentLocations'
  | 'id'
  | 'importLineItemsNotRequireShippingEnabled'
  | 'importOrdersNewerThan'
  | 'lastSync'
  | 'locationsToImport'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | ShopifyChannelKeySpecifier
)[];
export type ShopifyChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  fulfillmentLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  importLineItemsNotRequireShippingEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  importOrdersNewerThan?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  locationsToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopifyLocationKeySpecifier = ('id' | 'name' | ShopifyLocationKeySpecifier)[];
export type ShopifyLocationFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpreedlyIframeParametersKeySpecifier = (
  | 'certificateToken'
  | 'nonce'
  | 'signature'
  | 'timestamp'
  | SpreedlyIframeParametersKeySpecifier
)[];
export type SpreedlyIframeParametersFieldPolicy = {
  certificateToken?: FieldPolicy<any> | FieldReadFunction<any>;
  nonce?: FieldPolicy<any> | FieldReadFunction<any>;
  signature?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SquareChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'importCustomAttributes'
  | 'lastSync'
  | 'locations'
  | 'locationsToImport'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | SquareChannelKeySpecifier
)[];
export type SquareChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  importCustomAttributes?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  locations?: FieldPolicy<any> | FieldReadFunction<any>;
  locationsToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SquareLocationKeySpecifier = ('id' | 'name' | SquareLocationKeySpecifier)[];
export type SquareLocationFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SquarespaceChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'clientSecret'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | SquarespaceChannelKeySpecifier
)[];
export type SquarespaceChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StageDotKeySpecifier = ('message' | 'status' | 'title' | StageDotKeySpecifier)[];
export type StageDotFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StateDistributionChartKeySpecifier = (
  | 'stateDistributions'
  | 'totalCount'
  | StateDistributionChartKeySpecifier
)[];
export type StateDistributionChartFieldPolicy = {
  stateDistributions?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubblyChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'clientSecret'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | SubblyChannelKeySpecifier
)[];
export type SubblyChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SummaryKeySpecifier = ('amount' | 'count' | SummaryKeySpecifier)[];
export type SummaryFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportSearchResultKeySpecifier = (
  | 'id'
  | 'label'
  | 'type'
  | 'value'
  | SupportSearchResultKeySpecifier
)[];
export type SupportSearchResultFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncStatusResultKeySpecifier = (
  | 'autosyncRequired'
  | 'hasError'
  | 'info'
  | 'isRunning'
  | 'messages'
  | 'progress'
  | 'timestamp'
  | SyncStatusResultKeySpecifier
)[];
export type SyncStatusResultFieldPolicy = {
  autosyncRequired?: FieldPolicy<any> | FieldReadFunction<any>;
  hasError?: FieldPolicy<any> | FieldReadFunction<any>;
  info?: FieldPolicy<any> | FieldReadFunction<any>;
  isRunning?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  progress?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimezoneKeySpecifier = ('description' | 'ianaName' | TimezoneKeySpecifier)[];
export type TimezoneFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  ianaName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwoFactorAuthenticationConfigurationKeySpecifier = (
  | 'activeProvider'
  | 'hasMultipleConfirmedProviders'
  | 'staySignedIn'
  | TwoFactorAuthenticationConfigurationKeySpecifier
)[];
export type TwoFactorAuthenticationConfigurationFieldPolicy = {
  activeProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  hasMultipleConfirmedProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  staySignedIn?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwoFactorProviderKeySpecifier = (
  | 'active'
  | 'confirmed'
  | 'provider'
  | TwoFactorProviderKeySpecifier
)[];
export type TwoFactorProviderFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmed?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateShipmentPresetResultKeySpecifier = (
  | 'default'
  | 'shipmentPreset'
  | UpdateShipmentPresetResultKeySpecifier
)[];
export type UpdateShipmentPresetResultFieldPolicy = {
  default?: FieldPolicy<any> | FieldReadFunction<any>;
  shipmentPreset?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserKeySpecifier = (
  | 'activePlatforms'
  | 'admin'
  | 'company'
  | 'createdAt'
  | 'email'
  | 'emailVerified'
  | 'firstName'
  | 'groupId'
  | 'id'
  | 'lastName'
  | 'rateGroupSortOrder'
  | 'roles'
  | 'status'
  | 'timezone'
  | 'twoFactorAuthenticationProviders'
  | 'updatedAt'
  | 'userHash'
  | UserKeySpecifier
)[];
export type UserFieldPolicy = {
  activePlatforms?: FieldPolicy<any> | FieldReadFunction<any>;
  admin?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  emailVerified?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  groupId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  rateGroupSortOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  roles?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  twoFactorAuthenticationProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  userHash?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserTermsKeySpecifier = ('id' | 'terms' | UserTermsKeySpecifier)[];
export type UserTermsFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  terms?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WarehouseKeySpecifier = (
  | 'createdAt'
  | 'id'
  | 'originAddress'
  | 'originalId'
  | 'returnAddress'
  | 'scanForms'
  | 'shy'
  | 'title'
  | 'totalAvailableLabelsForScanForm'
  | 'updatedAt'
  | 'useOriginAsReturnAddress'
  | WarehouseKeySpecifier
)[];
export type WarehouseFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  originalId?: FieldPolicy<any> | FieldReadFunction<any>;
  returnAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  scanForms?: FieldPolicy<any> | FieldReadFunction<any>;
  shy?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  totalAvailableLabelsForScanForm?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  useOriginAsReturnAddress?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WixChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | WixChannelKeySpecifier
)[];
export type WixChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WoocommerceChannelKeySpecifier = (
  | 'active'
  | 'autoSyncEnabled'
  | 'createdAt'
  | 'customOptions'
  | 'id'
  | 'lastSync'
  | 'mappableFields'
  | 'platform'
  | 'reconnectUrl'
  | 'rubberstampConfig'
  | 'shopUrl'
  | 'statusesToImport'
  | 'title'
  | 'trackingEmailsEnabled'
  | 'updatedAt'
  | 'valid'
  | WoocommerceChannelKeySpecifier
)[];
export type WoocommerceChannelFieldPolicy = {
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSyncEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  customOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  mappableFields?: FieldPolicy<any> | FieldReadFunction<any>;
  platform?: FieldPolicy<any> | FieldReadFunction<any>;
  reconnectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  rubberstampConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  shopUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusesToImport?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AccountingTransaction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingTransactionKeySpecifier
      | (() => undefined | AccountingTransactionKeySpecifier);
    fields?: AccountingTransactionFieldPolicy;
  };
  Address?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier);
    fields?: AddressFieldPolicy;
  };
  AddressAutocompleteSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddressAutocompleteSettingsKeySpecifier
      | (() => undefined | AddressAutocompleteSettingsKeySpecifier);
    fields?: AddressAutocompleteSettingsFieldPolicy;
  };
  AddressInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddressInterfaceKeySpecifier
      | (() => undefined | AddressInterfaceKeySpecifier);
    fields?: AddressInterfaceFieldPolicy;
  };
  AdjustmentReason?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdjustmentReasonKeySpecifier
      | (() => undefined | AdjustmentReasonKeySpecifier);
    fields?: AdjustmentReasonFieldPolicy;
  };
  AdjustmentReasonReference?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdjustmentReasonReferenceKeySpecifier
      | (() => undefined | AdjustmentReasonReferenceKeySpecifier);
    fields?: AdjustmentReasonReferenceFieldPolicy;
  };
  ApplicationConfiguration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplicationConfigurationKeySpecifier
      | (() => undefined | ApplicationConfigurationKeySpecifier);
    fields?: ApplicationConfigurationFieldPolicy;
  };
  AssociatedCompany?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssociatedCompanyKeySpecifier
      | (() => undefined | AssociatedCompanyKeySpecifier);
    fields?: AssociatedCompanyFieldPolicy;
  };
  BasicAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BasicAddressKeySpecifier | (() => undefined | BasicAddressKeySpecifier);
    fields?: BasicAddressFieldPolicy;
  };
  BasicAddressInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BasicAddressInterfaceKeySpecifier
      | (() => undefined | BasicAddressInterfaceKeySpecifier);
    fields?: BasicAddressInterfaceFieldPolicy;
  };
  Batch?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BatchKeySpecifier | (() => undefined | BatchKeySpecifier);
    fields?: BatchFieldPolicy;
  };
  BatchCustomsFormSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BatchCustomsFormSummaryKeySpecifier
      | (() => undefined | BatchCustomsFormSummaryKeySpecifier);
    fields?: BatchCustomsFormSummaryFieldPolicy;
  };
  BatchPackageSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BatchPackageSummaryKeySpecifier
      | (() => undefined | BatchPackageSummaryKeySpecifier);
    fields?: BatchPackageSummaryFieldPolicy;
  };
  BatchPriceSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BatchPriceSummaryKeySpecifier
      | (() => undefined | BatchPriceSummaryKeySpecifier);
    fields?: BatchPriceSummaryFieldPolicy;
  };
  BatchProcess?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BatchProcessKeySpecifier | (() => undefined | BatchProcessKeySpecifier);
    fields?: BatchProcessFieldPolicy;
  };
  BigcartelChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BigcartelChannelKeySpecifier
      | (() => undefined | BigcartelChannelKeySpecifier);
    fields?: BigcartelChannelFieldPolicy;
  };
  BigcommerceChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BigcommerceChannelKeySpecifier
      | (() => undefined | BigcommerceChannelKeySpecifier);
    fields?: BigcommerceChannelFieldPolicy;
  };
  BlockedCountry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BlockedCountryKeySpecifier | (() => undefined | BlockedCountryKeySpecifier);
    fields?: BlockedCountryFieldPolicy;
  };
  Carrier?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CarrierKeySpecifier | (() => undefined | CarrierKeySpecifier);
    fields?: CarrierFieldPolicy;
  };
  CarrierMailClass?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CarrierMailClassKeySpecifier
      | (() => undefined | CarrierMailClassKeySpecifier);
    fields?: CarrierMailClassFieldPolicy;
  };
  CarrierPackageType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CarrierPackageTypeKeySpecifier
      | (() => undefined | CarrierPackageTypeKeySpecifier);
    fields?: CarrierPackageTypeFieldPolicy;
  };
  Challenge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChallengeKeySpecifier | (() => undefined | ChallengeKeySpecifier);
    fields?: ChallengeFieldPolicy;
  };
  ChallengeState?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChallengeStateKeySpecifier | (() => undefined | ChallengeStateKeySpecifier);
    fields?: ChallengeStateFieldPolicy;
  };
  Channel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChannelKeySpecifier | (() => undefined | ChannelKeySpecifier);
    fields?: ChannelFieldPolicy;
  };
  ChannelInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChannelInterfaceKeySpecifier
      | (() => undefined | ChannelInterfaceKeySpecifier);
    fields?: ChannelInterfaceFieldPolicy;
  };
  ChannelRubberstampConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChannelRubberstampConfigKeySpecifier
      | (() => undefined | ChannelRubberstampConfigKeySpecifier);
    fields?: ChannelRubberstampConfigFieldPolicy;
  };
  ChannelSync?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChannelSyncKeySpecifier | (() => undefined | ChannelSyncKeySpecifier);
    fields?: ChannelSyncFieldPolicy;
  };
  Chart?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChartKeySpecifier | (() => undefined | ChartKeySpecifier);
    fields?: ChartFieldPolicy;
  };
  ClaimInsuranceLinkResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ClaimInsuranceLinkResultKeySpecifier
      | (() => undefined | ClaimInsuranceLinkResultKeySpecifier);
    fields?: ClaimInsuranceLinkResultFieldPolicy;
  };
  Company?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CompanyKeySpecifier | (() => undefined | CompanyKeySpecifier);
    fields?: CompanyFieldPolicy;
  };
  CompanySettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanySettingsKeySpecifier
      | (() => undefined | CompanySettingsKeySpecifier);
    fields?: CompanySettingsFieldPolicy;
  };
  CompanyUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CompanyUserKeySpecifier | (() => undefined | CompanyUserKeySpecifier);
    fields?: CompanyUserFieldPolicy;
  };
  Country?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CountryKeySpecifier | (() => undefined | CountryKeySpecifier);
    fields?: CountryFieldPolicy;
  };
  CountryDistributionChart?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CountryDistributionChartKeySpecifier
      | (() => undefined | CountryDistributionChartKeySpecifier);
    fields?: CountryDistributionChartFieldPolicy;
  };
  CratejoyChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CratejoyChannelKeySpecifier
      | (() => undefined | CratejoyChannelKeySpecifier);
    fields?: CratejoyChannelFieldPolicy;
  };
  CreatePaymentSourceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePaymentSourceResponseKeySpecifier
      | (() => undefined | CreatePaymentSourceResponseKeySpecifier);
    fields?: CreatePaymentSourceResponseFieldPolicy;
  };
  CreatePaymentSourceResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePaymentSourceResultKeySpecifier
      | (() => undefined | CreatePaymentSourceResultKeySpecifier);
    fields?: CreatePaymentSourceResultFieldPolicy;
  };
  CreateShipmentPresetResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateShipmentPresetResultKeySpecifier
      | (() => undefined | CreateShipmentPresetResultKeySpecifier);
    fields?: CreateShipmentPresetResultFieldPolicy;
  };
  CustomOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CustomOptionKeySpecifier | (() => undefined | CustomOptionKeySpecifier);
    fields?: CustomOptionFieldPolicy;
  };
  CustomsItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CustomsItemKeySpecifier | (() => undefined | CustomsItemKeySpecifier);
    fields?: CustomsItemFieldPolicy;
  };
  DataGridColumn?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DataGridColumnKeySpecifier | (() => undefined | DataGridColumnKeySpecifier);
    fields?: DataGridColumnFieldPolicy;
  };
  DataGridColumnOverride?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridColumnOverrideKeySpecifier
      | (() => undefined | DataGridColumnOverrideKeySpecifier);
    fields?: DataGridColumnOverrideFieldPolicy;
  };
  DataGridExportStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridExportStatusKeySpecifier
      | (() => undefined | DataGridExportStatusKeySpecifier);
    fields?: DataGridExportStatusFieldPolicy;
  };
  DataGridFilter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DataGridFilterKeySpecifier | (() => undefined | DataGridFilterKeySpecifier);
    fields?: DataGridFilterFieldPolicy;
  };
  DataGridFilterOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridFilterOptionKeySpecifier
      | (() => undefined | DataGridFilterOptionKeySpecifier);
    fields?: DataGridFilterOptionFieldPolicy;
  };
  DataGridMetaData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridMetaDataKeySpecifier
      | (() => undefined | DataGridMetaDataKeySpecifier);
    fields?: DataGridMetaDataFieldPolicy;
  };
  DataGridResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DataGridResultKeySpecifier | (() => undefined | DataGridResultKeySpecifier);
    fields?: DataGridResultFieldPolicy;
  };
  DataGridResultRows?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridResultRowsKeySpecifier
      | (() => undefined | DataGridResultRowsKeySpecifier);
    fields?: DataGridResultRowsFieldPolicy;
  };
  DataGridRowAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridRowActionKeySpecifier
      | (() => undefined | DataGridRowActionKeySpecifier);
    fields?: DataGridRowActionFieldPolicy;
  };
  DataGridSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridSettingsKeySpecifier
      | (() => undefined | DataGridSettingsKeySpecifier);
    fields?: DataGridSettingsFieldPolicy;
  };
  DataGridSorting?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DataGridSortingKeySpecifier
      | (() => undefined | DataGridSortingKeySpecifier);
    fields?: DataGridSortingFieldPolicy;
  };
  DateTimeRange?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DateTimeRangeKeySpecifier | (() => undefined | DateTimeRangeKeySpecifier);
    fields?: DateTimeRangeFieldPolicy;
  };
  DeliveryEstimation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeliveryEstimationKeySpecifier
      | (() => undefined | DeliveryEstimationKeySpecifier);
    fields?: DeliveryEstimationFieldPolicy;
  };
  DiscogsChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DiscogsChannelKeySpecifier | (() => undefined | DiscogsChannelKeySpecifier);
    fields?: DiscogsChannelFieldPolicy;
  };
  DistributionChartItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DistributionChartItemKeySpecifier
      | (() => undefined | DistributionChartItemKeySpecifier);
    fields?: DistributionChartItemFieldPolicy;
  };
  DockOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DockOrderKeySpecifier | (() => undefined | DockOrderKeySpecifier);
    fields?: DockOrderFieldPolicy;
  };
  EbayChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | EbayChannelKeySpecifier | (() => undefined | EbayChannelKeySpecifier);
    fields?: EbayChannelFieldPolicy;
  };
  EcwidChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | EcwidChannelKeySpecifier | (() => undefined | EcwidChannelKeySpecifier);
    fields?: EcwidChannelFieldPolicy;
  };
  EcwidOrderStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EcwidOrderStatusKeySpecifier
      | (() => undefined | EcwidOrderStatusKeySpecifier);
    fields?: EcwidOrderStatusFieldPolicy;
  };
  EcwidOrderStatusImpl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EcwidOrderStatusImplKeySpecifier
      | (() => undefined | EcwidOrderStatusImplKeySpecifier);
    fields?: EcwidOrderStatusImplFieldPolicy;
  };
  EmailTemplate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | EmailTemplateKeySpecifier | (() => undefined | EmailTemplateKeySpecifier);
    fields?: EmailTemplateFieldPolicy;
  };
  EtsyChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | EtsyChannelKeySpecifier | (() => undefined | EtsyChannelKeySpecifier);
    fields?: EtsyChannelFieldPolicy;
  };
  FakeshopChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FakeshopChannelKeySpecifier
      | (() => undefined | FakeshopChannelKeySpecifier);
    fields?: FakeshopChannelFieldPolicy;
  };
  Feature?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FeatureKeySpecifier | (() => undefined | FeatureKeySpecifier);
    fields?: FeatureFieldPolicy;
  };
  FlashMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FlashMessageKeySpecifier | (() => undefined | FlashMessageKeySpecifier);
    fields?: FlashMessageFieldPolicy;
  };
  GlobalSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | GlobalSettingsKeySpecifier | (() => undefined | GlobalSettingsKeySpecifier);
    fields?: GlobalSettingsFieldPolicy;
  };
  HistoricShipmentAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HistoricShipmentAddressKeySpecifier
      | (() => undefined | HistoricShipmentAddressKeySpecifier);
    fields?: HistoricShipmentAddressFieldPolicy;
  };
  IgnoreOrderResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IgnoreOrderResultKeySpecifier
      | (() => undefined | IgnoreOrderResultKeySpecifier);
    fields?: IgnoreOrderResultFieldPolicy;
  };
  InstallTwoFactorAuthenticationResultType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InstallTwoFactorAuthenticationResultTypeKeySpecifier
      | (() => undefined | InstallTwoFactorAuthenticationResultTypeKeySpecifier);
    fields?: InstallTwoFactorAuthenticationResultTypeFieldPolicy;
  };
  InsuranceDetailsType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InsuranceDetailsTypeKeySpecifier
      | (() => undefined | InsuranceDetailsTypeKeySpecifier);
    fields?: InsuranceDetailsTypeFieldPolicy;
  };
  InterceptOptionsType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InterceptOptionsTypeKeySpecifier
      | (() => undefined | InterceptOptionsTypeKeySpecifier);
    fields?: InterceptOptionsTypeFieldPolicy;
  };
  InterceptPriceType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InterceptPriceTypeKeySpecifier
      | (() => undefined | InterceptPriceTypeKeySpecifier);
    fields?: InterceptPriceTypeFieldPolicy;
  };
  LabelsType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LabelsTypeKeySpecifier | (() => undefined | LabelsTypeKeySpecifier);
    fields?: LabelsTypeFieldPolicy;
  };
  Link?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LinkKeySpecifier | (() => undefined | LinkKeySpecifier);
    fields?: LinkFieldPolicy;
  };
  Location?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LocationKeySpecifier | (() => undefined | LocationKeySpecifier);
    fields?: LocationFieldPolicy;
  };
  MailClassCount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MailClassCountKeySpecifier | (() => undefined | MailClassCountKeySpecifier);
    fields?: MailClassCountFieldPolicy;
  };
  MailTemplate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MailTemplateKeySpecifier | (() => undefined | MailTemplateKeySpecifier);
    fields?: MailTemplateFieldPolicy;
  };
  MappableShipmentField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MappableShipmentFieldKeySpecifier
      | (() => undefined | MappableShipmentFieldKeySpecifier);
    fields?: MappableShipmentFieldFieldPolicy;
  };
  MerchantAccount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MerchantAccountKeySpecifier
      | (() => undefined | MerchantAccountKeySpecifier);
    fields?: MerchantAccountFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  NavbarLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NavbarLinkKeySpecifier | (() => undefined | NavbarLinkKeySpecifier);
    fields?: NavbarLinkFieldPolicy;
  };
  NotOverrideableReason?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotOverrideableReasonKeySpecifier
      | (() => undefined | NotOverrideableReasonKeySpecifier);
    fields?: NotOverrideableReasonFieldPolicy;
  };
  NotificationsSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationsSettingsKeySpecifier
      | (() => undefined | NotificationsSettingsKeySpecifier);
    fields?: NotificationsSettingsFieldPolicy;
  };
  Numbers?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NumbersKeySpecifier | (() => undefined | NumbersKeySpecifier);
    fields?: NumbersFieldPolicy;
  };
  Order?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier);
    fields?: OrderFieldPolicy;
  };
  OrderItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OrderItemKeySpecifier | (() => undefined | OrderItemKeySpecifier);
    fields?: OrderItemFieldPolicy;
  };
  OrderSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OrderSummaryKeySpecifier | (() => undefined | OrderSummaryKeySpecifier);
    fields?: OrderSummaryFieldPolicy;
  };
  OrderSummaryCustomsItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderSummaryCustomsItemKeySpecifier
      | (() => undefined | OrderSummaryCustomsItemKeySpecifier);
    fields?: OrderSummaryCustomsItemFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  PaginatedBatches?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaginatedBatchesKeySpecifier
      | (() => undefined | PaginatedBatchesKeySpecifier);
    fields?: PaginatedBatchesFieldPolicy;
  };
  Payment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier);
    fields?: PaymentFieldPolicy;
  };
  PaymentAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PaymentActionKeySpecifier | (() => undefined | PaymentActionKeySpecifier);
    fields?: PaymentActionFieldPolicy;
  };
  PaymentApiMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentApiMethodKeySpecifier
      | (() => undefined | PaymentApiMethodKeySpecifier);
    fields?: PaymentApiMethodFieldPolicy;
  };
  PaymentSource?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PaymentSourceKeySpecifier | (() => undefined | PaymentSourceKeySpecifier);
    fields?: PaymentSourceFieldPolicy;
  };
  PaypalChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PaypalChannelKeySpecifier | (() => undefined | PaypalChannelKeySpecifier);
    fields?: PaypalChannelFieldPolicy;
  };
  PendingNumbers?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PendingNumbersKeySpecifier | (() => undefined | PendingNumbersKeySpecifier);
    fields?: PendingNumbersFieldPolicy;
  };
  PickupRateResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupRateResultKeySpecifier
      | (() => undefined | PickupRateResultKeySpecifier);
    fields?: PickupRateResultFieldPolicy;
  };
  PickupRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PickupRequestKeySpecifier | (() => undefined | PickupRequestKeySpecifier);
    fields?: PickupRequestFieldPolicy;
  };
  PickupSurcharge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupSurchargeKeySpecifier
      | (() => undefined | PickupSurchargeKeySpecifier);
    fields?: PickupSurchargeFieldPolicy;
  };
  PlaidActivation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaidActivationKeySpecifier
      | (() => undefined | PlaidActivationKeySpecifier);
    fields?: PlaidActivationFieldPolicy;
  };
  Platform?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PlatformKeySpecifier | (() => undefined | PlatformKeySpecifier);
    fields?: PlatformFieldPolicy;
  };
  PlatformLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PlatformLinkKeySpecifier | (() => undefined | PlatformLinkKeySpecifier);
    fields?: PlatformLinkFieldPolicy;
  };
  PlatformMappableField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlatformMappableFieldKeySpecifier
      | (() => undefined | PlatformMappableFieldKeySpecifier);
    fields?: PlatformMappableFieldFieldPolicy;
  };
  PlatformOverrideField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlatformOverrideFieldKeySpecifier
      | (() => undefined | PlatformOverrideFieldKeySpecifier);
    fields?: PlatformOverrideFieldFieldPolicy;
  };
  PossibleScanFormResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PossibleScanFormResultKeySpecifier
      | (() => undefined | PossibleScanFormResultKeySpecifier);
    fields?: PossibleScanFormResultFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  RateGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateGroupKeySpecifier | (() => undefined | RateGroupKeySpecifier);
    fields?: RateGroupFieldPolicy;
  };
  RateGroupKey?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateGroupKeyKeySpecifier | (() => undefined | RateGroupKeyKeySpecifier);
    fields?: RateGroupKeyFieldPolicy;
  };
  RateGroupTrait?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateGroupTraitKeySpecifier | (() => undefined | RateGroupTraitKeySpecifier);
    fields?: RateGroupTraitFieldPolicy;
  };
  RateResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateResultKeySpecifier | (() => undefined | RateResultKeySpecifier);
    fields?: RateResultFieldPolicy;
  };
  RateSelection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateSelectionKeySpecifier | (() => undefined | RateSelectionKeySpecifier);
    fields?: RateSelectionFieldPolicy;
  };
  RateSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateSummaryKeySpecifier | (() => undefined | RateSummaryKeySpecifier);
    fields?: RateSummaryFieldPolicy;
  };
  RateSurcharge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RateSurchargeKeySpecifier | (() => undefined | RateSurchargeKeySpecifier);
    fields?: RateSurchargeFieldPolicy;
  };
  RateSurchargeSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RateSurchargeSummaryKeySpecifier
      | (() => undefined | RateSurchargeSummaryKeySpecifier);
    fields?: RateSurchargeSummaryFieldPolicy;
  };
  Receipt?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ReceiptKeySpecifier | (() => undefined | ReceiptKeySpecifier);
    fields?: ReceiptFieldPolicy;
  };
  RecipientAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RecipientAddressKeySpecifier
      | (() => undefined | RecipientAddressKeySpecifier);
    fields?: RecipientAddressFieldPolicy;
  };
  ReconciliationAdjustment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReconciliationAdjustmentKeySpecifier
      | (() => undefined | ReconciliationAdjustmentKeySpecifier);
    fields?: ReconciliationAdjustmentFieldPolicy;
  };
  Region?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RegionKeySpecifier | (() => undefined | RegionKeySpecifier);
    fields?: RegionFieldPolicy;
  };
  ReversalType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ReversalTypeKeySpecifier | (() => undefined | ReversalTypeKeySpecifier);
    fields?: ReversalTypeFieldPolicy;
  };
  RubberStamps?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RubberStampsKeySpecifier | (() => undefined | RubberStampsKeySpecifier);
    fields?: RubberStampsFieldPolicy;
  };
  ScanForm?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScanFormKeySpecifier | (() => undefined | ScanFormKeySpecifier);
    fields?: ScanFormFieldPolicy;
  };
  ScanFormFile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScanFormFileKeySpecifier | (() => undefined | ScanFormFileKeySpecifier);
    fields?: ScanFormFileFieldPolicy;
  };
  ScanFormResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScanFormResultKeySpecifier | (() => undefined | ScanFormResultKeySpecifier);
    fields?: ScanFormResultFieldPolicy;
  };
  SecretType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SecretTypeKeySpecifier | (() => undefined | SecretTypeKeySpecifier);
    fields?: SecretTypeFieldPolicy;
  };
  SelectOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SelectOptionKeySpecifier | (() => undefined | SelectOptionKeySpecifier);
    fields?: SelectOptionFieldPolicy;
  };
  SenderEmailMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SenderEmailMetadataKeySpecifier
      | (() => undefined | SenderEmailMetadataKeySpecifier);
    fields?: SenderEmailMetadataFieldPolicy;
  };
  Shipment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShipmentKeySpecifier | (() => undefined | ShipmentKeySpecifier);
    fields?: ShipmentFieldPolicy;
  };
  ShipmentBoundaries?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentBoundariesKeySpecifier
      | (() => undefined | ShipmentBoundariesKeySpecifier);
    fields?: ShipmentBoundariesFieldPolicy;
  };
  ShipmentMapping?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentMappingKeySpecifier
      | (() => undefined | ShipmentMappingKeySpecifier);
    fields?: ShipmentMappingFieldPolicy;
  };
  ShipmentMobileCode?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentMobileCodeKeySpecifier
      | (() => undefined | ShipmentMobileCodeKeySpecifier);
    fields?: ShipmentMobileCodeFieldPolicy;
  };
  ShipmentPassthroughFieldType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentPassthroughFieldTypeKeySpecifier
      | (() => undefined | ShipmentPassthroughFieldTypeKeySpecifier);
    fields?: ShipmentPassthroughFieldTypeFieldPolicy;
  };
  ShipmentPreset?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShipmentPresetKeySpecifier | (() => undefined | ShipmentPresetKeySpecifier);
    fields?: ShipmentPresetFieldPolicy;
  };
  ShipmentPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShipmentPriceKeySpecifier | (() => undefined | ShipmentPriceKeySpecifier);
    fields?: ShipmentPriceFieldPolicy;
  };
  ShipmentStatusSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentStatusSummaryKeySpecifier
      | (() => undefined | ShipmentStatusSummaryKeySpecifier);
    fields?: ShipmentStatusSummaryFieldPolicy;
  };
  ShipmentSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentSummaryKeySpecifier
      | (() => undefined | ShipmentSummaryKeySpecifier);
    fields?: ShipmentSummaryFieldPolicy;
  };
  ShipmentTrackingNumbers?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentTrackingNumbersKeySpecifier
      | (() => undefined | ShipmentTrackingNumbersKeySpecifier);
    fields?: ShipmentTrackingNumbersFieldPolicy;
  };
  ShipmentUpload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShipmentUploadKeySpecifier | (() => undefined | ShipmentUploadKeySpecifier);
    fields?: ShipmentUploadFieldPolicy;
  };
  ShippingCustomsItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShippingCustomsItemKeySpecifier
      | (() => undefined | ShippingCustomsItemKeySpecifier);
    fields?: ShippingCustomsItemFieldPolicy;
  };
  ShopifyChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShopifyChannelKeySpecifier | (() => undefined | ShopifyChannelKeySpecifier);
    fields?: ShopifyChannelFieldPolicy;
  };
  ShopifyLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopifyLocationKeySpecifier
      | (() => undefined | ShopifyLocationKeySpecifier);
    fields?: ShopifyLocationFieldPolicy;
  };
  SpreedlyIframeParameters?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpreedlyIframeParametersKeySpecifier
      | (() => undefined | SpreedlyIframeParametersKeySpecifier);
    fields?: SpreedlyIframeParametersFieldPolicy;
  };
  SquareChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SquareChannelKeySpecifier | (() => undefined | SquareChannelKeySpecifier);
    fields?: SquareChannelFieldPolicy;
  };
  SquareLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SquareLocationKeySpecifier | (() => undefined | SquareLocationKeySpecifier);
    fields?: SquareLocationFieldPolicy;
  };
  SquarespaceChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SquarespaceChannelKeySpecifier
      | (() => undefined | SquarespaceChannelKeySpecifier);
    fields?: SquarespaceChannelFieldPolicy;
  };
  StageDot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | StageDotKeySpecifier | (() => undefined | StageDotKeySpecifier);
    fields?: StageDotFieldPolicy;
  };
  StateDistributionChart?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StateDistributionChartKeySpecifier
      | (() => undefined | StateDistributionChartKeySpecifier);
    fields?: StateDistributionChartFieldPolicy;
  };
  SubblyChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SubblyChannelKeySpecifier | (() => undefined | SubblyChannelKeySpecifier);
    fields?: SubblyChannelFieldPolicy;
  };
  Summary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SummaryKeySpecifier | (() => undefined | SummaryKeySpecifier);
    fields?: SummaryFieldPolicy;
  };
  SupportSearchResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportSearchResultKeySpecifier
      | (() => undefined | SupportSearchResultKeySpecifier);
    fields?: SupportSearchResultFieldPolicy;
  };
  SyncStatusResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncStatusResultKeySpecifier
      | (() => undefined | SyncStatusResultKeySpecifier);
    fields?: SyncStatusResultFieldPolicy;
  };
  Timezone?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TimezoneKeySpecifier | (() => undefined | TimezoneKeySpecifier);
    fields?: TimezoneFieldPolicy;
  };
  TwoFactorAuthenticationConfiguration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwoFactorAuthenticationConfigurationKeySpecifier
      | (() => undefined | TwoFactorAuthenticationConfigurationKeySpecifier);
    fields?: TwoFactorAuthenticationConfigurationFieldPolicy;
  };
  TwoFactorProvider?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwoFactorProviderKeySpecifier
      | (() => undefined | TwoFactorProviderKeySpecifier);
    fields?: TwoFactorProviderFieldPolicy;
  };
  UpdateShipmentPresetResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateShipmentPresetResultKeySpecifier
      | (() => undefined | UpdateShipmentPresetResultKeySpecifier);
    fields?: UpdateShipmentPresetResultFieldPolicy;
  };
  User?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier);
    fields?: UserFieldPolicy;
  };
  UserTerms?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserTermsKeySpecifier | (() => undefined | UserTermsKeySpecifier);
    fields?: UserTermsFieldPolicy;
  };
  Warehouse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | WarehouseKeySpecifier | (() => undefined | WarehouseKeySpecifier);
    fields?: WarehouseFieldPolicy;
  };
  WixChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | WixChannelKeySpecifier | (() => undefined | WixChannelKeySpecifier);
    fields?: WixChannelFieldPolicy;
  };
  WoocommerceChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WoocommerceChannelKeySpecifier
      | (() => undefined | WoocommerceChannelKeySpecifier);
    fields?: WoocommerceChannelFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
